import React, { FC, SVGProps, ReactNode } from 'react';

export interface IconProps extends SVGProps<SVGSVGElement> {
  fill?: string;
  className?: string;
  onClick?: any;
  outline?: string;
  height?: string;
  width?: string;
  size?: string;
  children?: ReactNode;
}

/* Arrow Icon for dropdown button */
export const CaretDown = ({
  fill,
  className,
  children,
  ...rest
}: IconProps) => (
  <svg
    width="10"
    height="6"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    className={className || ''}
  >
    {children}
    <path
      d="M.978666 0H9.01929c.55625 0 .83438.671875.44063 1.06563L5.44117 5.0875c-.24375.24375-.64063.24375-.88438 0L.538041 1.06563C.144291.671875.422416 0 .978666 0z"
      fill={fill}
    />
  </svg>
);

export const SolidCirclePhone = ({
  height,
  width,
  fill,
  children,
  className,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    {...rest}
  >
    <path
      d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 128l40 72-41.9 33.5c18.1 34.2 46.2 62.3 80.4 80.4L312 272l72 40-16 72H352c-123.7 0-224-100.3-224-224l0-16 72-16z"
      fill={fill || '#000'}
    />
  </svg>
);

export const CloseIcon = ({
  children,
  fill,
  width,
  height,
  ...rest
}: IconProps) => (
  <svg
    width={width || '18'}
    height={height || '17'}
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M3.38909 15.6008c-.37231.3335-.87728.5208-1.40381.5208s-1.031491-.1873-1.403804-.5208C.209163 15.2674 0 14.8151 0 14.3435c0-.2335.0513509-.4647.151121-.6804.09977-.2157.246004-.4117.430355-.5768L14.6116.522552c.3721-.333447.8768-.52086848 1.4031-.52103511.5264-.00016663 1.0312.18693611 1.4035.52014711.3724.33321.5816.785236.5818 1.256636.0002.47139-.2087.92355-.5808 1.257L3.38909 15.599v.0018z"
      fill={fill || '#A3A5A7'}
    />
    <path
      d="M.581476 3.0353c-.184351-.16511-.330585-.36112-.430355-.57684C.0513509 2.24274 0 2.01153 0 1.77804c0-.2335.0513509-.46471.151121-.68043C.250891.881889.397125.685881.581476.520775.765826.355669.984682.2247 1.22555.135345 1.46641.0459903 1.72457 0 1.98528 0s.51887.0459903.75974.135345c.24086.089355.45972.220324.64407.38543L17.4172 13.0863c.3724.3332.5816.7852.5818 1.2566.0002.4714-.2087.9236-.5808 1.257-.372.3335-.8767.5209-1.4031.5211-.5263.0001-1.0312-.187-1.4035-.5202L.58346 3.0353H.581476z"
      fill={fill || '#A3A5A7'}
    />
  </svg>
);

export const OverviewIcon = ({
  children,
  className,
  fill,
  ...rest
}: IconProps) => (
  <svg
    width="10"
    height="15"
    viewBox="0 0 10 15"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className || ''}
    {...rest}
  >
    {children}
    <path d="M2.8125 0.9375H0.9375C0.419824 0.9375 0 1.35732 0 1.875V3.75C0 4.26768 0.419824 4.6875 0.9375 4.6875H2.8125C3.33018 4.6875 3.75 4.26768 3.75 3.75V1.875C3.75 1.35732 3.33018 0.9375 2.8125 0.9375ZM2.8125 5.625H0.9375C0.419824 5.625 0 6.04482 0 6.5625V8.4375C0 8.95518 0.419824 9.375 0.9375 9.375H2.8125C3.33018 9.375 3.75 8.95518 3.75 8.4375V6.5625C3.75 6.04482 3.33018 5.625 2.8125 5.625ZM2.8125 10.3125H0.9375C0.419824 10.3125 0 10.7323 0 11.25V13.125C0 13.6427 0.419824 14.0625 0.9375 14.0625H2.8125C3.33018 14.0625 3.75 13.6427 3.75 13.125V11.25C3.75 10.7323 3.33018 10.3125 2.8125 10.3125ZM8.4375 0.9375H6.5625C6.04482 0.9375 5.625 1.35732 5.625 1.875V3.75C5.625 4.26768 6.04482 4.6875 6.5625 4.6875H8.4375C8.95518 4.6875 9.375 4.26768 9.375 3.75V1.875C9.375 1.35732 8.95518 0.9375 8.4375 0.9375ZM8.4375 5.625H6.5625C6.04482 5.625 5.625 6.04482 5.625 6.5625V8.4375C5.625 8.95518 6.04482 9.375 6.5625 9.375H8.4375C8.95518 9.375 9.375 8.95518 9.375 8.4375V6.5625C9.375 6.04482 8.95518 5.625 8.4375 5.625ZM8.4375 10.3125H6.5625C6.04482 10.3125 5.625 10.7323 5.625 11.25V13.125C5.625 13.6427 6.04482 14.0625 6.5625 14.0625H8.4375C8.95518 14.0625 9.375 13.6427 9.375 13.125V11.25C9.375 10.7323 8.95518 10.3125 8.4375 10.3125Z" />
  </svg>
);

export const RecommendationsIcon = ({
  children,
  className,
  fill,
  ...rest
}: IconProps) => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className ? className : ''}
    {...rest}
  >
    {children}
    <path d="M14.1836 4.77988L13.1008 3.69707C12.8438 3.44004 12.4282 3.44004 12.1739 3.69707L5.62502 10.2459L2.57893 7.19707C2.3219 6.94004 1.90627 6.94004 1.65198 7.19707L0.566431 8.28262C0.309399 8.53965 0.309399 8.95527 0.566431 9.21231L5.16018 13.8088C5.41721 14.0658 5.83284 14.0658 6.08713 13.8088L14.1809 5.70957C14.4379 5.44981 14.4379 5.03418 14.1836 4.77988ZM5.31604 7.67832C5.48557 7.85059 5.76448 7.85059 5.93401 7.67832L11.6215 1.98535C11.791 1.81309 11.791 1.53691 11.6215 1.36738L10.3856 0.128711C10.216 -0.0435547 9.93713 -0.0435547 9.7676 0.128711L5.62502 4.27129L4.11018 2.75371C3.94065 2.58145 3.66174 2.58145 3.49221 2.75371L2.25354 3.99238C2.08401 4.16465 2.08401 4.44082 2.25354 4.61035L5.31604 7.67832Z" />
  </svg>
);

export const AnalyticsIcon = ({
  className,
  children,
  fill,
  ...rest
}: IconProps) => (
  <svg
    width="17"
    height="12"
    viewBox="0 0 17 12"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className ? className : ''}
    {...rest}
  >
    {children}
    <path d="M10.775 8H11.975C12.175 8 12.375 7.8 12.375 7.6V3.4C12.375 3.2 12.175 3 11.975 3H10.775C10.575 3 10.375 3.2 10.375 3.4V7.6C10.375 7.8 10.575 8 10.775 8ZM13.775 8H14.975C15.175 8 15.375 7.8 15.375 7.6V0.4C15.375 0.2 15.175 0 14.975 0H13.775C13.575 0 13.375 0.2 13.375 0.4V7.6C13.375 7.8 13.575 8 13.775 8ZM4.775 8H5.975C6.175 8 6.375 7.8 6.375 7.6V5.4C6.375 5.2 6.175 5 5.975 5H4.775C4.575 5 4.375 5.2 4.375 5.4V7.6C4.375 7.8 4.575 8 4.775 8ZM7.775 8H8.975C9.175 8 9.375 7.8 9.375 7.6V1.4C9.375 1.2 9.175 1 8.975 1H7.775C7.575 1 7.375 1.2 7.375 1.4V7.6C7.375 7.8 7.575 8 7.775 8ZM15.875 10H2.375V0.5C2.375 0.22375 2.15125 0 1.875 0H0.875C0.59875 0 0.375 0.22375 0.375 0.5V11C0.375 11.5522 0.822812 12 1.375 12H15.875C16.1512 12 16.375 11.7762 16.375 11.5V10.5C16.375 10.2238 16.1512 10 15.875 10Z" />
  </svg>
);

export const CampaignsIcon = ({
  className,
  children,
  fill,
  ...rest
}: IconProps) => (
  <svg
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className ? className : ''}
    {...rest}
  >
    {children}
    <path d="M16.375 6.66667C16.375 6.01028 16.0153 5.44333 15.4861 5.13556V0.889167C15.4861 0.646111 15.2922 0 14.5972 0C14.3994 0 14.2031 0.0661111 14.0422 0.195L11.6803 2.08472C10.4939 3.03306 9.00444 3.55556 7.48611 3.55556H2.15278C1.17083 3.55556 0.375 4.35139 0.375 5.33333V8C0.375 8.98194 1.17083 9.77778 2.15278 9.77778H3.08889C3.05028 10.0689 3.02833 10.365 3.02833 10.6667C3.02833 11.7714 3.28556 12.8153 3.73833 13.7483C3.8825 14.0453 4.19722 14.2222 4.52722 14.2222H6.59056C7.31417 14.2222 7.74861 13.3933 7.31 12.8178C6.85444 12.22 6.58361 11.4744 6.58361 10.6667C6.58361 10.3581 6.62861 10.0614 6.70611 9.77778H7.48611C9.00444 9.77778 10.4939 10.3003 11.68 11.2486L14.0419 13.1383C14.1995 13.2644 14.3952 13.3332 14.5969 13.3333C15.2892 13.3333 15.4858 12.7006 15.4858 12.4444V8.19806C16.0153 7.89 16.375 7.32306 16.375 6.66667ZM13.7083 10.595L12.7903 9.86056C11.2903 8.66056 9.40611 8 7.48611 8V5.33333C9.40611 5.33333 11.2903 4.67278 12.7903 3.47278L13.7083 2.73833V10.595Z" />
  </svg>
);

export const MagnifyingGlass: FC<IconProps> = ({
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M16.377 13.8344L13.2613 10.7188C13.1207 10.5781 12.9301 10.5 12.7301 10.5H12.2207C13.0832 9.39688 13.5957 8.00937 13.5957 6.5C13.5957 2.90937 10.6863 0 7.0957 0C3.50508 0 0.595703 2.90937 0.595703 6.5C0.595703 10.0906 3.50508 13 7.0957 13C8.60508 13 9.99258 12.4875 11.0957 11.625V12.1344C11.0957 12.3344 11.1738 12.525 11.3145 12.6656L14.4301 15.7812C14.7238 16.075 15.1988 16.075 15.4895 15.7812L16.3738 14.8969C16.6676 14.6031 16.6676 14.1281 16.377 13.8344ZM7.0957 10.5C4.88633 10.5 3.0957 8.7125 3.0957 6.5C3.0957 4.29063 4.8832 2.5 7.0957 2.5C9.30508 2.5 11.0957 4.2875 11.0957 6.5C11.0957 8.70938 9.3082 10.5 7.0957 10.5Z"
      fill={fill}
    />
  </svg>
);

export const ToolsIcon = ({
  className,
  children,
  fill,
  ...rest
}: IconProps) => (
  <svg
    width="17"
    height="14"
    viewBox="0 0 17 14"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className ? className : ''}
    {...rest}
  >
    {children}
    <path d="M16.0822 5.70719L14.6681 4.29313C14.4806 4.10563 14.2262 4.00031 13.9609 4.00031H12.375V1.5C12.375 0.671562 11.7034 0 10.875 0H5.875C5.04656 0 4.375 0.671562 4.375 1.5V4H2.78906C2.52375 4 2.26969 4.10531 2.08187 4.29281L0.667812 5.70719C0.480312 5.89469 0.375 6.14906 0.375 6.41437V9H4.375V8.5C4.375 8.22375 4.59875 8 4.875 8H5.875C6.15125 8 6.375 8.22375 6.375 8.5V9H10.375V8.5C10.375 8.22375 10.5988 8 10.875 8H11.875C12.1512 8 12.375 8.22375 12.375 8.5V9H16.375V6.41406C16.375 6.14906 16.2697 5.89469 16.0822 5.70719ZM10.375 4H6.375V2H10.375V4ZM12.375 10.5C12.375 10.7762 12.1512 11 11.875 11H10.875C10.5988 11 10.375 10.7762 10.375 10.5V10H6.375V10.5C6.375 10.7762 6.15125 11 5.875 11H4.875C4.59875 11 4.375 10.7762 4.375 10.5V10H0.375V13C0.375 13.5522 0.822812 14 1.375 14H15.375C15.9272 14 16.375 13.5522 16.375 13V10H12.375V10.5Z" />
  </svg>
);

export const Warning: FC<IconProps> = ({ children, ...rest }: IconProps) => (
  <svg
    width="16"
    height="16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M15.75 8c0 4.2812-3.4701 7.75-7.75 7.75C3.72009 15.75.25 12.2812.25 8 .25 3.72134 3.72009.25 8 .25c4.2799 0 7.75 3.47134 7.75 7.75zM8 9.5625c-.79391 0-1.4375.6436-1.4375 1.4375S7.20609 12.4375 8 12.4375 9.4375 11.7939 9.4375 11 8.79391 9.5625 8 9.5625zM6.63522 4.39544l.23181 4.25C6.87787 8.84431 7.04231 9 7.24147 9h1.51706c.19916 0 .36359-.15569.37444-.35456l.23181-4.25C9.3765 4.18063 9.20547 4 8.99034 4H7.00962c-.21512 0-.38612.18063-.3744.39544z"
      fill="#DF2A2A"
    />
  </svg>
);

export const RemindersIcon = ({ className, children, ...rest }: IconProps) => (
  <div className={`relative flex ${className || ''}`}>
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      {children}
      <path
        d="M20.2203 14.769H18.6963C18.5486 14.769 18.4089 14.8454 18.3298 14.972C17.9949 15.502 17.6047 15.9924 17.1565 16.4406C16.3839 17.2132 15.4848 17.8197 14.4855 18.2415C13.4492 18.6792 12.3497 18.9007 11.2159 18.9007C10.0795 18.9007 8.98 18.6792 7.9464 18.2415C6.94709 17.8197 6.04797 17.2132 5.27541 16.4406C4.50285 15.6681 3.8964 14.769 3.47453 13.7697C3.03683 12.7361 2.81535 11.6365 2.81535 10.5001C2.81535 9.3637 3.03683 8.26682 3.47453 7.23059C3.8964 6.23127 4.50285 5.33215 5.27541 4.55959C6.04797 3.78704 6.94709 3.18059 7.9464 2.75871C8.98 2.32102 10.0821 2.09953 11.2159 2.09953C12.3524 2.09953 13.4519 2.32102 14.4855 2.75871C15.4848 3.18059 16.3839 3.78704 17.1565 4.55959C17.6047 5.00784 17.9949 5.49827 18.3298 6.02825C18.4089 6.15481 18.5486 6.23127 18.6963 6.23127H20.2203C20.4023 6.23127 20.5183 6.04143 20.4365 5.88059C18.7174 2.46077 15.2317 0.238011 11.3399 0.193187C5.64191 0.121996 0.909002 4.78635 0.898456 10.479C0.887909 16.1823 5.51008 20.8097 11.2133 20.8097C15.1552 20.8097 18.6989 18.579 20.4365 15.1197C20.5183 14.9588 20.3996 14.769 20.2203 14.769Z"
        fill="#231F20"
      />
    </svg>
    <svg
      width="15"
      height="11"
      viewBox="0 0 15 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`absolute left-[10px] top-[5px]`}
      {...rest}
    >
      <path
        d="M13.9169 2.86328H7.16689C7.05088 2.86328 6.95596 2.9582 6.95596 3.07422V4.33984C6.95596 4.45586 7.05088 4.55078 7.16689 4.55078H13.9169C14.0329 4.55078 14.1278 4.45586 14.1278 4.33984V3.07422C14.1278 2.9582 14.0329 2.86328 13.9169 2.86328ZM10.3837 6.44922H7.16689C7.05088 6.44922 6.95596 6.54414 6.95596 6.66016V7.92578C6.95596 8.0418 7.05088 8.13672 7.16689 8.13672H10.3837C10.4997 8.13672 10.5946 8.0418 10.5946 7.92578V6.66016C10.5946 6.54414 10.4997 6.44922 10.3837 6.44922ZM1.58496 0.503418H0.443262C0.279785 0.503418 0.147949 0.635254 0.147949 0.798731V7.33779C0.147949 7.43272 0.192774 7.51973 0.269238 7.5751L4.19531 10.4386C4.32715 10.5335 4.51172 10.5071 4.60664 10.3753L5.28428 9.44981V9.44717C5.3792 9.31533 5.35019 9.13076 5.21836 9.03584L1.87764 6.62061V0.798731C1.88027 0.635254 1.7458 0.503418 1.58496 0.503418Z"
        fill="#231F20"
      />
    </svg>
  </div>
);

export const NotificationsIcon = ({
  className,
  children,
  ...rest
}: IconProps) => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className ? className : ''}
    {...rest}
  >
    {children}
    <path
      d="M16 11.586V8C16 4.783 13.815 2.073 10.855 1.258C10.562 0.52 9.846 0 9 0C8.154 0 7.438 0.52 7.145 1.258C4.185 2.074 2 4.783 2 8V11.586L0.293001 13.293C0.199958 13.3857 0.126171 13.4959 0.0758854 13.6172C0.0256001 13.7386 -0.000189449 13.8687 1.04767e-06 14V16C1.04767e-06 16.2652 0.105358 16.5196 0.292894 16.7071C0.480431 16.8946 0.734785 17 1 17H17C17.2652 17 17.5196 16.8946 17.7071 16.7071C17.8946 16.5196 18 16.2652 18 16V14C18.0002 13.8687 17.9744 13.7386 17.9241 13.6172C17.8738 13.4959 17.8 13.3857 17.707 13.293L16 11.586ZM16 15H2V14.414L3.707 12.707C3.80004 12.6143 3.87383 12.5041 3.92412 12.3828C3.9744 12.2614 4.00019 12.1313 4 12V8C4 5.243 6.243 3 9 3C11.757 3 14 5.243 14 8V12C14 12.266 14.105 12.52 14.293 12.707L16 14.414V15ZM9 20C9.6193 20.0008 10.2235 19.8086 10.7285 19.4502C11.2335 19.0917 11.6143 18.5849 11.818 18H6.182C6.38566 18.5849 6.76648 19.0917 7.27151 19.4502C7.77654 19.8086 8.3807 20.0008 9 20Z"
      fill="#231F20"
    />
  </svg>
);

export const FormSuccess: FC<IconProps> = ({
  children,
  ...rest
}: IconProps) => (
  <svg
    width="16"
    height="16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M15.75 8c0 4.2802-3.4698 7.75-7.75 7.75C3.71978 15.75.25 12.2802.25 8 .25 3.71978 3.71978.25 8 .25c4.2802 0 7.75 3.46978 7.75 7.75zm-8.64644 4.1036l5.75004-5.75004c.1952-.19525.1952-.51184 0-.70709l-.7071-.7071c-.1953-.19528-.5119-.19528-.7072 0L6.75 9.62869 4.56066 7.43934c-.19525-.19525-.51185-.19525-.70713 0l-.70709.7071c-.19525.19525-.19525.51184 0 .70709l3.25 3.24997c.19528.1953.51184.1953.70712.0001z"
      fill="#16A085"
    />
  </svg>
);

export const BackArrow = ({ children, ...rest }: IconProps) => (
  <svg
    width="10"
    height="14"
    viewBox="0 0 10 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M1.07874 6.46974L7.15218 0.396611C7.44499 0.103799 7.91999 0.103799 8.2128 0.396611L8.92124 1.10505C9.21374 1.39755 9.21405 1.8713 8.92249 2.16442L4.10905 7.00005L8.92218 11.836C9.21405 12.1291 9.21343 12.6029 8.92093 12.8954L8.21249 13.6038C7.91968 13.8966 7.44468 13.8966 7.15187 13.6038L1.07874 7.53036C0.785928 7.23755 0.785928 6.76255 1.07874 6.46974Z"
      fill="#29292D"
    />
  </svg>
);

export const LockIcon = ({ className, children, ...rest }: IconProps) => (
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...rest}
  >
    {children}
    <path
      d="M7.00016 0.666626C4.70266 0.666626 2.8335 2.53579 2.8335 4.83329V7.33329H2.00016C1.55814 7.33329 1.13421 7.50889 0.821652 7.82145C0.509091 8.13401 0.333496 8.55793 0.333496 8.99996V15.6666C0.333496 16.1087 0.509091 16.5326 0.821652 16.8451C1.13421 17.1577 1.55814 17.3333 2.00016 17.3333H12.0002C12.4422 17.3333 12.8661 17.1577 13.1787 16.8451C13.4912 16.5326 13.6668 16.1087 13.6668 15.6666V8.99996C13.6668 8.55793 13.4912 8.13401 13.1787 7.82145C12.8661 7.50889 12.4422 7.33329 12.0002 7.33329H11.1668V4.83329C11.1668 2.53579 9.29766 0.666626 7.00016 0.666626ZM4.50016 4.83329C4.50016 3.45496 5.62183 2.33329 7.00016 2.33329C8.3785 2.33329 9.50016 3.45496 9.50016 4.83329V7.33329H4.50016V4.83329ZM7.8335 13.7691V15.6666H6.16683V13.7691C5.87549 13.6023 5.64154 13.3511 5.49585 13.0486C5.35017 12.7461 5.29957 12.4066 5.35073 12.0748C5.4019 11.743 5.55243 11.4344 5.78247 11.1899C6.01251 10.9454 6.31126 10.7763 6.63933 10.705C6.88301 10.6511 7.13568 10.6526 7.3787 10.7094C7.62172 10.7661 7.8489 10.8767 8.04349 11.033C8.23807 11.1893 8.39509 11.3873 8.50298 11.6123C8.61086 11.8373 8.66685 12.0837 8.66683 12.3333C8.66635 12.6247 8.58907 12.9109 8.44277 13.163C8.29647 13.4151 8.08632 13.6241 7.8335 13.7691Z"
      fill="#29292D"
    />
  </svg>
);

export const RemoveTag: FC<IconProps> = ({ children, ...rest }: IconProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="button"
    {...rest}
  >
    {children}
    <path
      d="M9 0.28125C4.18359 0.28125 0.28125 4.18359 0.28125 9C0.28125 13.8164 4.18359 17.7188 9 17.7188C13.8164 17.7188 17.7188 13.8164 17.7188 9C17.7188 4.18359 13.8164 0.28125 9 0.28125ZM13.275 11.2887C13.4402 11.4539 13.4402 11.7211 13.275 11.8863L11.8828 13.275C11.7176 13.4402 11.4504 13.4402 11.2852 13.275L9 10.9688L6.71133 13.275C6.54609 13.4402 6.27891 13.4402 6.11367 13.275L4.725 11.8828C4.55977 11.7176 4.55977 11.4504 4.725 11.2852L7.03125 9L4.725 6.71133C4.55977 6.54609 4.55977 6.27891 4.725 6.11367L6.11719 4.72148C6.28242 4.55625 6.54961 4.55625 6.71484 4.72148L9 7.03125L11.2887 4.725C11.4539 4.55977 11.7211 4.55977 11.8863 4.725L13.2785 6.11719C13.4438 6.28242 13.4438 6.54961 13.2785 6.71484L10.9688 9L13.275 11.2887Z"
      fill="#231F20"
    />
  </svg>
);

export const CalendarIcon = ({
  fill,
  children,
  className,
  ...rest
}: IconProps) => (
  <svg
    width="13"
    height="15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <g clipPath="url(#calendar0)">
      <path
        d="M.0463867 13.5938C.0463867 14.3701.644887 15 1.38257 15h9.79873c.7377 0 1.3362-.6299 1.3362-1.4062V5.625H.0463867v7.9688zM8.95429 7.85156c0-.19336.15032-.35156.33405-.35156h1.11346c.1838 0 .3341.1582.3341.35156v1.17188c0 .19336-.1503.35156-.3341.35156H9.28834c-.18373 0-.33405-.1582-.33405-.35156V7.85156zm0 3.75004c0-.1934.15032-.3516.33405-.3516h1.11346c.1838 0 .3341.1582.3341.3516v1.1718c0 .1934-.1503.3516-.3341.3516H9.28834c-.18373 0-.33405-.1582-.33405-.3516v-1.1718zM5.39113 7.85156c0-.19336.15032-.35156.33405-.35156h1.11349c.18372 0 .33404.1582.33404.35156v1.17188c0 .19336-.15032.35156-.33404.35156H5.72518c-.18373 0-.33405-.1582-.33405-.35156V7.85156zm0 3.75004c0-.1934.15032-.3516.33405-.3516h1.11349c.18372 0 .33404.1582.33404.3516v1.1718c0 .1934-.15032.3516-.33404.3516H5.72518c-.18373 0-.33405-.1582-.33405-.3516v-1.1718zM1.82797 7.85156c0-.19336.15032-.35156.33404-.35156H3.2755c.18373 0 .33405.1582.33405.35156v1.17188c0 .19336-.15032.35156-.33405.35156H2.16201c-.18372 0-.33404-.1582-.33404-.35156V7.85156zm0 3.75004c0-.1934.15032-.3516.33404-.3516H3.2755c.18373 0 .33405.1582.33405.3516v1.1718c0 .1934-.15032.3516-.33405.3516H2.16201c-.18372 0-.33404-.1582-.33404-.3516v-1.1718zM11.1813 1.875H9.84508V.46875C9.84508.210938 9.64466 0 9.39969 0H8.5089c-.24497 0-.4454.210938-.4454.46875V1.875H4.50034V.46875C4.50034.210938 4.29991 0 4.05494 0h-.89079c-.24496 0-.44539.210938-.44539.46875V1.875H1.38257c-.737683 0-1.3361833.62988-1.3361833 1.40625V4.6875H12.5175V3.28125c0-.77637-.5985-1.40625-1.3362-1.40625z"
        fill={fill}
        className={className || ''}
      />
    </g>
    <defs>
      <clipPath id="calendar0">
        <path
          fill="#fff"
          transform="translate(.0463867)"
          d="M0 0h12.4711v15H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

export const CalendarClockIcon = ({
  fill,
  children,
  className,
  height,
  width,
  ...rest
}: IconProps) => (
  <svg
    width={width || '26'}
    height={height || '26'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    {...rest}
  >
    {children}
    <path
      d="M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H432 0V464c0 26.5 21.5 48 48 48H330.8C285.6 480.1 256 427.5 256 368c0-97.2 78.8-176 176-176c5.4 0 10.7 .2 16 .7V192zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"
      fill={fill || '#000'}
      className={className || ''}
    />
  </svg>
);

export const AkarIconsArrowLeft = ({ children, ...rest }: IconProps) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M11 5l-7 7 7 7M4 12h16"
      stroke="#231F20"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AkarIconsArrowRight = ({ children, ...rest }: IconProps) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M4 12h16M13 5l7 7-7 7"
      stroke="#231F20"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UploadIcon = ({ className, children, ...rest }: IconProps) => (
  <svg
    width="100"
    height="71"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className || ''}
    {...rest}
  >
    {children}
    <path
      d="M81.1765 29.4118c.5882-1.7647 1.1764-3.5294 1.1764-5.8824C82.3529 10.5882 71.7647 0 58.8235 0 50 0 41.7647 5.29412 38.2353 12.9412c-1.7647-.5883-4.1177-1.1765-5.8824-1.1765-8.2353 0-14.7058 6.4706-14.7058 14.7059 0 1.1765 0 2.3529.5882 2.9412C7.64706 31.1765 0 39.4118 0 50c0 11.1765 9.41176 20.5882 20.5882 20.5882h20.5883v-17.647H23.5294L50 26.4706l26.4706 26.4706H58.8235v17.647h20.5883C90.5882 70.5882 100 61.1765 100 50c0-10.5882-8.2353-19.4118-18.8235-20.5882z"
      fill="#CCC"
    />
  </svg>
);

export const SolidTrashIcon = ({ children, ...rest }: IconProps) => (
  <svg
    width="16"
    height="19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <g clipPath="url(#trash0)">
      <path
        d="M15.4286 1.14274h-4.2857l-.3358-.667856c-.0711-.14278-.1806-.262885-.3163-.3468-.1356-.0839161-.292-.12831421-.4515-.1281998H5.95714c-.15915-.00061181-.31525.0436207-.45042.1276298-.13518.084009-.24395.204397-.31386.34737l-.33572.667856H.571429c-.151553 0-.296898.06021-.404061.16737C.0602039 1.41727 0 1.56262 0 1.71417v1.14286c0 .15155.0602039.29689.167368.40406.107163.10716.252508.16737.404061.16737H15.4286c.1515 0 .2969-.06021.404-.16737.1072-.10717.1674-.25251.1674-.40406V1.71417c0-.15155-.0602-.2969-.1674-.40406-.1071-.10716-.2525-.16737-.404-.16737zM1.9 16.6785c.02725.4352.21934.8437.53716 1.1422.31782.2986.73748.4648 1.17355.4649h8.77859c.4361-.0001.8557-.1663 1.1735-.4649.3179-.2985.5099-.707.5372-1.1422l.7571-12.10719H1.14286L1.9 16.6785z"
        fill="#231F20"
      />
    </g>
    <defs>
      <clipPath id="trash0">
        <path fill="#fff" d="M0 0h16v18.2857H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const FileFailed = ({ children, ...rest }: IconProps) => (
  <svg
    width="18"
    height="18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M9 .28125C4.18359.28125.28125 4.18359.28125 9c0 4.8164 3.90234 8.7188 8.71875 8.7188 4.8164 0 8.7188-3.9024 8.7188-8.7188C17.7188 4.18359 13.8164.28125 9 .28125zm4.275 11.00745c.1652.1652.1652.4324 0 .5976l-1.3922 1.3887c-.1652.1652-.4324.1652-.5976 0L9 10.9688 6.71133 13.275c-.16524.1652-.43242.1652-.59766 0L4.725 11.8828c-.16523-.1652-.16523-.4324 0-.5976L7.03125 9 4.725 6.71133c-.16523-.16524-.16523-.43242 0-.59766l1.39219-1.39219c.16523-.16523.43242-.16523.59765 0L9 7.03125 11.2887 4.725c.1652-.16523.4324-.16523.5976 0l1.3922 1.39219c.1653.16523.1653.43242 0 .59765L10.9688 9l2.3062 2.2887z"
      fill="#DF2A2A"
    />
  </svg>
);

export const MemoCheck = ({
  height,
  width,
  fill,
  children,
  className,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    fill="none"
    className={className || ''}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    {...rest}
  >
    {children}
    <path
      d="M0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V198.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm64 80c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16s7.2 16 16 16H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm208 48a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm188.7-43.3L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"
      fill={fill || '#000'}
    />
  </svg>
);

export const Briefcase = ({
  height,
  width,
  fill,
  children,
  className,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    fill="none"
    className={className || ''}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
    viewBox="0 0 512 512"
    {...rest}
  >
    {children}
    <path
      d="M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z"
      fill={fill || '#000'}
    />
  </svg>
);

export const RegularBriefcase = ({
  height,
  width,
  fill,
  children,
  className,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    fill="none"
    className={className || ''}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    {...rest}
  >
    {children}
    <path
      d="M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96h64c35.3 0 64 28.7 64 64V280 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V280 160c0-35.3 28.7-64 64-64h64zM48 304V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V304H320v16c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V304H48zm144-48H320 464V160c0-8.8-7.2-16-16-16H360 152 64c-8.8 0-16 7.2-16 16v96H192z"
      fill={fill || '#000'}
    />
  </svg>
);

export const LightArrowRight = ({
  children,
  className,
  ...rest
}: IconProps) => (
  <div className={`flex cursor-pointer ${className || ''}`}>
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      {children}
      <g filter="url(#filter0_d)">
        <circle r="12" transform="matrix(-1 0 0 1 16 14)" fill="white" />
        <circle r="11.5" transform="matrix(-1 0 0 1 16 14)" stroke="#ECEEF1" />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0"
          width="32"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`absolute left-[12px] top-[8px]`}
    >
      <path
        d="M7.44849 5.53353L2.1078 0.193114C1.85031 -0.0643713 1.43262 -0.0643713 1.17513 0.193114L0.552166 0.81608C0.294955 1.07329 0.294681 1.48988 0.551067 1.74764L4.78377 5.99986L0.551342 10.2524C0.294681 10.5101 0.29523 10.9267 0.552441 11.1839L1.17541 11.8069C1.43289 12.0644 1.85059 12.0644 2.10807 11.8069L7.44849 6.46619C7.70597 6.20871 7.70597 5.79102 7.44849 5.53353Z"
        fill="black"
      />
    </svg>
  </div>
);

export const FlyoutOpenArrow = ({
  children,
  className,
  ...rest
}: IconProps) => (
  <div className={`${className || ''} cursor-pointer`}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      {children}
      <path
        d="M0 10C0 4.47715 4.47715 0 10 0H24V24H10C4.47715 24 0 19.5228 0 14V10Z"
        fill="#231F20"
      />
    </svg>
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`absolute top-[6px] left-[8px]`}
    >
      <path
        d="M0.551512 5.53353L5.8922 0.193114C6.14969 -0.0643713 6.56738 -0.0643713 6.82487 0.193114L7.44783 0.81608C7.70504 1.07329 7.70532 1.48988 7.44893 1.74764L3.21623 5.99986L7.44866 10.2524C7.70532 10.5101 7.70477 10.9267 7.44756 11.1839L6.82459 11.8069C6.56711 12.0644 6.14941 12.0644 5.89193 11.8069L0.551512 6.46619C0.294027 6.20871 0.294027 5.79102 0.551512 5.53353Z"
        fill="white"
      />
    </svg>
  </div>
);

export const FlyoutCloseArrow = ({
  children,
  className,
  ...rest
}: IconProps) => (
  <div className={`${className || ''} cursor-pointer`}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      {children}
      <path
        d="M0 10C0 4.47715 4.47715 0 10 0H24V24H10C4.47715 24 0 19.5228 0 14V10Z"
        fill="#231F20"
      />
    </svg>
    <svg
      width="10"
      height="14"
      viewBox="0 0 384 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`absolute top-[5px] left-[8px]`}
    >
      <path
        d="M342.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L274.7 256 105.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
        fill="white"
      />
    </svg>
  </div>
);

export const MultiSelectIconBlank = ({ children, ...rest }: IconProps) => (
  <svg
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M15.8333 2.5H4.16667C3.24167 2.5 2.5 3.24167 2.5 4.16667V15.8333c0 .4421.17559.866.48816 1.1785.31256.3126.73648.4882 1.17851.4882H15.8333c.4421 0 .866-.1756 1.1785-.4882.3126-.3125.4882-.7364.4882-1.1785V4.16667c0-.44203-.1756-.86595-.4882-1.17851-.3125-.31257-.7364-.48816-1.1785-.48816zm0 1.66667V15.8333H4.16667V4.16667H15.8333z"
      fill="#CCC"
    />
  </svg>
);

export const MultiSelectIconFilled = ({ children, ...rest }: IconProps) => (
  <svg
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M8.33333 14.1667L4.16667 10l1.175-1.18333 2.99166 2.99163 6.32497-6.32497 1.175 1.18334-7.49997 7.50003zM15.8333 2.5H4.16667C3.24167 2.5 2.5 3.24167 2.5 4.16667V15.8333c0 .4421.17559.866.48816 1.1785.31256.3126.73648.4882 1.17851.4882H15.8333c.4421 0 .866-.1756 1.1785-.4882.3126-.3125.4882-.7364.4882-1.1785V4.16667c0-.44203-.1756-.86595-.4882-1.17851-.3125-.31257-.7364-.48816-1.1785-.48816z"
      fill="#231F20"
    />
  </svg>
);

export const MultiSelectDisabledIcon = ({ children, ...rest }: IconProps) => (
  <svg
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M8.33333 14.1667L4.16667 10l1.175-1.18333 2.99166 2.99163 6.32497-6.32497 1.175 1.18334-7.49997 7.50003zM15.8333 2.5H4.16667C3.24167 2.5 2.5 3.24167 2.5 4.16667V15.8333c0 .4421.17559.866.48816 1.1785.31256.3126.73648.4882 1.17851.4882H15.8333c.4421 0 .866-.1756 1.1785-.4882.3126-.3125.4882-.7364.4882-1.1785V4.16667c0-.44203-.1756-.86595-.4882-1.17851-.3125-.31257-.7364-.48816-1.1785-.48816z"
      fill="#CCCCCC"
    />
  </svg>
);

export const CheckIcon = ({
  className,
  children,
  width,
  height,
  size,
  ...rest
}: IconProps) => (
  <>
    {size === 'small' ? (
      <svg
        width={width || '32'}
        height={height || '32'}
        viewBox="0 0 32 32"
        fill="#FF5000"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className ? className : ''} block mx-auto`}
        {...rest}
      >
        {children}
        <circle
          cx="16"
          cy="16"
          r="15"
          fill="#FF5000"
          stroke="#FF5000"
          strokeWidth="2"
        />
        <path
          d="M9.14258 17.1973L14.3997 21.551L22.8569 11.7551"
          stroke="white"
          strokeWidth="4"
          strokeLinecap="round"
        />
      </svg>
    ) : (
      <svg
        width={width || '49'}
        height={height || '49'}
        viewBox="0 0 49 49"
        fill="#FF5000"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className ? className : ''} block mx-auto`}
      >
        <circle
          cx="24.5"
          cy="24.5"
          r="23.5"
          fill="#FF5000"
          stroke="#FF5000"
          strokeWidth="2"
        />
        <path
          d="M14 25.3333L22.05 32L35 17"
          stroke="white"
          strokeWidth="4"
          strokeLinecap="round"
          fill="#FF5000"
        />
      </svg>
    )}
  </>
);

export const SetupIcon = ({
  children,
  className,
  fill,
  outline,
  stroke,
  size,
  ...rest
}: IconProps) => (
  <>
    {size === 'small' ? (
      <div className={`${className ? className : ''} relative block mx-auto`}>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...rest}
        >
          {children}
          <circle
            cx="16"
            cy="16"
            r="15"
            fill={fill}
            stroke={outline}
            strokeWidth="2"
          />
        </svg>
        <svg
          width="19"
          height="15"
          viewBox="0 0 19 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`absolute top-[8px] left-[7px]`}
        >
          <path
            d="M9.2481 3.83302L3.16692 8.84158V14.2473C3.16692 14.3872 3.22252 14.5215 3.32149 14.6204C3.42046 14.7194 3.55469 14.775 3.69465 14.775L7.39079 14.7654C7.5303 14.7647 7.66385 14.7088 7.76225 14.6099C7.86065 14.511 7.91589 14.3772 7.91589 14.2377V11.0808C7.91589 10.9409 7.97149 10.8066 8.07046 10.7077C8.16943 10.6087 8.30366 10.5531 8.44363 10.5531H10.5546C10.6945 10.5531 10.8288 10.6087 10.9277 10.7077C11.0267 10.8066 11.0823 10.9409 11.0823 11.0808V14.2354C11.0821 14.3048 11.0956 14.3736 11.122 14.4378C11.1484 14.5021 11.1873 14.5604 11.2363 14.6096C11.2853 14.6588 11.3436 14.6978 11.4077 14.7244C11.4718 14.7511 11.5406 14.7648 11.6101 14.7648L15.3049 14.775C15.4448 14.775 15.5791 14.7194 15.678 14.6204C15.777 14.5215 15.8326 14.3872 15.8326 14.2473V8.83795L9.75275 3.83302C9.68127 3.77541 9.59223 3.74399 9.50042 3.74399C9.40862 3.74399 9.31958 3.77541 9.2481 3.83302ZM18.8539 7.23726L16.0965 4.96436V0.395803C16.0965 0.290829 16.0548 0.190156 15.9805 0.115928C15.9063 0.0417006 15.8056 0 15.7007 0H13.8536C13.7486 0 13.6479 0.0417006 13.5737 0.115928C13.4995 0.190156 13.4578 0.290829 13.4578 0.395803V2.79074L10.5048 0.36117C10.2214 0.127969 9.86578 0.000466172 9.49877 0.000466172C9.13177 0.000466172 8.77616 0.127969 8.49277 0.36117L0.143643 7.23726C0.103564 7.27038 0.0704047 7.31108 0.0460602 7.35703C0.0217157 7.40297 0.00666293 7.45327 0.00176203 7.50503C-0.00313887 7.5568 0.00220814 7.60902 0.0174975 7.65872C0.0327869 7.70842 0.057719 7.75462 0.0908693 7.79468L0.93195 8.81717C0.96501 8.85737 1.00567 8.89065 1.05161 8.91512C1.09755 8.93958 1.14787 8.95474 1.19968 8.95974C1.25148 8.96473 1.30377 8.95946 1.35353 8.94422C1.4033 8.92898 1.44957 8.90408 1.4897 8.87093L9.2481 2.4807C9.31958 2.42308 9.40862 2.39166 9.50042 2.39166C9.59223 2.39166 9.68127 2.42308 9.75275 2.4807L17.5115 8.87093C17.5515 8.90408 17.5977 8.92902 17.6474 8.9443C17.6971 8.95959 17.7494 8.96494 17.8011 8.96004C17.8529 8.95514 17.9032 8.94009 17.9491 8.91574C17.9951 8.8914 18.0358 8.85824 18.0689 8.81816L18.91 7.79567C18.9431 7.75538 18.9679 7.70894 18.983 7.65902C18.9981 7.60911 19.0032 7.5567 18.998 7.50481C18.9928 7.45291 18.9774 7.40256 18.9527 7.35665C18.9279 7.31073 18.8944 7.27016 18.8539 7.23726Z"
            fill={stroke}
          />
        </svg>
      </div>
    ) : (
      <div className={`${className ? className : ''} relative block mx-auto`}>
        <svg
          width="49"
          height="49"
          viewBox="0 0 49 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="24.5"
            cy="24.5"
            r="23.5"
            fill={fill}
            stroke={outline}
            strokeWidth="2"
          />
        </svg>
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill={fill}
          xmlns="http://www.w3.org/2000/svg"
          className={`absolute top-[9px] left-[9px]`}
        >
          <path
            d="M14.6023 9.38759L5.0004 17.2958V25.8311C5.0004 26.0521 5.08819 26.2641 5.24445 26.4203C5.40072 26.5766 5.61267 26.6644 5.83366 26.6644L11.6697 26.6493C11.8899 26.6482 12.1008 26.5599 12.2562 26.4038C12.4116 26.2476 12.4988 26.0363 12.4988 25.816V20.8315C12.4988 20.6105 12.5866 20.3986 12.7428 20.2423C12.8991 20.086 13.111 19.9982 13.332 19.9982H16.6651C16.8861 19.9982 17.0981 20.086 17.2543 20.2423C17.4106 20.3986 17.4984 20.6105 17.4984 20.8315V25.8124C17.498 25.922 17.5193 26.0306 17.5611 26.132C17.6028 26.2334 17.6641 26.3256 17.7415 26.4033C17.8189 26.4809 17.9109 26.5425 18.0122 26.5846C18.1134 26.6266 18.222 26.6482 18.3317 26.6482L24.1656 26.6644C24.3866 26.6644 24.5985 26.5766 24.7548 26.4203C24.9111 26.2641 24.9989 26.0521 24.9989 25.8311V17.2901L15.3991 9.38759C15.2862 9.29662 15.1456 9.24701 15.0007 9.24701C14.8557 9.24701 14.7151 9.29662 14.6023 9.38759ZM29.7693 14.7627L25.4155 11.1739V3.9604C25.4155 3.79465 25.3496 3.63569 25.2324 3.51849C25.1152 3.40129 24.9563 3.33545 24.7905 3.33545H21.8741C21.7083 3.33545 21.5494 3.40129 21.4322 3.51849C21.315 3.63569 21.2491 3.79465 21.2491 3.9604V7.74188L16.5865 3.90572C16.139 3.53751 15.5775 3.33619 14.9981 3.33619C14.4186 3.33619 13.8571 3.53751 13.4096 3.90572L0.226805 14.7627C0.163522 14.815 0.111165 14.8793 0.0727266 14.9518C0.0342879 15.0244 0.0105204 15.1038 0.00278216 15.1855C-0.0049561 15.2672 0.00348653 15.3497 0.0276277 15.4282C0.0517688 15.5066 0.0911353 15.5796 0.143478 15.6428L1.4715 17.2573C1.5237 17.3208 1.58791 17.3733 1.66044 17.4119C1.73298 17.4506 1.81242 17.4745 1.89422 17.4824C1.97603 17.4903 2.05858 17.482 2.13716 17.4579C2.21574 17.4338 2.2888 17.3945 2.35216 17.3422L14.6023 7.25234C14.7151 7.16137 14.8557 7.11176 15.0007 7.11176C15.1456 7.11176 15.2862 7.16137 15.3991 7.25234L27.6497 17.3422C27.7129 17.3945 27.7859 17.4339 27.8644 17.458C27.9428 17.4822 28.0253 17.4906 28.107 17.4829C28.1888 17.4751 28.2682 17.4514 28.3407 17.4129C28.4133 17.3745 28.4775 17.3221 28.5298 17.2589L29.8579 15.6444C29.9101 15.5808 29.9493 15.5075 29.9732 15.4286C29.9971 15.3498 30.0051 15.2671 29.9969 15.1851C29.9886 15.1032 29.9643 15.0237 29.9253 14.9512C29.8862 14.8787 29.8332 14.8146 29.7693 14.7627Z"
            fill={stroke}
          />
        </svg>
      </div>
    )}
  </>
);

export const AudienceIcon = ({
  children,
  className,
  fill,
  stroke,
  outline,
  size,
  ...rest
}: IconProps) => (
  <>
    {size === 'small' ? (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className ? className : ''} block mx-auto`}
        {...rest}
      >
        {children}
        <circle
          cx="16"
          cy="16"
          r="15"
          fill={fill}
          stroke={outline}
          strokeWidth="2"
        />
        <path
          d="M18.2459 14.8574C19.0344 14.8574 19.6744 15.4974 19.6744 16.286V18.9391H19.6712V19.7554H12.3242V17.3064H12.3259V16.286C12.3259 15.4974 12.965 14.8574 13.7544 14.8574H18.2459Z"
          fill={stroke}
        />
        <path
          d="M24.1622 16.286C24.1622 15.9071 24.0117 15.5437 23.7438 15.2758C23.4759 15.0079 23.1125 14.8574 22.7336 14.8574H19.9785C20.2993 15.2452 20.492 15.7431 20.492 16.286V17.3064H20.4887V19.7554H23.5499C23.7123 19.7554 23.868 19.6909 23.9829 19.5761C24.0977 19.4612 24.1622 19.3055 24.1622 19.1431V16.286Z"
          fill={stroke}
        />
        <path
          d="M11.5094 18.9391H11.511V16.286L11.5184 16.1064C11.5551 15.6329 11.7388 15.2019 12.0245 14.8574H9.26451L9.14696 14.8623C8.78965 14.8918 8.4565 15.0546 8.21364 15.3183C7.97077 15.5821 7.83595 15.9275 7.83594 16.286V19.1431C7.83594 19.4811 8.11022 19.7554 8.44818 19.7554H11.5094V18.9391Z"
          fill={stroke}
        />
        <path
          d="M15.9998 9.14282C16.6493 9.14282 17.2722 9.40084 17.7315 9.86011C18.1907 10.3194 18.4487 10.9423 18.4487 11.5918C18.4487 12.2413 18.1907 12.8642 17.7315 13.3235C17.2722 13.7828 16.6493 14.0408 15.9998 14.0408C15.3503 14.0408 14.7273 13.7828 14.2681 13.3235C13.8088 12.8642 13.5508 12.2413 13.5508 11.5918C13.5508 10.9423 13.8088 10.3194 14.2681 9.86011C14.7273 9.40084 15.3503 9.14282 15.9998 9.14282Z"
          fill={stroke}
        />
        <path
          d="M21.3064 9.95947C21.8477 9.95947 22.3668 10.1745 22.7495 10.5572C23.1322 10.9399 23.3473 11.459 23.3473 12.0003C23.3473 12.5415 23.1322 13.0606 22.7495 13.4434C22.3668 13.8261 21.8477 14.0411 21.3064 14.0411C20.7652 14.0411 20.2461 13.8261 19.8634 13.4434C19.4806 13.0606 19.2656 12.5415 19.2656 12.0003C19.2656 11.459 19.4806 10.9399 19.8634 10.5572C20.2461 10.1745 20.7652 9.95947 21.3064 9.95947Z"
          fill={stroke}
        />
        <path
          d="M10.6932 9.95947C11.2344 9.95947 11.7535 10.1745 12.1362 10.5572C12.519 10.9399 12.734 11.459 12.734 12.0003C12.734 12.5415 12.519 13.0606 12.1362 13.4434C11.7535 13.8261 11.2344 14.0411 10.6932 14.0411C10.1519 14.0411 9.63281 13.8261 9.25009 13.4434C8.86736 13.0606 8.65234 12.5415 8.65234 12.0003C8.65234 11.459 8.86736 10.9399 9.25009 10.5572C9.63281 10.1745 10.1519 9.95947 10.6932 9.95947Z"
          fill={stroke}
        />
        <path
          d="M7.83594 21.184C7.83594 21.0216 7.90044 20.8659 8.01526 20.7511C8.13008 20.6363 8.28581 20.5718 8.44818 20.5718H23.5502C23.7126 20.5718 23.8683 20.6363 23.9831 20.7511C24.098 20.8659 24.1625 21.0216 24.1625 21.184V21.5922C24.1625 22.4041 23.84 23.1827 23.2659 23.7568C22.6918 24.3309 21.9131 24.6534 21.1012 24.6534H10.8972C10.0853 24.6534 9.30664 24.3309 8.73255 23.7568C8.15846 23.1827 7.83594 22.4041 7.83594 21.5922V21.184Z"
          fill={stroke}
        />
      </svg>
    ) : (
      <svg
        width="49"
        height="49"
        viewBox="0 0 49 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className ? className : ''} block mx-auto`}
        {...rest}
      >
        {children}
        <circle
          cx="24.5"
          cy="24.5"
          r="23.5"
          fill={fill}
          stroke={outline}
          strokeWidth="2"
        />
        <path
          d="M27.9425 21.75C29.15 21.75 30.13 22.73 30.13 23.9375V28H30.125V29.25H18.875V25.5H18.8775V23.9375C18.8775 22.73 19.8562 21.75 21.065 21.75H27.9425Z"
          fill={stroke}
        />
        <path
          d="M37 23.9375C37 23.3573 36.7695 22.8009 36.3593 22.3907C35.9491 21.9805 35.3927 21.75 34.8125 21.75H30.5938C31.085 22.3438 31.38 23.1062 31.38 23.9375V25.5H31.375V29.25H36.0625C36.3111 29.25 36.5496 29.1512 36.7254 28.9754C36.9012 28.7996 37 28.5611 37 28.3125V23.9375Z"
          fill={stroke}
        />
        <path
          d="M17.625 28H17.6275V23.9375L17.6387 23.6625C17.695 22.9375 17.9762 22.2775 18.4137 21.75H14.1875L14.0075 21.7575C13.4604 21.8027 12.9502 22.0519 12.5783 22.4558C12.2065 22.8596 12 23.3885 12 23.9375V28.3125C12 28.83 12.42 29.25 12.9375 29.25H17.625V28Z"
          fill={stroke}
        />
        <path
          d="M24.5 13C25.4946 13 26.4484 13.3951 27.1517 14.0983C27.8549 14.8016 28.25 15.7554 28.25 16.75C28.25 17.7446 27.8549 18.6984 27.1517 19.4017C26.4484 20.1049 25.4946 20.5 24.5 20.5C23.5054 20.5 22.5516 20.1049 21.8483 19.4017C21.1451 18.6984 20.75 17.7446 20.75 16.75C20.75 15.7554 21.1451 14.8016 21.8483 14.0983C22.5516 13.3951 23.5054 13 24.5 13Z"
          fill={stroke}
        />
        <path
          d="M32.625 14.25C33.4538 14.25 34.2487 14.5792 34.8347 15.1653C35.4208 15.7513 35.75 16.5462 35.75 17.375C35.75 18.2038 35.4208 18.9987 34.8347 19.5847C34.2487 20.1708 33.4538 20.5 32.625 20.5C31.7962 20.5 31.0013 20.1708 30.4153 19.5847C29.8292 18.9987 29.5 18.2038 29.5 17.375C29.5 16.5462 29.8292 15.7513 30.4153 15.1653C31.0013 14.5792 31.7962 14.25 32.625 14.25Z"
          fill={stroke}
        />
        <path
          d="M16.375 14.25C17.2038 14.25 17.9987 14.5792 18.5847 15.1653C19.1708 15.7513 19.5 16.5462 19.5 17.375C19.5 18.2038 19.1708 18.9987 18.5847 19.5847C17.9987 20.1708 17.2038 20.5 16.375 20.5C15.5462 20.5 14.7513 20.1708 14.1653 19.5847C13.5792 18.9987 13.25 18.2038 13.25 17.375C13.25 16.5462 13.5792 15.7513 14.1653 15.1653C14.7513 14.5792 15.5462 14.25 16.375 14.25Z"
          fill={stroke}
        />
        <path
          d="M12 31.4375C12 31.1889 12.0988 30.9504 12.2746 30.7746C12.4504 30.5988 12.6889 30.5 12.9375 30.5H36.0625C36.3111 30.5 36.5496 30.5988 36.7254 30.7746C36.9012 30.9504 37 31.1889 37 31.4375V32.0625C37 33.3057 36.5061 34.498 35.6271 35.3771C34.748 36.2561 33.5557 36.75 32.3125 36.75H16.6875C15.4443 36.75 14.252 36.2561 13.3729 35.3771C12.4939 34.498 12 33.3057 12 32.0625V31.4375Z"
          fill={stroke}
        />
      </svg>
    )}
  </>
);

export const SpendIcon = ({
  children,
  className,
  fill,
  stroke,
  outline,
  size,
  ...rest
}: IconProps) => (
  <>
    {size === 'small' ? (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
        className={`${className ? className : ''} block mx-auto`}
        {...rest}
      >
        {children}
        <circle
          cx="16"
          cy="16"
          r="15"
          fill={fill}
          stroke={outline}
          strokeWidth="2"
        />
        <path
          d="M20.5989 15.7305C22.6621 15.7305 24.3346 14.7804 24.3346 13.6083C24.3346 12.4362 22.6621 11.4861 20.5989 11.4861C18.5358 11.4861 16.8633 12.4362 16.8633 13.6083C16.8633 14.7804 18.5358 15.7305 20.5989 15.7305Z"
          fill={stroke}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6556 16.9519C17.9837 16.9519 16.9199 15.8322 16.9199 15.1836V17.9619C16.9199 19.1344 18.5925 20.0831 20.6556 20.0831C22.7208 20.0831 24.3934 19.1344 24.3934 17.9619V15.2503C24.3934 15.9 23.3285 16.9519 20.6556 16.9519Z"
          fill={stroke}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6556 21.2447C18.2655 21.2447 16.9199 20.168 16.9199 19.5194V22.272C16.9199 23.4444 18.5925 24.3942 20.6556 24.3942C22.7208 24.3942 24.3934 23.4444 24.3934 22.272V19.4861C24.3934 20.1347 23.0467 21.2447 20.6556 21.2447Z"
          fill={stroke}
        />
        <path
          d="M11.4183 11.428C13.7571 11.428 15.6531 10.4779 15.6531 9.30581C15.6531 8.13374 13.7571 7.18359 11.4183 7.18359C9.07956 7.18359 7.18359 8.13374 7.18359 9.30581C7.18359 10.4779 9.07956 11.428 11.4183 11.428Z"
          fill={stroke}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5531 12.6485C8.52522 12.6485 7.31836 11.5287 7.31836 10.8801V13.6585C7.31836 14.8309 9.2147 15.7796 11.5531 15.7796C13.8937 15.7796 15.7889 14.8309 15.7889 13.6585V10.9468C15.7889 11.5965 14.581 12.6485 11.5531 12.6485Z"
          fill={stroke}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5531 16.9422C8.8436 16.9422 7.31836 15.8655 7.31836 15.2169V17.9695C7.31836 19.1419 9.2147 20.0917 11.5531 20.0917C13.8937 20.0917 15.7889 19.1419 15.7889 17.9695V15.1836C15.7889 15.8322 14.2616 16.9422 11.5531 16.9422Z"
          fill={stroke}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5531 21.2447C8.8436 21.2447 7.31836 20.168 7.31836 19.5194V22.272C7.31836 23.4444 9.2147 24.3942 11.5531 24.3942C13.8937 24.3942 15.7889 23.4444 15.7889 22.272V19.4861C15.7889 20.1347 14.2616 21.2447 11.5531 21.2447Z"
          fill={stroke}
        />
      </svg>
    ) : (
      <svg
        width="49"
        height="49"
        viewBox="0 0 49 49"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
        className={`${className ? className : ''} block mx-auto`}
        {...rest}
      >
        {children}
        <circle
          cx="24.5"
          cy="24.5"
          r="23.5"
          fill={fill}
          stroke={outline}
          strokeWidth="2"
        />
        <path
          d="M31.5445 24.0872C34.7036 24.0872 37.2647 22.6323 37.2647 20.8375C37.2647 19.0428 34.7036 17.5879 31.5445 17.5879C28.3853 17.5879 25.8242 19.0428 25.8242 20.8375C25.8242 22.6323 28.3853 24.0872 31.5445 24.0872Z"
          fill={stroke}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.6304 25.9568C27.5391 25.9568 25.9102 24.2422 25.9102 23.249V27.5034C25.9102 29.2987 28.4713 30.7514 31.6304 30.7514C34.7927 30.7514 37.3539 29.2987 37.3539 27.5034V23.3511C37.3539 24.346 35.7233 25.9568 31.6304 25.9568Z"
          fill={stroke}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.6304 32.5308C27.9706 32.5308 25.9102 30.8821 25.9102 29.8889V34.1038C25.9102 35.8991 28.4713 37.3534 31.6304 37.3534C34.7927 37.3534 37.3539 35.8991 37.3539 34.1038V29.8379C37.3539 30.8311 35.2918 32.5308 31.6304 32.5308Z"
          fill={stroke}
        />
        <path
          d="M17.4845 17.4993C21.0657 17.4993 23.9689 16.0444 23.9689 14.2496C23.9689 12.4549 21.0657 11 17.4845 11C13.9032 11 11 12.4549 11 14.2496C11 16.0444 13.9032 17.4993 17.4845 17.4993Z"
          fill={stroke}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.6895 19.3689C13.0531 19.3689 11.2051 17.6543 11.2051 16.6611V20.9155C11.2051 22.7108 14.1088 24.1635 17.6895 24.1635C21.2735 24.1635 24.1757 22.7108 24.1757 20.9155V16.7633C24.1757 17.7581 22.326 19.3689 17.6895 19.3689Z"
          fill={stroke}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.6895 25.942C13.5406 25.942 11.2051 24.2933 11.2051 23.3001V27.5149C11.2051 29.3102 14.1088 30.7646 17.6895 30.7646C21.2735 30.7646 24.1757 29.3102 24.1757 27.5149V23.249C24.1757 24.2422 21.8368 25.942 17.6895 25.942Z"
          fill={stroke}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.6895 32.5308C13.5406 32.5308 11.2051 30.8821 11.2051 29.8889V34.1038C11.2051 35.8991 14.1088 37.3534 17.6895 37.3534C21.2735 37.3534 24.1757 35.8991 24.1757 34.1038V29.8379C24.1757 30.8311 21.8368 32.5308 17.6895 32.5308Z"
          fill={stroke}
        />
      </svg>
    )}
  </>
);

export const ReviewAndSaveIcon = ({
  children,
  className,
  fill,
  stroke,
  outline,
  size,
  ...rest
}: IconProps) => (
  <>
    {size === 'small' ? (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
        className={`${className ? className : ''} block mx-auto`}
        {...rest}
      >
        {children}
        <circle
          cx="16"
          cy="16"
          r="15"
          fill={fill}
          stroke={outline}
          strokeWidth="2"
        />
        <path
          d="M22.5293 23.5248H11.7542C11.4787 23.5248 11.2465 23.4305 11.0578 23.2417C10.869 23.0529 10.7746 22.8208 10.7746 22.5453V21.3055C9.90729 20.9892 9.20068 20.4535 8.65478 19.6985C8.10889 18.9434 7.83594 18.0914 7.83594 17.1424C7.83594 16.1935 8.10889 15.3415 8.65478 14.5864C9.20068 13.8313 9.90729 13.3007 10.7746 12.9946V8.83153C10.7746 8.56623 10.869 8.33665 11.0578 8.14278C11.2465 7.94891 11.4787 7.85198 11.7542 7.85198H17.6315V13.2395C17.6315 13.3722 17.6799 13.487 17.7769 13.5839C17.8738 13.6808 17.9886 13.7293 18.1213 13.7293H23.4935L23.5088 13.7446V22.5453C23.5088 22.8106 23.4119 23.0402 23.218 23.234C23.0241 23.4279 22.7946 23.5248 22.5293 23.5248ZM17.509 21.1525L15.1979 18.8567C15.5142 18.3159 15.6724 17.7445 15.6724 17.1424C15.6724 16.2037 15.3382 15.3976 14.6699 14.7242C14.0015 14.0507 13.1929 13.714 12.2439 13.714C11.295 13.714 10.4863 14.0482 9.818 14.7165C9.14966 15.3849 8.81549 16.1935 8.81549 17.1424C8.81549 18.0914 9.14966 18.9 9.818 19.5684C10.4863 20.2367 11.295 20.5709 12.2439 20.5709C12.8357 20.5709 13.4072 20.4127 13.9582 20.0964L16.254 22.4075C16.3356 22.4892 16.4377 22.53 16.5601 22.53C16.6825 22.53 16.7897 22.4892 16.8815 22.4075L17.509 21.78C17.5907 21.6984 17.6315 21.5963 17.6315 21.4739C17.6315 21.3515 17.5907 21.2443 17.509 21.1525ZM12.2439 19.5913C11.5705 19.5913 10.994 19.3541 10.5144 18.8796C10.0348 18.4051 9.79505 17.8286 9.79505 17.1501C9.79505 16.4715 10.0348 15.8925 10.5144 15.4129C10.994 14.9333 11.5705 14.6936 12.2439 14.6936C12.9174 14.6936 13.4939 14.9333 13.9735 15.4129C14.453 15.8925 14.6928 16.4715 14.6928 17.1501C14.6928 17.8286 14.453 18.4051 13.9735 18.8796C13.4939 19.3541 12.9174 19.5913 12.2439 19.5913ZM18.611 7.83667C18.8763 7.84687 19.1008 7.94381 19.2845 8.12748L23.218 12.061C23.4119 12.2549 23.5037 12.4845 23.4935 12.7497H18.611V7.83667Z"
          fill={stroke}
        />
      </svg>
    ) : (
      <svg
        width="49"
        height="49"
        viewBox="0 0 49 49"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
        className={`${className ? className : ''} block mx-auto`}
        {...rest}
      >
        {children}
        <circle
          cx="24.5"
          cy="24.5"
          r="23.5"
          fill={fill}
          stroke={outline}
          strokeWidth="2"
        />
        <path
          d="M34.4991 36.0225H17.9998C17.5779 36.0225 17.2225 35.878 16.9334 35.5889C16.6444 35.2999 16.4998 34.9444 16.4998 34.5226V32.6242C15.1718 32.1399 14.0898 31.3196 13.2539 30.1634C12.418 29.0072 12 27.7025 12 26.2495C12 24.7964 12.418 23.4917 13.2539 22.3355C14.0898 21.1793 15.1718 20.3669 16.4998 19.8981V13.5234C16.4998 13.1171 16.6444 12.7656 16.9334 12.4687C17.2225 12.1719 17.5779 12.0234 17.9998 12.0234H26.9994V20.2731C26.9994 20.4762 27.0736 20.652 27.2221 20.8004C27.3705 20.9489 27.5463 21.0231 27.7494 21.0231H35.9756L35.9991 21.0465V34.5226C35.9991 34.9288 35.8507 35.2804 35.5538 35.5772C35.2569 35.8741 34.9054 36.0225 34.4991 36.0225ZM26.8119 32.3898L23.273 28.8744C23.7574 28.0463 23.9995 27.1713 23.9995 26.2495C23.9995 24.812 23.4878 23.5777 22.4644 22.5465C21.441 21.5153 20.2028 20.9997 18.7497 20.9997C17.2967 20.9997 16.0584 21.5114 15.035 22.5348C14.0116 23.5582 13.4999 24.7964 13.4999 26.2495C13.4999 27.7025 14.0116 28.9408 15.035 29.9642C16.0584 30.9876 17.2967 31.4993 18.7497 31.4993C19.656 31.4993 20.5309 31.2571 21.3746 30.7727L24.8901 34.3116C25.0151 34.4366 25.1714 34.4991 25.3589 34.4991C25.5464 34.4991 25.7104 34.4366 25.851 34.3116L26.8119 33.3507C26.9369 33.2258 26.9994 33.0695 26.9994 32.882C26.9994 32.6945 26.9369 32.5305 26.8119 32.3898ZM18.7497 29.9993C17.7185 29.9993 16.8358 29.636 16.1014 28.9095C15.3671 28.183 14.9999 27.3002 14.9999 26.2612C14.9999 25.2222 15.3671 24.3355 16.1014 23.6011C16.8358 22.8668 17.7185 22.4996 18.7497 22.4996C19.781 22.4996 20.6637 22.8668 21.3981 23.6011C22.1324 24.3355 22.4996 25.2222 22.4996 26.2612C22.4996 27.3002 22.1324 28.183 21.3981 28.9095C20.6637 29.636 19.781 29.9993 18.7497 29.9993ZM28.4994 12C28.9056 12.0156 29.2493 12.1641 29.5306 12.4453L35.5538 18.4685C35.8507 18.7654 35.9913 19.1169 35.9756 19.5232H28.4994V12Z"
          fill={stroke}
        />
      </svg>
    )}
  </>
);

export const LoadingFileIcon = ({ children, ...rest }: IconProps) => (
  <svg
    width="18"
    height="18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M9 .28125C4.18359.28125.28125 4.18359.28125 9c0 4.8164 3.90234 8.7188 8.71875 8.7188 4.8164 0 8.7188-3.9024 8.7188-8.7188C17.7188 4.18359 13.8164.28125 9 .28125zm4.275 11.00745c.1652.1652.1652.4324 0 .5976l-1.3922 1.3887c-.1652.1652-.4324.1652-.5976 0L9 10.9688 6.71133 13.275c-.16524.1652-.43242.1652-.59766 0L4.725 11.8828c-.16523-.1652-.16523-.4324 0-.5976L7.03125 9 4.725 6.71133c-.16523-.16524-.16523-.43242 0-.59766l1.39219-1.39219c.16523-.16523.43242-.16523.59765 0L9 7.03125 11.2887 4.725c.1652-.16523.4324-.16523.5976 0l1.3922 1.39219c.1653.16523.1653.43242 0 .59765L10.9688 9l2.3062 2.2887z"
      fill="#231F20"
    />
  </svg>
);

export const CloseFilterIcon = ({ children, ...rest }: IconProps) => (
  <svg
    width="13"
    height="13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M2.44768 12.5806c-.2689.2688-.63359.4199-1.01386.4199-.38028 0-.744973-.1511-1.013865-.4199C.151062 12.3117 0 11.947 0 11.5667c0-.1883.0370868-.3747.109143-.5487.072056-.174.17767-.332.310812-.4652L10.5528.421388c.2687-.268893.6332-.42003041 1.0134-.42016477.3801-.00013437.7447.15074577 1.0136.41944877.2689.268702.4201.633218.4202 1.013358.0001.38013-.1507.74475-.4194 1.01365L2.44768 12.5791v.0015z"
      fill="#A3A5A7"
    />
    <path
      d="M.419955 2.44768c-.133142-.13315-.238756-.29121-.310812-.46517C.0370868 1.80855 0 1.62211 0 1.43382c0-.1883.0370868-.37474.109143-.548702C.181199.711159.286813.553097.419955.419955.553097.286813.711159.181199.885118.109143 1.05908.0370868 1.24552 0 1.43382 0c.18829 0 .37473.0370868.54869.109143.17396.072056.33202.17767.46517.310812L12.5791 10.5528c.2689.2687.4201.6332.4202 1.0134.0001.3801-.1508.7447-.4195 1.0136-.2687.2689-.6332.4201-1.0133.4202-.3802.0001-.7448-.1507-1.0137-.4194L.421388 2.44768H.419955z"
      fill="#A3A5A7"
    />
  </svg>
);

export const FiltersIcon = ({ children, ...rest }: IconProps) => (
  <svg
    width="18"
    height="18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M17.1554 0H.84473C.0952696 0-.282906.909351.248129 1.44039L6.74999 7.94324v7.24426c0 .2753.13434.5333.3599.6912l2.8125 1.9681c.55491.3884 1.32761-.0053 1.32761-.6913V7.94324l6.502-6.50285C18.282.910406 17.9064 0 17.1554 0z"
      fill="#4D4D4D"
    />
  </svg>
);

export const PlusSign = ({ children, ...rest }: IconProps) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M22.286 9.429H14.57V1.714C14.571.768 13.804 0 12.857 0h-1.714c-.947 0-1.714.768-1.714 1.714V9.43H1.714C.768 9.429 0 10.196 0 11.143v1.714c0 .947.768 1.714 1.714 1.714H9.43v7.715c0 .946.767 1.714 1.714 1.714h1.714c.947 0 1.714-.768 1.714-1.714V14.57h7.715c.946 0 1.714-.767 1.714-1.714v-1.714c0-.947-.768-1.714-1.714-1.714z"
      fill="#fff"
    />
  </svg>
);

export const MenuChevron = ({ children, ...rest }: IconProps) => (
  <svg
    width="10"
    height="7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M4.61138 5.9077L.160979 1.45728c-.2146388-.21464-.2146388-.562622 0-.777238L.680047.160974c.214273-.2142726.561543-.214685.776323-.000916L5.00001 3.6871 8.54363.160058c.21478-.213769.56205-.2133566.77632.000916l.51907.519068c.21468.214639.21468.562628 0 .777238L5.38864 5.9077c-.21464.21462-.56262.21462-.77726 0z"
      fill="gray"
    />
  </svg>
);

export const TableSuccessIcon = ({ children, ...rest }: IconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58171 16 0 12.4183 0 8C0 3.58171 3.58171 0 8 0C12.4183 0 16 3.58171 16 8ZM7.07464 12.2359L13.0101 6.30045C13.2117 6.0989 13.2117 5.7721 13.0101 5.57055L12.2802 4.84064C12.0787 4.63906 11.7519 4.63906 11.5503 4.84064L6.70968 9.68123L4.44971 7.42126C4.24816 7.21971 3.92135 7.21971 3.71977 7.42126L2.98987 8.15116C2.78832 8.35271 2.78832 8.67952 2.98987 8.88106L6.34471 12.2359C6.54629 12.4375 6.87306 12.4375 7.07464 12.2359Z"
      fill="#16A085"
    />
  </svg>
);

export const TableErrorIcon = ({ children, ...rest }: IconProps) => (
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M9.99993 12.5001C7.62962 12.5001 5.71087 10.6654 5.53431 8.34039L2.25618 5.80696C1.82524 6.34758 1.42868 6.91914 1.10868 7.54414C1.0372 7.68555 0.999949 7.84179 0.999949 8.00024C0.999949 8.15869 1.0372 8.31492 1.10868 8.45633C2.80337 11.7629 6.15837 14.0001 9.99993 14.0001C10.8409 14.0001 11.6521 13.8751 12.434 13.6732L10.8124 12.4185C10.5446 12.4703 10.2727 12.4976 9.99993 12.5001ZM19.8068 14.3157L16.3521 11.6457C17.4016 10.7613 18.2646 9.67705 18.8912 8.45602C18.9627 8.31461 18.9999 8.15838 18.9999 7.99993C18.9999 7.84147 18.9627 7.68524 18.8912 7.54383C17.1965 4.23727 13.8415 2.00008 9.99993 2.00008C8.39103 2.00203 6.80825 2.40707 5.39618 3.17821L1.42056 0.105395C1.36871 0.0650531 1.30943 0.0353228 1.24609 0.0179024C1.18276 0.000481963 1.11661 -0.00428704 1.05142 0.00386788C0.986243 0.0120228 0.923308 0.0329418 0.866214 0.0654295C0.809121 0.0979172 0.758989 0.141337 0.718682 0.193207L0.105245 0.982895C0.0238694 1.08758 -0.0125944 1.2203 0.00387316 1.35186C0.0203407 1.48342 0.088391 1.60306 0.193057 1.68446L18.5793 15.8948C18.6312 15.9351 18.6904 15.9648 18.7538 15.9823C18.8171 15.9997 18.8833 16.0045 18.9484 15.9963C19.0136 15.9881 19.0766 15.9672 19.1337 15.9347C19.1907 15.9022 19.2409 15.8588 19.2812 15.807L19.8949 15.0173C19.9763 14.9125 20.0127 14.7798 19.9962 14.6482C19.9796 14.5167 19.9115 14.3971 19.8068 14.3157ZM14.0656 9.87821L12.8374 8.92883C12.9409 8.62992 12.9957 8.31636 12.9999 8.00008C13.006 7.53704 12.9034 7.07902 12.7004 6.66281C12.4974 6.24661 12.1996 5.88382 11.8309 5.60359C11.4623 5.32336 11.033 5.13349 10.5776 5.04925C10.1223 4.96501 9.65352 4.98873 9.20899 5.11852C9.39744 5.37386 9.49937 5.68273 9.49993 6.00008C9.49527 6.10569 9.47913 6.21047 9.45181 6.31258L7.15149 4.53477C7.95055 3.86702 8.9586 3.50085 9.99993 3.50008C10.591 3.49975 11.1763 3.61592 11.7224 3.84195C12.2685 4.06798 12.7647 4.39944 13.1826 4.81737C13.6006 5.2353 13.932 5.7315 14.1581 6.27762C14.3841 6.82373 14.5003 7.40904 14.4999 8.00008C14.4999 8.67602 14.3346 9.30602 14.0656 9.87852V9.87821Z"
      fill="#DF2A2A"
    />
  </svg>
);

export const TableWarningIcon = ({ children, ...rest }: IconProps) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M8.09084 0.234674C8.50551 0.005073 8.99174 -0.0589637 9.4517 0.0554483C9.91167 0.16986 10.3112 0.45423 10.57 0.85134L10.6392 0.96634L17.105 12.6405C17.2577 12.9164 17.3383 13.2263 17.3394 13.5416C17.3405 13.8569 17.2621 14.1674 17.1114 14.4444C16.9607 14.7214 16.7426 14.9558 16.4773 15.1262C16.2119 15.2965 15.9079 15.3972 15.5933 15.4188L15.465 15.4238H2.53501C2.21997 15.424 1.90998 15.3447 1.63366 15.1934C1.35733 15.0421 1.12359 14.8236 0.954006 14.5581C0.784425 14.2926 0.684475 13.9887 0.663386 13.6744C0.642297 13.36 0.700749 13.0454 0.833345 12.7597L0.893345 12.6405L7.35834 0.96634C7.529 0.658538 7.78285 0.404982 8.09084 0.234674ZM9.00001 11.2513C8.88853 11.2478 8.77747 11.2667 8.67343 11.307C8.5694 11.3472 8.4745 11.4079 8.39439 11.4855C8.31428 11.5631 8.25059 11.6561 8.20709 11.7588C8.16359 11.8615 8.14117 11.9719 8.14117 12.0834C8.14117 12.195 8.16359 12.3054 8.20709 12.4081C8.25059 12.5108 8.31428 12.6037 8.39439 12.6813C8.4745 12.7589 8.5694 12.8197 8.67343 12.8599C8.77747 12.9001 8.88853 12.919 9.00001 12.9155C9.21614 12.9087 9.42112 12.818 9.57158 12.6627C9.72204 12.5074 9.80618 12.2997 9.80618 12.0834C9.80618 11.8672 9.72204 11.6594 9.57158 11.5041C9.42112 11.3488 9.21614 11.2582 9.00001 11.2513ZM8.99834 4.58134C8.79411 4.58139 8.597 4.65644 8.44445 4.79225C8.2919 4.92805 8.19454 5.11515 8.17084 5.31801L8.16668 5.41467V9.58301L8.17251 9.68051C8.1958 9.88376 8.29305 10.0714 8.44572 10.2075C8.5984 10.3437 8.79584 10.419 9.00043 10.419C9.20502 10.419 9.40245 10.3437 9.55513 10.2075C9.70781 10.0714 9.80506 9.88376 9.82834 9.68051L9.83334 9.58301V5.41467L9.82751 5.31717C9.80361 5.11432 9.70605 4.92731 9.55334 4.79166C9.40064 4.65601 9.20343 4.58116 8.99918 4.58134H8.99834Z"
      fill="#FAC02B"
    />
  </svg>
);

export const AccordionCaretDown = ({ children, ...rest }: IconProps) => (
  <svg
    width="20"
    height="13"
    viewBox="0 0 20 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M9.22276 11.8154L0.321959 2.91456C-0.10732 2.48528 -0.10732 1.78932 0.321959 1.36008L1.36009 0.321948C1.78864 -0.106597 2.48319 -0.107422 2.91274 0.320116L10 7.37419L17.0873 0.320116C17.5168 -0.107422 18.2114 -0.106597 18.6399 0.321948L19.678 1.36008C20.1073 1.78936 20.1073 2.48533 19.678 2.91456L10.7773 11.8154C10.348 12.2446 9.65204 12.2446 9.22276 11.8154Z"
      fill="#231F20"
    />
  </svg>
);

export const SolidUser = ({ children, ...rest }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0ZM12 4.64516C14.3516 4.64516 16.2581 6.55161 16.2581 8.90323C16.2581 11.2548 14.3516 13.1613 12 13.1613C9.64839 13.1613 7.74194 11.2548 7.74194 8.90323C7.74194 6.55161 9.64839 4.64516 12 4.64516ZM12 21.2903C9.15968 21.2903 6.61452 20.0032 4.91129 17.9903C5.82097 16.2774 7.60161 15.0968 9.67742 15.0968C9.79355 15.0968 9.90968 15.1161 10.021 15.15C10.65 15.3532 11.3081 15.4839 12 15.4839C12.6919 15.4839 13.3548 15.3532 13.979 15.15C14.0903 15.1161 14.2065 15.0968 14.3226 15.0968C16.3984 15.0968 18.179 16.2774 19.0887 17.9903C17.3855 20.0032 14.8403 21.2903 12 21.2903Z"
      fill="#BABABA"
    />
  </svg>
);

// SOCIAL MEDIA ICONS
export const GoogleLogo = ({ children, width, height, ...rest }: IconProps) => (
  <svg
    width={width || '32'}
    height={height || '32'}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M30.0014 16.3109C30.0014 15.1598 29.9061 14.3198 29.6998 13.4487H16.2871V18.6442H24.1601C24.0014 19.9354 23.1442 21.8798 21.2394 23.1864L21.2127 23.3604L25.4536 26.58L25.7474 26.6087C28.4458 24.1665 30.0014 20.5731 30.0014 16.3109Z"
      fill="#4285F4"
    />
    <path
      d="M16.2862 30C20.1433 30 23.3814 28.7555 25.7465 26.6089L21.2386 23.1865C20.0322 24.011 18.4132 24.5866 16.2862 24.5866C12.5085 24.5866 9.30219 22.1444 8.15923 18.7688L7.9917 18.7827L3.58202 22.1272L3.52435 22.2843C5.87353 26.8577 10.6989 30 16.2862 30Z"
      fill="#34A853"
    />
    <path
      d="M8.16007 18.7688C7.85848 17.8977 7.68395 16.9643 7.68395 15.9999C7.68395 15.0354 7.85849 14.1021 8.1442 13.231L8.13621 13.0455L3.67126 9.64734L3.52518 9.71544C2.55696 11.6132 2.0014 13.7444 2.0014 15.9999C2.0014 18.2555 2.55696 20.3865 3.52518 22.2843L8.16007 18.7688Z"
      fill="#FBBC05"
    />
    <path
      d="M16.2863 7.4133C18.9688 7.4133 20.7783 8.54885 21.8101 9.4978L25.8418 5.64C23.3657 3.38445 20.1434 2 16.2863 2C10.699 2 5.87354 5.1422 3.52435 9.71549L8.14339 13.2311C9.30223 9.85555 12.5086 7.4133 16.2863 7.4133Z"
      fill="#EB4335"
    />
  </svg>
);

export const FacebookLogo = ({
  children,
  width,
  height,
  ...rest
}: IconProps) => (
  <svg
    width={width || '32'}
    height={height || '32'}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <circle cx="16" cy="16" r="14" fill="url(#facebook_linear)" />
    <path
      d="M21.2137 20.2816L21.8356 16.3301H17.9452V13.767C17.9452 12.6857 18.4877 11.6311 20.2302 11.6311H22V8.26699C22 8.26699 20.3945 8 18.8603 8C15.6548 8 13.5617 9.89294 13.5617 13.3184V16.3301H10V20.2816H13.5617V29.8345C14.2767 29.944 15.0082 30 15.7534 30C16.4986 30 17.2302 29.944 17.9452 29.8345V20.2816H21.2137Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="facebook_linear"
        x1="16"
        y1="2"
        x2="16"
        y2="29.917"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18ACFE" />
        <stop offset="1" stopColor="#0163E0" />
      </linearGradient>
    </defs>
  </svg>
);

export const HuluLogo = ({ children, width, height, ...rest }: IconProps) => (
  <svg
    width={width || '32'}
    height={height || '11'}
    viewBox="0 0 32 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M19.6091 10.553H22.1584V0H19.6091V10.553ZM15.1329 7.54423C15.1329 7.91478 14.8217 8.22603 14.4511 8.22603H12.969C12.5984 8.22603 12.2872 7.91478 12.2872 7.54423C12.2872 7.39602 12.2872 3.29041 12.2872 3.29041H9.73784V7.75174C9.73784 9.5748 10.9088 10.5382 12.6281 10.5382H15.1181C16.704 10.5382 17.6674 9.39694 17.6674 7.75174V3.29041H15.1181C15.1329 3.29041 15.1329 7.41084 15.1329 7.54423ZM29.4655 3.29041C29.4655 3.29041 29.4655 7.41084 29.4655 7.54423C29.4655 7.91478 29.1542 8.22603 28.7837 8.22603H27.3015C26.931 8.22603 26.6197 7.91478 26.6197 7.54423C26.6197 7.39602 26.6197 3.29041 26.6197 3.29041H24.0704V7.75174C24.0704 9.5748 25.2413 10.5382 26.9606 10.5382H29.4507C31.0366 10.5382 32 9.39694 32 7.75174V3.29041H29.4655ZM5.03937 3.29041C5.03937 3.29041 3.72024 3.29041 3.40899 3.29041C2.83094 3.29041 2.54933 3.43863 2.54933 3.43863V0H0V10.5382H2.53451V6.29921C2.53451 5.92867 2.84576 5.61742 3.2163 5.61742H4.69847C5.06901 5.61742 5.38027 5.92867 5.38027 6.29921V10.553H7.9296V5.95831C7.9296 4.0315 6.64011 3.29041 5.03937 3.29041Z"
      fill="#040405"
    />
  </svg>
);

export const TwitterLogo = ({
  children,
  width,
  height,
  ...rest
}: IconProps) => (
  <svg
    width={width || '28'}
    height={height || '23'}
    viewBox="0 0 28 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M8.78874 23C5.55374 23 2.53817 22.0591 0 20.4356C2.15499 20.5751 5.95807 20.2411 8.32358 17.9848C4.76508 17.8215 3.16026 15.0923 2.95094 13.926C3.25329 14.0426 4.6953 14.1826 5.50934 13.856C1.4159 12.8296 0.787928 9.23732 0.927477 8.14097C1.695 8.67749 2.99745 8.8641 3.50913 8.81744C-0.305207 6.08823 1.06703 1.98276 1.74151 1.09635C4.47882 4.88867 8.5812 7.01857 13.6564 7.13704C13.5607 6.71736 13.5102 6.28042 13.5102 5.83164C13.5102 2.61092 16.1134 0 19.3247 0C21.0025 0 22.5144 0.712754 23.5757 1.85284C24.6969 1.59011 26.3843 0.975068 27.2092 0.443205C26.7934 1.93611 25.4989 3.18149 24.7159 3.64308C24.7224 3.65878 24.7095 3.62731 24.7159 3.64308C25.4037 3.53904 27.2648 3.18137 28 2.68256C27.6364 3.52125 26.264 4.91573 25.1377 5.69642C25.3473 14.9381 18.2765 23 8.78874 23Z"
      fill="#47ACDF"
    />
  </svg>
);

export const YelpLogo = ({ children, width, height, ...rest }: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '27'}
    viewBox="0 0 22 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0.540394 12.9998C0.0871344 13.7014 -0.102868 15.9079 0.0550857 17.3708C0.110026 17.8532 0.201594 18.256 0.332078 18.4972C0.512924 18.8292 0.817386 19.0284 1.16305 19.0394C1.38511 19.0505 1.52475 19.0129 5.70252 17.7138C5.70252 17.7138 7.55905 17.1406 7.56821 17.1362C8.03063 17.0211 8.34425 16.6094 8.37401 16.0849C8.40376 15.5449 8.11762 15.0691 7.64146 14.8987C7.64146 14.8987 6.33205 14.383 6.32976 14.383C1.83837 12.5926 1.63692 12.5218 1.41029 12.5196C1.06233 12.5085 0.755578 12.6767 0.540394 12.9998ZM10.5854 26.3428C10.6586 26.1391 10.6678 25.9997 10.6792 21.7549C10.6792 21.7549 10.6884 19.8804 10.6907 19.8605C10.7204 19.4002 10.4137 18.9819 9.91005 18.7938C9.39041 18.6013 8.83184 18.7208 8.51822 19.097C8.51822 19.097 7.60255 20.1482 7.59797 20.1482C4.45262 23.7202 4.31985 23.8862 4.2443 24.0964C4.19623 24.2204 4.18021 24.3532 4.19394 24.4859C4.21226 24.6763 4.30153 24.8622 4.44804 25.037C5.1783 25.8758 8.67618 27.1196 9.7933 26.9337C10.1848 26.8695 10.4663 26.6592 10.5854 26.3428ZM17.6841 24.8666C18.7395 24.4594 21.0401 21.631 21.2026 20.5399C21.2599 20.1615 21.1362 19.834 20.8661 19.6259C20.6899 19.4976 20.5548 19.4467 16.377 18.121C16.377 18.121 14.5457 17.5367 14.5205 17.5257C14.0764 17.3597 13.5705 17.5146 13.2317 17.9196C12.8768 18.3357 12.8242 18.8867 13.1081 19.3006L13.8452 20.4603C16.3244 24.3532 16.5144 24.6276 16.6929 24.7626C16.9676 24.9728 17.3179 25.0082 17.6841 24.8666ZM15.5254 14.8456C20.2709 13.7346 20.4564 13.6748 20.6418 13.5553C20.9302 13.3672 21.0744 13.0552 21.0493 12.6745C21.0493 12.6634 21.0515 12.6502 21.0493 12.6369C20.9279 11.5082 18.886 8.57803 17.8787 8.1022C17.5216 7.93622 17.1645 7.94729 16.8692 8.13983C16.6861 8.25491 16.551 8.42975 14.01 11.7915C14.01 11.7915 12.8631 13.303 12.8494 13.3185C12.5472 13.6748 12.5426 14.1839 12.8379 14.6221C13.1447 15.0758 13.662 15.2948 14.1359 15.1687C14.1359 15.1687 14.1176 15.2019 14.113 15.2063C14.3465 15.12 14.7631 15.0204 15.5254 14.8456ZM10.7616 11.0567C10.6792 9.23754 10.1138 1.13973 10.0474 0.765708C9.95126 0.424887 9.67656 0.183657 9.28281 0.0862795C8.06954 -0.203639 3.43851 1.0512 2.58006 1.90547C2.30307 2.18432 2.20235 2.52514 2.28476 2.82834C2.41982 3.09612 8.15882 11.8247 8.15882 11.8247C9.00582 13.1548 9.69945 12.9467 9.92608 12.8781C10.1504 12.8139 10.8395 12.6059 10.7616 11.0567Z"
      fill="#BF2519"
    />
  </svg>
);

export const LinkedInLogo = ({
  children,
  width,
  height,
  ...rest
}: IconProps) => (
  <svg
    width={width || '32'}
    height={height || '32'}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <rect x="2" y="2" width="28" height="28" rx="14" fill="#1275B1" />
    <path
      d="M12.6186 9.69215C12.6186 10.6267 11.8085 11.3843 10.8093 11.3843C9.81004 11.3843 9 10.6267 9 9.69215C9 8.7576 9.81004 8 10.8093 8C11.8085 8 12.6186 8.7576 12.6186 9.69215Z"
      fill="white"
    />
    <path d="M9.24742 12.6281H12.3402V22H9.24742V12.6281Z" fill="white" />
    <path
      d="M17.3196 12.6281H14.2268V22H17.3196C17.3196 22 17.3196 19.0496 17.3196 17.2049C17.3196 16.0976 17.6977 14.9855 19.2062 14.9855C20.911 14.9855 20.9008 16.4345 20.8928 17.5571C20.8824 19.0244 20.9072 20.5219 20.9072 22H24V17.0537C23.9738 13.8954 23.1508 12.4401 20.4433 12.4401C18.8354 12.4401 17.8387 13.1701 17.3196 13.8305V12.6281Z"
      fill="white"
    />
  </svg>
);

export const BingLogo = ({ children, width, height, ...rest }: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '28'}
    viewBox="0 0 22 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <g clipPath="url(#bing0)">
      <path
        d="M10.3066 9.71056C10.3024 9.74417 10.3024 9.78233 10.3024 9.81979C10.3024 9.96543 10.3315 10.1055 10.384 10.2343L10.4309 10.3309L10.6164 10.8056L11.5802 13.2643L12.4208 15.4114C12.6606 15.8448 13.0446 16.185 13.5078 16.3664L13.6517 16.4192C13.6573 16.421 13.6667 16.421 13.6744 16.4231L15.9783 17.2153V17.2171L16.8591 17.5196L16.9193 17.5399C16.9214 17.5399 16.9249 17.542 16.927 17.542C17.1007 17.5857 17.2708 17.6445 17.4333 17.7163C17.8089 17.8784 18.1495 18.1095 18.4405 18.3913C18.5577 18.5033 18.6656 18.6241 18.7653 18.7529C18.8503 18.8611 18.9279 18.9747 18.9978 19.0932C19.3052 19.6036 19.4816 20.2037 19.4816 20.8426C19.4816 20.9567 19.476 21.067 19.4645 21.179C19.4606 21.2284 19.4547 21.276 19.4473 21.3232V21.3271C19.4396 21.3772 19.4302 21.429 19.4207 21.4797C19.4109 21.5291 19.4018 21.5781 19.3906 21.6271C19.3888 21.6327 19.3867 21.6387 19.3846 21.6443C19.3741 21.694 19.3608 21.743 19.3472 21.7924C19.3349 21.8389 19.3195 21.8869 19.3024 21.932C19.2873 21.9815 19.2696 22.0301 19.2495 22.0777C19.2324 22.1267 19.212 22.1764 19.1893 22.2233C19.127 22.3672 19.0528 22.5055 18.9694 22.6375C18.862 22.8108 18.7394 22.9743 18.6029 23.1258C19.684 21.9635 20.4027 20.4627 20.5816 18.8019C20.6117 18.5296 20.6271 18.2533 20.6271 17.9754C20.6271 17.7979 20.6194 17.6221 20.6078 17.4457C20.4717 15.4541 19.5649 13.6728 18.181 12.4017C17.7995 12.0484 17.3825 11.7341 16.934 11.4673L16.0868 11.0342L11.7938 8.83115C11.6618 8.77457 11.5197 8.7455 11.3761 8.74573C10.8202 8.74573 10.3612 9.16968 10.3066 9.71056Z"
        fill="#7F7F7F"
      />
      <path
        d="M10.3066 9.71056C10.3024 9.74417 10.3024 9.78233 10.3024 9.81979C10.3024 9.96543 10.3315 10.1055 10.384 10.2343L10.4309 10.3309L10.6164 10.8056L11.5802 13.2643L12.4208 15.4114C12.6606 15.8448 13.0446 16.185 13.5078 16.3664L13.6517 16.4192C13.6573 16.421 13.6667 16.421 13.6744 16.4231L15.9783 17.2153V17.2171L16.8591 17.5196L16.9193 17.5399C16.9214 17.5399 16.9249 17.542 16.927 17.542C17.1007 17.5857 17.2708 17.6445 17.4333 17.7163C17.8089 17.8784 18.1495 18.1095 18.4405 18.3913C18.5577 18.5033 18.6656 18.6241 18.7653 18.7529C18.8503 18.8611 18.9279 18.9747 18.9978 19.0932C19.3052 19.6036 19.4816 20.2037 19.4816 20.8426C19.4816 20.9567 19.476 21.067 19.4645 21.179C19.4606 21.2284 19.4547 21.276 19.4473 21.3232V21.3271C19.4396 21.3772 19.4302 21.429 19.4207 21.4797C19.4109 21.5291 19.4018 21.5781 19.3906 21.6271C19.3888 21.6327 19.3867 21.6387 19.3846 21.6443C19.3741 21.694 19.3608 21.743 19.3472 21.7924C19.3349 21.8389 19.3195 21.8869 19.3024 21.932C19.2873 21.9815 19.2696 22.0301 19.2495 22.0777C19.2324 22.1267 19.212 22.1764 19.1893 22.2233C19.127 22.3672 19.0528 22.5055 18.9694 22.6375C18.862 22.8108 18.7394 22.9743 18.6029 23.1258C19.684 21.9635 20.4027 20.4627 20.5816 18.8019C20.6117 18.5296 20.6271 18.2533 20.6271 17.9754C20.6271 17.7979 20.6194 17.6221 20.6078 17.4457C20.4717 15.4541 19.5649 13.6728 18.181 12.4017C17.7995 12.0484 17.3825 11.7341 16.934 11.4673L16.0868 11.0342L11.7938 8.83115C11.6618 8.77457 11.5197 8.7455 11.3761 8.74573C10.8202 8.74573 10.3612 9.16968 10.3066 9.71056Z"
        fill="url(#bing0_linear)"
      />
      <path
        d="M2.66252 0C2.05162 0.0108526 1.56116 0.510771 1.56116 1.12202V20.6938C1.56361 20.8303 1.57131 20.9651 1.58111 21.102C1.58986 21.1741 1.59932 21.249 1.61262 21.3218C1.89164 22.8926 3.25836 24.0847 4.90865 24.0847C5.48734 24.0847 6.02997 23.9373 6.50468 23.681C6.50748 23.6789 6.51238 23.6761 6.51483 23.6761L6.68567 23.5728L7.37814 23.1654L8.25895 22.6427L8.26105 5.253C8.26105 4.09737 7.68271 3.07863 6.79735 2.47334C6.77635 2.46073 6.75604 2.44743 6.73749 2.43238L3.31017 0.191145C3.13653 0.0763181 2.92718 0.004201 2.70278 0H2.66252Z"
        fill="#7F7F7F"
      />
      <path
        d="M2.66252 0C2.05162 0.0108526 1.56116 0.510771 1.56116 1.12202V20.6938C1.56361 20.8303 1.57131 20.9651 1.58111 21.102C1.58986 21.1741 1.59932 21.249 1.61262 21.3218C1.89164 22.8926 3.25836 24.0847 4.90865 24.0847C5.48734 24.0847 6.02997 23.9373 6.50468 23.681C6.50748 23.6789 6.51238 23.6761 6.51483 23.6761L6.68567 23.5728L7.37814 23.1654L8.25895 22.6427L8.26105 5.253C8.26105 4.09737 7.68271 3.07863 6.79735 2.47334C6.77635 2.46073 6.75604 2.44743 6.73749 2.43238L3.31017 0.191145C3.13653 0.0763181 2.92718 0.004201 2.70278 0H2.66252Z"
        fill="url(#bing1_linear)"
      />
      <path
        d="M16.2524 17.88L8.37237 22.5509L8.25894 22.6192V22.644L7.37813 23.1656L6.68602 23.5742L6.51623 23.6768L6.50467 23.6824C6.03101 23.9397 5.48803 24.0853 4.90969 24.0853C3.25975 24.0853 1.89128 22.894 1.61331 21.3224C1.74529 22.4721 2.13704 23.5423 2.72798 24.4746C3.94487 26.3956 6.00265 27.7318 8.38322 27.9639H9.83887C11.1265 27.8295 12.2016 27.3138 13.3316 26.6175L15.0695 25.5546C15.8522 25.053 17.9769 23.8189 18.6028 23.1264C18.739 22.9749 18.8619 22.8124 18.9694 22.6384C19.0527 22.5061 19.1269 22.3678 19.1892 22.2239C19.2102 22.1749 19.2302 22.1273 19.2495 22.0786C19.2677 22.0303 19.2848 21.9817 19.3023 21.9323C19.3349 21.8378 19.3608 21.7429 19.3856 21.6452C19.3982 21.5896 19.4098 21.5346 19.4213 21.48C19.4592 21.2738 19.4798 21.062 19.4798 20.8425C19.4798 20.2036 19.3034 19.6035 18.9977 19.0938C18.9277 18.9748 18.8507 18.861 18.7653 18.7535C18.6655 18.624 18.5577 18.5039 18.4404 18.3919C18.1495 18.11 17.8099 17.879 17.4332 17.7165C17.2708 17.6448 17.1013 17.5856 16.927 17.5425C16.9249 17.5425 16.9214 17.5404 16.9193 17.5404L16.8591 17.5201L16.2524 17.88Z"
        fill="#7F7F7F"
      />
      <path
        d="M16.2524 17.88L8.37237 22.5509L8.25894 22.6192V22.644L7.37813 23.1656L6.68602 23.5742L6.51623 23.6768L6.50467 23.6824C6.03101 23.9397 5.48803 24.0853 4.90969 24.0853C3.25975 24.0853 1.89128 22.894 1.61331 21.3224C1.74529 22.4721 2.13704 23.5423 2.72798 24.4746C3.94487 26.3956 6.00265 27.7318 8.38322 27.9639H9.83887C11.1265 27.8295 12.2016 27.3138 13.3316 26.6175L15.0695 25.5546C15.8522 25.053 17.9769 23.8189 18.6028 23.1264C18.739 22.9749 18.8619 22.8124 18.9694 22.6384C19.0527 22.5061 19.1269 22.3678 19.1892 22.2239C19.2102 22.1749 19.2302 22.1273 19.2495 22.0786C19.2677 22.0303 19.2848 21.9817 19.3023 21.9323C19.3349 21.8378 19.3608 21.7429 19.3856 21.6452C19.3982 21.5896 19.4098 21.5346 19.4213 21.48C19.4592 21.2738 19.4798 21.062 19.4798 20.8425C19.4798 20.2036 19.3034 19.6035 18.9977 19.0938C18.9277 18.9748 18.8507 18.861 18.7653 18.7535C18.6655 18.624 18.5577 18.5039 18.4404 18.3919C18.1495 18.11 17.8099 17.879 17.4332 17.7165C17.2708 17.6448 17.1013 17.5856 16.927 17.5425C16.9249 17.5425 16.9214 17.5404 16.9193 17.5404L16.8591 17.5201L16.2524 17.88Z"
        fill="url(#bing2_linear)"
      />
      <path
        opacity="0.15"
        d="M19.4798 20.8425C19.4798 21.062 19.4592 21.2741 19.421 21.4803C19.4098 21.5349 19.3982 21.5895 19.3853 21.6449C19.3608 21.7429 19.3349 21.8377 19.3023 21.9326C19.2852 21.9816 19.2677 22.0306 19.2495 22.0783C19.2305 22.1273 19.2102 22.1749 19.1889 22.2239C19.1265 22.3673 19.0532 22.5058 18.9697 22.638C18.8624 22.8115 18.7396 22.9748 18.6028 23.1261C17.9769 23.8189 15.8522 25.0529 15.0695 25.5546L13.3316 26.6175C12.0577 27.4024 10.8541 27.958 9.33615 27.9961C9.26438 27.9982 9.19401 28 9.12435 28C9.02632 28 8.9297 27.9982 8.83273 27.9944C6.26242 27.8963 4.02083 26.5152 2.72798 24.4746C2.12302 23.5216 1.74192 22.4439 1.61331 21.3224C1.89128 22.894 3.25975 24.0853 4.90969 24.0853C5.48803 24.0853 6.03101 23.9393 6.50467 23.6824L6.51623 23.6764L6.68602 23.5742L7.37813 23.1656L8.25894 22.644V22.6191L8.37237 22.5509L16.2524 17.8797L16.8591 17.5201L16.9193 17.5404C16.921 17.5404 16.9249 17.5425 16.927 17.5425C17.1013 17.5856 17.2711 17.6448 17.4332 17.7165C17.8099 17.879 18.1491 18.11 18.4404 18.3919C18.5576 18.5041 18.6662 18.6249 18.7653 18.7535C18.8507 18.861 18.9277 18.9747 18.9977 19.0938C19.3034 19.6035 19.4798 20.2036 19.4798 20.8425Z"
        fill="#7F7F7F"
      />
      <path
        opacity="0.15"
        d="M19.4798 20.8425C19.4798 21.062 19.4592 21.2741 19.421 21.4803C19.4098 21.5349 19.3982 21.5895 19.3853 21.6449C19.3608 21.7429 19.3349 21.8377 19.3023 21.9326C19.2852 21.9816 19.2677 22.0306 19.2495 22.0783C19.2305 22.1273 19.2102 22.1749 19.1889 22.2239C19.1265 22.3673 19.0532 22.5058 18.9697 22.638C18.8624 22.8115 18.7396 22.9748 18.6028 23.1261C17.9769 23.8189 15.8522 25.0529 15.0695 25.5546L13.3316 26.6175C12.0577 27.4024 10.8541 27.958 9.33615 27.9961C9.26438 27.9982 9.19401 28 9.12435 28C9.02632 28 8.9297 27.9982 8.83273 27.9944C6.26242 27.8963 4.02083 26.5152 2.72798 24.4746C2.12302 23.5216 1.74192 22.4439 1.61331 21.3224C1.89128 22.894 3.25975 24.0853 4.90969 24.0853C5.48803 24.0853 6.03101 23.9393 6.50467 23.6824L6.51623 23.6764L6.68602 23.5742L7.37813 23.1656L8.25894 22.644V22.6191L8.37237 22.5509L16.2524 17.8797L16.8591 17.5201L16.9193 17.5404C16.921 17.5404 16.9249 17.5425 16.927 17.5425C17.1013 17.5856 17.2711 17.6448 17.4332 17.7165C17.8099 17.879 18.1491 18.11 18.4404 18.3919C18.5576 18.5041 18.6662 18.6249 18.7653 18.7535C18.8507 18.861 18.9277 18.9747 18.9977 19.0938C19.3034 19.6035 19.4798 20.2036 19.4798 20.8425Z"
        fill="url(#bing3_linear)"
      />
    </g>
    <defs>
      <linearGradient
        id="bing0_linear"
        x1="11.5814"
        y1="9.94474"
        x2="20.5321"
        y2="19.9202"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#37BDFF" />
        <stop offset="0.25" stopColor="#26C6F4" />
        <stop offset="0.5" stopColor="#15D0E9" />
        <stop offset="0.75" stopColor="#3BD6DF" />
        <stop offset="1" stopColor="#62DCD4" />
      </linearGradient>
      <linearGradient
        id="bing1_linear"
        x1="5.37073"
        y1="23.6614"
        x2="5.08285"
        y2="1.52528"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B48EF" />
        <stop offset="0.5" stopColor="#2080F1" />
        <stop offset="1" stopColor="#26B8F4" />
      </linearGradient>
      <linearGradient
        id="bing2_linear"
        x1="10.5465"
        y1="22.742"
        x2="32.2099"
        y2="22.742"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#39D2FF" />
        <stop offset="0.5" stopColor="#248FFA" />
        <stop offset="1" stopColor="#104CF5" />
      </linearGradient>
      <linearGradient
        id="bing3_linear"
        x1="10.5465"
        y1="22.742"
        x2="32.2099"
        y2="22.742"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" />
      </linearGradient>
      <clipPath id="bing0">
        <rect width="21.1456" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const InstagramLogo = ({
  children,
  width,
  height,
  ...rest
}: IconProps) => (
  <svg
    width={width || '32'}
    height={height || '32'}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <rect
      x="2"
      y="2"
      width="28"
      height="28"
      rx="6"
      fill="url(#paint0_radial)"
    />
    <rect
      x="2"
      y="2"
      width="28"
      height="28"
      rx="6"
      fill="url(#paint1_radial)"
    />
    <rect
      x="2"
      y="2"
      width="28"
      height="28"
      rx="6"
      fill="url(#paint2_radial)"
    />
    <path
      d="M23 10.5C23 11.3284 22.3284 12 21.5 12C20.6716 12 20 11.3284 20 10.5C20 9.67157 20.6716 9 21.5 9C22.3284 9 23 9.67157 23 10.5Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 21C18.7614 21 21 18.7614 21 16C21 13.2386 18.7614 11 16 11C13.2386 11 11 13.2386 11 16C11 18.7614 13.2386 21 16 21ZM16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16C13 17.6569 14.3431 19 16 19Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 15.6C6 12.2397 6 10.5595 6.65396 9.27606C7.2292 8.14708 8.14708 7.2292 9.27606 6.65396C10.5595 6 12.2397 6 15.6 6H16.4C19.7603 6 21.4405 6 22.7239 6.65396C23.8529 7.2292 24.7708 8.14708 25.346 9.27606C26 10.5595 26 12.2397 26 15.6V16.4C26 19.7603 26 21.4405 25.346 22.7239C24.7708 23.8529 23.8529 24.7708 22.7239 25.346C21.4405 26 19.7603 26 16.4 26H15.6C12.2397 26 10.5595 26 9.27606 25.346C8.14708 24.7708 7.2292 23.8529 6.65396 22.7239C6 21.4405 6 19.7603 6 16.4V15.6ZM15.6 8H16.4C18.1132 8 19.2777 8.00156 20.1779 8.0751C21.0548 8.14674 21.5032 8.27659 21.816 8.43597C22.5686 8.81947 23.1805 9.43139 23.564 10.184C23.7234 10.4968 23.8533 10.9452 23.9249 11.8221C23.9984 12.7223 24 13.8868 24 15.6V16.4C24 18.1132 23.9984 19.2777 23.9249 20.1779C23.8533 21.0548 23.7234 21.5032 23.564 21.816C23.1805 22.5686 22.5686 23.1805 21.816 23.564C21.5032 23.7234 21.0548 23.8533 20.1779 23.9249C19.2777 23.9984 18.1132 24 16.4 24H15.6C13.8868 24 12.7223 23.9984 11.8221 23.9249C10.9452 23.8533 10.4968 23.7234 10.184 23.564C9.43139 23.1805 8.81947 22.5686 8.43597 21.816C8.27659 21.5032 8.14674 21.0548 8.0751 20.1779C8.00156 19.2777 8 18.1132 8 16.4V15.6C8 13.8868 8.00156 12.7223 8.0751 11.8221C8.14674 10.9452 8.27659 10.4968 8.43597 10.184C8.81947 9.43139 9.43139 8.81947 10.184 8.43597C10.4968 8.27659 10.9452 8.14674 11.8221 8.0751C12.7223 8.00156 13.8868 8 15.6 8Z"
      fill="white"
    />
    <defs>
      <radialGradient
        id="paint0_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12 23) rotate(-55.3758) scale(25.5196)"
      >
        <stop stopColor="#B13589" />
        <stop offset="0.79309" stopColor="#C62F94" />
        <stop offset="1" stopColor="#8A3AC8" />
      </radialGradient>
      <radialGradient
        id="paint1_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11 31) rotate(-65.1363) scale(22.5942)"
      >
        <stop stopColor="#E0E8B7" />
        <stop offset="0.444662" stopColor="#FB8A2E" />
        <stop offset="0.71474" stopColor="#E2425C" />
        <stop offset="1" stopColor="#E2425C" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0.500002 3) rotate(-8.1301) scale(38.8909 8.31836)"
      >
        <stop offset="0.156701" stopColor="#406ADC" />
        <stop offset="0.467799" stopColor="#6A45BE" />
        <stop offset="1" stopColor="#6A45BE" stopOpacity="0" />
      </radialGradient>
    </defs>
  </svg>
);

export const YahooLogo = ({ children, width, height, ...rest }: IconProps) => (
  <svg
    width={width || '30'}
    height={height || '26'}
    viewBox="0 0 30 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0 6.32947H5.57776L8.82566 14.6386L12.1158 6.32947H17.546L9.36907 26H3.9035L6.14198 20.7876L0.000172729 6.32947H0ZM23.8697 12.9687H17.7874L23.1858 0L29.2459 0.000259093L23.8697 12.9687ZM19.3807 14.21C21.2469 14.21 22.7597 15.7228 22.7597 17.5887C22.7597 19.4547 21.2469 20.9675 19.3807 20.9675C17.5147 20.9675 16.0022 19.4547 16.0022 17.5887C16.0022 15.7228 17.515 14.21 19.3807 14.21Z"
      fill="#5F01D1"
    />
  </svg>
);

export const YouTubeLogo = ({
  children,
  width,
  height,
  ...rest
}: IconProps) => (
  <svg
    width={width || '32'}
    height={height || '32'}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M2.24451 9.94111C2.37304 7.96233 3.96395 6.41157 5.94447 6.31345C8.81239 6.17136 12.9115 6 16 6C19.0885 6 23.1876 6.17136 26.0555 6.31345C28.0361 6.41157 29.627 7.96233 29.7555 9.94111C29.8786 11.8369 30 14.1697 30 16C30 17.8303 29.8786 20.1631 29.7555 22.0589C29.627 24.0377 28.0361 25.5884 26.0555 25.6866C23.1876 25.8286 19.0885 26 16 26C12.9115 26 8.81239 25.8286 5.94447 25.6866C3.96395 25.5884 2.37304 24.0377 2.24451 22.0589C2.12136 20.1631 2 17.8303 2 16C2 14.1697 2.12136 11.8369 2.24451 9.94111Z"
      fill="#FC0D1B"
    />
    <path d="M13 12V20L21 16L13 12Z" fill="white" />
  </svg>
);

export const YellowPagesLogo = ({
  children,
  width,
  height,
  ...rest
}: IconProps) => (
  <svg
    width={width || '29'}
    height={height || '28'}
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 28H28.087V0H0"
      fill="#0A0A08"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.0365 20.7627H22.8861V18.9299H5.0365"
      fill="#F9D021"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.7732 11.1954C20.7569 9.98691 20.2053 8.66182 18.6871 8.66182C17.1688 8.66182 16.6172 9.98691 16.6 11.1954C16.6172 12.4038 17.1688 13.7289 18.688 13.7289C20.2081 13.7289 20.7588 12.4038 20.7751 11.1954H20.7732ZM14.6516 7.00593H16.665V7.71819H16.6985C17.3103 7.15603 18.1918 6.80994 19.1823 6.80994C21.2952 6.80994 22.887 8.77941 22.887 11.1954C22.887 13.4201 21.5801 15.5837 18.9481 15.5837C17.8945 15.5837 17.0398 15.2108 16.666 14.7519V18.0656H14.6516V7.00593ZM10.8866 16.1305C10.3417 17.6669 9.62079 18.1669 8.16949 18.1669C7.67235 18.1669 7.17806 18.0684 6.73541 17.8897V16.0856C7.05091 16.2147 7.52894 16.3437 8.00888 16.3437C8.65326 16.3437 8.92478 16.0168 8.92478 15.598C8.92478 15.4336 8.8655 15.2634 8.73357 14.9259C8.60354 14.5875 5.63977 7.00497 5.63977 7.00497H7.83679L9.97835 13.3704H10.0042L11.9029 7.00497H14.0062L10.8856 16.1296L10.8866 16.1305Z"
      fill="white"
    />
  </svg>
);

export const CTVLogo = ({ children, width, height, ...rest }: IconProps) => (
  <svg
    width={width || '40'}
    height={height || '13'}
    viewBox="0 0 40 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    // xlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    {children}
    <rect width="40" height="12.6316" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use href="#image0_4550:297" transform="scale(0.00250627 0.00793651)" />
      </pattern>
      <image
        id="image0_4550:297"
        width="399"
        height="126"
        href="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const VimeoLogo = ({ children, width, height, ...rest }: IconProps) => (
  <svg
    width={width || '32'}
    height={height || '32'}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M5.79742 6.99579L2.04553 10.3966L3.34372 12.0312C3.92184 11.6719 5.07809 10.7344 5.59372 10.7344C6.74997 10.7344 7.7894 13.8672 8.78122 17.3125C9.67184 20.4062 10.5937 28.0938 14.8437 28.0938C19.7343 28.0938 30.0156 14.8906 30.0156 9.01435C30.0156 6.88807 29.5937 3.82812 25.3593 3.82812C20.8218 3.82812 18.5895 8.20714 18.0405 10.3966C18.4354 10.1333 19.5105 9.95781 20.1029 9.95781C22.5164 9.95781 22.001 12.4595 21.6718 13.4688C21.3427 14.478 18.8125 19.3924 17.4481 19.3924C15.7806 19.3924 14.7932 12.1519 14.3105 9.01435C13.8278 5.87679 12.5772 4.16541 10.6683 4.16541C9.14123 4.16541 6.78477 6.05233 5.79742 6.99579Z"
      fill="#3CB9E6"
    />
  </svg>
);

export const GoogleMapsMarker = ({
  children,
  width,
  height,
  ...rest
}: IconProps) => (
  <svg
    width={width || '20'}
    height={height || '28'}
    viewBox="0 0 20 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M5.38669 20.7472C6.1967 21.7795 6.93392 22.8669 7.59301 24.0014C8.15575 25.0685 8.39034 25.792 8.8016 27.0777C9.05382 27.788 9.28177 28 9.77186 28C10.3059 28 10.5482 27.6393 10.7354 27.0816C11.1241 25.8674 11.4292 24.9408 11.9104 24.0652C12.8547 22.3749 14.0281 20.8728 15.1811 19.4291C15.4932 19.0206 17.5113 16.6402 18.4198 14.7621C18.4198 14.7621 19.5364 12.6989 19.5364 9.81752C19.5364 7.12225 18.4352 5.25293 18.4352 5.25293L15.2647 6.102L13.3393 11.1732L12.863 11.8724L12.7677 11.9991L12.641 12.1577L12.4187 12.411L12.1009 12.7287L10.3863 14.1255L6.09977 16.6006L5.38669 20.7472Z"
      fill="#34A853"
    />
    <path
      d="M0.962494 14.415C2.00869 16.8047 4.02613 18.9053 5.39109 20.7487L12.641 12.1608C12.641 12.1608 11.6196 13.4966 9.76687 13.4966C7.7031 13.4966 6.03587 11.8486 6.03587 9.77055C6.03587 8.34554 6.89318 7.36658 6.89318 7.36658L1.97175 8.68529L0.962494 14.415V14.415Z"
      fill="#FBBC04"
    />
    <path
      d="M12.722 0.441483C15.1298 1.21783 17.1908 2.84767 18.4374 5.25103L12.6432 12.1558C12.6432 12.1558 13.5005 11.1591 13.5005 9.74297C13.5005 7.61655 11.71 6.02799 9.77562 6.02799C7.94645 6.02799 6.8959 7.36158 6.8959 7.36158V3.01167L12.722 0.441406V0.441483Z"
      fill="#4285F4"
    />
    <path
      d="M2.29056 3.49252C3.7287 1.77186 6.25928 0 9.74807 0C11.4407 0 12.7159 0.444378 12.7159 0.444378L6.8904 7.36555H2.76294L2.29056 3.4926V3.49252Z"
      fill="#1A73E8"
    />
    <path
      d="M0.962475 14.4152C0.962475 14.4152 0 12.5304 0 9.79985C0 7.21913 1.00323 4.96328 2.29057 3.49255L6.8937 7.36619L0.962475 14.4152Z"
      fill="#EA4335"
    />
  </svg>
);

export const FontAwesomeStripeS = ({ children, ...rest }: IconProps) => (
  <svg
    width="18"
    height="24"
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M7.273 7.24546C7.273 6.20035 8.1447 5.79731 9.5413 5.79731C11.5753 5.79731 14.1576 6.42062 16.1916 7.51728V1.2232C13.9748 0.337434 11.7627 0 9.54599 0C4.12361 0 0.510254 2.8307 0.510254 7.56415C0.510254 14.9643 10.6708 13.7645 10.6708 16.9561C10.6708 18.1933 9.59754 18.5917 8.10721 18.5917C5.89514 18.5917 3.03632 17.6778 0.791449 16.4593V22.4815C3.10046 23.4777 5.5878 23.9943 8.10252 24C13.6608 24 17.4897 21.6098 17.4897 16.8014C17.4897 8.82484 7.273 10.2542 7.273 7.24546Z"
      fill="black"
    />
  </svg>
);

export const FontAwesomeStripe = ({ children, ...rest }: IconProps) => (
  <svg
    width="24"
    height="10"
    viewBox="0 0 24 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M6.18472 0.827519L4.56071 1.17257L4.55321 6.51341C4.55321 7.49981 5.29583 8.13741 6.28223 8.13741C6.82982 8.13741 7.23113 8.03615 7.45241 7.91613V6.64843C7.23863 6.73469 6.18847 7.04224 6.18847 6.05959V3.68922H7.45241V2.27149H6.18847L6.18472 0.827519ZM9.52649 2.76282L9.42522 2.27149H7.985V8.01739H9.64651V4.15054C10.0403 3.63296 10.7042 3.73422 10.918 3.80173V2.27149C10.6929 2.19273 9.91655 2.04646 9.52649 2.76282ZM12.9883 0.0511475L11.3155 0.407453V1.76517L12.9883 1.40886V0.0511475ZM1.68026 3.96301C1.68026 3.70422 1.8978 3.60295 2.2466 3.5992C2.75293 3.5992 3.39803 3.75298 3.90436 4.02677V2.45902C3.35302 2.24149 2.80169 2.15523 2.25035 2.15523C0.900141 2.15523 0 2.86034 0 4.03802C0 5.88331 2.53165 5.58326 2.53165 6.37839C2.53165 6.68593 2.26535 6.7872 1.89405 6.7872C1.34271 6.7872 0.630098 6.55841 0.0712611 6.25462V7.75485C0.690108 8.02114 1.31646 8.13366 1.8903 8.13366C3.27426 8.13366 4.22691 7.54107 4.22691 6.34088C4.22691 4.35682 1.68026 4.71313 1.68026 3.96301ZM24 5.21195C24 3.50544 23.1749 2.15898 21.5921 2.15898C20.0094 2.15898 19.0455 3.50544 19.0455 5.2007C19.0455 7.20726 20.1819 8.13366 21.8022 8.13366C22.5973 8.13366 23.1936 7.95363 23.6474 7.70234V6.44965C23.1936 6.67843 22.6723 6.8172 22.0122 6.8172C21.3633 6.8172 20.7932 6.58842 20.7182 5.8083H23.9775C23.985 5.72203 24 5.37323 24 5.21195ZM20.7032 4.58186C20.7032 3.83174 21.1646 3.51669 21.5809 3.51669C21.9897 3.51669 22.4248 3.83174 22.4248 4.58186H20.7032ZM16.4688 2.15898C15.8162 2.15898 15.3962 2.46652 15.1636 2.68031L15.0774 2.26774H13.6109V9.94894L15.2761 9.59639L15.2799 7.71359C15.5199 7.88987 15.8762 8.13366 16.4576 8.13366C17.6503 8.13366 18.7379 7.26352 18.7379 5.14819C18.7417 3.21289 17.639 2.15898 16.4688 2.15898ZM16.0713 6.75344C15.6812 6.75344 15.4487 6.61092 15.2874 6.43839L15.2761 3.96301C15.4487 3.77173 15.6887 3.63296 16.0713 3.63296C16.6789 3.63296 17.0989 4.31556 17.0989 5.1857C17.1027 6.08209 16.6901 6.75344 16.0713 6.75344ZM11.3193 8.01739H12.992V2.27149H11.3193V8.01739Z"
      fill="black"
    />
  </svg>
);

export const FontAwesomeFacebook = ({ children, ...rest }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M24 12.0726C24 5.4436 18.629 0.0726318 12 0.0726318C5.37097 0.0726318 0 5.4436 0 12.0726C0 18.062 4.38823 23.0265 10.125 23.9275V15.5415H7.07661V12.0726H10.125V9.42876C10.125 6.4215 11.9153 4.76037 14.6574 4.76037C15.9706 4.76037 17.3439 4.99457 17.3439 4.99457V7.94618H15.8303C14.34 7.94618 13.875 8.87134 13.875 9.82021V12.0726H17.2031L16.6708 15.5415H13.875V23.9275C19.6118 23.0265 24 18.062 24 12.0726Z"
      fill="black"
    />
  </svg>
);

export const FontAwesomeFacebookInverted = ({
  children,
  ...rest
}: IconProps) => (
  <svg
    width="14"
    height="24"
    viewBox="0 0 14 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12.5847 13.5L13.2512 9.15656H9.08359V6.33797C9.08359 5.14969 9.66578 3.99141 11.5323 3.99141H13.427V0.293438C13.427 0.293438 11.7077 0 10.0637 0C6.63156 0 4.38812 2.08031 4.38812 5.84625V9.15656H0.572968V13.5H4.38812V24H9.08359V13.5H12.5847Z"
      fill="black"
    />
  </svg>
);

export const FontAwesomeFacebookSquare = ({ children, ...rest }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.4286 0H2.57143C1.88944 0 1.23539 0.270918 0.753154 0.753154C0.270918 1.23539 0 1.88944 0 2.57143L0 21.4286C0 22.1106 0.270918 22.7646 0.753154 23.2468C1.23539 23.7291 1.88944 24 2.57143 24H9.92411V15.8405H6.54911V12H9.92411V9.07286C9.92411 5.74339 11.9063 3.90429 14.9421 3.90429C16.3961 3.90429 17.9164 4.16357 17.9164 4.16357V7.43143H16.2413C14.5907 7.43143 14.0759 8.45571 14.0759 9.50625V12H17.7605L17.1712 15.8405H14.0759V24H21.4286C22.1106 24 22.7646 23.7291 23.2468 23.2468C23.7291 22.7646 24 22.1106 24 21.4286V2.57143C24 1.88944 23.7291 1.23539 23.2468 0.753154C22.7646 0.270918 22.1106 0 21.4286 0Z"
      fill="black"
    />
  </svg>
);

export const FontAwesomeYahoo = ({ children, ...rest }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M10.3487 6.30212L7.53848 13.3994L4.76242 6.30212H0L5.24625 18.6521L3.33424 23.1042H8.00248L14.9877 6.30212H10.3487ZM15.5737 13.0336C15.0029 13.0336 14.4449 13.2028 13.9702 13.52C13.4956 13.8371 13.1257 14.2878 12.9073 14.8152C12.6888 15.3426 12.6317 15.9229 12.743 16.4827C12.8544 17.0426 13.1293 17.5568 13.5329 17.9605C13.9365 18.3641 14.4508 18.639 15.0106 18.7503C15.5705 18.8617 16.1508 18.8045 16.6781 18.5861C17.2055 18.3676 17.6563 17.9977 17.9734 17.5231C18.2905 17.0485 18.4598 16.4905 18.4598 15.9197C18.4598 15.5407 18.3851 15.1654 18.2401 14.8152C18.0951 14.465 17.8825 14.1469 17.6145 13.8789C17.3465 13.6109 17.0283 13.3983 16.6781 13.2533C16.328 13.1082 15.9527 13.0336 15.5737 13.0336ZM18.8236 0.895752L14.2134 11.9737H19.4081L24 0.895752H18.8236Z"
      fill="black"
    />
  </svg>
);

export const FontAwesomeHouzz = ({ children, ...rest }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M14.7643 16.0018H9.16072V24H0.894653V0H6.76073V5.59821L23.1054 10.1839V24H14.7643V16.0018Z"
      fill="black"
    />
  </svg>
);

export const FontAwesomeApple = ({ children, ...rest }: IconProps) => (
  <svg
    width="22"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M17.778 12.6827C17.7673 10.7162 18.6567 9.23204 20.4571 8.13898C19.4497 6.69765 17.928 5.90465 15.9187 5.74926C14.0166 5.59923 11.9377 6.85839 11.1768 6.85839C10.3731 6.85839 8.5299 5.80284 7.08321 5.80284C4.09338 5.85106 0.916016 8.1872 0.916016 12.9399C0.916016 14.3437 1.17321 15.7939 1.68758 17.2906C2.37342 19.2571 4.84887 24.0794 7.43149 23.999C8.78173 23.9669 9.73548 23.0399 11.4929 23.0399C13.1968 23.0399 14.0809 23.999 15.5865 23.999C18.1906 23.9615 20.4303 19.5786 21.084 17.6068C17.5905 15.9618 17.778 12.7845 17.778 12.6827ZM14.7453 3.88464C16.2081 2.14861 16.0741 0.56796 16.0313 0C14.74 0.0750136 13.245 0.878731 12.3931 1.86998C11.4554 2.93089 10.9035 4.24363 11.0214 5.72247C12.4199 5.82963 13.6951 5.11164 14.7453 3.88464Z"
      fill="black"
    />
  </svg>
);

export const FontAwesomeHubspot = ({ children, ...rest }: IconProps) => (
  <svg
    width="22"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M11.532 9.91875C10.3555 11.0297 9.61952 12.6047 9.61952 14.3531C9.61952 15.7266 10.0742 16.9922 10.8383 18.0094L8.51796 20.3438C8.31171 20.2687 8.09139 20.2266 7.86171 20.2266C7.35546 20.2266 6.88202 20.4234 6.52577 20.7797C6.16952 21.1359 5.97264 21.6141 5.97264 22.1203C5.97264 22.6266 6.16952 23.1 6.52577 23.4562C6.88202 23.8125 7.36014 24 7.86171 24C8.36796 24 8.84139 23.8172 9.20233 23.4562C9.55858 23.1 9.75546 22.6219 9.75546 22.1203C9.75546 21.9234 9.72733 21.7359 9.66639 21.5531L12.0101 19.2C13.0414 19.9922 14.3258 20.4609 15.7273 20.4609C19.0976 20.4609 21.8211 17.7281 21.8211 14.3578C21.8211 11.3016 19.5851 8.77031 16.6555 8.325V5.4375C17.4758 5.09062 17.9773 4.32188 17.9773 3.42656C17.9773 2.20312 16.9976 1.18125 15.7742 1.18125C14.5508 1.18125 13.5851 2.20312 13.5851 3.42656C13.5851 4.32188 14.0867 5.09062 14.907 5.4375V8.30625C14.1945 8.40469 13.5195 8.62031 12.9055 8.94375C11.6117 7.96406 7.39764 4.92656 4.98827 3.09375C5.04452 2.8875 5.08202 2.67188 5.08202 2.44688C5.08202 1.09688 3.98046 0 2.62577 0C1.27577 0 0.178894 1.09688 0.178894 2.44688C0.178894 3.80156 1.27577 4.89844 2.62577 4.89844C3.08514 4.89844 3.51171 4.7625 3.88202 4.54219L11.532 9.91875ZM15.7273 17.5875C13.9414 17.5875 12.493 16.1391 12.493 14.3531C12.493 12.5672 13.9414 11.1187 15.7273 11.1187C17.5133 11.1187 18.9617 12.5672 18.9617 14.3531C18.9617 16.1391 17.5133 17.5875 15.7273 17.5875Z"
      fill="black"
    />
  </svg>
);

export const InfoAlertIcon = ({ children, ...rest }: IconProps) => (
  <svg
    width="18"
    height="18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M9 .281A8.72 8.72 0 0 0 .281 9 8.718 8.718 0 0 0 9 17.719 8.718 8.718 0 0 0 17.719 9 8.72 8.72 0 0 0 9 .281Zm0 3.867a1.477 1.477 0 1 1 0 2.954 1.477 1.477 0 0 1 0-2.954Zm1.969 8.93a.422.422 0 0 1-.422.422H7.453a.422.422 0 0 1-.422-.422v-.844c0-.233.19-.421.422-.421h.422v-2.25h-.422a.422.422 0 0 1-.422-.422v-.844c0-.233.19-.422.422-.422h2.25c.233 0 .422.189.422.422v3.515h.422c.233 0 .422.19.422.422v.844Z"
      fill="#057AFF"
    />
  </svg>
);

export const FontAwesomeInstagram = ({ children, ...rest }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12.0027 5.84808C8.59743 5.84808 5.85075 8.59477 5.85075 12C5.85075 15.4053 8.59743 18.1519 12.0027 18.1519C15.4079 18.1519 18.1546 15.4053 18.1546 12C18.1546 8.59477 15.4079 5.84808 12.0027 5.84808ZM12.0027 15.9996C9.80212 15.9996 8.00312 14.2059 8.00312 12C8.00312 9.7941 9.79677 8.00045 12.0027 8.00045C14.2086 8.00045 16.0022 9.7941 16.0022 12C16.0022 14.2059 14.2032 15.9996 12.0027 15.9996ZM19.8412 5.59644C19.8412 6.39421 19.1987 7.03135 18.4062 7.03135C17.6085 7.03135 16.9713 6.38885 16.9713 5.59644C16.9713 4.80402 17.6138 4.16153 18.4062 4.16153C19.1987 4.16153 19.8412 4.80402 19.8412 5.59644ZM23.9157 7.05277C23.8247 5.13063 23.3856 3.42801 21.9775 2.02522C20.5747 0.622429 18.8721 0.183388 16.9499 0.0870135C14.9689 -0.0254238 9.03112 -0.0254238 7.05008 0.0870135C5.1333 0.178034 3.43068 0.617075 2.02253 2.01986C0.614389 3.42265 0.180703 5.12527 0.0843279 7.04742C-0.0281093 9.02845 -0.0281093 14.9662 0.0843279 16.9472C0.175349 18.8694 0.614389 20.572 2.02253 21.9748C3.43068 23.3776 5.12794 23.8166 7.05008 23.913C9.03112 24.0254 14.9689 24.0254 16.9499 23.913C18.8721 23.822 20.5747 23.3829 21.9775 21.9748C23.3803 20.572 23.8193 18.8694 23.9157 16.9472C24.0281 14.9662 24.0281 9.03381 23.9157 7.05277ZM21.3564 19.0728C20.9388 20.1223 20.1303 20.9307 19.0755 21.3537C17.496 21.9802 13.7481 21.8356 12.0027 21.8356C10.2572 21.8356 6.50396 21.9748 4.92984 21.3537C3.88042 20.9361 3.07195 20.1276 2.64897 19.0728C2.02253 17.4934 2.16709 13.7455 2.16709 12C2.16709 10.2546 2.02789 6.50129 2.64897 4.92717C3.06659 3.87776 3.87507 3.06928 4.92984 2.6463C6.50931 2.01986 10.2572 2.16443 12.0027 2.16443C13.7481 2.16443 17.5014 2.02522 19.0755 2.6463C20.1249 3.06392 20.9334 3.8724 21.3564 4.92717C21.9828 6.50665 21.8383 10.2546 21.8383 12C21.8383 13.7455 21.9828 17.4987 21.3564 19.0728Z"
      fill="black"
    />
  </svg>
);
export const SuccessAlertIcon = ({ children, ...rest }: IconProps) => (
  <svg
    width="18"
    height="18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M17.719 9A8.719 8.719 0 1 1 .28 9a8.719 8.719 0 0 1 17.438 0Zm-9.727 4.617 6.468-6.47a.563.563 0 0 0 0-.795l-.795-.795a.562.562 0 0 0-.796 0l-5.275 5.275L5.13 8.37a.563.563 0 0 0-.796 0l-.795.796a.563.563 0 0 0 0 .795l3.656 3.656c.22.22.576.22.796 0Z"
      fill="#16A085"
    />
  </svg>
);

export const FontAwesomeInstagramSquare = ({
  children,
  ...rest
}: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 9.1425C11.4349 9.14271 10.8825 9.31048 10.4128 9.6246C9.94298 9.93871 9.57689 10.3851 9.36078 10.9072C9.14466 11.4294 9.08823 12.0039 9.19861 12.5581C9.30899 13.1124 9.58122 13.6214 9.98089 14.0209C10.3806 14.4205 10.8897 14.6925 11.444 14.8027C11.9983 14.9128 12.5728 14.8562 13.0948 14.6399C13.6169 14.4236 14.0631 14.0573 14.3771 13.5874C14.691 13.1175 14.8586 12.5651 14.8586 12C14.858 11.2421 14.5566 10.5155 14.0206 9.97969C13.4846 9.4439 12.7579 9.14278 12 9.1425ZM18.6809 6.94607C18.5354 6.57742 18.3158 6.24258 18.0355 5.96234C17.7553 5.6821 17.4204 5.46243 17.0518 5.31696C15.9268 4.87286 13.2482 4.9725 12 4.9725C10.7518 4.9725 8.07589 4.86911 6.94768 5.31696C6.57902 5.46243 6.24419 5.6821 5.96395 5.96234C5.68371 6.24258 5.46404 6.57742 5.31857 6.94607C4.875 8.07107 4.97411 10.7523 4.97411 11.9995C4.97411 13.2466 4.875 15.9246 5.32071 17.0534C5.46618 17.422 5.68585 17.7569 5.96609 18.0371C6.24633 18.3174 6.58117 18.537 6.94982 18.6825C8.07482 19.1266 10.7534 19.027 12.0021 19.027C13.2509 19.027 15.9257 19.1304 17.0539 18.6825C17.4226 18.537 17.7574 18.3174 18.0377 18.0371C18.3179 17.7569 18.5376 17.422 18.683 17.0534C19.1304 15.9284 19.0275 13.2471 19.0275 12C19.0275 10.7529 19.1304 8.07536 18.683 6.94661L18.6809 6.94607ZM12 16.3929C11.1312 16.3929 10.2819 16.1352 9.55946 15.6525C8.83706 15.1698 8.27401 14.4838 7.94153 13.6811C7.60904 12.8784 7.52205 11.9951 7.69155 11.143C7.86105 10.2909 8.27943 9.50813 8.89378 8.89378C9.50813 8.27943 10.2909 7.86105 11.143 7.69155C11.9951 7.52205 12.8784 7.60904 13.6811 7.94153C14.4838 8.27401 15.1698 8.83706 15.6525 9.55946C16.1352 10.2819 16.3929 11.1312 16.3929 12C16.3936 12.5771 16.2804 13.1486 16.0599 13.6819C15.8394 14.2152 15.5158 14.6997 15.1078 15.1078C14.6997 15.5158 14.2152 15.8394 13.6819 16.0599C13.1486 16.2804 12.5771 16.3936 12 16.3929ZM16.5739 8.44821C16.3711 8.44832 16.1728 8.38827 16.0041 8.27567C15.8354 8.16307 15.7039 8.00297 15.6262 7.81562C15.5486 7.62827 15.5282 7.42208 15.5677 7.22315C15.6072 7.02421 15.7048 6.84146 15.8482 6.69801C15.9915 6.55456 16.1742 6.45685 16.3732 6.41724C16.5721 6.37763 16.7783 6.39791 16.9657 6.4755C17.153 6.55309 17.3132 6.68451 17.4259 6.85314C17.5386 7.02177 17.5988 7.22004 17.5988 7.42286C17.5993 7.55754 17.5733 7.69101 17.5221 7.81562C17.471 7.94022 17.3958 8.0535 17.3008 8.14896C17.2058 8.24442 17.0928 8.32019 16.9685 8.37191C16.8441 8.42363 16.7108 8.45029 16.5761 8.45036L16.5739 8.44821ZM21.4286 0H2.57143C1.88944 0 1.23539 0.270918 0.753154 0.753154C0.270918 1.23539 0 1.88944 0 2.57143L0 21.4286C0 22.1106 0.270918 22.7646 0.753154 23.2468C1.23539 23.7291 1.88944 24 2.57143 24H21.4286C22.1106 24 22.7646 23.7291 23.2468 23.2468C23.7291 22.7646 24 22.1106 24 21.4286V2.57143C24 1.88944 23.7291 1.23539 23.2468 0.753154C22.7646 0.270918 22.1106 0 21.4286 0ZM20.5114 15.5357C20.4423 16.9088 20.1289 18.1254 19.1266 19.125C18.1243 20.1246 16.9088 20.4445 15.5373 20.5098C14.1225 20.5896 9.88071 20.5896 8.46589 20.5098C7.09286 20.4407 5.88054 20.1268 4.87661 19.125C3.87268 18.1232 3.55714 16.9061 3.49179 15.5357C3.41196 14.1204 3.41196 9.87804 3.49179 8.46429C3.56089 7.09125 3.87054 5.87464 4.87661 4.875C5.88268 3.87536 7.09821 3.55929 8.46589 3.49393C9.88071 3.41411 14.1225 3.41411 15.5373 3.49393C16.9104 3.56304 18.1264 3.87696 19.1266 4.87875C20.1268 5.88054 20.4461 7.09768 20.5114 8.47071C20.5913 9.88071 20.5913 14.1193 20.5114 15.5357Z"
      fill="black"
    />
  </svg>
);

export const WarningAlertIcon = ({ children, ...rest }: IconProps) => (
  <svg
    width="19"
    height="17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M18.786 14.514c.609 1.056-.155 2.375-1.371 2.375H1.585c-1.218 0-1.979-1.321-1.371-2.375L8.129.791c.609-1.056 2.134-1.054 2.742 0l7.915 13.723ZM9.5 11.677a1.517 1.517 0 1 0 0 3.035 1.517 1.517 0 0 0 0-3.035ZM8.06 6.223l.244 4.486c.012.21.185.374.395.374h1.602c.21 0 .383-.164.395-.374l.245-4.486a.396.396 0 0 0-.396-.417h-2.09a.396.396 0 0 0-.396.417Z"
      fill="#EE7B45"
    />
  </svg>
);

export const FontAwesomeYelp = ({ children, ...rest }: IconProps) => (
  <svg
    width="18"
    height="24"
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M2.02241 11.2647L6.69208 13.5433C7.59207 13.9839 7.45145 15.3015 6.48114 15.5453L1.44116 16.802C1.29322 16.8392 1.13901 16.8443 0.988936 16.8169C0.838858 16.7895 0.696385 16.7303 0.571101 16.6433C0.445818 16.5562 0.34063 16.4434 0.262617 16.3123C0.184604 16.1812 0.135574 16.0349 0.118826 15.8832C-0.0358215 14.5353 0.108212 13.1699 0.540699 11.8839C0.589217 11.7399 0.667897 11.6078 0.771487 11.4966C0.875078 11.3854 1.0012 11.2976 1.14143 11.239C1.28166 11.1804 1.43277 11.1523 1.58469 11.1568C1.73661 11.1612 1.88584 11.198 2.02241 11.2647ZM4.0849 22.4795C5.20217 23.2449 6.4724 23.7585 7.8077 23.9846C7.95797 24.0104 8.11201 24.0037 8.25948 23.965C8.40694 23.9263 8.54441 23.8564 8.66262 23.7602C8.78084 23.6639 8.87707 23.5434 8.94484 23.4068C9.0126 23.2702 9.05034 23.1207 9.05551 22.9684L9.23832 17.7737C9.27113 16.7753 8.04301 16.2779 7.37223 17.019L3.89365 20.8815C3.79179 20.9948 3.71532 21.1286 3.66936 21.2739C3.6234 21.4192 3.60902 21.5727 3.62717 21.724C3.64532 21.8753 3.69559 22.0209 3.77462 22.1512C3.85364 22.2815 3.95959 22.3934 4.08537 22.4795H4.0849ZM10.8977 17.327L13.6544 21.7332C13.7356 21.8626 13.8436 21.9732 13.9709 22.0575C14.0983 22.1419 14.2421 22.1982 14.393 22.2226C14.5438 22.247 14.698 22.239 14.8455 22.199C14.993 22.1591 15.1302 22.0882 15.2481 21.991C16.2929 21.1274 17.1362 20.0457 17.7189 18.8218C17.7831 18.684 17.8175 18.5342 17.8197 18.3822C17.8219 18.2302 17.792 18.0794 17.7318 17.9398C17.6716 17.8002 17.5826 17.6749 17.4706 17.5721C17.3586 17.4693 17.2261 17.3914 17.0819 17.3434L12.1403 15.7375C11.1883 15.4328 10.368 16.4781 10.8977 17.327ZM17.8506 11.1287C17.3103 9.88582 16.5037 8.77673 15.4877 7.87984C15.3733 7.77965 15.239 7.70494 15.0936 7.66067C14.9482 7.61641 14.795 7.6036 14.6442 7.62311C14.4935 7.64262 14.3486 7.694 14.2192 7.77382C14.0899 7.85365 13.979 7.9601 13.8939 8.08609L10.9877 12.3948C10.4299 13.2245 11.208 14.2984 12.1689 14.0218L17.1677 12.5917C17.3142 12.5486 17.4498 12.4748 17.5657 12.3753C17.6816 12.2758 17.775 12.1528 17.8397 12.0145C17.9045 11.8762 17.9391 11.7257 17.9413 11.573C17.9435 11.4203 17.9132 11.2689 17.8525 11.1287H17.8506ZM2.92288 1.4144C2.7901 1.47831 2.67192 1.56891 2.57575 1.68055C2.47957 1.7922 2.40745 1.92247 2.36389 2.06325C2.32034 2.20402 2.30629 2.35227 2.32263 2.49872C2.33896 2.64517 2.38532 2.78667 2.45882 2.9144L7.33942 11.3725C7.88786 12.3194 9.33675 11.9303 9.33675 10.8381V1.07222C9.33808 0.924635 9.30865 0.778394 9.25035 0.642813C9.19204 0.507232 9.10612 0.385284 8.99808 0.28474C8.89004 0.184195 8.76224 0.107258 8.62282 0.0588319C8.4834 0.0104056 8.33543 -0.00844828 8.18832 0.00347151C6.3618 0.14862 4.57725 0.626808 2.92288 1.4144Z"
      fill="black"
    />
  </svg>
);

export const FontAwesomeYoutube = ({ children, ...rest }: IconProps) => (
  <svg
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.4985 3.20286C23.2225 2.16356 22.4092 1.34503 21.3766 1.06726C19.505 0.5625 12 0.5625 12 0.5625C12 0.5625 4.49503 0.5625 2.62336 1.06726C1.59077 1.34508 0.777523 2.16356 0.501503 3.20286C0 5.08666 0 9.01704 0 9.01704C0 9.01704 0 12.9474 0.501503 14.8312C0.777523 15.8705 1.59077 16.6549 2.62336 16.9327C4.49503 17.4375 12 17.4375 12 17.4375C12 17.4375 19.505 17.4375 21.3766 16.9327C22.4092 16.6549 23.2225 15.8705 23.4985 14.8312C24 12.9474 24 9.01704 24 9.01704C24 9.01704 24 5.08666 23.4985 3.20286ZM9.54544 12.5855V5.44855L15.8181 9.01713L9.54544 12.5855Z"
      fill="black"
    />
  </svg>
);

export const DangerAlertIcon = ({ children, ...rest }: IconProps) => (
  <svg
    width="18"
    height="18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M17.719 9A8.718 8.718 0 0 1 9 17.719 8.718 8.718 0 0 1 .281 9 8.72 8.72 0 0 1 9 .281 8.72 8.72 0 0 1 17.719 9ZM9 10.758a1.617 1.617 0 1 0 0 3.234 1.617 1.617 0 0 0 0-3.234ZM7.465 4.945l.26 4.781a.422.422 0 0 0 .422.399h1.706a.422.422 0 0 0 .422-.399l.26-4.781a.422.422 0 0 0-.42-.445h-2.23a.422.422 0 0 0-.42.445Z"
      fill="#DF2A2A"
    />
  </svg>
);

export const ToolCardCaretIcon = ({ children, ...rest }: IconProps) => (
  <svg
    width="10"
    height="15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="m9.479 8.064-6.453 6.452a.797.797 0 0 1-1.127 0l-.753-.752a.797.797 0 0 1-.001-1.126L6.259 7.5 1.145 2.362a.797.797 0 0 1 .001-1.126L1.9.484a.797.797 0 0 1 1.127 0l6.453 6.453a.797.797 0 0 1 0 1.127Z"
      fill="#29292D"
    />
  </svg>
);

export const SuccessIcon = ({ children, ...rest }: IconProps) => (
  <svg
    width="16"
    height="16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58171 16 0 12.4183 0 8C0 3.58171 3.58171 0 8 0C12.4183 0 16 3.58171 16 8ZM7.07464 12.2359L13.0101 6.30045C13.2117 6.0989 13.2117 5.7721 13.0101 5.57055L12.2802 4.84064C12.0787 4.63906 11.7519 4.63906 11.5503 4.84064L6.70968 9.68123L4.44971 7.42126C4.24816 7.21971 3.92135 7.21971 3.71977 7.42126L2.98987 8.15116C2.78832 8.35271 2.78832 8.67952 2.98987 8.88106L6.34471 12.2359C6.54629 12.4375 6.87306 12.4375 7.07464 12.2359Z"
      fill="white"
    />
  </svg>
);

export const FailureIcon = ({ children, ...rest }: IconProps) => (
  <svg
    width="17"
    height="17.3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M8.5 0.5C3.80444 0.5 0 4.30444 0 9C0 13.6956 3.80444 17.5 8.5 17.5C13.1956 17.5 17 13.6956 17 9C17 4.30444 13.1956 0.5 8.5 0.5ZM12.6677 11.2313C12.8288 11.3923 12.8288 11.6528 12.6677 11.8139L11.3105 13.1677C11.1494 13.3288 10.8889 13.3288 10.7278 13.1677L8.5 10.9194L6.26875 13.1677C6.10766 13.3288 5.84718 13.3288 5.68609 13.1677L4.33226 11.8105C4.17117 11.6494 4.17117 11.3889 4.33226 11.2278L6.58065 9L4.33226 6.76875C4.17117 6.60766 4.17117 6.34718 4.33226 6.18609L5.68952 4.82883C5.85061 4.66774 6.11109 4.66774 6.27218 4.82883L8.5 7.08065L10.7313 4.83226C10.8923 4.67117 11.1528 4.67117 11.3139 4.83226L12.6712 6.18952C12.8323 6.35061 12.8323 6.61109 12.6712 6.77218L10.4194 9L12.6677 11.2313Z"
      fill="white"
    />
  </svg>
);

export const SolidCaretCircleDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M24 12C24 18.629 18.629 24 12 24C5.37097 24 0 18.629 0 12C0 5.37097 5.37097 0 12 0C18.629 0 24 5.37097 24 12ZM5.6371 10.6694L11.5887 16.621C11.8161 16.8484 12.1839 16.8484 12.4113 16.621L18.3629 10.6694C18.7306 10.3016 18.4694 9.67742 17.9516 9.67742H6.04839C5.53064 9.67742 5.26935 10.3016 5.6371 10.6694Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidCaretCircleLeft = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 24C5.37097 24 0 18.629 0 12C0 5.37097 5.37097 0 12 0C18.629 0 24 5.37097 24 12C24 18.629 18.629 24 12 24ZM13.3306 5.6371L7.37903 11.5887C7.15161 11.8161 7.15161 12.1839 7.37903 12.4113L13.3306 18.3629C13.6984 18.7306 14.3226 18.4694 14.3226 17.9516V6.04839C14.3226 5.53064 13.6984 5.26935 13.3306 5.6371Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidCaretCircleRight = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 0C18.629 0 24 5.37097 24 12C24 18.629 18.629 24 12 24C5.37097 24 0 18.629 0 12C0 5.37097 5.37097 0 12 0ZM10.6694 18.3629L16.621 12.4113C16.8484 12.1839 16.8484 11.8161 16.621 11.5887L10.6694 5.6371C10.3016 5.26935 9.67742 5.53064 9.67742 6.04839V17.9516C9.67742 18.4694 10.3016 18.7306 10.6694 18.3629Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidCaretCircleUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0 12C0 5.37097 5.37097 0 12 0C18.629 0 24 5.37097 24 12C24 18.629 18.629 24 12 24C5.37097 24 0 18.629 0 12ZM18.3629 13.3306L12.4113 7.37903C12.1839 7.15161 11.8161 7.15161 11.5887 7.37903L5.6371 13.3306C5.26935 13.6984 5.53064 14.3226 6.04839 14.3226H17.9516C18.4694 14.3226 18.7306 13.6984 18.3629 13.3306Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidArrowCircleUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0 12C0 5.37097 5.37097 0 12 0C18.629 0 24 5.37097 24 12C24 18.629 18.629 24 12 24C5.37097 24 0 18.629 0 12ZM14.129 17.6129V12H17.5597C18.0774 12 18.3387 11.371 17.971 11.0081L12.4113 5.47742C12.1839 5.25 11.821 5.25 11.5935 5.47742L6.02903 11.0081C5.66129 11.3758 5.92258 12 6.44032 12H9.87097V17.6129C9.87097 17.9323 10.1323 18.1935 10.4516 18.1935H13.5484C13.8677 18.1935 14.129 17.9323 14.129 17.6129Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidArrowCircleDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M24 12C24 18.629 18.629 24 12 24C5.37097 24 0 18.629 0 12C0 5.37097 5.37097 0 12 0C18.629 0 24 5.37097 24 12ZM9.87097 6.3871V12H6.44032C5.92258 12 5.66129 12.629 6.02903 12.9919L11.5887 18.5226C11.8161 18.75 12.179 18.75 12.4065 18.5226L17.9661 12.9919C18.3339 12.6242 18.0726 12 17.5548 12H14.129V6.3871C14.129 6.06774 13.8677 5.80645 13.5484 5.80645H10.4516C10.1323 5.80645 9.87097 6.06774 9.87097 6.3871Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidArrowCircleLeft = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 24C5.37097 24 0 18.629 0 12C0 5.37097 5.37097 0 12 0C18.629 0 24 5.37097 24 12C24 18.629 18.629 24 12 24ZM17.6129 9.87097H12V6.44032C12 5.92258 11.371 5.66129 11.0081 6.02903L5.47742 11.5887C5.25 11.8161 5.25 12.179 5.47742 12.4065L11.0081 17.9661C11.3758 18.3339 12 18.0726 12 17.5548V14.129H17.6129C17.9323 14.129 18.1935 13.8677 18.1935 13.5484V10.4516C18.1935 10.1323 17.9323 9.87097 17.6129 9.87097Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidArrowCircleRight = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 0C18.629 0 24 5.37097 24 12C24 18.629 18.629 24 12 24C5.37097 24 0 18.629 0 12C0 5.37097 5.37097 0 12 0ZM6.3871 14.129H12V17.5597C12 18.0774 12.629 18.3387 12.9919 17.971L18.5226 12.4113C18.75 12.1839 18.75 11.821 18.5226 11.5935L12.9919 6.02903C12.6242 5.66129 12 5.92258 12 6.44032V9.87097H6.3871C6.06774 9.87097 5.80645 10.1323 5.80645 10.4516V13.5484C5.80645 13.8677 6.06774 14.129 6.3871 14.129Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidChevronCircleUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0 12C0 5.37097 5.37097 0 12 0C18.629 0 24 5.37097 24 12C24 18.629 18.629 24 12 24C5.37097 24 0 18.629 0 12ZM11.1774 6.48871L4.62097 13.0452C4.16613 13.5 4.16613 14.2355 4.62097 14.6855L5.44355 15.5081C5.89839 15.9629 6.63387 15.9629 7.08387 15.5081L12 10.5919L16.9161 15.5081C17.371 15.9629 18.1065 15.9629 18.5565 15.5081L19.379 14.6855C19.8339 14.2306 19.8339 13.4952 19.379 13.0452L12.8226 6.48871C12.3677 6.03387 11.6323 6.03387 11.1774 6.48871Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidChevronCircleDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M24 12C24 18.629 18.629 24 12 24C5.37097 24 0 18.629 0 12C0 5.37097 5.37097 0 12 0C18.629 0 24 5.37097 24 12ZM12.8226 17.5113L19.379 10.9548C19.8339 10.5 19.8339 9.76452 19.379 9.31452L18.5565 8.49193C18.1016 8.0371 17.3661 8.0371 16.9161 8.49193L12 13.4081L7.08387 8.49193C6.62903 8.0371 5.89355 8.0371 5.44355 8.49193L4.62097 9.31452C4.16613 9.76935 4.16613 10.5048 4.62097 10.9548L11.1774 17.5113C11.6323 17.9661 12.3677 17.9661 12.8226 17.5113Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidChevronCircleLeft = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 24C5.37097 24 0 18.629 0 12C0 5.37097 5.37097 0 12 0C18.629 0 24 5.37097 24 12C24 18.629 18.629 24 12 24ZM6.48871 12.8226L13.0452 19.379C13.5 19.8339 14.2355 19.8339 14.6855 19.379L15.5081 18.5565C15.9629 18.1016 15.9629 17.3661 15.5081 16.9161L10.5919 12L15.5081 7.08387C15.9629 6.62903 15.9629 5.89355 15.5081 5.44355L14.6855 4.62097C14.2306 4.16613 13.4952 4.16613 13.0452 4.62097L6.48871 11.1774C6.03387 11.6323 6.03387 12.3677 6.48871 12.8226Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidChevronCircleRight = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 0C18.629 0 24 5.37097 24 12C24 18.629 18.629 24 12 24C5.37097 24 0 18.629 0 12C0 5.37097 5.37097 0 12 0ZM17.5113 11.1774L10.9548 4.62097C10.5 4.16613 9.76452 4.16613 9.31452 4.62097L8.49193 5.44355C8.0371 5.89839 8.0371 6.63387 8.49193 7.08387L13.4081 12L8.49193 16.9161C8.0371 17.371 8.0371 18.1065 8.49193 18.5565L9.31452 19.379C9.76935 19.8339 10.5048 19.8339 10.9548 19.379L17.5113 12.8226C17.9661 12.3677 17.9661 11.6323 17.5113 11.1774Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidChevronUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '16'}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12.9327 1.10389L23.6136 11.7849C24.1288 12.3 24.1288 13.1352 23.6136 13.6502L22.3679 14.896C21.8536 15.4102 21.0202 15.4112 20.5047 14.8982L12 6.43335L3.49529 14.8982C2.97983 15.4113 2.14637 15.4103 1.63211 14.896L0.38635 13.6503C-0.128783 13.1352 -0.128783 12.3 0.38635 11.7849L11.0673 1.10395C11.5824 0.588813 12.4176 0.588814 12.9327 1.10389Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidChevronDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '16'}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M11.0673 14.8961L0.38635 4.21507C-0.128783 3.69993 -0.128783 2.86477 0.38635 2.34969L1.63211 1.10393C2.14637 0.589674 2.97983 0.588684 3.49529 1.10173L12 9.56662L20.5047 1.10173C21.0202 0.588684 21.8536 0.589674 22.3679 1.10393L23.6136 2.34969C24.1288 2.86483 24.1288 3.69999 23.6136 4.21507L12.9327 14.8961C12.4176 15.4112 11.5824 15.4112 11.0673 14.8961Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidChevronLeft = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '16'}
    height={height || '24'}
    viewBox="0 0 16 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M1.10364 11.0671L11.785 0.386228C12.3 -0.128743 13.1354 -0.128743 13.6503 0.386228L14.8963 1.63216C15.4107 2.14658 15.4112 2.97977 14.8985 3.49529L6.43306 11.9997L14.8979 20.5047C15.4112 21.0202 15.4101 21.8534 14.8957 22.3678L13.6498 23.6138C13.1348 24.1287 12.2994 24.1287 11.7845 23.6138L1.10364 12.9324C0.588665 12.4174 0.588665 11.582 1.10364 11.0671Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidChevronRight = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '16'}
    height={height || '24'}
    viewBox="0 0 16 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M14.8961 12.9327L4.21513 23.6136C3.69999 24.1288 2.86483 24.1288 2.34975 23.6136L1.10399 22.3679C0.589734 21.8536 0.588745 21.0202 1.10179 20.5047L9.56668 12L1.10179 3.49529C0.588745 2.97983 0.589734 2.14637 1.10399 1.63211L2.34975 0.38635C2.86489 -0.128783 3.70005 -0.128783 4.21513 0.38635L14.8961 11.0673C15.4112 11.5824 15.4112 12.4176 14.8961 12.9327Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidArrowUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M1.87343 13.7958L0.684277 12.6066C0.180762 12.1031 0.180762 11.2889 0.684277 10.7908L11.092 0.377636C11.5956 -0.125879 12.4098 -0.125879 12.9079 0.377636L23.3157 10.7854C23.8192 11.2889 23.8192 12.1031 23.3157 12.6013L22.1265 13.7904C21.6177 14.2993 20.7874 14.2886 20.2892 13.769L14.1453 7.31972V22.7144C14.1453 23.4268 13.5721 24 12.8597 24H11.1456C10.4332 24 9.86004 23.4268 9.86004 22.7144V7.31972L3.71073 13.7744C3.21257 14.2993 2.3823 14.31 1.87343 13.7958Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidArrowDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M22.1292 10.2042L23.3184 11.3934C23.8219 11.8969 23.8219 12.7111 23.3184 13.2092L12.9106 23.6224C12.4071 24.1259 11.5929 24.1259 11.0947 23.6224L0.681592 13.2092C0.178076 12.7057 0.178076 11.8915 0.681592 11.3934L1.87074 10.2042C2.37962 9.69535 3.20988 9.70606 3.70804 10.2256L9.85735 16.6803V1.28557C9.85735 0.57315 10.4305 0 11.1429 0H12.857C13.5694 0 14.1426 0.57315 14.1426 1.28557V16.6803L20.2919 10.2256C20.7901 9.7007 21.6203 9.68999 22.1292 10.2042Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidArrowLeft = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M13.7958 22.1292L12.6066 23.3184C12.1031 23.8219 11.2889 23.8219 10.7908 23.3184L0.377636 12.9106C-0.125879 12.4071 -0.125879 11.5929 0.377636 11.0947L10.7908 0.681592C11.2943 0.178076 12.1085 0.178076 12.6066 0.681592L13.7958 1.87074C14.3047 2.37962 14.2939 3.20988 13.7744 3.70804L7.31972 9.85735H22.7144C23.4268 9.85735 24 10.4305 24 11.1429V12.857C24 13.5694 23.4268 14.1426 22.7144 14.1426H7.31972L13.7744 20.2919C14.2993 20.7901 14.31 21.6203 13.7958 22.1292Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidArrowRight = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M10.2042 1.87074L11.3934 0.681592C11.8969 0.178076 12.7111 0.178076 13.2092 0.681592L23.6224 11.0894C24.1259 11.5929 24.1259 12.4071 23.6224 12.9052L13.2092 23.3184C12.7057 23.8219 11.8915 23.8219 11.3934 23.3184L10.2042 22.1292C9.69535 21.6203 9.70606 20.7901 10.2256 20.2919L16.6803 14.1426H1.28557C0.57315 14.1426 0 13.5694 0 12.857V11.1429C0 10.4305 0.57315 9.85735 1.28557 9.85735H16.6803L10.2256 3.70804C9.7007 3.20988 9.68999 2.37962 10.2042 1.87074Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidLongArrowUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '18'}
    height={height || '24'}
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M3.55861 10.3637L7.07144 6.85085V22.7143C7.07144 23.4244 7.64706 24 8.35715 24H9.64286C10.353 24 10.9286 23.4244 10.9286 22.7143V6.85085L14.4414 10.3637C14.9435 10.8659 15.7576 10.8659 16.2597 10.3637L17.1688 9.45458C17.671 8.95245 17.671 8.13838 17.1688 7.63631L9.90917 0.376593C9.40704 -0.125531 8.59303 -0.125531 8.0909 0.376593L0.831183 7.63631C0.329059 8.13844 0.329059 8.95251 0.831183 9.45458L1.74034 10.3637C2.24241 10.8659 3.05648 10.8659 3.55861 10.3637Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidLongArrowDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '18'}
    height={height || '24'}
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M14.4414 13.6363L10.9286 17.1492V1.28571C10.9286 0.575625 10.353 0 9.64289 0H8.35717C7.64708 0 7.07146 0.575625 7.07146 1.28571V17.1492L3.55861 13.6363C3.05649 13.1342 2.24242 13.1342 1.74035 13.6363L0.831184 14.5455C0.329059 15.0476 0.329059 15.8617 0.831184 16.3637L8.09092 23.6234C8.59305 24.1255 9.40706 24.1255 9.90919 23.6234L17.1689 16.3637C17.671 15.8616 17.671 15.0475 17.1689 14.5455L16.2598 13.6363C15.7576 13.1342 14.9436 13.1342 14.4414 13.6363Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidLongArrowLeft = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '18'}
    height={height || '24'}
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M14.4414 13.6363L10.9286 17.1492V1.28571C10.9286 0.575625 10.353 0 9.64289 0H8.35717C7.64708 0 7.07146 0.575625 7.07146 1.28571V17.1492L3.55861 13.6363C3.05649 13.1342 2.24242 13.1342 1.74035 13.6363L0.831184 14.5455C0.329059 15.0476 0.329059 15.8617 0.831184 16.3637L8.09092 23.6234C8.59305 24.1255 9.40706 24.1255 9.90919 23.6234L17.1689 16.3637C17.671 15.8616 17.671 15.0475 17.1689 14.5455L16.2598 13.6363C15.7576 13.1342 14.9436 13.1342 14.4414 13.6363Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidLongArrowRight = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M13.6363 3.55861L17.1492 7.07145H1.28571C0.575625 7.07145 0 7.64708 0 8.35717V9.64289C0 10.353 0.575625 10.9286 1.28571 10.9286H17.1492L13.6363 14.4414C13.1342 14.9436 13.1342 15.7576 13.6363 16.2597L14.5455 17.1689C15.0476 17.671 15.8617 17.671 16.3637 17.1689L23.6234 9.90913C24.1255 9.40701 24.1255 8.59294 23.6234 8.09087L16.3637 0.831184C15.8616 0.329059 15.0475 0.329059 14.5455 0.831184L13.6363 1.74035C13.1342 2.24242 13.1342 3.05649 13.6363 3.55861Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidAltArrowUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '12'}
    height={height || '24'}
    viewBox="0 0 12 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M3.85714 7.18176V23.3571C3.85714 23.7122 4.14497 24 4.49999 24H7.49999C7.855 24 8.14284 23.7122 8.14284 23.3571V7.18176H10.6103C11.7557 7.18176 12.3294 5.79689 11.5194 4.98689L6.90915 0.376593C6.40702 -0.125531 5.59295 -0.125531 5.09088 0.376593L0.480588 4.98689C-0.329357 5.79683 0.244285 7.18176 1.38975 7.18176H3.85714Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidAltArrowDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '12'}
    height={height || '24'}
    viewBox="0 0 12 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M8.1429 16.8182V0.642856C8.1429 0.287839 7.85506 0 7.50004 0H4.50005C4.14503 0 3.85719 0.287839 3.85719 0.642856V16.8182H1.38975C0.244285 16.8182 -0.329357 18.2031 0.480588 19.0131L5.09088 23.6234C5.59301 24.1255 6.40708 24.1255 6.90915 23.6234L11.5194 19.0131C12.3294 18.2032 11.7557 16.8182 10.6103 16.8182H8.1429Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidAltArrowLeft = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '12'}
    viewBox="0 0 24 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M7.18176 8.1429H23.3571C23.7122 8.1429 24 7.85506 24 7.50004V4.50005C24 4.14503 23.7122 3.85719 23.3571 3.85719H7.18176V1.38975C7.18176 0.244285 5.79689 -0.329357 4.98689 0.480588L0.376593 5.09088C-0.125531 5.59301 -0.125531 6.40708 0.376593 6.90915L4.98689 11.5194C5.79683 12.3294 7.18176 11.7557 7.18176 10.6103V8.1429Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidAltArrowRight = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '12'}
    viewBox="0 0 24 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M16.8182 3.85714H0.642856C0.287839 3.85714 0 4.14498 0 4.49999V7.49999C0 7.855 0.287839 8.14284 0.642856 8.14284H16.8182V10.6103C16.8182 11.7557 18.2031 12.3294 19.0131 11.5194L23.6234 6.90915C24.1255 6.40703 24.1255 5.59295 23.6234 5.09088L19.0131 0.480588C18.2032 -0.329357 16.8182 0.244285 16.8182 1.38975V3.85714Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidCaretUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '14'}
    viewBox="0 0 24 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M22.3828 13.8053H1.61718C0.179299 13.8053 -0.540772 12.0669 0.475946 11.0501L10.8587 0.667331C11.489 0.0370777 12.511 0.0370777 13.1412 0.667331L23.524 11.0501C24.5408 12.0669 23.8207 13.8053 22.3828 13.8053Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidCaretDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '14'}
    viewBox="0 0 24 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M1.61487 0.192932H22.3851C23.822 0.192932 24.5405 1.9285 23.5233 2.94562L13.1422 13.3348C12.5126 13.9644 11.4874 13.9644 10.8578 13.3348L0.476659 2.94562C-0.540462 1.9285 0.177981 0.192932 1.61487 0.192932Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidCaretLeft = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '14'}
    height={height || '24'}
    viewBox="0 0 14 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M13.8054 1.61722V22.3828C13.8054 23.8207 12.0669 24.5408 11.0502 23.5241L0.667392 13.1413C0.0371388 12.511 0.0371388 11.489 0.667392 10.8588L11.0502 0.475981C12.0669 -0.540817 13.8054 0.179334 13.8054 1.61722Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidCaretRight = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '14'}
    height={height || '24'}
    viewBox="0 0 14 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0.194702 22.3828V1.61718C0.194702 0.179299 1.93319 -0.540772 2.9499 0.475946L13.3327 10.8587C13.963 11.489 13.963 12.511 13.3327 13.1412L2.9499 23.524C1.93319 24.5408 0.194702 23.8207 0.194702 22.3828Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleCaretUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M16.7855 13.9355H7.21452C6.69677 13.9355 6.43548 13.3065 6.80323 12.9435L11.5887 8.1871C11.8161 7.95968 12.179 7.95968 12.4065 8.1871L17.1919 12.9435C17.5645 13.3065 17.3032 13.9355 16.7855 13.9355ZM0 12C0 5.37097 5.37097 0 12 0C18.629 0 24 5.37097 24 12C24 18.629 18.629 24 12 24C5.37097 24 0 18.629 0 12ZM2.32258 12C2.32258 17.3468 6.65323 21.6774 12 21.6774C17.3468 21.6774 21.6774 17.3468 21.6774 12C21.6774 6.65323 17.3468 2.32258 12 2.32258C6.65323 2.32258 2.32258 6.65323 2.32258 12Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleCaretDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M7.21452 10.0645H16.7855C17.3032 10.0645 17.5645 10.6935 17.1968 11.0565L12.4113 15.8129C12.1839 16.0403 11.821 16.0403 11.5935 15.8129L6.80806 11.0565C6.43548 10.6935 6.69677 10.0645 7.21452 10.0645ZM24 12C24 18.629 18.629 24 12 24C5.37097 24 0 18.629 0 12C0 5.37097 5.37097 0 12 0C18.629 0 24 5.37097 24 12ZM21.6774 12C21.6774 6.65323 17.3468 2.32258 12 2.32258C6.65323 2.32258 2.32258 6.65323 2.32258 12C2.32258 17.3468 6.65323 21.6774 12 21.6774C17.3468 21.6774 21.6774 17.3468 21.6774 12Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleCaretLeft = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M13.9355 7.21452V16.7855C13.9355 17.3032 13.3065 17.5645 12.9435 17.1968L8.1871 12.4113C7.95968 12.1839 7.95968 11.821 8.1871 11.5935L12.9435 6.80806C13.3065 6.43548 13.9355 6.69677 13.9355 7.21452ZM12 24C5.37097 24 0 18.629 0 12C0 5.37097 5.37097 0 12 0C18.629 0 24 5.37097 24 12C24 18.629 18.629 24 12 24ZM12 21.6774C17.3468 21.6774 21.6774 17.3468 21.6774 12C21.6774 6.65323 17.3468 2.32258 12 2.32258C6.65323 2.32258 2.32258 6.65323 2.32258 12C2.32258 17.3468 6.65323 21.6774 12 21.6774Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleCaretRight = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M10.0645 16.7855V7.21452C10.0645 6.69677 10.6935 6.43548 11.0565 6.80323L15.8129 11.5887C16.0403 11.8161 16.0403 12.179 15.8129 12.4065L11.0565 17.1919C10.6935 17.5645 10.0645 17.3032 10.0645 16.7855ZM12 0C18.629 0 24 5.37097 24 12C24 18.629 18.629 24 12 24C5.37097 24 0 18.629 0 12C0 5.37097 5.37097 0 12 0ZM12 2.32258C6.65323 2.32258 2.32258 6.65323 2.32258 12C2.32258 17.3468 6.65323 21.6774 12 21.6774C17.3468 21.6774 21.6774 17.3468 21.6774 12C21.6774 6.65323 17.3468 2.32258 12 2.32258Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleAltArrowUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24ZM12 2.32258C17.3468 2.32258 21.6774 6.65323 21.6774 12C21.6774 17.3468 17.3468 21.6774 12 21.6774C6.65323 21.6774 2.32258 17.3468 2.32258 12C2.32258 6.65323 6.65323 2.32258 12 2.32258ZM12.9677 18.1935H11.0323C10.7129 18.1935 10.4516 17.9323 10.4516 17.6129V12H7.20968C6.69194 12 6.43548 11.3758 6.79839 11.0081L11.5887 6.21774C11.8161 5.99032 12.1839 5.99032 12.4113 6.21774L17.2016 11.0081C17.5694 11.3758 17.3081 12 16.7903 12H13.5484V17.6129C13.5484 17.9323 13.2871 18.1935 12.9677 18.1935Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleAltArrowDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0ZM12 21.6774C6.65323 21.6774 2.32258 17.3468 2.32258 12C2.32258 6.65323 6.65323 2.32258 12 2.32258C17.3468 2.32258 21.6774 6.65323 21.6774 12C21.6774 17.3468 17.3468 21.6774 12 21.6774ZM10.4516 6.3871V12H7.20968C6.69194 12 6.43548 12.6242 6.79839 12.9919L11.5887 17.7823C11.8161 18.0097 12.1839 18.0097 12.4113 17.7823L17.2016 12.9919C17.5694 12.6242 17.3081 12 16.7903 12H13.5484V6.3871C13.5484 6.06774 13.2871 5.80645 12.9677 5.80645H11.0323C10.7129 5.80645 10.4516 6.06774 10.4516 6.3871Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleAltArrowLeft = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0C5.37097 0 0 5.37097 0 12ZM21.6774 12C21.6774 17.3468 17.3468 21.6774 12 21.6774C6.65323 21.6774 2.32258 17.3468 2.32258 12C2.32258 6.65323 6.65323 2.32258 12 2.32258C17.3468 2.32258 21.6774 6.65323 21.6774 12ZM18.1935 11.0323V12.9677C18.1935 13.2871 17.9323 13.5484 17.6129 13.5484H12V16.7903C12 17.3081 11.3758 17.5645 11.0081 17.2016L6.21774 12.4113C5.99032 12.1839 5.99032 11.8161 6.21774 11.5887L11.0081 6.79839C11.3758 6.43064 12 6.69194 12 7.20968V10.4516H17.6129C17.9323 10.4516 18.1935 10.7129 18.1935 11.0323Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleAltArrowRight = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M24 12C24 5.37097 18.629 0 12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12ZM2.32258 12C2.32258 6.65323 6.65323 2.32258 12 2.32258C17.3468 2.32258 21.6774 6.65323 21.6774 12C21.6774 17.3468 17.3468 21.6774 12 21.6774C6.65323 21.6774 2.32258 17.3468 2.32258 12ZM5.80645 12.9677V11.0323C5.80645 10.7129 6.06774 10.4516 6.3871 10.4516H12V7.20968C12 6.69194 12.6242 6.43548 12.9919 6.79839L17.7823 11.5887C18.0097 11.8161 18.0097 12.1839 17.7823 12.4113L12.9919 17.2016C12.6242 17.5694 12 17.3081 12 16.7903V13.5484H6.3871C6.06774 13.5484 5.80645 13.2871 5.80645 12.9677Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleArrowUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24ZM12 2.32258C17.3468 2.32258 21.6774 6.65323 21.6774 12C21.6774 17.3468 17.3468 21.6774 12 21.6774C6.65323 21.6774 2.32258 17.3468 2.32258 12C2.32258 6.65323 6.65323 2.32258 12 2.32258ZM5.71452 11.4726L11.5887 5.59839C11.8161 5.37097 12.1839 5.37097 12.4113 5.59839L18.2855 11.4726C18.5129 11.7 18.5129 12.0677 18.2855 12.2952L17.3371 13.2435C17.1048 13.4758 16.7323 13.471 16.5048 13.2339L13.2581 9.83226V17.6129C13.2581 17.9323 12.9968 18.1935 12.6774 18.1935H11.3226C11.0032 18.1935 10.7419 17.9323 10.7419 17.6129V9.83226L7.49516 13.2339C7.26774 13.471 6.89516 13.4758 6.6629 13.2435L5.71452 12.2952C5.4871 12.0677 5.4871 11.7 5.71452 11.4726Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleArrowDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0ZM12 21.6774C6.65323 21.6774 2.32258 17.3468 2.32258 12C2.32258 6.65323 6.65323 2.32258 12 2.32258C17.3468 2.32258 21.6774 6.65323 21.6774 12C21.6774 17.3468 17.3468 21.6774 12 21.6774ZM18.2855 11.7048L17.3371 10.7565C17.1048 10.5242 16.7323 10.529 16.5048 10.7661L13.2581 14.1677V6.3871C13.2581 6.06774 12.9968 5.80645 12.6774 5.80645H11.3226C11.0032 5.80645 10.7419 6.06774 10.7419 6.3871V14.1677L7.49516 10.7661C7.26774 10.529 6.89516 10.5242 6.6629 10.7565L5.71452 11.7048C5.4871 11.9323 5.4871 12.3 5.71452 12.5274L11.5887 18.4016C11.8161 18.629 12.1839 18.629 12.4113 18.4016L18.2855 12.5274C18.5129 12.3 18.5129 11.9323 18.2855 11.7048Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleArrowLeft = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M24 12C24 5.37097 18.629 0 12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12ZM2.32258 12C2.32258 6.65323 6.65323 2.32258 12 2.32258C17.3468 2.32258 21.6774 6.65323 21.6774 12C21.6774 17.3468 17.3468 21.6774 12 21.6774C6.65323 21.6774 2.32258 17.3468 2.32258 12ZM11.4726 18.2855L5.59839 12.4113C5.37097 12.1839 5.37097 11.8161 5.59839 11.5887L11.4726 5.71452C11.7 5.4871 12.0677 5.4871 12.2952 5.71452L13.2435 6.6629C13.4758 6.89516 13.471 7.26774 13.2339 7.49516L9.83226 10.7419H17.6129C17.9323 10.7419 18.1935 11.0032 18.1935 11.3226V12.6774C18.1935 12.9968 17.9323 13.2581 17.6129 13.2581H9.83226L13.2339 16.5048C13.471 16.7323 13.4758 17.1048 13.2435 17.3371L12.2952 18.2855C12.0677 18.5129 11.7 18.5129 11.4726 18.2855Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleArrowRight = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0C5.37097 0 0 5.37097 0 12ZM21.6774 12C21.6774 17.3468 17.3468 21.6774 12 21.6774C6.65323 21.6774 2.32258 17.3468 2.32258 12C2.32258 6.65323 6.65323 2.32258 12 2.32258C17.3468 2.32258 21.6774 6.65323 21.6774 12ZM12.5274 5.71452L18.4016 11.5887C18.629 11.8161 18.629 12.1839 18.4016 12.4113L12.5274 18.2855C12.3 18.5129 11.9323 18.5129 11.7048 18.2855L10.7565 17.3371C10.5242 17.1048 10.529 16.7323 10.7661 16.5048L14.1677 13.2581H6.3871C6.06774 13.2581 5.80645 12.9968 5.80645 12.6774V11.3226C5.80645 11.0032 6.06774 10.7419 6.3871 10.7419H14.1677L10.7661 7.49516C10.529 7.26774 10.5242 6.89516 10.7565 6.6629L11.7048 5.71452C11.9323 5.4871 12.3 5.4871 12.5274 5.71452Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleChevronUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12.4113 7.52419L18.3532 13.4661C18.5806 13.6935 18.5806 14.0613 18.3532 14.2887L17.2597 15.3823C17.0323 15.6097 16.6645 15.6097 16.4371 15.3823L12 10.9452L7.5629 15.3823C7.33548 15.6097 6.96774 15.6097 6.74032 15.3823L5.64677 14.2887C5.41935 14.0613 5.41935 13.6935 5.64677 13.4661L11.5887 7.52419C11.8161 7.29677 12.1839 7.29677 12.4113 7.52419ZM24 12C24 18.629 18.629 24 12 24C5.37097 24 0 18.629 0 12C0 5.37097 5.37097 0 12 0C18.629 0 24 5.37097 24 12ZM21.6774 12C21.6774 6.65323 17.3468 2.32258 12 2.32258C6.65323 2.32258 2.32258 6.65323 2.32258 12C2.32258 17.3468 6.65323 21.6774 12 21.6774C17.3468 21.6774 21.6774 17.3468 21.6774 12Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleChevronDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0ZM12 21.6774C6.65323 21.6774 2.32258 17.3468 2.32258 12C2.32258 6.65323 6.65323 2.32258 12 2.32258C17.3468 2.32258 21.6774 6.65323 21.6774 12C21.6774 17.3468 17.3468 21.6774 12 21.6774ZM12.4113 16.4758L18.3532 10.5339C18.5806 10.3065 18.5806 9.93871 18.3532 9.71129L17.2597 8.61774C17.0323 8.39032 16.6645 8.39032 16.4371 8.61774L12 13.0548L7.5629 8.61774C7.33548 8.39032 6.96774 8.39032 6.74032 8.61774L5.64677 9.71129C5.41935 9.93871 5.41935 10.3065 5.64677 10.5339L11.5887 16.4758C11.8161 16.7032 12.1839 16.7032 12.4113 16.4758Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleChevronLeft = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M24 12C24 5.37097 18.629 0 12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12ZM2.32258 12C2.32258 6.65323 6.65323 2.32258 12 2.32258C17.3468 2.32258 21.6774 6.65323 21.6774 12C21.6774 17.3468 17.3468 21.6774 12 21.6774C6.65323 21.6774 2.32258 17.3468 2.32258 12ZM7.52419 11.5887L13.4661 5.64677C13.6935 5.41935 14.0613 5.41935 14.2887 5.64677L15.3823 6.74032C15.6097 6.96774 15.6097 7.33548 15.3823 7.5629L10.9452 12L15.3823 16.4371C15.6097 16.6645 15.6097 17.0323 15.3823 17.2597L14.2887 18.3532C14.0613 18.5806 13.6935 18.5806 13.4661 18.3532L7.52419 12.4113C7.29677 12.1839 7.29677 11.8161 7.52419 11.5887Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleChevronRight = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0C5.37097 0 0 5.37097 0 12ZM21.6774 12C21.6774 17.3468 17.3468 21.6774 12 21.6774C6.65323 21.6774 2.32258 17.3468 2.32258 12C2.32258 6.65323 6.65323 2.32258 12 2.32258C17.3468 2.32258 21.6774 6.65323 21.6774 12ZM16.4758 12.4113L10.5339 18.3532C10.3065 18.5806 9.93871 18.5806 9.71129 18.3532L8.61774 17.2597C8.39032 17.0323 8.39032 16.6645 8.61774 16.4371L13.0548 12L8.61774 7.5629C8.39032 7.33548 8.39032 6.96774 8.61774 6.74032L9.71129 5.64677C9.93871 5.41935 10.3065 5.41935 10.5339 5.64677L16.4758 11.5887C16.7032 11.8161 16.7032 12.1839 16.4758 12.4113Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularChevronUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '14'}
    viewBox="0 0 24 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0.190516 12.5982L1.26356 13.6712C1.51753 13.9252 1.92932 13.9252 2.18334 13.6712L12 3.87787L21.8167 13.6712C22.0707 13.9251 22.4825 13.9251 22.7365 13.6712L23.8095 12.5981C24.0635 12.3442 24.0635 11.9324 23.8095 11.6783L12.4599 0.328781C12.2059 0.0748139 11.7941 0.0748139 11.5401 0.328781L0.190516 11.6784C-0.0635054 11.9324 -0.0635054 12.3442 0.190516 12.5982Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularChevronDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '14'}
    viewBox="0 0 24 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.809 1.40172L22.7359 0.32867C22.4812 0.0739558 22.0693 0.0739558 21.8146 0.32867L12 10.1216L2.18539 0.32867C1.93068 0.0739558 1.5188 0.0739558 1.26408 0.32867L0.191035 1.40172C-0.0636784 1.65643 -0.0636784 2.06831 0.191035 2.32302L11.5393 13.6713C11.7941 13.9261 12.2059 13.9261 12.4607 13.6713L23.809 2.32302C24.0637 2.06831 24.0637 1.65643 23.809 1.40172Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularChevronLeft = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '14'}
    height={height || '24'}
    viewBox="0 0 14 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12.5982 23.8095L13.6712 22.7364C13.9252 22.4825 13.9252 22.0707 13.6712 21.8167L3.87787 12L13.6712 2.1833C13.9252 1.92933 13.9252 1.51754 13.6712 1.26352L12.5982 0.190475C12.3442 -0.0634918 11.9324 -0.0634918 11.6784 0.190475L0.328781 11.5401C0.0748139 11.7941 0.0748139 12.2059 0.328781 12.4599L11.6784 23.8095C11.9324 24.0635 12.3442 24.0635 12.5982 23.8095Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularChevronRight = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '14'}
    height={height || '24'}
    viewBox="0 0 14 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M1.40183 0.190516L0.328781 1.26351C0.0748139 1.51748 0.0748139 1.92927 0.328781 2.18329L10.1221 12L0.328781 21.8167C0.0748139 22.0707 0.0748139 22.4825 0.328781 22.7365L1.40183 23.8095C1.6558 24.0635 2.06758 24.0635 2.32161 23.8095L13.6712 12.4599C13.9252 12.2059 13.9252 11.7942 13.6712 11.5401L2.32161 0.190516C2.06758 -0.0635054 1.6558 -0.0635054 1.40183 0.190516Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularArrowUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0.326867 12.316L1.38753 13.3767C1.63856 13.6277 2.0456 13.6277 2.29669 13.3767L10.6072 5.06612V23.3571C10.6072 23.7122 10.895 24 11.25 24H12.75C13.1051 24 13.3929 23.7122 13.3929 23.3571V5.06612L21.7034 13.3767C21.9545 13.6277 22.3615 13.6277 22.6126 13.3767L23.6733 12.316C23.9243 12.065 23.9243 11.6579 23.6733 11.4068L12.4546 0.188277C12.2036 -0.062759 11.7965 -0.062759 11.5454 0.188277L0.326867 11.4069C0.0757774 11.6579 0.0757774 12.065 0.326867 12.316Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularArrowDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.6725 11.6833L22.6119 10.6226C22.3601 10.3709 21.953 10.3709 21.7012 10.6226L13.3927 18.9311V0.642821C13.3927 0.28927 13.1035 0 12.7499 0H11.25C10.8964 0 10.6072 0.28927 10.6072 0.642821V18.9311L2.2987 10.6226C2.04693 10.3709 1.63981 10.3709 1.38803 10.6226L0.327379 11.6833C0.0756069 11.935 0.0756069 12.3422 0.327379 12.5939L11.5446 23.8112C11.7964 24.0629 12.2035 24.0629 12.4553 23.8112L23.6725 12.5939C23.9243 12.3422 23.9243 11.935 23.6725 11.6833Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularArrowLeft = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12.3161 23.6732L13.3767 22.6125C13.6278 22.3615 13.6278 21.9544 13.3767 21.7034L5.06617 13.3929H23.3571C23.7122 13.3929 24 13.105 24 12.75V11.25C24 10.895 23.7122 10.6071 23.3571 10.6071H5.06617L13.3767 2.2966C13.6278 2.04556 13.6278 1.63852 13.3767 1.38743L12.3161 0.326827C12.065 0.0757908 11.658 0.0757908 11.4069 0.326827L0.188277 11.5454C-0.062759 11.7965 -0.062759 12.2035 0.188277 12.4546L11.4069 23.6732C11.6579 23.9243 12.065 23.9243 12.3161 23.6732Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularArrowRight = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M11.684 0.326867L10.6233 1.38753C10.3723 1.63856 10.3723 2.0456 10.6233 2.29669L18.9338 10.6072H0.642856C0.287839 10.6072 0 10.895 0 11.25V12.75C0 13.105 0.287839 13.3929 0.642856 13.3929H18.9338L10.6233 21.7034C10.3723 21.9544 10.3723 22.3615 10.6233 22.6126L11.684 23.6732C11.935 23.9243 12.342 23.9243 12.5931 23.6732L23.8117 12.4546C24.0628 12.2036 24.0628 11.7965 23.8117 11.5455L12.5931 0.326867C12.342 0.0757775 11.935 0.0757775 11.684 0.326867Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularLongArrowUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '16'}
    height={height || '24'}
    viewBox="0 0 16 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0.481452 8.16172L1.53332 9.21358C1.78806 9.46832 2.2024 9.46414 2.45195 9.20431L6.60656 4.87819V23.3569C6.60656 23.712 6.89453 24 7.24971 24H8.75039C9.10556 24 9.39353 23.712 9.39353 23.3569V4.87819L13.5482 9.20426C13.7977 9.46414 14.212 9.46832 14.4668 9.21353L15.5186 8.16166C15.7698 7.91051 15.7698 7.50329 15.5186 7.25209L8.45481 0.188362C8.20366 -0.0627872 7.79644 -0.0627872 7.54524 0.188362L0.481452 7.2522C0.230304 7.50335 0.230304 7.91057 0.481452 8.16172Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularLongArrowDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '16'}
    height={height || '24'}
    viewBox="0 0 16 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M15.516 15.8365L14.4656 14.7861C14.2084 14.5289 13.7957 14.5342 13.5492 14.7969L9.3904 19.1218V0.643108C9.3904 0.289399 9.101 0 8.74729 0H7.2467C6.89299 0 6.60359 0.289399 6.60359 0.643108V19.1218L2.45019 14.7969C2.1983 14.5396 1.78564 14.5342 1.53376 14.7861L0.483347 15.8365C0.231463 16.0884 0.231463 16.4957 0.483347 16.7476L7.54682 23.8111C7.79871 24.063 8.20601 24.063 8.45789 23.8111L15.5214 16.7476C15.7679 16.4957 15.7679 16.0884 15.516 15.8365Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularLongArrowLeft = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '16'}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M8.16172 15.5186L9.21358 14.4667C9.46832 14.212 9.46414 13.7976 9.20431 13.5481L4.87819 9.39347H23.3569C23.712 9.39347 24 9.1055 24 8.75032V7.24965C24 6.89447 23.712 6.6065 23.3569 6.6065H4.87819L9.20426 2.45188C9.46414 2.20234 9.46832 1.788 9.21353 1.53326L8.16166 0.481391C7.91051 0.230243 7.50329 0.230243 7.25209 0.481391L0.188362 7.54523C-0.0627872 7.79638 -0.0627872 8.2036 0.188362 8.4548L7.2522 15.5186C7.50335 15.7697 7.91057 15.7697 8.16172 15.5186Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularLongArrowRight = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '16'}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M15.8382 0.481451L14.7864 1.53331C14.5316 1.78805 14.5358 2.2024 14.7956 2.45194L19.1217 6.60654H0.643144C0.287968 6.60654 0 6.8945 0 7.24968V8.75035C0 9.10552 0.287968 9.39349 0.643144 9.39349H19.1217L14.7957 13.5481C14.5358 13.7976 14.5316 14.212 14.7864 14.4667L15.8383 15.5186C16.0894 15.7697 16.4966 15.7697 16.7478 15.5186L23.8116 8.45477C24.0628 8.20362 24.0628 7.7964 23.8116 7.5452L16.7477 0.481451C16.4966 0.230304 16.0894 0.230304 15.8382 0.481451Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularLongAltArrowUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '14'}
    height={height || '24'}
    viewBox="0 0 14 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12.8244 5.55509L7.45974 0.190389C7.20588 -0.063463 6.79428 -0.063463 6.54038 0.190389L1.17573 5.55509C0.766187 5.96458 1.05623 6.66481 1.63533 6.66481H5.4832V23.3499C5.4832 23.7089 5.77427 24 6.13327 24H7.86679C8.22579 24 8.51686 23.7089 8.51686 23.3499V6.66481H12.3647C12.9438 6.66481 13.2339 5.96458 12.8244 5.55509Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularLongAltArrowDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '14'}
    height={height || '24'}
    viewBox="0 0 14 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M1.17569 18.4449L6.54034 23.8096C6.79419 24.0635 7.20579 24.0635 7.4597 23.8096L12.8243 18.4449C13.2339 18.0354 12.9438 17.3352 12.3647 17.3352H8.51687V0.65007C8.51687 0.291069 8.22581 0 7.8668 0H6.13329C5.77428 0 5.48322 0.291069 5.48322 0.65007V17.3352H1.63535C1.05624 17.3352 0.766203 18.0354 1.17569 18.4449Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularLongAltArrowLeft = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '14'}
    viewBox="0 0 24 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M5.55509 1.17567L0.190389 6.54031C-0.063463 6.79417 -0.063463 7.20577 0.190389 7.45968L5.55509 12.8243C5.96463 13.2339 6.66481 12.9438 6.66481 12.3647V8.5168H23.3499C23.7089 8.5168 24 8.22573 24 7.86673V6.13321C24 5.77421 23.7089 5.48314 23.3499 5.48314H6.66481V1.63527C6.66481 1.05617 5.96458 0.766125 5.55509 1.17567Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularLongAltArrowRight = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '14'}
    viewBox="0 0 24 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M18.4449 12.8243L23.8096 7.45967C24.0635 7.20582 24.0635 6.79422 23.8096 6.54031L18.4449 1.17567C18.0354 0.766124 17.3352 1.05616 17.3352 1.63532V5.48319H0.65007C0.291069 5.48319 0 5.77426 0 6.13326V7.86678C0 8.22578 0.291069 8.51685 0.65007 8.51685H17.3352V12.3647C17.3352 12.9438 18.0354 13.2338 18.4449 12.8243Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const WarningIcon = ({ children, ...rest }: IconProps) => (
  <svg
    width="19"
    height="16.89"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M18.7862 15.0699C19.395 16.1252 18.6308 17.4444 17.4147 17.4444H1.58512C0.366716 17.4444 -0.39401 16.1232 0.213661 15.0699L8.12855 1.34671C8.7377 0.290862 10.2634 0.292775 10.8715 1.34671L18.7862 15.0699ZM9.50001 12.2326C8.662 12.2326 7.98265 12.912 7.98265 13.75C7.98265 14.588 8.662 15.2673 9.50001 15.2673C10.338 15.2673 11.0174 14.588 11.0174 13.75C11.0174 12.912 10.338 12.2326 9.50001 12.2326ZM8.05941 6.7785L8.3041 11.2646C8.31555 11.4745 8.48912 11.6389 8.69934 11.6389H10.3007C10.5109 11.6389 10.6845 11.4745 10.6959 11.2646L10.9406 6.7785C10.953 6.55176 10.7725 6.3611 10.5454 6.3611H8.45462C8.22754 6.3611 8.04704 6.55176 8.05941 6.7785Z"
      fill="white"
    />
  </svg>
);

export const SolidAdIcon = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M7.38375 9.75H9.11625L8.25 7.25531L7.38375 9.75ZM16.5 9C15.8798 9 15.375 9.50484 15.375 10.125C15.375 10.7452 15.8798 11.25 16.5 11.25C17.1202 11.25 17.625 10.7452 17.625 10.125C17.625 9.50484 17.1202 9 16.5 9ZM21.75 0H2.25C1.00781 0 0 1.00781 0 2.25V15.75C0 16.9922 1.00781 18 2.25 18H21.75C22.9922 18 24 16.9922 24 15.75V2.25C24 1.00781 22.9922 0 21.75 0ZM11.7459 13.5H10.9519C10.6327 13.5 10.3481 13.2975 10.2431 12.9961L9.89766 12H6.60281L6.25688 12.9961C6.20574 13.1433 6.11001 13.2709 5.98299 13.3613C5.85597 13.4516 5.70397 13.5001 5.54813 13.5H4.75406C4.23797 13.5 3.87609 12.9914 4.04531 12.5039L6.5625 5.25562C6.63919 5.03489 6.78272 4.84353 6.97316 4.70812C7.1636 4.5727 7.39148 4.49996 7.62516 4.5H8.87484C9.10858 4.49996 9.33652 4.57275 9.52698 4.70826C9.71743 4.84377 9.86092 5.03526 9.9375 5.25609L12.4542 12.5039C12.6234 12.9914 12.2616 13.5 11.7459 13.5ZM19.875 12.75C19.875 13.1644 19.5394 13.5 19.125 13.5H18.375C18.1477 13.5 17.9513 13.3936 17.8134 13.2338C17.4094 13.4053 16.9655 13.5 16.5 13.5C14.6391 13.5 13.125 11.9859 13.125 10.125C13.125 8.26406 14.6391 6.75 16.5 6.75C16.8966 6.75 17.2716 6.83109 17.625 6.95719V5.25C17.625 4.83563 17.9606 4.5 18.375 4.5H19.125C19.5394 4.5 19.875 4.83563 19.875 5.25V12.75Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidBullhorn = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M24 10.3333C24 9.34873 23.4604 8.49831 22.6667 8.03665V1.66706C22.6667 1.30248 22.3758 0.333313 21.3333 0.333313C21.0367 0.333313 20.7421 0.43248 20.5008 0.625813L16.9579 3.4604C15.1783 4.8829 12.9442 5.66665 10.6667 5.66665H2.66667C1.19375 5.66665 0 6.8604 0 8.33331V12.3333C0 13.8062 1.19375 15 2.66667 15H4.07083C4.01292 15.4366 3.98 15.8808 3.98 16.3333C3.98 17.9904 4.36583 19.5562 5.045 20.9558C5.26125 21.4012 5.73333 21.6666 6.22833 21.6666H9.32333C10.4087 21.6666 11.0604 20.4233 10.4025 19.56C9.71917 18.6633 9.31292 17.545 9.31292 16.3333C9.31292 15.8704 9.38042 15.4254 9.49667 15H10.6667C12.9442 15 15.1783 15.7837 16.9575 17.2062L20.5004 20.0408C20.7367 20.2299 21.0303 20.333 21.3329 20.3333C22.3713 20.3333 22.6663 19.3841 22.6663 19V12.6304C23.4604 12.1683 24 11.3179 24 10.3333ZM20 16.2258L18.6229 15.1241C16.3729 13.3241 13.5467 12.3333 10.6667 12.3333V8.33331C13.5467 8.33331 16.3729 7.34248 18.6229 5.54248L20 4.44081V16.2258Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidBars = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0.857143 4.35714H23.1429C23.6163 4.35714 24 3.97341 24 3.5V1.35714C24 0.883732 23.6163 0.5 23.1429 0.5H0.857143C0.383732 0.5 0 0.883732 0 1.35714V3.5C0 3.97341 0.383732 4.35714 0.857143 4.35714ZM0.857143 12.9286H23.1429C23.6163 12.9286 24 12.5448 24 12.0714V9.92857C24 9.45516 23.6163 9.07143 23.1429 9.07143H0.857143C0.383732 9.07143 0 9.45516 0 9.92857V12.0714C0 12.5448 0.383732 12.9286 0.857143 12.9286ZM0.857143 21.5H23.1429C23.6163 21.5 24 21.1163 24 20.6429V18.5C24 18.0266 23.6163 17.6429 23.1429 17.6429H0.857143C0.383732 17.6429 0 18.0266 0 18.5V20.6429C0 21.1163 0.383732 21.5 0.857143 21.5Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidBell = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M11 24C12.6557 24 13.9986 22.657 13.9986 21H8.00144C8.00144 22.657 9.34441 24 11 24ZM21.0964 16.9823C20.1908 16.0092 18.4963 14.5453 18.4963 9.75C18.4963 6.10781 15.9425 3.19219 12.4991 2.47688V1.5C12.4991 0.671719 11.8278 0 11 0C10.1722 0 9.50097 0.671719 9.50097 1.5V2.47688C6.05753 3.19219 3.50378 6.10781 3.50378 9.75C3.50378 14.5453 1.80925 16.0092 0.903626 16.9823C0.622376 17.2847 0.497689 17.6461 0.500032 18C0.505189 18.7687 1.10847 19.5 2.00472 19.5H19.9953C20.8916 19.5 21.4953 18.7687 21.5 18C21.5024 17.6461 21.3777 17.2842 21.0964 16.9823Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidSignIn = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M19.5 18.8115H15.5625C15.2531 18.8115 15 18.5584 15 18.249V16.374C15 16.0646 15.2531 15.8115 15.5625 15.8115H19.5C20.3297 15.8115 21 15.1412 21 14.3115V5.31152C21 4.48184 20.3297 3.81152 19.5 3.81152H15.5625C15.2531 3.81152 15 3.5584 15 3.24902V1.37402C15 1.06465 15.2531 0.811523 15.5625 0.811523H19.5C21.9844 0.811523 24 2.82715 24 5.31152V14.3115C24 16.7959 21.9844 18.8115 19.5 18.8115ZM17.2969 9.38965L9.42188 1.51465C8.71875 0.811523 7.5 1.30371 7.5 2.31152V6.81152H1.125C0.501562 6.81152 0 7.31309 0 7.93652V12.4365C0 13.06 0.501562 13.5615 1.125 13.5615H7.5V18.0615C7.5 19.0693 8.71875 19.5615 9.42188 18.8584L17.2969 10.9834C17.7328 10.5428 17.7328 9.83027 17.2969 9.38965Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidSignOut = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.6678 10.8091L15.6674 18.8094C14.9531 19.5238 13.715 19.0237 13.715 17.9999V13.4282H7.23845C6.60509 13.4282 6.09554 12.9187 6.09554 12.2853V7.71366C6.09554 7.08029 6.60509 6.57075 7.23845 6.57075H13.715V1.99909C13.715 0.979992 14.9484 0.475205 15.6674 1.18953L23.6678 9.18992C24.1107 9.63756 24.1107 10.3614 23.6678 10.8091ZM9.14331 18.5713V16.6665C9.14331 16.3522 8.88616 16.095 8.57185 16.095H4.57166C3.72876 16.095 3.04777 15.414 3.04777 14.5711V5.42783C3.04777 4.58493 3.72876 3.90395 4.57166 3.90395H8.57185C8.88616 3.90395 9.14331 3.64679 9.14331 3.33249V1.42763C9.14331 1.11333 8.88616 0.856176 8.57185 0.856176H4.57166C2.04772 0.856176 0 2.9039 0 5.42783V14.5711C0 17.0951 2.04772 19.1428 4.57166 19.1428H8.57185C8.88616 19.1428 9.14331 18.8856 9.14331 18.5713Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAdIcon = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M4.75406 13.5H5.54813C5.86734 13.5 6.15188 13.2975 6.25688 12.9961L6.60281 12H9.89766L10.2436 12.9961C10.2947 13.1433 10.3905 13.2709 10.5175 13.3613C10.6445 13.4516 10.7965 13.5001 10.9523 13.5H11.7464C12.2625 13.5 12.6244 12.9914 12.4552 12.5039L9.9375 5.25609C9.86083 5.03531 9.71732 4.84388 9.52689 4.70838C9.33646 4.57289 9.10856 4.50006 8.87484 4.5H7.62516C7.14609 4.5 6.71953 4.80328 6.5625 5.25562L4.04578 12.5039C3.87656 12.9914 4.23844 13.5 4.75406 13.5ZM8.25 7.25531L9.11625 9.75H7.38375L8.25 7.25531ZM16.5 13.5C16.9655 13.5 17.4094 13.4053 17.8134 13.2338C17.9513 13.3936 18.1477 13.5 18.375 13.5H19.125C19.5394 13.5 19.875 13.1644 19.875 12.75V5.25C19.875 4.83563 19.5394 4.5 19.125 4.5H18.375C17.9606 4.5 17.625 4.83563 17.625 5.25V6.95719C17.2716 6.83109 16.8966 6.75 16.5 6.75C14.6391 6.75 13.125 8.26406 13.125 10.125C13.125 11.9859 14.6391 13.5 16.5 13.5ZM16.5 9C17.1202 9 17.625 9.50484 17.625 10.125C17.625 10.7452 17.1202 11.25 16.5 11.25C15.8798 11.25 15.375 10.7452 15.375 10.125C15.375 9.50484 15.8798 9 16.5 9ZM21.75 0H2.25C1.00781 0 0 1.00781 0 2.25V15.75C0 16.9922 1.00781 18 2.25 18H21.75C22.9922 18 24 16.9922 24 15.75V2.25C24 1.00781 22.9922 0 21.75 0ZM21.75 15.75H2.25V2.25H21.75V15.75Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularBullhorn = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M22.6671 8.0366V1.6669C22.6671 1.30231 22.3762 0.33313 21.3341 0.33313H21.3337C21.037 0.33313 20.7424 0.432298 20.5012 0.625635L16.9582 3.46027C15.1786 4.88279 12.9444 5.66656 10.6669 5.66656H2.66671C1.19377 5.66656 0 6.86033 0 8.33327V12.3333C0 13.8063 1.19377 15.0001 2.66671 15.0001L2.64671 16.3334C2.64671 17.9905 3.03255 19.5564 3.71173 20.956C3.92798 21.4014 4.40008 21.6668 4.89509 21.6668H9.32349C10.4089 21.6668 11.0606 20.4235 10.4027 19.5601C9.71934 18.6634 9.31308 17.5451 9.31308 16.3334C9.31308 15.8705 9.38058 15.4255 9.49683 15.0001H10.6669C12.9444 15.0001 15.1786 15.7838 16.9578 17.2063L20.5008 20.041C20.7371 20.2301 21.0306 20.3332 21.3333 20.3335C22.3716 20.3335 22.6666 19.3843 22.6666 19.0001V12.6304C23.4604 12.1683 24 11.3183 24 10.3337C24.0004 9.3487 23.4608 8.49869 22.6671 8.0366ZM5.32218 19.6668C4.87383 18.6064 4.64675 17.4872 4.64675 16.3334C4.64675 15.7409 4.71842 15.2776 4.75508 15.0001H7.45971C7.37263 15.4459 7.31304 15.8921 7.31304 16.3334C7.31304 17.5093 7.58722 18.6418 8.11347 19.6668H5.32218ZM10.0002 13H2.66671C2.29921 13 2.00003 12.7008 2.00003 12.3333V8.33327C2.00003 7.96576 2.29921 7.66659 2.66671 7.66659H10.0002V13ZM20.667 17.6126L18.207 15.6442C16.4236 14.2184 14.2573 13.3371 12.0002 13.0838V7.58284C14.2573 7.3295 16.4236 6.44824 18.2074 5.02196L20.667 3.05401V17.6126Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularBars = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.3571 3.92859H0.642857C0.287839 3.92859 0 3.64075 0 3.28573V1.57145C0 1.21643 0.287839 0.928589 0.642857 0.928589H23.3571C23.7122 0.928589 24 1.21643 24 1.57145V3.28573C24 3.64075 23.7122 3.92859 23.3571 3.92859ZM23.3571 12.5H0.642857C0.287839 12.5 0 12.2122 0 11.8572V10.1429C0 9.78786 0.287839 9.50002 0.642857 9.50002H23.3571C23.7122 9.50002 24 9.78786 24 10.1429V11.8572C24 12.2122 23.7122 12.5 23.3571 12.5ZM23.3571 21.0714H0.642857C0.287839 21.0714 0 20.7836 0 20.4286V18.7143C0 18.3593 0.287839 18.0714 0.642857 18.0714H23.3571C23.7122 18.0714 24 18.3593 24 18.7143V20.4286C24 20.7836 23.7122 21.0714 23.3571 21.0714Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularBell = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.0964 16.9823C20.1908 16.0092 18.4963 14.5453 18.4963 9.75C18.4963 6.10781 15.9425 3.19219 12.4991 2.47688V1.5C12.4991 0.671719 11.8278 0 11 0C10.1722 0 9.50097 0.671719 9.50097 1.5V2.47688C6.05753 3.19219 3.50378 6.10781 3.50378 9.75C3.50378 14.5453 1.80925 16.0092 0.903626 16.9823C0.622376 17.2847 0.497689 17.6461 0.500032 18C0.505189 18.7687 1.10847 19.5 2.00472 19.5H19.9953C20.8916 19.5 21.4953 18.7687 21.5 18C21.5024 17.6461 21.3777 17.2842 21.0964 16.9823ZM3.6655 17.25C4.66019 15.9389 5.74769 13.7658 5.75284 9.77719C5.75284 9.76781 5.75003 9.75937 5.75003 9.75C5.75003 6.85031 8.10034 4.5 11 4.5C13.8997 4.5 16.25 6.85031 16.25 9.75C16.25 9.75937 16.2472 9.76781 16.2472 9.77719C16.2524 13.7662 17.3399 15.9394 18.3346 17.25H3.6655ZM11 24C12.6557 24 13.9986 22.657 13.9986 21H8.00144C8.00144 22.657 9.34441 24 11 24Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularSignIn = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M19.5 18H15.5625C15.2531 18 15 17.7469 15 17.4375V16.3125C15 16.0031 15.2531 15.75 15.5625 15.75H19.5C20.7422 15.75 21.75 14.7422 21.75 13.5V4.5C21.75 3.25781 20.7422 2.25 19.5 2.25H15.5625C15.2531 2.25 15 1.99688 15 1.6875V0.5625C15 0.253125 15.2531 0 15.5625 0H19.5C21.9844 0 24 2.01562 24 4.5V13.5C24 15.9844 21.9844 18 19.5 18ZM7.83281 0.914062L6.91406 1.83281C6.68906 2.05781 6.69375 2.41875 6.92344 2.63437L12.225 7.78125H0.5625C0.253125 7.78125 0 8.03438 0 8.34375V9.65625C0 9.96562 0.253125 10.2188 0.5625 10.2188H12.225L6.92344 15.3609C6.69844 15.5813 6.69375 15.9422 6.91406 16.1625L7.83281 17.0812C8.05313 17.3016 8.40938 17.3016 8.62969 17.0812L16.3359 9.39375C16.5562 9.17344 16.5562 8.81719 16.3359 8.59687L8.62969 0.909375C8.40938 0.69375 8.05313 0.69375 7.83281 0.914062Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularSignOut = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M4.49978 0.000427246H8.43709C8.74645 0.000427246 8.99956 0.25354 8.99956 0.5629V1.68784C8.99956 1.9972 8.74645 2.25032 8.43709 2.25032H4.49978C3.25765 2.25032 2.24989 3.25808 2.24989 4.50021V13.4998C2.24989 14.7419 3.25765 15.7497 4.49978 15.7497H8.43709C8.74645 15.7497 8.99956 16.0028 8.99956 16.3121V17.4371C8.99956 17.7464 8.74645 17.9995 8.43709 17.9995H4.49978C2.01553 17.9995 0 15.984 0 13.4998V4.50021C0 2.01595 2.01553 0.000427246 4.49978 0.000427246ZM15.3321 0.914445L14.4134 1.83315C14.1884 2.05814 14.1931 2.41906 14.4227 2.63467L19.724 7.7813H8.06211C7.75275 7.7813 7.49963 8.03441 7.49963 8.34377V9.65621C7.49963 9.96556 7.75275 10.2187 8.06211 10.2187H19.724L14.4227 15.3606C14.1977 15.5809 14.1931 15.9418 14.4134 16.1621L15.3321 17.0808C15.5524 17.3011 15.9086 17.3011 16.1289 17.0808L23.8348 9.39372C24.0551 9.17342 24.0551 8.81718 23.8348 8.59688L16.1289 0.909758C15.9086 0.694143 15.5524 0.694143 15.3321 0.914445Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAltSignIn = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M6.75 3.25124V5.66999H2.25C1.00781 5.66999 0 6.6778 0 7.91999V12.0731C0 13.3153 1.00781 14.3231 2.25 14.3231H6.75V16.7419C6.75 18.7387 9.17344 19.7512 10.5891 18.3309L17.3391 11.5856C18.2156 10.709 18.2156 9.28405 17.3391 8.4028L10.5891 1.6528C9.17812 0.251238 6.75 1.24968 6.75 3.25124ZM15.75 10.0012L9 16.7512V12.0778H2.25V7.92467H9V3.25124L15.75 10.0012ZM19.5 19.0012H15.5625C15.2531 19.0012 15 18.7481 15 18.4387V17.3137C15 17.0044 15.2531 16.7512 15.5625 16.7512H19.5C20.7422 16.7512 21.75 15.7434 21.75 14.5012V5.50124C21.75 4.25905 20.7422 3.25124 19.5 3.25124H15.5625C15.2531 3.25124 15 2.99811 15 2.68874V1.56374C15 1.25436 15.2531 1.00124 15.5625 1.00124H19.5C21.9844 1.00124 24 3.01686 24 5.50124V14.5012C24 16.9856 21.9844 19.0012 19.5 19.0012Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAltSignOut = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12.7519 3.25023V5.66933H8.25121C7.00884 5.66933 6.00088 6.67729 6.00088 7.91966V12.0734C6.00088 13.3158 7.00884 14.3237 8.25121 14.3237H12.7519V16.7428C12.7519 18.74 15.1757 19.7526 16.5915 18.3321L23.3425 11.5858C24.2192 10.7091 24.2192 9.28392 23.3425 8.40254L16.5915 1.65155C15.1803 0.249786 12.7519 1.24837 12.7519 3.25023ZM21.7532 10.0012L15.0022 16.7522V12.0781H8.25121V7.92435H15.0022V3.25023L21.7532 10.0012ZM4.50066 0.999896H8.43874C8.74816 0.999896 9.00132 1.25306 9.00132 1.56248V2.68764C9.00132 2.99706 8.74816 3.25023 8.43874 3.25023H4.50066C3.25829 3.25023 2.25033 4.25819 2.25033 5.50055V14.5019C2.25033 15.7442 3.25829 16.7522 4.50066 16.7522H8.43874C8.74816 16.7522 9.00132 17.0054 9.00132 17.3148V18.4399C9.00132 18.7494 8.74816 19.0025 8.43874 19.0025H4.50066C2.01592 19.0025 0 16.9866 0 14.5019V5.50055C0 3.01582 2.01592 0.999896 4.50066 0.999896Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidAnalytics = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.2758 4.1929C21.5013 4.28081 21.7438 4.33331 22 4.33331C23.1046 4.33331 24 3.4379 24 2.33331C24 1.22873 23.1046 0.333313 22 0.333313C20.8954 0.333313 20 1.22873 20 2.33331C20 2.43456 20.0154 2.53165 20.0296 2.62873L16.0571 5.80665C15.8321 5.71873 15.5892 5.66623 15.3329 5.66623C15.0767 5.66623 14.8342 5.71873 14.6087 5.80665L10.6371 2.62915C10.6517 2.53206 10.6667 2.43456 10.6667 2.33331C10.6667 1.22873 9.77125 0.333313 8.66667 0.333313C7.56208 0.333313 6.66667 1.22873 6.66667 2.33331C6.66667 2.51123 6.6975 2.68081 6.74083 2.84498L2.51167 7.07415C2.3475 7.03081 2.17792 6.99998 2 6.99998C0.895417 6.99998 0 7.8954 0 8.99998C0 10.1046 0.895417 11 2 11C3.10458 11 4 10.1046 4 8.99998C4 8.82206 3.96917 8.65248 3.92583 8.48831L8.155 4.25915C8.31917 4.30248 8.48875 4.33331 8.66667 4.33331C8.92292 4.33331 9.16542 4.28081 9.39083 4.1929L13.3633 7.37081C13.3488 7.4679 13.3338 7.5654 13.3338 7.66665C13.3338 8.77123 14.2292 9.66665 15.3338 9.66665C16.4383 9.66665 17.3338 8.77123 17.3338 7.66665C17.3338 7.5654 17.3183 7.46831 17.3042 7.37123L21.2758 4.1929ZM16.6667 13.6666H14C13.6317 13.6666 13.3333 13.965 13.3333 14.3333V21C13.3333 21.3683 13.6317 21.6666 14 21.6666H16.6667C17.035 21.6666 17.3333 21.3683 17.3333 21V14.3333C17.3333 13.965 17.035 13.6666 16.6667 13.6666ZM23.3333 8.33331H20.6667C20.2983 8.33331 20 8.63165 20 8.99998V21C20 21.3683 20.2983 21.6666 20.6667 21.6666H23.3333C23.7017 21.6666 24 21.3683 24 21V8.99998C24 8.63165 23.7017 8.33331 23.3333 8.33331ZM10 8.33331H7.33333C6.965 8.33331 6.66667 8.63165 6.66667 8.99998V21C6.66667 21.3683 6.965 21.6666 7.33333 21.6666H10C10.3683 21.6666 10.6667 21.3683 10.6667 21V8.99998C10.6667 8.63165 10.3683 8.33331 10 8.33331ZM3.33333 15H0.666667C0.298333 15 0 15.2983 0 15.6666V21C0 21.3683 0.298333 21.6666 0.666667 21.6666H3.33333C3.70167 21.6666 4 21.3683 4 21V15.6666C4 15.2983 3.70167 15 3.33333 15Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidChartLineUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.25 15H3V0.75C3 0.335625 2.66438 0 2.25 0H0.75C0.335625 0 0 0.335625 0 0.75V16.5C0 17.3283 0.671719 18 1.5 18H23.25C23.6644 18 24 17.6644 24 17.25V15.75C24 15.3356 23.6644 15 23.25 15ZM21.75 1.5H16.2159C15.2137 1.5 14.7117 2.71172 15.4205 3.42047L16.9392 4.93922L13.5 8.37891L10.0608 4.93969C9.47484 4.35375 8.52516 4.35375 7.93969 4.93969L4.71984 8.15953C4.42688 8.4525 4.42688 8.92734 4.71984 9.22031L5.78016 10.2806C6.07312 10.5736 6.54797 10.5736 6.84094 10.2806L9 8.12109L12.4392 11.5603C13.0252 12.1462 13.9748 12.1462 14.5603 11.5603L19.0603 7.06031L20.5791 8.57906C21.2878 9.28781 22.4995 8.78578 22.4995 7.78359V2.25C22.5 1.83562 22.1644 1.5 21.75 1.5Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidChartLineDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.25 15H3V0.75C3 0.335625 2.66438 0 2.25 0H0.75C0.335625 0 0 0.335625 0 0.75V16.5C0 17.3283 0.671719 18 1.5 18H23.25C23.6644 18 24 17.6644 24 17.25V15.75C24 15.3356 23.6644 15 23.25 15ZM22.5 11.25V5.71594C22.5 4.71375 21.2883 4.21172 20.5795 4.92047L19.0608 6.43922L14.5608 1.93922C13.9748 1.35328 13.0252 1.35328 12.4397 1.93922L9 5.37891L6.84094 3.21984C6.54797 2.92688 6.07312 2.92688 5.78016 3.21984L4.71984 4.28016C4.42688 4.57312 4.42688 5.04797 4.71984 5.34094L7.93969 8.56078C8.52563 9.14672 9.47531 9.14672 10.0608 8.56078L13.5 5.12109L16.9397 8.56078L15.4209 10.0795C14.7122 10.7883 15.2142 12 16.2164 12H21.75C22.1644 12 22.5 11.6639 22.5 11.25Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidChartNetwork = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.6 7.60002C22.9238 7.60002 24 6.52377 24 5.20002C24 3.87627 22.9238 2.80002 21.6 2.80002C20.2763 2.80002 19.2 3.87627 19.2 5.20002C19.2 6.52377 20.2763 7.60002 21.6 7.60002ZM2.4 9.40002C1.07625 9.40002 0 10.4763 0 11.8C0 13.1238 1.07625 14.2 2.4 14.2C3.72375 14.2 4.8 13.1238 4.8 11.8C4.8 10.4763 3.72375 9.40002 2.4 9.40002ZM19.26 8.00502L18.54 7.04502L16.74 8.39502L17.46 9.35503L19.26 8.00502ZM21.6 14.8C21.06 14.8 20.565 14.9875 20.1638 15.2875L16.5638 13.1275C16.7063 12.7075 16.8 12.265 16.8 11.7963C16.8 9.47502 14.9213 7.59627 12.6 7.59627C12.285 7.59627 11.9775 7.63752 11.685 7.70502L10.155 4.42752C10.5525 4.00002 10.8 3.43002 10.8 2.80002C10.8 1.47627 9.72375 0.400024 8.4 0.400024C7.07625 0.400024 6 1.47627 6 2.80002C6 4.12377 7.07625 5.20002 8.4 5.20002C8.44125 5.20002 8.47875 5.18877 8.52 5.18877L10.0575 8.48127C9.05625 9.24627 8.4 10.4425 8.4 11.8C8.4 14.1213 10.2788 16 12.6 16C13.8038 16 14.88 15.4863 15.645 14.6763L19.2375 16.8325C19.2188 16.9525 19.2 17.0763 19.2 17.2C19.2 18.5238 20.2763 19.6 21.6 19.6C22.9238 19.6 24 18.5238 24 17.2C24 15.8763 22.9238 14.8 21.6 14.8ZM12.6 13.6C11.6063 13.6 10.8 12.7938 10.8 11.8C10.8 10.8063 11.6063 10 12.6 10C13.5938 10 14.4 10.8063 14.4 11.8C14.4 12.7938 13.5938 13.6 12.6 13.6ZM5.7 12.4H7.5V11.2H5.7V12.4Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidPieChart = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.6228 13.4998H10.5V2.377C10.5 1.92935 10.1067 1.56185 9.66373 1.6242C4.08193 2.41262 -0.185502 7.28568 0.00621355 13.1281C0.196992 18.9419 5.05833 23.8028 10.8717 23.9936C16.7141 24.1853 21.5871 19.9178 22.3756 14.336C22.4379 13.8931 22.0699 13.4998 21.6228 13.4998ZM13.5374 0.00187809C13.1099 -0.0276527 12.7499 0.332811 12.7499 0.761242V11.2498H23.239C23.6674 11.2498 24.0274 10.8894 23.9984 10.4623C23.6116 4.86274 19.137 0.388122 13.5374 0.00187809Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidBarChart = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M15.6 12H17.4C17.7 12 18 11.7 18 11.4V5.1C18 4.8 17.7 4.5 17.4 4.5H15.6C15.3 4.5 15 4.8 15 5.1V11.4C15 11.7 15.3 12 15.6 12ZM20.1 12H21.9C22.2 12 22.5 11.7 22.5 11.4V0.6C22.5 0.3 22.2 0 21.9 0H20.1C19.8 0 19.5 0.3 19.5 0.6V11.4C19.5 11.7 19.8 12 20.1 12ZM6.6 12H8.4C8.7 12 9 11.7 9 11.4V8.1C9 7.8 8.7 7.5 8.4 7.5H6.6C6.3 7.5 6 7.8 6 8.1V11.4C6 11.7 6.3 12 6.6 12ZM11.1 12H12.9C13.2 12 13.5 11.7 13.5 11.4V2.1C13.5 1.8 13.2 1.5 12.9 1.5H11.1C10.8 1.5 10.5 1.8 10.5 2.1V11.4C10.5 11.7 10.8 12 11.1 12ZM23.25 15H3V0.75C3 0.335625 2.66438 0 2.25 0H0.75C0.335625 0 0 0.335625 0 0.75V16.5C0 17.3283 0.671719 18 1.5 18H23.25C23.6644 18 24 17.6644 24 17.25V15.75C24 15.3356 23.6644 15 23.25 15Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidPoll = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.4286 0H2.57143C1.15179 0 0 1.15179 0 2.57143V21.4286C0 22.8482 1.15179 24 2.57143 24H21.4286C22.8482 24 24 22.8482 24 21.4286V2.57143C24 1.15179 22.8482 0 21.4286 0ZM8.57143 18C8.57143 18.4736 8.18786 18.8571 7.71429 18.8571H6C5.52643 18.8571 5.14286 18.4736 5.14286 18V11.1429C5.14286 10.6693 5.52643 10.2857 6 10.2857H7.71429C8.18786 10.2857 8.57143 10.6693 8.57143 11.1429V18ZM13.7143 18C13.7143 18.4736 13.3307 18.8571 12.8571 18.8571H11.1429C10.6693 18.8571 10.2857 18.4736 10.2857 18V6C10.2857 5.52643 10.6693 5.14286 11.1429 5.14286H12.8571C13.3307 5.14286 13.7143 5.52643 13.7143 6V18ZM18.8571 18C18.8571 18.4736 18.4736 18.8571 18 18.8571H16.2857C15.8121 18.8571 15.4286 18.4736 15.4286 18V14.5714C15.4286 14.0979 15.8121 13.7143 16.2857 13.7143H18C18.4736 13.7143 18.8571 14.0979 18.8571 14.5714V18Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAnalytics = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M16.4211 13.5263H13.8947C13.1972 13.5263 12.6316 14.092 12.6316 14.7895V19.8421C12.6316 20.5396 13.1972 21.1052 13.8947 21.1052H16.4211C17.1186 21.1052 17.6842 20.5396 17.6842 19.8421V14.7895C17.6842 14.092 17.1186 13.5263 16.4211 13.5263ZM15.7895 19.2105H14.5263V15.421H15.7895V19.2105ZM22.7368 8.47366H20.2105C19.513 8.47366 18.9474 9.03932 18.9474 9.73682V19.8421C18.9474 20.5396 19.513 21.1052 20.2105 21.1052H22.7368C23.4343 21.1052 24 20.5396 24 19.8421V9.73682C24 9.03932 23.4343 8.47366 22.7368 8.47366ZM22.1053 19.2105H20.8421V10.3684H22.1053V19.2105ZM10.1053 8.47366H7.57895C6.88145 8.47366 6.31579 9.03932 6.31579 9.73682V19.8421C6.31579 20.5396 6.88145 21.1052 7.57895 21.1052H10.1053C10.8028 21.1052 11.3684 20.5396 11.3684 19.8421V9.73682C11.3684 9.03932 10.8028 8.47366 10.1053 8.47366ZM9.47368 19.2105H8.21053V10.3684H9.47368V19.2105ZM3.78947 14.7895H1.26316C0.565658 14.7895 0 15.3551 0 16.0526V19.8421C0 20.5396 0.565658 21.1052 1.26316 21.1052H3.78947C4.48697 21.1052 5.05263 20.5396 5.05263 19.8421V16.0526C5.05263 15.3551 4.48697 14.7895 3.78947 14.7895ZM3.15789 19.2105H1.89474V16.6842H3.15789V19.2105ZM2.52632 11C3.57276 11 4.42105 10.1517 4.42105 9.10524C4.42105 8.93669 4.39184 8.77603 4.35079 8.6205L8.35737 4.61392C8.51289 4.65498 8.67355 4.68419 8.8421 4.68419C9.08487 4.68419 9.3146 4.63445 9.52816 4.55116L13.2916 7.56182C13.2778 7.65379 13.2636 7.74616 13.2636 7.84208C13.2636 8.88853 14.1118 9.73682 15.1583 9.73682C16.2047 9.73682 17.053 8.88853 17.053 7.84208C17.053 7.74616 17.0384 7.65419 17.025 7.56221L20.7884 4.55156C21.0012 4.63445 21.2309 4.68419 21.4737 4.68419C22.5201 4.68419 23.3684 3.8359 23.3684 2.78945C23.3684 1.743 22.5201 0.894714 21.4737 0.894714C20.4272 0.894714 19.5789 1.743 19.5789 2.78945C19.5789 2.88537 19.5936 2.97735 19.607 3.06932L15.8436 6.07998C15.6304 5.99669 15.4003 5.94695 15.1575 5.94695C14.9147 5.94695 14.685 5.99669 14.4714 6.07998L10.7088 3.06971C10.7226 2.97774 10.7368 2.88537 10.7368 2.78945C10.7368 1.743 9.88855 0.894714 8.8421 0.894714C7.79566 0.894714 6.94737 1.743 6.94737 2.78945C6.94737 2.958 6.97658 3.11866 7.01763 3.27419L3.01105 7.28077C2.85553 7.23971 2.69487 7.2105 2.52632 7.2105C1.47987 7.2105 0.631579 8.05879 0.631579 9.10524C0.631579 10.1517 1.47987 11 2.52632 11Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularChartLineUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M5.51484 10.0148C5.80781 10.3078 6.28266 10.3078 6.57562 10.0148L9 7.59094L12.9698 11.5608C13.2628 11.8538 13.7377 11.8538 14.0306 11.5608L19.1972 6.39375L20.5795 7.77656C21.2883 8.48531 22.5 7.98328 22.5 6.98109V2.25C22.5 1.83562 22.1644 1.5 21.75 1.5H17.0189C16.0167 1.5 15.5147 2.71172 16.2234 3.42047L17.6063 4.80281L13.5 8.90906L9.53016 4.93922C9.23719 4.64625 8.76234 4.64625 8.46937 4.93922L4.98469 8.42391C4.69172 8.71688 4.69172 9.19172 4.98469 9.48469L5.51484 10.0148ZM23.25 15.75H2.25V0.75C2.25 0.335625 1.91438 0 1.5 0H0.75C0.335625 0 0 0.335625 0 0.75V16.5C0 17.3283 0.671719 18 1.5 18H23.25C23.6644 18 24 17.6644 24 17.25V16.5C24 16.0856 23.6644 15.75 23.25 15.75Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularChartLineDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M8.46984 8.56031C8.76281 8.85328 9.23766 8.85328 9.53063 8.56031L13.5 4.59094L17.6063 8.69719L16.2234 10.0795C15.5147 10.7883 16.0167 12 17.0189 12H21.75C22.1644 12 22.5 11.6644 22.5 11.25V6.51891C22.5 5.51672 21.2883 5.01469 20.5795 5.72344L19.1972 7.10625L14.0302 1.93969C13.7372 1.64672 13.2623 1.64672 12.9694 1.93969L9 5.90906L6.57562 3.48469C6.28266 3.19172 5.80781 3.19172 5.51484 3.48469L4.98469 4.01484C4.69172 4.30781 4.69172 4.78266 4.98469 5.07562L8.46984 8.56031ZM23.25 15.75H2.25V0.75C2.25 0.335625 1.91438 0 1.5 0H0.75C0.335625 0 0 0.335625 0 0.75V16.5C0 17.3283 0.671719 18 1.5 18H23.25C23.6644 18 24 17.6644 24 17.25V16.5C24 16.0856 23.6644 15.75 23.25 15.75Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularChartNetwork = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.3 14.1981C20.5838 14.1981 19.9388 14.4831 19.455 14.9369L16.5225 13.2606C16.6913 12.8031 16.8 12.3156 16.8 11.7981C16.8 9.47685 14.9213 7.5981 12.6 7.5981C12.285 7.5981 11.9775 7.63935 11.685 7.70685L10.4775 5.11936C11.04 4.62436 11.4 3.90811 11.4 3.10186C11.4 1.60936 10.1925 0.401855 8.7 0.401855C7.2075 0.401855 6 1.60936 6 3.10186C6 4.59436 7.2075 5.80186 8.7 5.80186C8.73375 5.80186 8.7675 5.79435 8.80125 5.79061L10.0575 8.47935C9.05625 9.24435 8.4 10.4406 8.4 11.7981C8.4 14.1194 10.2788 15.9981 12.6 15.9981C13.7513 15.9981 14.7975 15.5331 15.555 14.7794L18.6375 16.5419C18.6225 16.6581 18.6 16.7781 18.6 16.8981C18.6 18.3906 19.8075 19.5981 21.3 19.5981C22.7925 19.5981 24 18.3906 24 16.8981C24 15.4056 22.7925 14.1981 21.3 14.1981ZM8.7 3.99811C8.205 3.99811 7.8 3.59311 7.8 3.09811C7.8 2.60311 8.205 2.19811 8.7 2.19811C9.195 2.19811 9.6 2.60311 9.6 3.09811C9.6 3.59311 9.195 3.99811 8.7 3.99811ZM12.6 14.1981C11.2763 14.1981 10.2 13.1219 10.2 11.7981C10.2 10.4744 11.2763 9.3981 12.6 9.3981C13.9238 9.3981 15 10.4744 15 11.7981C15 13.1219 13.9238 14.1981 12.6 14.1981ZM21.3 17.7981C20.805 17.7981 20.4 17.3931 20.4 16.8981C20.4 16.4031 20.805 15.9981 21.3 15.9981C21.795 15.9981 22.2 16.4031 22.2 16.8981C22.2 17.3931 21.795 17.7981 21.3 17.7981ZM19.26 8.0031L18.54 7.0431L16.74 8.3931L17.46 9.3531L19.26 8.0031ZM21.6 7.5981C22.9238 7.5981 24 6.52186 24 5.19811C24 3.87436 22.9238 2.79811 21.6 2.79811C20.2763 2.79811 19.2 3.87436 19.2 5.19811C19.2 6.52186 20.2763 7.5981 21.6 7.5981ZM5.7 12.3981H7.5V11.1981H5.7V12.3981ZM2.4 9.3981C1.07625 9.3981 0 10.4744 0 11.7981C0 13.1219 1.07625 14.1981 2.4 14.1981C3.72375 14.1981 4.8 13.1219 4.8 11.7981C4.8 10.4744 3.72375 9.3981 2.4 9.3981Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularPieChart = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.6228 13.5H10.5V2.37718C10.5 1.96328 10.1634 1.61735 9.76216 1.61735C9.72935 1.61735 9.69654 1.61969 9.66326 1.62438C4.08193 2.4128 -0.185502 7.28586 0.00621355 13.1283C0.196992 18.9421 5.05833 23.803 10.8717 23.9937C10.9978 23.998 11.1243 23.9998 11.25 23.9998C16.9236 23.9998 21.604 19.7971 22.3756 14.3362C22.4379 13.8933 22.0699 13.5 21.6228 13.5ZM11.25 21.7499C11.1492 21.7499 11.047 21.748 10.9453 21.7447C6.30565 21.5924 2.40712 17.6938 2.25477 13.0542C2.12399 9.05724 4.61068 5.54776 8.25 4.27231V15.7499H19.7239C18.4756 19.2683 15.0965 21.7499 11.25 21.7499ZM13.5374 0.00205808C13.521 0.000651849 13.5046 0.000183105 13.4887 0.000183105C13.0827 0.000183105 12.7499 0.348928 12.7499 0.760953V11.25H23.239C23.6674 11.25 24.0274 10.8896 23.9984 10.4625C23.6116 4.86292 19.137 0.388302 13.5374 0.00205808Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularBarChart = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M18.6 13.5H19.65C19.95 13.5 20.25 13.2 20.25 12.9V2.1C20.25 1.8 19.95 1.5 19.65 1.5H18.6C18.3 1.5 18 1.8 18 2.1V12.9C18 13.2 18.3 13.5 18.6 13.5ZM9.6 13.5H10.65C10.95 13.5 11.25 13.2 11.25 12.9V3.6C11.25 3.3 10.95 3 10.65 3H9.6C9.3 3 9 3.3 9 3.6V12.9C9 13.2 9.3 13.5 9.6 13.5ZM14.1 13.5H15.15C15.45 13.5 15.75 13.2 15.75 12.9V6.6C15.75 6.3 15.45 6 15.15 6H14.1C13.8 6 13.5 6.3 13.5 6.6V12.9C13.5 13.2 13.8 13.5 14.1 13.5ZM23.25 15.75H2.25V0.75C2.25 0.335625 1.91438 0 1.5 0H0.75C0.335625 0 0 0.335625 0 0.75V16.5C0 17.3283 0.671719 18 1.5 18H23.25C23.6644 18 24 17.6644 24 17.25V16.5C24 16.0856 23.6644 15.75 23.25 15.75ZM5.1 13.5H6.15C6.45 13.5 6.75 13.2 6.75 12.9V9.6C6.75 9.3 6.45 9 6.15 9H5.1C4.8 9 4.5 9.3 4.5 9.6V12.9C4.5 13.2 4.8 13.5 5.1 13.5Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularPoll = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.4286 0H2.57143C1.15179 0 0 1.15179 0 2.57143V21.4286C0 22.8482 1.15179 24 2.57143 24H21.4286C22.8482 24 24 22.8482 24 21.4286V2.57143C24 1.15179 22.8482 0 21.4286 0ZM21.4286 21.4286H2.57143V2.57143H21.4286V21.4286ZM6.42857 18.8571H7.28571C7.75929 18.8571 8.14286 18.4736 8.14286 18V11.1429C8.14286 10.6693 7.75929 10.2857 7.28571 10.2857H6.42857C5.955 10.2857 5.57143 10.6693 5.57143 11.1429V18C5.57143 18.4736 5.955 18.8571 6.42857 18.8571ZM11.5714 18.8571H12.4286C12.9021 18.8571 13.2857 18.4736 13.2857 18V6C13.2857 5.52643 12.9021 5.14286 12.4286 5.14286H11.5714C11.0979 5.14286 10.7143 5.52643 10.7143 6V18C10.7143 18.4736 11.0979 18.8571 11.5714 18.8571ZM16.7143 18.8571H17.5714C18.045 18.8571 18.4286 18.4736 18.4286 18V14.5714C18.4286 14.0979 18.045 13.7143 17.5714 13.7143H16.7143C16.2407 13.7143 15.8571 14.0979 15.8571 14.5714V18C15.8571 18.4736 16.2407 18.8571 16.7143 18.8571Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidHome = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M11.6818 5.51014L4.00032 11.8367V18.665C4.00032 18.8418 4.07055 19.0113 4.19556 19.1363C4.32058 19.2613 4.49013 19.3316 4.66693 19.3316L9.33574 19.3195C9.51196 19.3186 9.68066 19.248 9.80495 19.1231C9.92925 18.9981 9.99902 18.8291 9.99902 18.6529V14.6653C9.99902 14.4885 10.0693 14.3189 10.1943 14.1939C10.3193 14.0689 10.4888 13.9987 10.6656 13.9987H13.3321C13.5089 13.9987 13.6785 14.0689 13.8035 14.1939C13.9285 14.3189 13.9987 14.4885 13.9987 14.6653V18.65C13.9984 18.7377 14.0155 18.8246 14.0489 18.9057C14.0822 18.9868 14.1313 19.0606 14.1932 19.1227C14.2552 19.1848 14.3287 19.2341 14.4097 19.2677C14.4908 19.3013 14.5776 19.3187 14.6653 19.3187L19.3325 19.3316C19.5093 19.3316 19.6788 19.2613 19.8038 19.1363C19.9289 19.0113 19.9991 18.8418 19.9991 18.665V11.8322L12.3193 5.51014C12.229 5.43736 12.1165 5.39768 12.0005 5.39768C11.8846 5.39768 11.7721 5.43736 11.6818 5.51014ZM23.8155 9.81022L20.3324 6.93919V1.16839C20.3324 1.03579 20.2797 0.908623 20.186 0.814862C20.0922 0.721101 19.965 0.668427 19.8324 0.668427H17.4993C17.3667 0.668427 17.2395 0.721101 17.1458 0.814862C17.052 0.908623 16.9993 1.03579 16.9993 1.16839V4.19357L13.2692 1.12464C12.9112 0.830072 12.462 0.669015 11.9985 0.669015C11.5349 0.669015 11.0857 0.830072 10.7277 1.12464L0.181444 9.81022C0.130818 9.85207 0.0889323 9.90348 0.0581813 9.96151C0.0274303 10.0196 0.00841634 10.0831 0.00222573 10.1485C-0.00396488 10.2139 0.00278923 10.2798 0.0221021 10.3426C0.0414151 10.4054 0.0729083 10.4637 0.114782 10.5143L1.1772 11.8059C1.21896 11.8567 1.27033 11.8987 1.32835 11.9296C1.38638 11.9605 1.44994 11.9797 1.51538 11.986C1.58082 11.9923 1.64686 11.9856 1.70973 11.9664C1.77259 11.9471 1.83104 11.9157 1.88173 11.8738L11.6818 3.80194C11.7721 3.72916 11.8846 3.68947 12.0005 3.68947C12.1165 3.68947 12.229 3.72916 12.3193 3.80194L22.1198 11.8738C22.1704 11.9157 22.2287 11.9472 22.2915 11.9665C22.3543 11.9858 22.4202 11.9926 22.4856 11.9864C22.551 11.9802 22.6145 11.9612 22.6726 11.9304C22.7306 11.8997 22.782 11.8578 22.8239 11.8072L23.8863 10.5156C23.9281 10.4647 23.9595 10.406 23.9786 10.343C23.9976 10.2799 24.0041 10.2137 23.9975 10.1482C23.9909 10.0826 23.9714 10.019 23.9402 9.96103C23.909 9.90304 23.8666 9.85178 23.8155 9.81022Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidStar = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M10.7125 1.31354L7.78319 7.25297L1.22918 8.20848C0.053853 8.37895 -0.417174 9.82792 0.435161 10.6578L5.17683 15.2784L4.05534 21.8055C3.85347 22.9853 5.09609 23.869 6.13683 23.3172L12 20.2354L17.8632 23.3172C18.9039 23.8645 20.1465 22.9853 19.9447 21.8055L18.8232 15.2784L23.5648 10.6578C24.4172 9.82792 23.9461 8.37895 22.7708 8.20848L16.2168 7.25297L13.2875 1.31354C12.7626 0.254848 11.2419 0.24139 10.7125 1.31354Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidHalfStar = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '14'}
    height={height || '24'}
    viewBox="0 0 14 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M13.2704 0C12.736 0 12.2015 0.2766 11.9249 0.834489L8.86356 7.04159L2.01419 8.03547C0.785894 8.21362 0.293639 9.72789 1.18439 10.5952L6.13975 15.424L4.96772 22.2452C4.75675 23.4688 6.04599 24.4018 7.14301 23.8251L13.2704 20.6091V0Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidAltHalfStar = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M22.7708 8.21694L16.217 7.26277L13.2883 1.33493C13.025 0.805234 12.5114 0.537476 11.9978 0.537476C11.4874 0.537476 10.9774 0.801652 10.7132 1.33493L7.78354 7.26232L1.22929 8.2156C0.0539301 8.38574 -0.417109 9.83155 0.43497 10.6599L5.17626 15.2718L4.05418 21.7857C3.89478 22.7162 4.63761 23.4626 5.46954 23.4626C5.69028 23.4626 5.9173 23.4102 6.13535 23.2947L11.9987 20.2195L17.8616 23.2956C18.0792 23.4097 18.3058 23.4617 18.5257 23.4617C19.3585 23.4617 20.1027 22.718 19.9433 21.7871L18.8225 15.2727L23.5647 10.6617C24.4172 9.83334 23.9462 8.38709 22.7708 8.21694ZM17.3199 13.7333L16.5085 14.5222L16.7002 15.6363L17.5742 20.716L13.0012 18.3165L11.9992 17.7909L12.0005 3.58849L14.2854 8.21336L14.786 9.22663L15.9058 9.38961L21.0206 10.1342L17.3199 13.7333Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidMousePointer = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '16'}
    height={height || '24'}
    viewBox="0 0 16 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M14.6651 15.4278H9.69242L12.3095 21.8024C12.4918 22.2444 12.2835 22.7399 11.8668 22.9274L9.5622 23.9318C9.13259 24.1193 8.65081 23.905 8.46851 23.4764L5.98165 17.4232L1.91928 21.6015C1.37792 22.1583 0.5 21.7291 0.5 20.9989V0.857753C0.5 0.0890034 1.4338 -0.285762 1.91923 0.255128L15.251 13.968C15.7888 14.492 15.392 15.4278 14.6651 15.4278Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidStreetView = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M17.2453 15.4575C17.0287 15.7059 16.7869 15.9309 16.5 16.0973V17.1727C19.6181 17.6105 21.75 18.4875 21.75 19.5C21.75 20.9498 17.385 22.125 12 22.125C6.615 22.125 2.25 20.9498 2.25 19.5C2.25 18.4875 4.38188 17.6109 7.5 17.1727V16.0973C7.21313 15.9309 6.97125 15.7059 6.75469 15.4575C2.75953 16.1878 0 17.7211 0 19.5C0 21.9853 5.37281 24 12 24C18.6272 24 24 21.9853 24 19.5C24 17.7211 21.2405 16.1878 17.2453 15.4575ZM12 6C13.657 6 15 4.65703 15 3C15 1.34297 13.657 0 12 0C10.343 0 9 1.34297 9 3C9 4.65703 10.343 6 12 6ZM9 15V19.5C9 20.3283 9.67172 21 10.5 21H13.5C14.3283 21 15 20.3283 15 19.5V15C15.8283 15 16.5 14.3283 16.5 13.5V9C16.5 7.75734 15.4927 6.75 14.25 6.75H13.6969C13.178 6.98578 12.6066 7.125 12 7.125C11.3934 7.125 10.822 6.98578 10.3031 6.75H9.75C8.50734 6.75 7.5 7.75734 7.5 9V13.5C7.5 14.3283 8.17172 15 9 15Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularHome = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.7589 9.64161L13.4935 1.2078C13.0738 0.858386 12.545 0.667053 11.9989 0.667053C11.4528 0.667053 10.924 0.858386 10.5043 1.2078L0.238799 9.64161C0.171656 9.6978 0.11624 9.76667 0.0757144 9.84428C0.0351887 9.92189 0.0103474 10.0067 0.00260907 10.0939C-0.0051293 10.1811 0.00438679 10.269 0.030614 10.3526C0.0568411 10.4361 0.0992657 10.5136 0.155465 10.5808L0.582134 11.0933C0.69561 11.2288 0.858233 11.3136 1.03426 11.3293C1.21029 11.3449 1.38532 11.29 1.52089 11.1766L2.66548 10.2366V17.9996C2.66647 18.3529 2.80726 18.6915 3.0571 18.9413C3.30694 19.1911 3.6455 19.3319 3.99882 19.3329H9.33219C9.68551 19.3319 10.0241 19.1911 10.2739 18.9413C10.5237 18.6915 10.6645 18.3529 10.6655 17.9996V13.6662H13.3322V17.9996C13.3332 18.3529 13.474 18.6915 13.7238 18.9413C13.9737 19.1911 14.3122 19.3319 14.6656 19.3329H19.9989C20.3506 19.3322 20.6878 19.1928 20.9374 18.9451C21.187 18.6974 21.3289 18.3612 21.3323 18.0096V10.2358L22.4794 11.1783C22.6149 11.2917 22.79 11.3466 22.966 11.3309C23.142 11.3153 23.3046 11.2304 23.4181 11.0949L23.8444 10.5829C23.9008 10.5155 23.9433 10.4377 23.9695 10.3539C23.9958 10.2701 24.0052 10.1819 23.9973 10.0945C23.9893 10.007 23.9642 9.92198 23.9233 9.84426C23.8824 9.76655 23.8265 9.69767 23.7589 9.64161ZM19.326 17.3329H15.3322V12.9995C15.3312 12.6462 15.1904 12.3077 14.9406 12.0578C14.6908 11.808 14.3522 11.6672 13.9989 11.6662H9.99886C9.64554 11.6672 9.30697 11.808 9.05714 12.0578C8.8073 12.3077 8.66651 12.6462 8.66552 12.9995V17.3329H4.66549V8.5941L11.9989 2.56823L19.3323 8.5916L19.326 17.3329Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularStar = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M22.7708 8.20848L16.2168 7.25297L13.2875 1.31354C12.7626 0.254848 11.2419 0.24139 10.7125 1.31354L7.78319 7.25297L1.22918 8.20848C0.053853 8.37895 -0.417174 9.82792 0.435161 10.6578L5.17683 15.2784L4.05534 21.8055C3.85347 22.9853 5.09609 23.869 6.13683 23.3172L12 20.2354L17.8632 23.3172C18.9039 23.8645 20.1465 22.9853 19.9447 21.8055L18.8232 15.2784L23.5648 10.6578C24.4172 9.82792 23.9461 8.37895 22.7708 8.20848ZM16.5129 14.5247L17.5761 20.7333L12 17.804L6.42394 20.7333L7.48711 14.5247L2.97422 10.1285L9.20973 9.22231L12 3.56998L14.7903 9.22231L21.0258 10.1285L16.5129 14.5247Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularHalfStar = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '14'}
    height={height || '24'}
    viewBox="0 0 14 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M13.2704 18.0634L7.44306 21.1295L8.55414 14.6411L3.83787 10.0467L10.3544 9.09968L13.2704 3.19262V0C12.736 0 12.2015 0.2766 11.9249 0.834489L8.86356 7.04159L2.01419 8.03547C0.785894 8.21362 0.293639 9.72789 1.18439 10.5952L6.13975 15.424L4.96772 22.2452C4.75675 23.4688 6.04599 24.4018 7.14301 23.8251L13.2704 20.6091V18.0634Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularStreetView = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M7.875 15.8714V18C7.875 19.4475 9.0525 20.625 10.5 20.625H13.5C14.9475 20.625 16.125 19.4475 16.125 18V15.8714C17.0114 15.4495 17.625 14.5448 17.625 13.5V10.125C17.625 8.77594 16.8239 7.61812 15.6778 7.07812C16.192 6.34688 16.5 5.46047 16.5 4.5C16.5 2.01844 14.4816 0 12 0C9.51844 0 7.5 2.01844 7.5 4.5C7.5 5.46047 7.80797 6.34688 8.32266 7.07812C7.17609 7.61812 6.375 8.77594 6.375 10.125V13.5C6.375 14.5453 6.98859 15.4495 7.875 15.8714ZM12 2.25C13.2427 2.25 14.25 3.25734 14.25 4.5C14.25 5.74266 13.2427 6.75 12 6.75C10.7573 6.75 9.75 5.74266 9.75 4.5C9.75 3.25734 10.7573 2.25 12 2.25ZM8.625 10.125C8.625 9.50484 9.13031 9 9.75 9H14.25C14.8697 9 15.375 9.50484 15.375 10.125V13.5C15.375 13.7067 15.2067 13.875 15 13.875H13.875V18C13.875 18.2067 13.7067 18.375 13.5 18.375H10.5C10.2933 18.375 10.125 18.2067 10.125 18V13.875H9C8.79328 13.875 8.625 13.7067 8.625 13.5V10.125ZM18.4505 15.7097C18.2208 16.0683 17.9559 16.4048 17.625 16.6795V17.3587C20.1178 17.8341 21.75 18.6155 21.75 19.5005C21.75 20.9503 17.385 22.1255 12 22.1255C6.615 22.1255 2.25 20.9498 2.25 19.5C2.25 18.615 3.88219 17.8341 6.375 17.3583V16.6791C6.04406 16.4044 5.77922 16.0683 5.54953 15.7092C2.21625 16.5089 0 17.9062 0 19.5C0 21.9853 5.37281 24 12 24C18.6272 24 24 21.9853 24 19.5C24 17.9062 21.7837 16.5089 18.4505 15.7097Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularBullseyePointer = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M11.7175 11.2582L1.35399 14.204C0.619957 14.4126 0.533828 15.4185 1.22189 15.7485L4.53494 17.34L0.220281 21.6546C-0.073427 21.9479 -0.073427 22.424 0.220281 22.7172L1.28286 23.7798C1.57656 24.073 2.05221 24.073 2.34543 23.7798L6.66009 19.4651L8.25153 22.7782C8.58201 23.4662 9.58749 23.3801 9.79604 22.6461L12.7413 12.2826C12.9194 11.6579 12.3422 11.0811 11.7175 11.2582ZM13.0413 16.9209L12.3601 19.3185C16.2542 19.1274 19.3549 15.9416 19.3549 12C19.3549 7.93454 16.0646 4.6452 12.0001 4.6452C8.05798 4.6452 4.87268 7.7468 4.68155 11.6405L7.07912 10.9592C7.56057 8.6826 9.58265 6.96777 12.0001 6.96777C14.775 6.96777 17.0323 9.22501 17.0323 12C17.0323 14.4174 15.3175 16.4395 13.0413 16.9209ZM12.0001 6.10352e-05C5.37251 6.10352e-05 0.000120964 5.37245 0.000120964 12C0.000120964 12.3532 0.0228628 12.7011 0.0528626 13.0466C0.220281 12.9513 0.391571 12.8594 0.584634 12.8047L2.33817 12.3063C2.33479 12.2037 2.32269 12.1035 2.32269 12C2.32269 6.6639 6.66396 2.32263 12.0001 2.32263C17.3362 2.32263 21.6774 6.6639 21.6774 12C21.6774 17.3361 17.3362 21.6774 12.0001 21.6774C11.8965 21.6774 11.7964 21.6653 11.6938 21.6619L11.1954 23.4154C11.1402 23.6099 11.043 23.7783 10.9467 23.9467C11.2946 23.9772 11.6444 23.9999 12.0001 23.9999C18.6276 23.9999 24 18.6275 24 12C24 5.37245 18.6276 6.10352e-05 12.0001 6.10352e-05Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidHorizontalArrows = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '12'}
    viewBox="0 0 24 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M4.96006 7.50003H19.0399L16.8739 9.54978C16.4139 9.9852 16.4038 10.7144 16.8517 11.1624L17.3598 11.6705C17.7992 12.1099 18.5115 12.1099 18.9508 11.6705L23.5607 7.06067C24.1465 6.47487 24.1465 5.52514 23.5607 4.93934L18.9508 0.329519C18.5115 -0.10984 17.7992 -0.10984 17.3598 0.329519L16.8517 0.837644C16.4038 1.28558 16.4139 2.01481 16.8739 2.45024L19.0399 4.50003H4.96006L7.12606 2.45028C7.58614 2.01486 7.59622 1.28563 7.14828 0.83769L6.64015 0.329566C6.2008 -0.109793 5.48848 -0.109793 5.04917 0.329566L0.439347 4.93934C-0.146449 5.52514 -0.146449 6.47487 0.439347 7.06067L5.04917 11.6705C5.48853 12.1099 6.20084 12.1099 6.64015 11.6705L7.14828 11.1624C7.59622 10.7144 7.58614 9.9852 7.12606 9.54978L4.96006 7.50003Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidVerticalArrows = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '12'}
    height={height || '24'}
    viewBox="0 0 12 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M7.50003 19.0399V4.96006L9.54978 7.12606C9.9852 7.58614 10.7144 7.59622 11.1624 7.14828L11.6705 6.64015C12.1099 6.2008 12.1099 5.48848 11.6705 5.04917L7.06067 0.439347C6.47487 -0.146449 5.52514 -0.146449 4.93934 0.439347L0.329519 5.04912C-0.10984 5.48848 -0.10984 6.2008 0.329519 6.64011L0.837644 7.14823C1.28558 7.59617 2.01481 7.58609 2.45024 7.12601L4.50003 4.96006V19.0399L2.45028 16.8739C2.01486 16.4139 1.28563 16.4038 0.837691 16.8517L0.329566 17.3598C-0.109793 17.7992 -0.109793 18.5115 0.329566 18.9508L4.93939 23.5607C5.52519 24.1465 6.47492 24.1465 7.06072 23.5607L11.6705 18.9508C12.1099 18.5115 12.1099 17.7992 11.6705 17.3598L11.1624 16.8517C10.7145 16.4038 9.98524 16.4139 9.54982 16.8739L7.50003 19.0399Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidSort = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M10.1429 17.1429H7.57142V0.857143C7.57142 0.629814 7.48112 0.411797 7.32037 0.251051C7.15963 0.0903058 6.94161 0 6.71428 0H4.99999C4.77267 0 4.55465 0.0903058 4.3939 0.251051C4.23316 0.411797 4.14285 0.629814 4.14285 0.857143V17.1429H1.57142C0.811245 17.1429 0.427138 18.0664 0.966602 18.6059L5.25232 23.7488C5.41305 23.9094 5.63098 23.9996 5.85821 23.9996C6.08544 23.9996 6.30337 23.9094 6.4641 23.7488L10.7498 18.6059C11.2866 18.0675 10.9046 17.1429 10.1429 17.1429ZM21.0334 5.39411L16.7477 0.25125C16.5869 0.090626 16.369 0.000397273 16.1418 0.000397273C15.9145 0.000397273 15.6966 0.090626 15.5359 0.25125L11.2502 5.39411C10.7134 5.9325 11.0954 6.85714 11.8571 6.85714H14.4286V23.1429C14.4286 23.3702 14.5189 23.5882 14.6796 23.7489C14.8404 23.9097 15.0584 24 15.2857 24H17C17.2273 24 17.4453 23.9097 17.6061 23.7489C17.7668 23.5882 17.8571 23.3702 17.8571 23.1429V6.85714H20.4286C21.1887 6.85714 21.5729 5.93357 21.0334 5.39411Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidExchange = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0 5.87511V5.12511C0 4.50379 0.503672 4.00011 1.125 4.00011H18V1.75011C18 0.748537 19.214 0.248146 19.9205 0.954599L23.6705 4.7046C24.1098 5.14396 24.1098 5.85627 23.6705 6.29558L19.9205 10.0456C19.2167 10.7493 18 10.2559 18 9.25012V7.00012H1.125C0.503672 7.00012 0 6.49644 0 5.87511ZM22.875 13.0001H6V10.7501C6 9.75102 4.78772 9.24637 4.07948 9.9546L0.329484 13.7046C-0.109828 14.144 -0.109828 14.8563 0.329484 15.2956L4.07948 19.0456C4.78392 19.75 6 19.255 6 18.2501V16.0001H22.875C23.4963 16.0001 24 15.4964 24 14.8751V14.1251C24 13.5038 23.4963 13.0001 22.875 13.0001Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularHorizontalArrows = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '14'}
    viewBox="0 0 24 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M16.2845 1.69656C16.0617 1.91935 16.0654 2.28175 16.2926 2.5L19.724 5.78125H4.27591L7.7073 2.5C7.9346 2.28175 7.93826 1.91935 7.71541 1.69656L6.79545 0.776589C6.57579 0.556933 6.21963 0.556933 5.99993 0.776589L0.164742 6.60226C-0.0549141 6.82192 -0.0549141 7.17807 0.164742 7.39778L5.99998 13.2234C6.21963 13.4431 6.57579 13.4431 6.79549 13.2234L7.71546 12.3034C7.93826 12.0806 7.9346 11.7182 7.70735 11.5L4.27591 8.21875H19.724L16.2926 11.5C16.0654 11.7182 16.0617 12.0806 16.2845 12.3034L17.2045 13.2234C17.4242 13.4431 17.7803 13.4431 18 13.2234L23.8353 7.39773C24.0549 7.17807 24.0549 6.82192 23.8353 6.60221L18 0.776589C17.7803 0.556933 17.4242 0.556933 17.2045 0.776589L16.2845 1.69656Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularVerticalArrows = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '14'}
    height={height || '24'}
    viewBox="0 0 14 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12.301 16.284C12.076 16.059 11.7151 16.0637 11.4995 16.2933L8.21859 19.7242V4.27575L11.4995 7.70667C11.7198 7.93165 12.0807 7.93633 12.301 7.71604L13.2197 6.79738C13.44 6.57709 13.44 6.22088 13.2197 6.00059L7.39836 0.165218C7.17807 -0.0550727 6.82185 -0.0550727 6.60156 0.165218L0.77557 6.00059C0.555279 6.22088 0.555279 6.57709 0.77557 6.79738L1.69423 7.71604C1.91921 7.94102 2.28011 7.93633 2.49571 7.70667L5.77664 4.27575V19.7242L2.49571 16.2933C2.27542 16.0684 1.91452 16.0637 1.69423 16.284L0.77557 17.2026C0.555279 17.4229 0.555279 17.7791 0.77557 17.9994L6.60156 23.8348C6.82185 24.0551 7.17807 24.0551 7.39836 23.8348L13.2244 17.9994C13.4446 17.7791 13.4446 17.4229 13.2244 17.2026L12.301 16.284Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularSort = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '20'}
    height={height || '24'}
    viewBox="0 0 20 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M8.50032 18.8571H6.14318V0.857143C6.14318 0.629814 6.05287 0.411797 5.89213 0.251051C5.73138 0.0903058 5.51336 0 5.28604 0H4.42889C4.20157 0 3.98355 0.0903058 3.8228 0.251051C3.66206 0.411797 3.57175 0.629814 3.57175 0.857143V18.8571H1.21461C1.08899 18.8571 0.966113 18.8938 0.861147 18.9628C0.756181 19.0318 0.673729 19.1301 0.62398 19.2454C0.57423 19.3607 0.559362 19.4881 0.581212 19.6118C0.603063 19.7355 0.660675 19.8501 0.746929 19.9414L4.38979 23.7986C4.44987 23.8621 4.52229 23.9127 4.60261 23.9473C4.68293 23.9819 4.76947 23.9998 4.85693 23.9998C4.94439 23.9998 5.03093 23.9819 5.11125 23.9473C5.19157 23.9127 5.26399 23.8621 5.32407 23.7986L8.96693 19.9414C9.05312 19.8502 9.11071 19.7357 9.1326 19.6121C9.15449 19.4885 9.13971 19.3612 9.09009 19.2459C9.04047 19.1306 8.95819 19.0323 8.85338 18.9633C8.74858 18.8942 8.62584 18.8573 8.50032 18.8571ZM19.2532 4.05857L15.6103 0.201428C15.5502 0.137876 15.4778 0.0872513 15.3975 0.0526524C15.3172 0.0180535 15.2306 0.000208037 15.1432 0.000208037C15.0557 0.000208037 14.9692 0.0180535 14.8889 0.0526524C14.8085 0.0872513 14.7361 0.137876 14.676 0.201428L11.0332 4.05857C10.947 4.14986 10.8894 4.26439 10.8675 4.38804C10.8456 4.51169 10.8604 4.63904 10.9101 4.75436C10.9598 4.86968 11.0422 4.96793 11.1471 5.03697C11.2519 5.10601 11.3748 5.14282 11.5003 5.14286H13.8575V23.1429C13.8575 23.3702 13.9478 23.5882 14.1085 23.7489C14.2693 23.9097 14.4873 24 14.7146 24H15.5718C15.7991 24 16.0171 23.9097 16.1778 23.7489C16.3386 23.5882 16.4289 23.3702 16.4289 23.1429V5.14286H18.786C18.9116 5.14282 19.0344 5.10601 19.1393 5.03697C19.2442 4.96793 19.3266 4.86968 19.3762 4.75436C19.4259 4.63904 19.4407 4.51169 19.4189 4.38804C19.397 4.26439 19.3394 4.14986 19.2532 4.05857Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularExchange = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.8352 5.89774L19.1302 10.5852C18.9105 10.8049 18.5543 10.8049 18.3347 10.5852L17.4147 9.66527C17.1919 9.44247 17.1956 9.08008 17.4228 8.86183L19.8242 6.625H0.562517C0.251877 6.625 1.75717e-05 6.37314 1.75717e-05 6.0625V4.9375C1.75717e-05 4.62686 0.251877 4.375 0.562517 4.375H19.8242L17.4229 2.13818C17.1956 1.91993 17.1919 1.55754 17.4148 1.33474L18.3347 0.414773C18.5544 0.195116 18.9106 0.195116 19.1302 0.414773L23.8353 5.10227C24.0549 5.32193 24.0549 5.67808 23.8352 5.89774ZM0.164783 14.8977L4.86986 19.5852C5.08951 19.8049 5.44567 19.8049 5.66533 19.5852L6.58529 18.6653C6.80809 18.4425 6.80444 18.0801 6.57719 17.8618L4.17583 15.625H23.4375C23.7481 15.625 24 15.3731 24 15.0625V13.9375C24 13.6269 23.7481 13.375 23.4375 13.375H4.17583L6.57714 11.1382C6.80443 10.9199 6.80809 10.5575 6.58525 10.3347L5.66528 9.41477C5.44562 9.19511 5.08947 9.19511 4.86981 9.41477L0.164736 14.1023C-0.0549199 14.3219 -0.0549199 14.6781 0.164783 14.8977Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAltVerticalArrows = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '12'}
    height={height || '24'}
    viewBox="0 0 12 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M10.642 18.233H7.31248V5.76702H10.642C11.1432 5.76702 11.3941 5.16111 11.0398 4.80678L6.39776 0.164743C6.17811 -0.0549142 5.82195 -0.0549142 5.60225 0.164743L0.960252 4.80678C0.605877 5.16116 0.856846 5.76702 1.35799 5.76702H4.68748V18.233H1.35794C0.856799 18.233 0.60583 18.8389 0.960205 19.1932L5.6022 23.8353C5.82186 24.0549 6.17801 24.0549 6.39772 23.8353L11.0397 19.1932C11.3941 18.8389 11.1431 18.233 10.642 18.233Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAltHorizontalArrows = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '12'}
    viewBox="0 0 24 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.8352 5.60227L19.1932 0.960282C18.8388 0.605907 18.233 0.856876 18.233 1.35802V4.6875H5.76701V1.35797C5.76701 0.856829 5.1611 0.605861 4.80677 0.960236L0.164742 5.60222C-0.0549141 5.82188 -0.0549141 6.17803 0.164742 6.39774L4.80677 11.0397C5.16115 11.3941 5.76701 11.1431 5.76701 10.642V7.3125H18.233V10.642C18.233 11.1432 18.8389 11.3941 19.1932 11.0398L23.8353 6.39778C24.0549 6.17808 24.0549 5.82192 23.8352 5.60227Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularSortDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M13.9356 16.8065H10.8389C10.6336 16.8065 10.4366 16.888 10.2914 17.0332C10.1463 17.1784 10.0647 17.3753 10.0647 17.5807V18.3548C10.0647 18.5602 10.1463 18.7571 10.2914 18.9023C10.4366 19.0475 10.6336 19.129 10.8389 19.129H13.9356C14.1409 19.129 14.3379 19.0475 14.483 18.9023C14.6282 18.7571 14.7098 18.5602 14.7098 18.3548V17.5807C14.7098 17.3753 14.6282 17.1784 14.483 17.0332C14.3379 16.888 14.1409 16.8065 13.9356 16.8065ZM7.16151 17.1936H5.0325V0.935713C5.0325 0.730387 4.95093 0.53347 4.80575 0.388283C4.66056 0.243095 4.46364 0.16153 4.25832 0.16153H3.48413C3.27881 0.16153 3.08189 0.243095 2.9367 0.388283C2.79152 0.53347 2.70995 0.730387 2.70995 0.935713V17.1936H0.580944C0.467488 17.1935 0.3565 17.2267 0.261694 17.289C0.166887 17.3513 0.0924154 17.4401 0.0474806 17.5442C0.0025459 17.6484 -0.0108833 17.7635 0.00885243 17.8752C0.0285881 17.9869 0.080624 18.0904 0.158531 18.1729L3.44881 21.6567C3.50308 21.7141 3.56849 21.7599 3.64104 21.7911C3.71359 21.8224 3.79175 21.8385 3.87074 21.8385C3.94973 21.8385 4.0279 21.8224 4.10045 21.7911C4.17299 21.7599 4.2384 21.7141 4.29267 21.6567L7.58295 18.1729C7.6608 18.0905 7.71282 17.9871 7.73259 17.8754C7.75236 17.7638 7.73901 17.6488 7.69419 17.5447C7.64938 17.4405 7.57505 17.3518 7.48039 17.2894C7.38573 17.227 7.27488 17.1937 7.16151 17.1936ZM20.1291 7.51627H10.8389C10.6336 7.51627 10.4366 7.59784 10.2914 7.74303C10.1463 7.88822 10.0647 8.08513 10.0647 8.29046V9.06464C10.0647 9.26997 10.1463 9.46688 10.2914 9.61207C10.4366 9.75726 10.6336 9.83883 10.8389 9.83883H20.1291C20.3344 9.83883 20.5313 9.75726 20.6765 9.61207C20.8217 9.46688 20.9033 9.26997 20.9033 9.06464V8.29046C20.9033 8.08513 20.8217 7.88822 20.6765 7.74303C20.5313 7.59784 20.3344 7.51627 20.1291 7.51627ZM23.2258 2.87117H10.8389C10.6336 2.87117 10.4366 2.95274 10.2914 3.09793C10.1463 3.24311 10.0647 3.44003 10.0647 3.64536V4.41954C10.0647 4.62487 10.1463 4.82178 10.2914 4.96697C10.4366 5.11216 10.6336 5.19372 10.8389 5.19372H23.2258C23.4311 5.19372 23.6281 5.11216 23.7732 4.96697C23.9184 4.82178 24 4.62487 24 4.41954V3.64536C24 3.44003 23.9184 3.24311 23.7732 3.09793C23.6281 2.95274 23.4311 2.87117 23.2258 2.87117ZM17.0323 12.1614H10.8389C10.6336 12.1614 10.4366 12.2429 10.2914 12.3881C10.1463 12.5333 10.0647 12.7302 10.0647 12.9356V13.7097C10.0647 13.9151 10.1463 14.112 10.2914 14.2572C10.4366 14.4024 10.6336 14.4839 10.8389 14.4839H17.0323C17.2377 14.4839 17.4346 14.4024 17.5798 14.2572C17.725 14.112 17.8065 13.9151 17.8065 13.7097V12.9356C17.8065 12.7302 17.725 12.5333 17.5798 12.3881C17.4346 12.2429 17.2377 12.1614 17.0323 12.1614Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAltSortDown = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M14.7098 4.41905V3.64487C14.7098 3.43954 14.6282 3.24262 14.483 3.09744C14.3379 2.95225 14.1409 2.87068 13.9356 2.87068H10.8389C10.6336 2.87068 10.4366 2.95225 10.2914 3.09744C10.1463 3.24262 10.0647 3.43954 10.0647 3.64487V4.41905C10.0647 4.62438 10.1463 4.82129 10.2914 4.96648C10.4366 5.11167 10.6336 5.19323 10.8389 5.19323H13.9356C14.1409 5.19323 14.3379 5.11167 14.483 4.96648C14.6282 4.82129 14.7098 4.62438 14.7098 4.41905ZM7.16151 17.1931H5.0325V0.935225C5.0325 0.729899 4.95093 0.532982 4.80575 0.387794C4.66056 0.242607 4.46364 0.161041 4.25832 0.161041H3.48413C3.27881 0.161041 3.08189 0.242607 2.9367 0.387794C2.79152 0.532982 2.70995 0.729899 2.70995 0.935225V17.1931H0.580944C0.467488 17.193 0.3565 17.2262 0.261694 17.2885C0.166887 17.3508 0.0924154 17.4396 0.0474806 17.5438C0.0025459 17.6479 -0.0108833 17.763 0.00885243 17.8747C0.0285881 17.9864 0.080624 18.0899 0.158531 18.1724L3.44881 21.6562C3.50121 21.7119 3.56409 21.7567 3.63384 21.788C3.70359 21.8193 3.77884 21.8366 3.85527 21.8387C3.9317 21.8409 4.0078 21.8279 4.07921 21.8006C4.15062 21.7733 4.21592 21.7321 4.27138 21.6795L4.29461 21.6562L7.58489 18.1724C7.66285 18.0899 7.7149 17.9863 7.73461 17.8745C7.75431 17.7627 7.7408 17.6475 7.69575 17.5433C7.65069 17.4391 7.57607 17.3504 7.48112 17.2881C7.38616 17.2259 7.27504 17.1928 7.16151 17.1931ZM20.9033 13.7093V12.9351C20.9033 12.7297 20.8217 12.5328 20.6765 12.3876C20.5313 12.2425 20.3344 12.1609 20.1291 12.1609H10.8389C10.6336 12.1609 10.4366 12.2425 10.2914 12.3876C10.1463 12.5328 10.0647 12.7297 10.0647 12.9351V13.7093C10.0647 13.9146 10.1463 14.1115 10.2914 14.2567C10.4366 14.4019 10.6336 14.4834 10.8389 14.4834H20.1291C20.3344 14.4834 20.5313 14.4019 20.6765 14.2567C20.8217 14.1115 20.9033 13.9146 20.9033 13.7093ZM24 18.3544V17.5802C24 17.3748 23.9184 17.1779 23.7732 17.0327C23.6281 16.8876 23.4311 16.806 23.2258 16.806H10.8389C10.6336 16.806 10.4366 16.8876 10.2914 17.0327C10.1463 17.1779 10.0647 17.3748 10.0647 17.5802V18.3544C10.0647 18.5597 10.1463 18.7566 10.2914 18.9018C10.4366 19.047 10.6336 19.1285 10.8389 19.1285H23.2258C23.4311 19.1285 23.6281 19.047 23.7732 18.9018C23.9184 18.7566 24 18.5597 24 18.3544ZM17.8065 9.06415V8.28997C17.8065 8.08464 17.725 7.88773 17.5798 7.74254C17.4346 7.59735 17.2377 7.51579 17.0323 7.51579H10.8389C10.6336 7.51579 10.4366 7.59735 10.2914 7.74254C10.1463 7.88773 10.0647 8.08464 10.0647 8.28997V9.06415C10.0647 9.26948 10.1463 9.4664 10.2914 9.61158C10.4366 9.75677 10.6336 9.83834 10.8389 9.83834H17.0323C17.2377 9.83834 17.4346 9.75677 17.5798 9.61158C17.725 9.4664 17.8065 9.26948 17.8065 9.06415Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularSortUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M13.9352 16.8065H10.8383C10.633 16.8065 10.4361 16.8881 10.2909 17.0333C10.1457 17.1785 10.0641 17.3754 10.0641 17.5807V18.3549C10.0641 18.5603 10.1457 18.7572 10.2909 18.9024C10.4361 19.0476 10.633 19.1291 10.8383 19.1291H13.9352C14.1405 19.1291 14.3375 19.0476 14.4827 18.9024C14.6279 18.7572 14.7094 18.5603 14.7094 18.3549V17.5807C14.7094 17.3754 14.6279 17.1785 14.4827 17.0333C14.3375 16.8881 14.1405 16.8065 13.9352 16.8065ZM0.58 4.80617H2.70909V21.0647C2.70909 21.27 2.79066 21.4669 2.93585 21.6121C3.08105 21.7573 3.27797 21.8389 3.48331 21.8389H4.25752C4.46286 21.8389 4.65978 21.7573 4.80497 21.6121C4.95017 21.4669 5.03174 21.27 5.03174 21.0647V4.80617H7.16083C7.27429 4.80623 7.38528 4.77305 7.48009 4.71073C7.5749 4.6484 7.64938 4.55967 7.69431 4.45548C7.73925 4.3513 7.75268 4.23624 7.73294 4.12451C7.7132 4.01277 7.66117 3.90927 7.58326 3.82679L4.29284 0.342824C4.23857 0.28542 4.17316 0.239694 4.10061 0.208442C4.02806 0.177191 3.94989 0.161072 3.8709 0.161072C3.7919 0.161072 3.71374 0.177191 3.64118 0.208442C3.56863 0.239694 3.50322 0.28542 3.44895 0.342824L0.158537 3.82679C0.080684 3.90921 0.0286637 4.01263 0.00889496 4.12427C-0.0108738 4.23591 0.00247388 4.3509 0.047291 4.45504C0.0921082 4.55919 0.166434 4.64793 0.261098 4.71033C0.355762 4.77273 0.466622 4.80604 0.58 4.80617ZM20.1289 7.51593H10.8383C10.633 7.51593 10.4361 7.59749 10.2909 7.74269C10.1457 7.88788 10.0641 8.08481 10.0641 8.29014V9.06435C10.0641 9.26969 10.1457 9.46661 10.2909 9.61181C10.4361 9.757 10.633 9.83857 10.8383 9.83857H20.1289C20.3343 9.83857 20.5312 9.757 20.6764 9.61181C20.8216 9.46661 20.9031 9.26969 20.9031 9.06435V8.29014C20.9031 8.08481 20.8216 7.88788 20.6764 7.74269C20.5312 7.59749 20.3343 7.51593 20.1289 7.51593ZM23.2258 2.87064H10.8383C10.633 2.87064 10.4361 2.9522 10.2909 3.0974C10.1457 3.24259 10.0641 3.43952 10.0641 3.64485V4.41907C10.0641 4.6244 10.1457 4.82132 10.2909 4.96652C10.4361 5.11171 10.633 5.19328 10.8383 5.19328H23.2258C23.4311 5.19328 23.628 5.11171 23.7732 4.96652C23.9184 4.82132 24 4.6244 24 4.41907V3.64485C24 3.43952 23.9184 3.24259 23.7732 3.0974C23.628 2.9522 23.4311 2.87064 23.2258 2.87064ZM17.0321 12.1612H10.8383C10.633 12.1612 10.4361 12.2428 10.2909 12.388C10.1457 12.5332 10.0641 12.7301 10.0641 12.9354V13.7096C10.0641 13.915 10.1457 14.1119 10.2909 14.2571C10.4361 14.4023 10.633 14.4839 10.8383 14.4839H17.0321C17.2374 14.4839 17.4343 14.4023 17.5795 14.2571C17.7247 14.1119 17.8063 13.915 17.8063 13.7096V12.9354C17.8063 12.7301 17.7247 12.5332 17.5795 12.388C17.4343 12.2428 17.2374 12.1612 17.0321 12.1612Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAltSortUp = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M10.8383 14.4839H20.1289C20.3343 14.4839 20.5312 14.4023 20.6764 14.2571C20.8216 14.1119 20.9031 13.915 20.9031 13.7096V12.9354C20.9031 12.7301 20.8216 12.5332 20.6764 12.388C20.5312 12.2428 20.3343 12.1612 20.1289 12.1612H10.8383C10.633 12.1612 10.4361 12.2428 10.2909 12.388C10.1457 12.5332 10.0641 12.7301 10.0641 12.9354V13.7096C10.0641 13.915 10.1457 14.1119 10.2909 14.2571C10.4361 14.4023 10.633 14.4839 10.8383 14.4839ZM10.8383 5.19328H13.9352C14.1405 5.19328 14.3375 5.11171 14.4827 4.96652C14.6279 4.82132 14.7094 4.6244 14.7094 4.41907V3.64485C14.7094 3.43952 14.6279 3.24259 14.4827 3.0974C14.3375 2.9522 14.1405 2.87064 13.9352 2.87064H10.8383C10.633 2.87064 10.4361 2.9522 10.2909 3.0974C10.1457 3.24259 10.0641 3.43952 10.0641 3.64485V4.41907C10.0641 4.6244 10.1457 4.82132 10.2909 4.96652C10.4361 5.11171 10.633 5.19328 10.8383 5.19328ZM10.8383 9.83857H17.0321C17.2374 9.83857 17.4343 9.757 17.5795 9.61181C17.7247 9.46661 17.8063 9.26969 17.8063 9.06435V8.29014C17.8063 8.08481 17.7247 7.88788 17.5795 7.74269C17.4343 7.59749 17.2374 7.51593 17.0321 7.51593H10.8383C10.633 7.51593 10.4361 7.59749 10.2909 7.74269C10.1457 7.88788 10.0641 8.08481 10.0641 8.29014V9.06435C10.0641 9.26969 10.1457 9.46661 10.2909 9.61181C10.4361 9.757 10.633 9.83857 10.8383 9.83857ZM23.2258 16.8065H10.8383C10.633 16.8065 10.4361 16.8881 10.2909 17.0333C10.1457 17.1785 10.0641 17.3754 10.0641 17.5807V18.3549C10.0641 18.5603 10.1457 18.7572 10.2909 18.9024C10.4361 19.0476 10.633 19.1291 10.8383 19.1291H23.2258C23.4311 19.1291 23.628 19.0476 23.7732 18.9024C23.9184 18.7572 24 18.5603 24 18.3549V17.5807C24 17.3754 23.9184 17.1785 23.7732 17.0333C23.628 16.8881 23.4311 16.8065 23.2258 16.8065ZM0.58 4.80617H2.70909V21.0647C2.70909 21.27 2.79066 21.4669 2.93585 21.6121C3.08105 21.7573 3.27797 21.8389 3.48331 21.8389H4.25752C4.46286 21.8389 4.65978 21.7573 4.80497 21.6121C4.95017 21.4669 5.03174 21.27 5.03174 21.0647V4.80617H7.16083C7.27429 4.80623 7.38528 4.77305 7.48009 4.71073C7.5749 4.6484 7.64938 4.55967 7.69431 4.45548C7.73925 4.3513 7.75268 4.23624 7.73294 4.12451C7.7132 4.01277 7.66117 3.90927 7.58326 3.82679L4.29284 0.342824C4.23857 0.28542 4.17316 0.239694 4.10061 0.208442C4.02806 0.177191 3.94989 0.161072 3.8709 0.161072C3.7919 0.161072 3.71374 0.177191 3.64118 0.208442C3.56863 0.239694 3.50322 0.28542 3.44895 0.342824L0.158537 3.82679C0.080684 3.90921 0.0286637 4.01263 0.00889496 4.12427C-0.0108738 4.23591 0.00247388 4.3509 0.047291 4.45504C0.0921082 4.55919 0.166434 4.64793 0.261098 4.71033C0.355762 4.77273 0.466622 4.80604 0.58 4.80617Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidUnlock = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M19.25 12H7.62499V7.16722C7.62499 5.31097 9.11092 3.76879 10.9672 3.75004C12.8422 3.73129 14.375 5.25472 14.375 7.12503V7.87503C14.375 8.49847 14.8765 9.00003 15.5 9.00003H17C17.6234 9.00003 18.125 8.49847 18.125 7.87503V7.12503C18.125 3.18754 14.914 -0.0140163 10.9765 4.61492e-05C7.03905 0.0141086 3.87499 3.25785 3.87499 7.19535V12H2.75C1.50781 12 0.5 13.0078 0.5 14.25V21.75C0.5 22.9922 1.50781 24 2.75 24H19.25C20.4921 24 21.5 22.9922 21.5 21.75V14.25C21.5 13.0078 20.4921 12 19.25 12Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidAltUnlock = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M19.25 12H7.62499V7.16722C7.62499 5.31097 9.11092 3.76879 10.9672 3.75004C12.8422 3.73129 14.375 5.25472 14.375 7.12503V7.87503C14.375 8.49847 14.8765 9.00003 15.5 9.00003H17C17.6234 9.00003 18.125 8.49847 18.125 7.87503V7.12503C18.125 3.18754 14.914 -0.0140163 10.9765 4.61492e-05C7.03905 0.0141086 3.87499 3.25785 3.87499 7.19535V12H2.75C1.50781 12 0.5 13.0078 0.5 14.25V21.75C0.5 22.9922 1.50781 24 2.75 24H19.25C20.4921 24 21.5 22.9922 21.5 21.75V14.25C21.5 13.0078 20.4921 12 19.25 12ZM12.875 19.125C12.875 20.1609 12.0359 21 11 21C9.96404 21 9.12498 20.1609 9.12498 19.125V16.875C9.12498 15.8391 9.96404 15 11 15C12.0359 15 12.875 15.8391 12.875 16.875V19.125Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidLock = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M19.25 10.5H18.125V7.125C18.125 3.19687 14.9281 0 11 0C7.07187 0 3.875 3.19687 3.875 7.125V10.5H2.75C1.50781 10.5 0.5 11.5078 0.5 12.75V21.75C0.5 22.9922 1.50781 24 2.75 24H19.25C20.4922 24 21.5 22.9922 21.5 21.75V12.75C21.5 11.5078 20.4922 10.5 19.25 10.5ZM14.375 10.5H7.625V7.125C7.625 5.26406 9.13906 3.75 11 3.75C12.8609 3.75 14.375 5.26406 14.375 7.125V10.5Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidAltLock = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M19.25 10.5H18.125V7.125C18.125 3.19687 14.9281 0 11 0C7.07187 0 3.875 3.19687 3.875 7.125V10.5H2.75C1.50781 10.5 0.5 11.5078 0.5 12.75V21.75C0.5 22.9922 1.50781 24 2.75 24H19.25C20.4922 24 21.5 22.9922 21.5 21.75V12.75C21.5 11.5078 20.4922 10.5 19.25 10.5ZM12.875 18.375C12.875 19.4109 12.0359 20.25 11 20.25C9.96406 20.25 9.125 19.4109 9.125 18.375V16.125C9.125 15.0891 9.96406 14.25 11 14.25C12.0359 14.25 12.875 15.0891 12.875 16.125V18.375ZM14.375 10.5H7.625V7.125C7.625 5.26406 9.13906 3.75 11 3.75C12.8609 3.75 14.375 5.26406 14.375 7.125V10.5Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidOpenLock = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M17.6458 0.333354C14.1458 0.345854 11.3333 3.22919 11.3333 6.72919V9.66669H2C0.895833 9.66669 0 10.5625 0 11.6667V19.6667C0 20.7709 0.895833 21.6667 2 21.6667H16.6667C17.7708 21.6667 18.6667 20.7709 18.6667 19.6667V11.6667C18.6667 10.5625 17.7708 9.66669 16.6667 9.66669H14.6667V6.70419C14.6667 5.05419 15.9875 3.68335 17.6375 3.66669C19.3042 3.65002 20.6667 5.00419 20.6667 6.66669V10C20.6667 10.5542 21.1125 11 21.6667 11H23C23.5542 11 24 10.5542 24 10V6.66669C24 3.16669 21.1458 0.320854 17.6458 0.333354Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidAltOpenLock = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M17.6458 0.333354C14.1458 0.345854 11.3333 3.22919 11.3333 6.72919V9.66669H2C0.895833 9.66669 0 10.5625 0 11.6667V19.6667C0 20.7709 0.895833 21.6667 2 21.6667H16.6667C17.7708 21.6667 18.6667 20.7709 18.6667 19.6667V11.6667C18.6667 10.5625 17.7708 9.66669 16.6667 9.66669H14.6667V6.70419C14.6667 5.05419 15.9875 3.68335 17.6375 3.66669C19.3042 3.65002 20.6667 5.00419 20.6667 6.66669V10C20.6667 10.5542 21.1125 11 21.6667 11H23C23.5542 11 24 10.5542 24 10V6.66669C24 3.16669 21.1458 0.320854 17.6458 0.333354ZM11 16.6667C11 17.5875 10.2542 18.3334 9.33333 18.3334C8.4125 18.3334 7.66667 17.5875 7.66667 16.6667V14.6667C7.66667 13.7459 8.4125 13 9.33333 13C10.2542 13 11 13.7459 11 14.6667V16.6667Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularUnlock = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M19.25 11.25H6.49999V6.80626C6.49999 4.33127 8.47343 2.27346 10.9531 2.25002C13.4562 2.22189 15.5 4.25158 15.5 6.75001V7.87501C15.5 8.49845 16.0015 9.00001 16.625 9.00001C17.2484 9.00001 17.75 8.49845 17.75 7.87501V6.81564C17.75 3.08439 14.75 0.00939667 11.0141 2.16765e-05C7.28749 -0.00935331 4.25 3.02346 4.25 6.75001V11.25H2.75C1.50781 11.25 0.5 12.2578 0.5 13.5V21.75C0.5 22.9922 1.50781 24 2.75 24H19.25C20.4922 24 21.5 22.9922 21.5 21.75V13.5C21.5 12.2578 20.4922 11.25 19.25 11.25ZM19.25 21.75H2.75V13.5H19.25V21.75Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAltUnlock = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M19.25 11.25H6.49999V6.80626C6.49999 4.33127 8.47343 2.27346 10.9531 2.25002C13.4562 2.22189 15.5 4.25158 15.5 6.75001V7.87501C15.5 8.49845 16.0015 9.00001 16.625 9.00001C17.2484 9.00001 17.75 8.49845 17.75 7.87501V6.81564C17.75 3.08439 14.75 0.00939667 11.0141 2.16765e-05C7.28749 -0.00935331 4.25 3.02346 4.25 6.75001V11.25H2.75C1.50781 11.25 0.5 12.2578 0.5 13.5V21.75C0.5 22.9922 1.50781 24 2.75 24H19.25C20.4922 24 21.5 22.9922 21.5 21.75V13.5C21.5 12.2578 20.4922 11.25 19.25 11.25ZM19.25 21.75H2.75V13.5H19.25V21.75ZM11 20.25C10.2734 20.25 9.68749 19.6641 9.68749 18.9375V16.3125C9.68749 15.5859 10.2734 15 11 15C11.7266 15 12.3125 15.5859 12.3125 16.3125V18.9375C12.3125 19.6641 11.7266 20.25 11 20.25Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularLock = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M19.25 9.00001H17.75V6.81564C17.75 3.08439 14.75 0.00939667 11.0187 2.16765e-05C7.28749 -0.00935331 4.25 3.02346 4.25 6.75001V9.00001H2.75C1.50781 9.00001 0.5 10.0078 0.5 11.25V21.75C0.5 22.9922 1.50781 24 2.75 24H19.25C20.4922 24 21.5 22.9922 21.5 21.75V11.25C21.5 10.0078 20.4922 9.00001 19.25 9.00001ZM6.49999 6.75001C6.49999 4.27033 8.52031 2.25002 11 2.25002C13.4797 2.25002 15.5 4.27033 15.5 6.75001V9.00001H6.49999V6.75001ZM19.25 21.75H2.75V11.25H19.25V21.75Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAltLock = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M11 19.3125C10.2734 19.3125 9.68749 18.7266 9.68749 18V15C9.68749 14.2734 10.2734 13.6875 11 13.6875C11.7266 13.6875 12.3125 14.2734 12.3125 15V18C12.3125 18.7266 11.7266 19.3125 11 19.3125ZM21.5 11.25V21.75C21.5 22.9922 20.4922 24 19.25 24H2.75C1.50781 24 0.5 22.9922 0.5 21.75V11.25C0.5 10.0078 1.50781 9.00001 2.75 9.00001H4.25V6.75001C4.25 3.02346 7.28749 -0.00935331 11.0187 2.16765e-05C14.75 0.00939667 17.75 3.08439 17.75 6.81564V9.00001H19.25C20.4922 9.00001 21.5 10.0078 21.5 11.25ZM6.49999 9.00001H15.5V6.75001C15.5 4.27033 13.4797 2.25002 11 2.25002C8.52031 2.25002 6.49999 4.27033 6.49999 6.75001V9.00001ZM19.25 11.25H2.75V21.75H19.25V11.25Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularOpenLock = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M18.0125 0.333332C14.7 0.324999 12 3.02083 12 6.33333V8.33333H2C0.895833 8.33333 0 9.22917 0 10.3333V19.6667C0 20.7708 0.895833 21.6667 2 21.6667H16.6667C17.7708 21.6667 18.6667 20.7708 18.6667 19.6667V10.3333C18.6667 9.22917 17.7708 8.33333 16.6667 8.33333H14V6.38333C14 4.18333 15.7542 2.35417 17.9583 2.33333C20.1833 2.30833 22 4.1125 22 6.33333V8.66667C22 9.22083 22.4458 9.66667 23 9.66667C23.5542 9.66667 24 9.22083 24 8.66667V6.39166C24 3.075 21.3333 0.341666 18.0125 0.333332ZM16.6667 10.3333V19.6667H2V10.3333H16.6667Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAltOpenLock = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M18.0125 0.333332C14.7 0.324999 12 3.02083 12 6.33333V8.33333H2C0.895833 8.33333 0 9.22917 0 10.3333V19.6667C0 20.7708 0.895833 21.6667 2 21.6667H16.6667C17.7708 21.6667 18.6667 20.7708 18.6667 19.6667V10.3333C18.6667 9.22917 17.7708 8.33333 16.6667 8.33333H14V6.38333C14 4.18333 15.7542 2.35417 17.9583 2.33333C20.1833 2.30833 22 4.1125 22 6.33333V8.66667C22 9.22083 22.4458 9.66667 23 9.66667C23.5542 9.66667 24 9.22083 24 8.66667V6.39166C24 3.075 21.3333 0.341666 18.0125 0.333332ZM16.6667 10.3333V19.6667H2V10.3333H16.6667ZM9.375 17.5C8.72917 17.5 8.20833 16.9792 8.20833 16.3333V13.6667C8.20833 13.0208 8.72917 12.5 9.375 12.5C10.0208 12.5 10.5417 13.0208 10.5417 13.6667V16.3333C10.5417 16.9792 10.0208 17.5 9.375 17.5Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCreditCard = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.9958 0.666656H2.00417C0.895833 0.666656 0 1.56249 0 2.66666V17.3333C0 18.4375 0.895833 19.3333 2.00417 19.3333H21.9958C23.1042 19.3333 24 18.4375 24 17.3333V2.66666C24 1.56249 23.1042 0.666656 21.9958 0.666656ZM2.25417 2.66666H21.7458C21.8833 2.66666 21.9958 2.77916 21.9958 2.91666V4.66666H2.00417V2.91666C2.00417 2.77916 2.11667 2.66666 2.25417 2.66666ZM21.7458 17.3333H2.25417C2.11667 17.3333 2.00417 17.2208 2.00417 17.0833V9.99999H21.9958V17.0833C21.9958 17.2208 21.8833 17.3333 21.7458 17.3333ZM8 13.1667V14.8333C8 15.1083 7.775 15.3333 7.5 15.3333H4.5C4.225 15.3333 4 15.1083 4 14.8333V13.1667C4 12.8917 4.225 12.6667 4.5 12.6667H7.5C7.775 12.6667 8 12.8917 8 13.1667ZM16 13.1667V14.8333C16 15.1083 15.775 15.3333 15.5 15.3333H9.83333C9.55833 15.3333 9.33333 15.1083 9.33333 14.8333V13.1667C9.33333 12.8917 9.55833 12.6667 9.83333 12.6667H15.5C15.775 12.6667 16 12.8917 16 13.1667Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCoins = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M15 0C10.0312 0 6 1.67812 6 3.75V6.21563C2.50781 6.73125 0 8.11875 0 9.75V20.25C0 22.3219 4.03125 24 9 24C13.9688 24 18 22.3219 18 20.25V17.7797C21.4922 17.2641 24 15.8813 24 14.25V3.75C24 1.67812 19.9688 0 15 0ZM15.75 20.0766C15.2812 20.625 12.9187 21.75 9 21.75C5.08125 21.75 2.71875 20.625 2.25 20.0766V18.225C3.9 19.0031 6.30937 19.5 9 19.5C11.6906 19.5 14.1 19.0031 15.75 18.225V20.0766ZM15.75 15.5766C15.2812 16.125 12.9187 17.25 9 17.25C5.08125 17.25 2.71875 16.125 2.25 15.5766V13.4719C3.9 14.4094 6.30937 15 9 15C11.6906 15 14.1 14.4047 15.75 13.4719V15.5766ZM9 12.75C5.27344 12.75 2.25 11.7422 2.25 10.5C2.25 9.25781 5.27344 8.25 9 8.25C12.7266 8.25 15.75 9.25781 15.75 10.5C15.75 11.7422 12.7266 12.75 9 12.75ZM21.75 14.0766C21.4172 14.4656 20.1141 15.1359 18 15.5016V13.2656C19.4531 13.05 20.7516 12.6984 21.75 12.225V14.0766ZM21.75 9.57656C21.4172 9.96562 20.1141 10.6359 18 11.0016V9.75C18 9.4125 17.8828 9.08438 17.6813 8.77031C19.2656 8.52188 20.6812 8.07656 21.75 7.46719V9.57656ZM15 6.75C14.7656 6.75 14.5406 6.73594 14.3109 6.72656C13.0922 6.35625 11.6484 6.10781 10.0734 6.02813C8.95312 5.625 8.25 5.09062 8.25 4.5C8.25 3.25781 11.2734 2.25 15 2.25C18.7266 2.25 21.75 3.25781 21.75 4.5C21.75 5.74219 18.7266 6.75 15 6.75Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularDatabase = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M11 2.25C15.5547 2.25 19.25 3.54952 19.25 5.14284V5.35711C19.25 6.95048 15.5547 8.25 11 8.25C6.4453 8.25 2.75 6.95048 2.75 5.35716V5.14289C2.75 3.54952 6.4453 2.25 11 2.25ZM19.25 8.57897V9.81642C19.25 11.4097 15.5547 12.7093 11 12.7093C6.4453 12.7093 2.75 11.4097 2.75 9.81642V8.57897C4.52248 9.88978 7.76661 10.5 11 10.5C14.2334 10.5 17.4775 9.88978 19.25 8.57897ZM19.25 13.079V14.3368C19.25 15.9301 15.5547 17.2297 11 17.2297C6.4453 17.2297 2.75 15.9301 2.75 14.3368V13.0789C4.52248 14.3898 7.76661 15 11 15C14.2334 15 17.4775 14.3898 19.25 13.079ZM19.25 17.579V18.8572C19.25 20.4505 15.5547 21.75 11 21.75C6.4453 21.75 2.75 20.4505 2.75 18.8572V17.579C4.52248 18.8898 7.76661 19.5 11 19.5C14.2334 19.5 17.4775 18.8898 19.25 17.579ZM11 0C6.92431 0 0.5 1.09031 0.5 5.14284V18.8571C0.5 22.9105 6.92328 24 11 24C15.0757 24 21.5 22.9097 21.5 18.8572V5.14284C21.5 1.08947 15.0767 0 11 0Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularBill = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M11.9998 5.42068C10.3431 5.42068 8.99986 7.03915 8.99986 9.036C8.99986 11.0325 10.3427 12.6513 11.9998 12.6513C13.6562 12.6513 14.9998 11.0332 14.9998 9.036C14.9998 7.03915 13.6565 5.42068 11.9998 5.42068ZM23.2931 1.44237C21.8385 0.83225 20.3828 0.600128 18.9278 0.600128C14.309 0.599753 9.6906 2.93784 5.0718 2.93784C3.91344 2.93784 2.75583 2.79084 1.59747 2.42335C1.46735 2.3821 1.33685 2.3626 1.20936 2.3626C0.563991 2.3626 0 2.86209 0 3.55546V15.4525C0 15.9261 0.271121 16.375 0.706489 16.5573C2.16109 17.1677 3.61682 17.3999 5.0718 17.3999C9.6906 17.3999 14.3094 15.0618 18.9282 15.0618C20.0866 15.0618 21.2442 15.2088 22.4025 15.5763C22.5326 15.6175 22.6631 15.637 22.7906 15.637C23.436 15.637 24 15.1375 24 14.4442V2.54747C23.9996 2.07348 23.7285 1.62499 23.2931 1.44237ZM22.1997 13.6492C21.1609 13.3893 20.0832 13.2622 18.9278 13.2622C16.3944 13.2622 13.9355 13.8843 11.5581 14.4862C9.2946 15.0588 7.15676 15.5999 5.0718 15.5999C3.88606 15.5999 2.81133 15.4206 1.79997 15.0532V4.35082C2.83871 4.61069 3.91644 4.73781 5.0718 4.73781C7.60526 4.73781 10.0637 4.1157 12.4412 3.51383C14.7046 2.94122 16.8425 2.4001 18.9278 2.4001C20.1139 2.4001 21.1887 2.57935 22.1997 2.94684V13.6492Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularDollarSign = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '14'}
    height={height || '24'}
    viewBox="0 0 14 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M10.1828 11.3484L4.73119 9.79219C3.99056 9.58125 3.39056 8.98594 3.27338 8.22187C3.09056 7.03125 4.014 6 5.17181 6H8.63119C9.3765 6 10.1078 6.23438 10.7124 6.66094C11.0124 6.87188 11.4156 6.83906 11.6734 6.58125L12.7468 5.50781C13.0656 5.18906 13.0328 4.65469 12.6765 4.37813C11.5187 3.48281 10.1124 3 8.63119 3H8.49994V0.75C8.49994 0.3375 8.16244 0 7.74994 0H6.24994C5.83744 0 5.49994 0.3375 5.49994 0.75V3H5.38275C3.0765 3 0.948377 4.49063 0.395252 6.73125C-0.256311 9.36563 1.34213 11.9437 3.81713 12.6516L9.26869 14.2078C10.0093 14.4188 10.6093 15.0141 10.7265 15.7781C10.9093 16.9688 9.98588 18 8.82806 18H5.36869C4.62338 18 3.89213 17.7656 3.28744 17.3391C2.98744 17.1281 2.58431 17.1609 2.3265 17.4188L1.25306 18.4922C0.934314 18.8109 0.967126 19.3453 1.32338 19.6219C2.4765 20.5172 3.88275 21 5.36869 21H5.49994V23.25C5.49994 23.6625 5.83744 24 6.24994 24H7.74994C8.16244 24 8.49994 23.6625 8.49994 23.25V21H8.61713C10.9234 21 13.0515 19.5094 13.6046 17.2687C14.2562 14.6344 12.6578 12.0563 10.1828 11.3484Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleDollarSign = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M14.0806 11.4194L10.5968 10.3597C10.1613 10.2242 9.86129 9.77419 9.86129 9.26129C9.86129 8.6371 10.3065 8.12903 10.8532 8.12903H13.0306C13.3694 8.12903 13.6984 8.22097 13.9935 8.39032C14.3032 8.56935 14.6855 8.55484 14.9468 8.3129L15.5274 7.76613C15.8952 7.41774 15.8323 6.82742 15.4161 6.54677C14.7484 6.09677 13.9694 5.84516 13.171 5.81613V5.03226C13.171 4.60645 12.8226 4.25806 12.3968 4.25806H11.6226C11.1968 4.25806 10.8484 4.60645 10.8484 5.03226V5.80645C9.02903 5.81129 7.54839 7.35968 7.54839 9.26129C7.54839 10.7855 8.52581 12.15 9.92903 12.5806L13.4129 13.6403C13.8484 13.7758 14.1484 14.2258 14.1484 14.7387C14.1484 15.3629 13.7032 15.871 13.1565 15.871H10.979C10.6403 15.871 10.3113 15.779 10.0161 15.6097C9.70645 15.4306 9.32419 15.4452 9.0629 15.6871L8.48226 16.2339C8.11452 16.5823 8.17742 17.1726 8.59355 17.4532C9.26129 17.9032 10.0403 18.1548 10.8387 18.1839V18.9677C10.8387 19.3935 11.1871 19.7419 11.6129 19.7419H12.3871C12.8129 19.7419 13.1613 19.3935 13.1613 18.9677V18.1935C14.9806 18.1887 16.4613 16.6403 16.4613 14.7387C16.4613 13.2145 15.4839 11.85 14.0806 11.4194ZM12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0ZM12 21.6774C6.6629 21.6774 2.32258 17.3371 2.32258 12C2.32258 6.6629 6.6629 2.32258 12 2.32258C17.3371 2.32258 21.6774 6.6629 21.6774 12C21.6774 17.3371 17.3371 21.6774 12 21.6774Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularSearchDollarSign = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M11.0198 9.34795L8.91043 8.71514C8.66855 8.64248 8.49933 8.39733 8.49933 8.11843C8.49933 7.77765 8.74777 7.50015 9.05246 7.50015H10.3701C10.5839 7.50015 10.7901 7.56062 10.971 7.67452C11.1229 7.76968 11.316 7.76405 11.4459 7.6403L11.9967 7.11484C12.1621 6.95687 12.1528 6.68312 11.9699 6.54578C11.5434 6.22562 11.0287 6.04093 10.4995 6.01375V5.25016C10.4995 5.04297 10.3317 4.87516 10.1245 4.87516H9.37449C9.1673 4.87516 8.99949 5.04297 8.99949 5.25016V6.00578C7.89231 6.03531 6.99934 6.96906 6.99934 8.11843C6.99934 9.05451 7.60778 9.89076 8.47965 10.1523L10.589 10.7851C10.8309 10.8578 11.0001 11.1029 11.0001 11.3818C11.0001 11.7226 10.7517 12.0001 10.447 12.0001H9.12933C8.91558 12.0001 8.70933 11.9397 8.5284 11.8258C8.37652 11.7306 8.1834 11.7362 8.05355 11.86L7.50278 12.3854C7.33731 12.5434 7.34668 12.8172 7.52949 12.9545C7.95606 13.2746 8.47074 13.4593 8.99996 13.4865V14.2501C8.99996 14.4573 9.16777 14.6251 9.37495 14.6251H10.125C10.3321 14.6251 10.4999 14.4573 10.4999 14.2501V13.4945C11.6071 13.465 12.5001 12.5317 12.5001 11.3818C12.5001 10.4458 11.8917 9.60951 11.0198 9.34795ZM23.8344 21.9788L18.1443 16.2882C18.0365 16.1804 17.8958 16.1242 17.7459 16.1242H17.1271C18.6037 14.4132 19.499 12.1867 19.499 9.74967C19.499 4.36422 15.1349 0.000183105 9.74948 0.000183105C4.36404 0.000183105 0 4.36422 0 9.74967C0 15.1351 4.36404 19.4992 9.74948 19.4992C12.187 19.4992 14.4131 18.6038 16.124 17.1273V17.746C16.124 17.896 16.1849 18.0367 16.288 18.1445L21.9782 23.8346C22.1985 24.0549 22.5547 24.0549 22.775 23.8346L23.8344 22.7752C24.0552 22.5554 24.0552 22.1991 23.8344 21.9788ZM9.74948 17.2492C5.60575 17.2492 2.24999 13.8929 2.24999 9.74967C2.24999 5.60594 5.60575 2.25017 9.74948 2.25017C13.8927 2.25017 17.249 5.60641 17.249 9.74967C17.249 13.8934 13.8927 17.2492 9.74948 17.2492Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidCreditCard = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0 17.3333C0 18.4375 0.895833 19.3333 2 19.3333H22C23.1042 19.3333 24 18.4375 24 17.3333V9.99999H0V17.3333ZM8 14.5C8 14.225 8.225 14 8.5 14H14.1667C14.4417 14 14.6667 14.225 14.6667 14.5V16.1667C14.6667 16.4417 14.4417 16.6667 14.1667 16.6667H8.5C8.225 16.6667 8 16.4417 8 16.1667V14.5ZM2.66667 14.5C2.66667 14.225 2.89167 14 3.16667 14H6.16667C6.44167 14 6.66667 14.225 6.66667 14.5V16.1667C6.66667 16.4417 6.44167 16.6667 6.16667 16.6667H3.16667C2.89167 16.6667 2.66667 16.4417 2.66667 16.1667V14.5ZM24 2.66666V4.66666H0V2.66666C0 1.56249 0.895833 0.666656 2 0.666656H22C23.1042 0.666656 24 1.56249 24 2.66666Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidCoins = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0 18.9984V21C0 22.6547 4.03125 24 9 24C13.9688 24 18 22.6547 18 21V18.9984C16.0641 20.3625 12.525 21 9 21C5.475 21 1.93594 20.3625 0 18.9984ZM15 6C19.9688 6 24 4.65469 24 3C24 1.34531 19.9688 0 15 0C10.0312 0 6 1.34531 6 3C6 4.65469 10.0312 6 15 6ZM0 14.0812V16.5C0 18.1547 4.03125 19.5 9 19.5C13.9688 19.5 18 18.1547 18 16.5V14.0812C16.0641 15.675 12.5203 16.5 9 16.5C5.47969 16.5 1.93594 15.675 0 14.0812ZM19.5 14.5969C22.1859 14.0766 24 13.1109 24 12V9.99844C22.9125 10.7672 21.3141 11.2922 19.5 11.6156V14.5969ZM9 7.5C4.03125 7.5 0 9.17813 0 11.25C0 13.3219 4.03125 15 9 15C13.9688 15 18 13.3219 18 11.25C18 9.17813 13.9688 7.5 9 7.5ZM19.2797 10.1391C22.0922 9.63281 24 8.63906 24 7.5V5.49844C22.3359 6.675 19.4766 7.30781 16.4672 7.45781C17.85 8.12813 18.8672 9.02812 19.2797 10.1391Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidDatabase = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.5 3.42858V5.57142C21.5 7.45983 16.7969 9 11 9C5.20311 9 0.5 7.45983 0.5 5.57142V3.42858C0.5 1.54017 5.20311 0 11 0C16.7969 0 21.5 1.54017 21.5 3.42858ZM21.5 8.25V13.0714C21.5 14.9598 16.7969 16.5 11 16.5C5.20311 16.5 0.5 14.9598 0.5 13.0714V8.25C2.75586 9.80358 6.88475 10.5268 11 10.5268C15.1152 10.5268 19.2441 9.80358 21.5 8.25ZM21.5 15.75V20.5714C21.5 22.4598 16.7969 24 11 24C5.20311 24 0.5 22.4598 0.5 20.5714V15.75C2.75586 17.3036 6.88475 18.0268 11 18.0268C15.1152 18.0268 19.2441 17.3036 21.5 15.75Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidDollarSign = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '14'}
    height={height || '24'}
    viewBox="0 0 14 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M10.056 10.9406L4.99351 9.45938C4.40757 9.29063 3.99976 8.74219 3.99976 8.13281C3.99976 7.36875 4.61851 6.75 5.38257 6.75H8.49038C9.06226 6.75 9.62476 6.92344 10.0935 7.24219C10.3794 7.43437 10.7638 7.3875 11.0076 7.14844L12.6388 5.55469C12.9716 5.23125 12.9248 4.69219 12.5544 4.40625C11.406 3.50625 9.97163 3.00469 8.49976 3V0.75C8.49976 0.3375 8.16226 0 7.74976 0H6.24976C5.83726 0 5.49976 0.3375 5.49976 0.75V3H5.38257C2.39663 3 -0.0033679 5.56406 0.273195 8.60625C0.47007 10.7672 2.12007 12.525 4.20132 13.1344L9.00601 14.5406C9.59194 14.7141 9.99976 15.2578 9.99976 15.8672C9.99976 16.6313 9.38101 17.25 8.61694 17.25H5.50913C4.93726 17.25 4.37476 17.0766 3.90601 16.7578C3.62007 16.5656 3.23569 16.6125 2.99194 16.8516L1.36069 18.4453C1.02788 18.7687 1.07476 19.3078 1.44507 19.5938C2.59351 20.4937 4.02788 20.9953 5.49976 21V23.25C5.49976 23.6625 5.83726 24 6.24976 24H7.74976C8.16226 24 8.49976 23.6625 8.49976 23.25V20.9906C10.6841 20.9484 12.7326 19.65 13.4544 17.5828C14.4623 14.6953 12.7701 11.7328 10.056 10.9406Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidSearchDollarSign = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.6736 20.7496L18.9997 16.0767C18.7888 15.8658 18.5029 15.7486 18.2029 15.7486H17.4388C18.7326 14.0939 19.5013 12.0131 19.5013 9.74907C19.5013 4.36363 15.1368 6.10352e-05 9.75089 6.10352e-05C4.36498 6.10352e-05 0 4.36363 0 9.74907C0 15.1345 4.36451 19.4981 9.75089 19.4981C12.0149 19.4981 14.0966 18.7293 15.7513 17.4356V18.1997C15.7513 18.4997 15.8685 18.7856 16.0795 18.9965L20.7533 23.6695C21.194 24.1101 21.9065 24.1101 22.3424 23.6695L23.6689 22.3429C24.1096 21.9023 24.1096 21.1903 23.6736 20.7496ZM9.75089 16.4981C6.02247 16.4981 3.00092 13.4822 3.00092 9.74907C3.00092 6.02112 6.01731 3.00005 9.75089 3.00005C13.4793 3.00005 16.5009 6.01597 16.5009 9.74907C16.5009 13.477 13.4845 16.4981 9.75089 16.4981ZM11.0217 9.34783L8.91183 8.71502C8.66996 8.64236 8.50074 8.39721 8.50074 8.1183C8.50074 7.77752 8.74918 7.50002 9.05386 7.50002H10.3715C10.5853 7.50002 10.7915 7.56049 10.9724 7.6744C11.1243 7.76955 11.3174 7.76393 11.4473 7.64018L11.9981 7.11471C12.1635 6.95674 12.1542 6.683 11.9713 6.54565C11.5448 6.2255 11.0301 6.04081 10.5009 6.01362V5.25003C10.5009 5.04285 10.3331 4.87504 10.1259 4.87504H9.37589C9.1687 4.87504 9.00089 5.04285 9.00089 5.25003V6.00566C7.89324 6.03519 7.00028 6.96893 7.00028 8.1183C7.00028 9.05439 7.60918 9.89064 8.48058 10.1522L10.5904 10.785C10.8323 10.8577 11.0015 11.1028 11.0015 11.3817C11.0015 11.7225 10.7531 12 10.4484 12H9.1312C8.91746 12 8.71121 11.9395 8.53027 11.8256C8.3784 11.7305 8.18527 11.7361 8.05543 11.8598L7.50465 12.3853C7.33918 12.5433 7.34856 12.817 7.53137 12.9544C7.95793 13.2745 8.47261 13.4592 9.00183 13.4864V14.25C9.00183 14.4572 9.16964 14.625 9.37683 14.625H10.1268C10.334 14.625 10.5018 14.4572 10.5018 14.25V13.4944C11.6095 13.4648 12.5024 12.5316 12.5024 11.3817C12.5024 10.4456 11.8935 9.60939 11.0217 9.34783Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidUsers = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M3.6 7.80001C4.92375 7.80001 6 6.72376 6 5.40001C6 4.07626 4.92375 3.00001 3.6 3.00001C2.27625 3.00001 1.2 4.07626 1.2 5.40001C1.2 6.72376 2.27625 7.80001 3.6 7.80001ZM20.4 7.80001C21.7238 7.80001 22.8 6.72376 22.8 5.40001C22.8 4.07626 21.7238 3.00001 20.4 3.00001C19.0763 3.00001 18 4.07626 18 5.40001C18 6.72376 19.0763 7.80001 20.4 7.80001ZM21.6 9.00001H19.2C18.54 9.00001 17.9438 9.26626 17.5088 9.69751C19.02 10.5263 20.0925 12.0225 20.325 13.8H22.8C23.4638 13.8 24 13.2638 24 12.6V11.4C24 10.0763 22.9238 9.00001 21.6 9.00001ZM12 9.00001C14.3213 9.00001 16.2 7.12126 16.2 4.80001C16.2 2.47876 14.3213 0.600006 12 0.600006C9.67875 0.600006 7.8 2.47876 7.8 4.80001C7.8 7.12126 9.67875 9.00001 12 9.00001ZM14.88 10.2H14.5688C13.7888 10.575 12.9225 10.8 12 10.8C11.0775 10.8 10.215 10.575 9.43125 10.2H9.12C6.735 10.2 4.8 12.135 4.8 14.52V15.6C4.8 16.5938 5.60625 17.4 6.6 17.4H17.4C18.3938 17.4 19.2 16.5938 19.2 15.6V14.52C19.2 12.135 17.265 10.2 14.88 10.2ZM6.49125 9.69751C6.05625 9.26626 5.46 9.00001 4.8 9.00001H2.4C1.07625 9.00001 0 10.0763 0 11.4V12.6C0 13.2638 0.53625 13.8 1.2 13.8H3.67125C3.9075 12.0225 4.98 10.5263 6.49125 9.69751Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidUsersClock = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M18.6 8.79999C15.615 8.79999 13.2 11.215 13.2 14.2C13.2 17.185 15.615 19.6 18.6 19.6C21.585 19.6 24 17.185 24 14.2C24 11.215 21.585 8.79999 18.6 8.79999ZM21 14.4362C21 14.635 20.835 14.8 20.6362 14.8H18.3638C18.165 14.8 18 14.635 18 14.4362V11.5637C18 11.365 18.165 11.2 18.3638 11.2H18.8363C19.035 11.2 19.2 11.365 19.2 11.5637V13.6H20.6362C20.835 13.6 21 13.765 21 13.9637V14.4362ZM12 14.2C12 13.1575 12.2513 12.1712 12.6825 11.2937C12.3825 11.2375 12.075 11.2 11.76 11.2H11.1337C10.3013 11.5825 9.375 11.8 8.4 11.8C7.425 11.8 6.5025 11.5825 5.66625 11.2H5.04C2.2575 11.2 0 13.4575 0 16.24V17.8C0 18.7937 0.80625 19.6 1.8 19.6H14.8163C13.1175 18.4037 12 16.4312 12 14.2ZM8.4 9.99999C11.0513 9.99999 13.2 7.85124 13.2 5.19999C13.2 2.54874 11.0513 0.399994 8.4 0.399994C5.74875 0.399994 3.6 2.54874 3.6 5.19999C3.6 7.85124 5.74875 9.99999 8.4 9.99999Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidUsersCircle = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0ZM12 4.64516C14.3516 4.64516 16.2581 6.55161 16.2581 8.90323C16.2581 11.2548 14.3516 13.1613 12 13.1613C9.64839 13.1613 7.74194 11.2548 7.74194 8.90323C7.74194 6.55161 9.64839 4.64516 12 4.64516ZM12 21.2903C9.15968 21.2903 6.61452 20.0032 4.91129 17.9903C5.82097 16.2774 7.60161 15.0968 9.67742 15.0968C9.79355 15.0968 9.90968 15.1161 10.021 15.15C10.65 15.3532 11.3081 15.4839 12 15.4839C12.6919 15.4839 13.3548 15.3532 13.979 15.15C14.0903 15.1161 14.2065 15.0968 14.3226 15.0968C16.3984 15.0968 18.179 16.2774 19.0887 17.9903C17.3855 20.0032 14.8403 21.2903 12 21.2903Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const User = ({ height, width, fill, children, ...rest }: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M11 12C14.3141 12 17 9.31406 17 6C17 2.68594 14.3141 0 11 0C7.68594 0 5 2.68594 5 6C5 9.31406 7.68594 12 11 12ZM15.2 13.5H14.4172C13.3766 13.9781 12.2188 14.25 11 14.25C9.78125 14.25 8.62813 13.9781 7.58281 13.5H6.8C3.32187 13.5 0.5 16.3219 0.5 19.8V21.75C0.5 22.9922 1.50781 24 2.75 24H19.25C20.4922 24 21.5 22.9922 21.5 21.75V19.8C21.5 16.3219 18.6781 13.5 15.2 13.5Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularUsers = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M20.4032 7.79982C22.0609 7.79982 23.4036 6.45711 23.4036 4.79935C23.4036 3.14159 22.0609 1.79888 20.4032 1.79888C18.7454 1.79888 17.4027 3.14159 17.4027 4.79935C17.4027 6.45711 18.7454 7.79982 20.4032 7.79982ZM20.4032 3.59916C21.0633 3.59916 21.6034 4.13925 21.6034 4.79935C21.6034 5.45945 21.0633 5.99954 20.4032 5.99954C19.7431 5.99954 19.203 5.45945 19.203 4.79935C19.203 4.13925 19.7431 3.59916 20.4032 3.59916ZM3.60056 7.79982C5.25832 7.79982 6.60103 6.45711 6.60103 4.79935C6.60103 3.14159 5.25832 1.79888 3.60056 1.79888C1.9428 1.79888 0.600094 3.14159 0.600094 4.79935C0.600094 6.45711 1.9428 7.79982 3.60056 7.79982ZM3.60056 3.59916C4.26066 3.59916 4.80075 4.13925 4.80075 4.79935C4.80075 5.45945 4.26066 5.99954 3.60056 5.99954C2.94046 5.99954 2.40037 5.45945 2.40037 4.79935C2.40037 4.13925 2.94046 3.59916 3.60056 3.59916ZM18.4679 11.5091C17.4365 9.97891 15.4412 9.40882 13.6746 9.94515C13.142 10.1064 12.5832 10.1964 11.9981 10.1964C11.413 10.1964 10.8542 10.1064 10.3216 9.94515C8.55508 9.40882 6.55977 9.97515 5.52836 11.5091C5.06329 12.1993 4.79325 13.0281 4.79325 13.9208V15.601C4.79325 16.5949 5.59962 17.4013 6.59353 17.4013H17.3952C18.3891 17.4013 19.1955 16.5949 19.1955 15.601V13.9208C19.203 13.0281 18.933 12.1993 18.4679 11.5091ZM17.4027 15.601H6.60103V13.9208C6.60103 12.5556 7.6962 11.4379 9.05391 11.4004C10.0103 11.7979 11.0005 12.0005 12.0019 12.0005C13.0033 12.0005 13.9934 11.7979 14.9498 11.4004C16.3075 11.4379 17.4027 12.5518 17.4027 13.9208V15.601ZM20.8533 9H19.9531C19.3043 9 18.7004 9.19878 18.1978 9.53634C18.7004 9.91515 19.143 10.369 19.488 10.894C19.6343 10.8415 19.7881 10.8003 19.9494 10.8003H20.8495C21.5921 10.8003 22.1997 11.4079 22.1997 12.1505C22.1997 12.6456 22.6048 13.0506 23.0999 13.0506C23.5949 13.0506 24 12.6456 24 12.1505C24.0037 10.414 22.5898 9 20.8533 9ZM12.0019 9C14.3235 9 16.2025 7.12096 16.2025 4.79935C16.2025 2.47774 14.3235 0.598694 12.0019 0.598694C9.68026 0.598694 7.80122 2.47774 7.80122 4.79935C7.80122 7.12096 9.68026 9 12.0019 9ZM12.0019 2.39897C13.3258 2.39897 14.4022 3.47539 14.4022 4.79935C14.4022 6.1233 13.3258 7.19972 12.0019 7.19972C10.6779 7.19972 9.6015 6.1233 9.6015 4.79935C9.6015 3.47539 10.6779 2.39897 12.0019 2.39897ZM5.80591 9.53634C5.30333 9.19878 4.69948 9 4.05063 9H3.15049C1.41397 9 0 10.414 0 12.1505C0 12.6456 0.405063 13.0506 0.90014 13.0506C1.39522 13.0506 1.80028 12.6456 1.80028 12.1505C1.80028 11.4079 2.40788 10.8003 3.15049 10.8003H4.05063C4.21566 10.8003 4.36943 10.8415 4.51195 10.894C4.86076 10.369 5.30333 9.91515 5.80591 9.53634Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularUsersChart = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M6 12.4C7.9875 12.4 9.6 10.7875 9.6 8.79999C9.6 6.81249 7.9875 5.19999 6 5.19999C4.0125 5.19999 2.4 6.81249 2.4 8.79999C2.4 10.7875 4.0125 12.4 6 12.4ZM6 6.99999C6.99375 6.99999 7.8 7.80624 7.8 8.79999C7.8 9.79374 6.99375 10.6 6 10.6C5.00625 10.6 4.2 9.79374 4.2 8.79999C4.2 7.80624 5.00625 6.99999 6 6.99999ZM15.6375 10.0375L18.3375 7.33749L19.2488 8.24874C19.6725 8.67249 20.4 8.37249 20.4 7.77249V4.44999C20.4 4.20249 20.1975 3.99999 19.95 3.99999H16.6313C16.0312 3.99999 15.7275 4.72749 16.155 5.15124L17.0625 6.06249L15 8.12499L12.9375 6.06249C12.585 5.70999 12.015 5.70999 11.6663 6.06249L10.515 7.21374C10.6875 7.71249 10.8 8.24124 10.8 8.79999C10.8 9.05499 10.7625 9.30249 10.725 9.54999L12.3 7.97499L14.3625 10.0375C14.715 10.3862 15.285 10.3862 15.6375 10.0375ZM22.2 0.399994H7.8C6.80625 0.399994 6 1.23249 6 2.25999V3.99999C6.24 3.99999 6.4275 4.02249 6.5925 4.05999C6.795 4.08624 6.99375 4.11624 7.18875 4.16874C7.34625 4.20624 7.49625 4.25499 7.64625 4.31124C7.695 4.32999 7.75125 4.33749 7.8 4.35999V2.19999H22.2V14.2H13.2V16H22.2C23.1938 16 24 15.1675 24 14.14V2.25999C24 1.23249 23.1938 0.399994 22.2 0.399994ZM8.505 13.225C8.13375 13.225 7.75875 13.2812 7.395 13.39C6.9525 13.525 6.4875 13.6 6 13.6C5.5125 13.6 5.0475 13.525 4.605 13.39C4.24125 13.2812 3.86625 13.225 3.495 13.225C2.3625 13.225 1.25625 13.7312 0.61125 14.6912C0.225 15.265 0 15.955 0 16.7012V18.1C0 18.9287 0.67125 19.6 1.5 19.6H10.5C11.3288 19.6 12 18.9287 12 18.1V16.7012C12 15.9587 11.775 15.2687 11.3888 14.695C10.74 13.7312 9.6375 13.225 8.505 13.225ZM10.2 17.8H1.8V16.7012C1.8 16.3412 1.905 15.9962 2.10375 15.7C2.385 15.28 2.90625 15.0287 3.495 15.0287C3.69375 15.0287 3.8925 15.0587 4.08 15.115C4.71 15.3062 5.355 15.4037 6 15.4037C6.645 15.4037 7.29 15.3062 7.92 15.115C8.11125 15.0587 8.30625 15.0287 8.505 15.0287C9.09375 15.0287 9.61125 15.28 9.89625 15.7C10.095 15.9962 10.2 16.3412 10.2 16.7012V17.8Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularUsersChalkboard = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M8.50463 13.2258C7.4625 13.2258 7.20075 13.6 6 13.6C4.80113 13.6 4.53938 13.2258 3.49538 13.2258C0.792 13.2258 0 15.5125 0 16.7002V18.1C0 18.9284 0.671625 19.6 1.5 19.6H10.5C11.3284 19.6 12 18.9284 12 18.1V16.7002C12 15.0982 10.8533 13.2258 8.50463 13.2258ZM10.2 17.8H1.8V16.7002C1.8 16.1748 2.10563 15.0258 3.49538 15.0258C4.14188 15.0258 4.60388 15.4 6 15.4C7.40137 15.4 7.85588 15.0258 8.50463 15.0258C9.89288 15.0258 10.2 16.1725 10.2 16.7002V17.8ZM6 12.4C7.98825 12.4 9.6 10.7883 9.6 8.80002C9.6 6.81177 7.98825 5.20002 6 5.20002C4.01175 5.20002 2.4 6.81177 2.4 8.80002C2.4 10.7883 4.01175 12.4 6 12.4ZM6 7.00002C6.99263 7.00002 7.8 7.8074 7.8 8.80002C7.8 9.79265 6.99263 10.6 6 10.6C5.00737 10.6 4.2 9.79265 4.2 8.80002C4.2 7.8074 5.00737 7.00002 6 7.00002ZM22.2 0.400024H7.8C6.80737 0.400024 6 1.2344 6 2.25965V4.00002C6.36338 4.00002 7.21012 4.1174 7.8 4.35702V2.20002H22.2V14.2H20.4V12.4C20.4 11.7374 19.8626 11.2 19.2 11.2H14.4C13.7374 11.2 13.2 11.7374 13.2 12.4V16H22.2C23.1926 16 24 15.1657 24 14.1404V2.25965C24 1.2344 23.1926 0.400024 22.2 0.400024ZM18.6 14.2H15V13H18.6V14.2Z"
      fill={fill || '#231F20'}
    />
  </svg>
);

export const RegularUsersCircle = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 4.64516C9.43548 4.64516 7.35484 6.72581 7.35484 9.29032C7.35484 11.8548 9.43548 13.9355 12 13.9355C14.5645 13.9355 16.6452 11.8548 16.6452 9.29032C16.6452 6.72581 14.5645 4.64516 12 4.64516ZM12 11.6129C10.7177 11.6129 9.67742 10.5726 9.67742 9.29032C9.67742 8.00806 10.7177 6.96774 12 6.96774C13.2823 6.96774 14.3226 8.00806 14.3226 9.29032C14.3226 10.5726 13.2823 11.6129 12 11.6129ZM12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0ZM12 21.6774C9.59516 21.6774 7.39839 20.7919 5.70484 19.3355C6.42581 18.2226 7.65968 17.4677 9.07258 17.4242C10.079 17.7339 11.0371 17.8887 12 17.8887C12.9629 17.8887 13.921 17.7387 14.9274 17.4242C16.3403 17.4726 17.5742 18.2226 18.2952 19.3355C16.6016 20.7919 14.4048 21.6774 12 21.6774ZM19.8726 17.6081C18.6919 16.0887 16.8677 15.0968 14.7871 15.0968C14.2935 15.0968 13.529 15.5613 12 15.5613C10.4758 15.5613 9.70645 15.0968 9.2129 15.0968C7.1371 15.0968 5.3129 16.0887 4.12742 17.6081C2.99516 16.0258 2.32258 14.0903 2.32258 12C2.32258 6.6629 6.6629 2.32258 12 2.32258C17.3371 2.32258 21.6774 6.6629 21.6774 12C21.6774 14.0903 21.0048 16.0258 19.8726 17.6081Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularUser = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M15.2 14.25C13.8547 14.25 13.2078 15 11 15C8.79219 15 8.15 14.25 6.8 14.25C3.32187 14.25 0.5 17.0719 0.5 20.55V21.75C0.5 22.9922 1.50781 24 2.75 24H19.25C20.4922 24 21.5 22.9922 21.5 21.75V20.55C21.5 17.0719 18.6781 14.25 15.2 14.25ZM19.25 21.75H2.75V20.55C2.75 18.3188 4.56875 16.5 6.8 16.5C7.48437 16.5 8.59531 17.25 11 17.25C13.4234 17.25 14.5109 16.5 15.2 16.5C17.4312 16.5 19.25 18.3188 19.25 20.55V21.75ZM11 13.5C14.7266 13.5 17.75 10.4766 17.75 6.75C17.75 3.02344 14.7266 0 11 0C7.27344 0 4.25 3.02344 4.25 6.75C4.25 10.4766 7.27344 13.5 11 13.5ZM11 2.25C13.4797 2.25 15.5 4.27031 15.5 6.75C15.5 9.22969 13.4797 11.25 11 11.25C8.52031 11.25 6.5 9.22969 6.5 6.75C6.5 4.27031 8.52031 2.25 11 2.25Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAltUser = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M18 15.75C16.0969 15.75 15.7687 15.6797 14.6156 16.0687C13.7953 16.3453 12.9141 16.5 12 16.5C11.0859 16.5 10.2047 16.3453 9.38437 16.0687C8.23125 15.6797 7.90781 15.75 6 15.75C2.68594 15.75 0 18.4359 0 21.75V22.5C0 23.3297 0.670312 24 1.5 24H22.5C23.3297 24 24 23.3297 24 22.5V21.75C24 18.4359 21.3141 15.75 18 15.75ZM21.75 21.75H2.25C2.25 20.7469 2.63906 19.8047 3.34688 19.0969C4.05469 18.3891 4.99687 18 6 18C7.92656 18 7.92188 17.9484 8.6625 18.1969C9.74063 18.5625 10.8656 18.75 12 18.75C13.1344 18.75 14.2594 18.5625 15.3375 18.1969C16.0781 17.9438 16.0734 18 18 18C20.0672 18 21.75 19.6828 21.75 21.75ZM12 15C16.1437 15 19.5 11.6438 19.5 7.5C19.5 3.35625 16.1437 0 12 0C7.85625 0 4.5 3.35625 4.5 7.5C4.5 11.6438 7.85625 15 12 15ZM12 2.25C14.8969 2.25 17.25 4.60313 17.25 7.5C17.25 10.3969 14.8969 12.75 12 12.75C9.10312 12.75 6.75 10.3969 6.75 7.5C6.75 4.60313 9.10312 2.25 12 2.25Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const HorizontalEllipsis = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '6'}
    viewBox="0 0  24'}${height || ' 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M14.6667 2.99999C14.6667 4.47222 13.4722 5.66666 12 5.66666C10.5278 5.66666 9.33333 4.47222 9.33333 2.99999C9.33333 1.52777 10.5278 0.333328 12 0.333328C13.4722 0.333328 14.6667 1.52777 14.6667 2.99999ZM21.3333 0.333328C19.8611 0.333328 18.6667 1.52777 18.6667 2.99999C18.6667 4.47222 19.8611 5.66666 21.3333 5.66666C22.8056 5.66666 24 4.47222 24 2.99999C24 1.52777 22.8056 0.333328 21.3333 0.333328ZM2.66667 0.333328C1.19444 0.333328 0 1.52777 0 2.99999C0 4.47222 1.19444 5.66666 2.66667 5.66666C4.13889 5.66666 5.33333 4.47222 5.33333 2.99999C5.33333 1.52777 4.13889 0.333328 2.66667 0.333328Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const VerticalEllipsis = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '6'}
    height={height || '24'}
    viewBox="0 0 6 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M3 9.12C4.59 9.12 5.88 10.41 5.88 12C5.88 13.59 4.59 14.88 3 14.88C1.41 14.88 0.119995 13.59 0.119995 12C0.119995 10.41 1.41 9.12 3 9.12ZM0.119995 2.88C0.119995 4.47 1.41 5.76 3 5.76C4.59 5.76 5.88 4.47 5.88 2.88C5.88 1.29 4.59 0 3 0C1.41 0 0.119995 1.29 0.119995 2.88ZM0.119995 21.12C0.119995 22.71 1.41 24 3 24C4.59 24 5.88 22.71 5.88 21.12C5.88 19.53 4.59 18.24 3 18.24C1.41 18.24 0.119995 19.53 0.119995 21.12Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidQuestion = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '18'}
    height={height || '24'}
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M9.02206 0C5.28055 0 2.85716 1.53295 0.954546 4.26684C0.609405 4.76278 0.715812 5.44275 1.19726 5.80781L3.21936 7.34105C3.70559 7.70972 4.39742 7.62352 4.77809 7.14661C5.95226 5.67562 6.82325 4.82869 8.65733 4.82869C10.0994 4.82869 11.8831 5.75677 11.8831 7.15514C11.8831 8.21227 11.0104 8.75517 9.58653 9.55345C7.92608 10.4844 5.72877 11.643 5.72877 14.5412V15C5.72877 15.6213 6.23244 16.125 6.85377 16.125H10.2508C10.8722 16.125 11.3758 15.6213 11.3758 15V14.7294C11.3758 12.7203 17.2478 12.6367 17.2478 7.2C17.2478 3.10575 13.0009 0 9.02206 0ZM8.55233 17.5059C6.76189 17.5059 5.30525 18.9625 5.30525 20.753C5.30525 22.5434 6.76189 24 8.55233 24C10.3428 24 11.7994 22.5434 11.7994 20.7529C11.7994 18.9625 10.3428 17.5059 8.55233 17.5059Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidCircleQuestion = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M24 12C24 18.6289 18.627 24 12 24C5.37305 24 0 18.6289 0 12C0 5.37498 5.37305 0 12 0C18.627 0 24 5.37498 24 12ZM12.322 3.96774C9.68506 3.96774 8.00323 5.07856 6.68255 7.05281C6.51145 7.30858 6.56869 7.65353 6.81392 7.83948L8.4929 9.11255C8.74476 9.30353 9.1036 9.2581 9.29927 9.00987C10.1637 7.91352 10.7564 7.27776 12.072 7.27776C13.0605 7.27776 14.2832 7.91395 14.2832 8.8725C14.2832 9.59715 13.685 9.96929 12.709 10.5165C11.5707 11.1546 10.0645 11.9488 10.0645 13.9355V14.129C10.0645 14.4497 10.3245 14.7097 10.6452 14.7097H13.3548C13.6755 14.7097 13.9355 14.4497 13.9355 14.129V14.0645C13.9355 12.6873 17.9606 12.63 17.9606 8.90323C17.9606 6.09668 15.0494 3.96774 12.322 3.96774ZM12 15.9677C10.7727 15.9677 9.77419 16.9662 9.77419 18.1935C9.77419 19.4208 10.7727 20.4194 12 20.4194C13.2273 20.4194 14.2258 19.4208 14.2258 18.1935C14.2258 16.9662 13.2273 15.9677 12 15.9677Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidCircleExclamation = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M24 12C24 18.6289 18.627 24 12 24C5.37305 24 0 18.6289 0 12C0 5.37498 5.37305 0 12 0C18.627 0 24 5.37498 24 12ZM12 14.4194C10.7707 14.4194 9.77419 15.4159 9.77419 16.6452C9.77419 17.8744 10.7707 18.871 12 18.871C13.2293 18.871 14.2258 17.8744 14.2258 16.6452C14.2258 15.4159 13.2293 14.4194 12 14.4194ZM9.88679 6.41874L10.2457 12.9994C10.2625 13.3073 10.5171 13.5484 10.8255 13.5484H13.1745C13.4829 13.5484 13.7375 13.3073 13.7543 12.9994L14.1132 6.41874C14.1314 6.08613 13.8665 5.80645 13.5334 5.80645H10.4665C10.1334 5.80645 9.86864 6.08613 9.88679 6.41874Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidExclamation = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '8'}
    height={height || '24'}
    viewBox="0 0 '8 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M7.75 20.25C7.75 22.3177 6.06775 24 4 24C1.93225 24 0.25 22.3177 0.25 20.25C0.25 18.1823 1.93225 16.5 4 16.5C6.06775 16.5 7.75 18.1823 7.75 20.25ZM0.684063 1.1812L1.32156 13.9312C1.35152 14.5299 1.84567 15 2.44516 15H5.55484C6.15433 15 6.64848 14.5299 6.67844 13.9312L7.31594 1.1812C7.34805 0.538594 6.83575 0 6.19234 0H1.80766C1.16425 0 0.651953 0.538594 0.684063 1.1812Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidTriangleExclamation = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.7299 18.6672C24.499 20.0003 23.5336 21.6667 21.9975 21.6667H2.00226C0.46322 21.6667 -0.497696 19.9977 0.269887 18.6672L10.2676 1.33272C11.0371 -0.000989497 12.9643 0.00142711 13.7324 1.33272L23.7299 18.6672ZM12 15.0833C10.9415 15.0833 10.0833 15.9415 10.0833 17C10.0833 18.0585 10.9415 18.9167 12 18.9167C13.0585 18.9167 13.9167 18.0585 13.9167 17C13.9167 15.9415 13.0585 15.0833 12 15.0833ZM10.1803 8.19392L10.4894 13.8606C10.5038 14.1258 10.7231 14.3333 10.9886 14.3333H13.0114C13.2769 14.3333 13.4962 14.1258 13.5106 13.8606L13.8197 8.19392C13.8353 7.90751 13.6073 7.66667 13.3205 7.66667H10.6795C10.3927 7.66667 10.1647 7.90751 10.1803 8.19392Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidInfoCircle = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 0C5.37305 0 0 5.37498 0 12C0 18.6289 5.37305 24 12 24C18.627 24 24 18.6289 24 12C24 5.37498 18.627 0 12 0ZM12 5.32258C13.1224 5.32258 14.0323 6.23245 14.0323 7.35484C14.0323 8.47723 13.1224 9.3871 12 9.3871C10.8776 9.3871 9.96774 8.47723 9.96774 7.35484C9.96774 6.23245 10.8776 5.32258 12 5.32258ZM14.7097 17.6129C14.7097 17.9336 14.4497 18.1935 14.129 18.1935H9.87097C9.55031 18.1935 9.29032 17.9336 9.29032 17.6129V16.4516C9.29032 16.131 9.55031 15.871 9.87097 15.871H10.4516V12.7742H9.87097C9.55031 12.7742 9.29032 12.5142 9.29032 12.1935V11.0323C9.29032 10.7116 9.55031 10.4516 9.87097 10.4516H12.9677C13.2884 10.4516 13.5484 10.7116 13.5484 11.0323V15.871H14.129C14.4497 15.871 14.7097 16.131 14.7097 16.4516V17.6129Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAt = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M24 10.8387C24 4.24602 18.68 0 12 0C5.36806 0 0 5.36705 0 12C0 18.6319 5.36705 24 12 24C14.5609 24 17.0652 23.1736 19.1175 21.6619C19.3837 21.4658 19.4283 21.0849 19.2189 20.8291L18.4823 19.9292C18.2861 19.6895 17.938 19.6485 17.6874 19.8305C16.0426 21.025 14.0438 21.6774 12 21.6774C6.66387 21.6774 2.32258 17.3361 2.32258 12C2.32258 6.66387 6.66387 2.32258 12 2.32258C17.2969 2.32258 21.6774 5.46871 21.6774 10.8387C21.6774 13.8922 19.622 15.5947 17.6603 15.5947C16.7165 15.5947 16.6861 14.984 16.8684 14.0723L18.2533 6.88403C18.3223 6.52587 18.0479 6.19355 17.6832 6.19355H15.7876C15.6526 6.1936 15.5219 6.24064 15.4178 6.3266C15.3138 6.41256 15.2429 6.53207 15.2174 6.6646C15.1641 6.94152 15.137 7.06795 15.1071 7.34168C14.5302 6.39581 13.371 5.83839 11.9521 5.83839C8.48768 5.83839 5.41935 8.86205 5.41935 13.2353C5.41935 16.1946 7.01018 18.1761 9.92806 18.1761C11.3701 18.1761 12.8963 17.3616 13.7869 16.1323C13.9875 17.6249 15.1658 17.9715 16.6597 17.9715C21.4581 17.9715 24 14.8929 24 10.8387ZM10.7468 15.5492C9.3691 15.5492 8.54661 14.6077 8.54661 13.0306C8.54661 10.2477 10.4608 8.51081 12.1568 8.51081C13.6142 8.51081 14.357 9.55268 14.357 11.0066C14.357 13.2742 12.7516 15.5492 10.7468 15.5492Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleQuestion = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 0C5.37305 0 0 5.37498 0 12C0 18.6289 5.37305 24 12 24C18.627 24 24 18.6289 24 12C24 5.37498 18.627 0 12 0ZM12 21.6774C6.65168 21.6774 2.32258 17.3501 2.32258 12C2.32258 6.65347 6.65187 2.32258 12 2.32258C17.3463 2.32258 21.6774 6.65182 21.6774 12C21.6774 17.3482 17.3501 21.6774 12 21.6774ZM17.1892 9.32903C17.1892 12.5735 13.685 12.6234 13.685 13.8224V14.129C13.685 14.4497 13.425 14.7097 13.1043 14.7097H10.8956C10.575 14.7097 10.315 14.4497 10.315 14.129V13.71C10.315 11.9805 11.6263 11.289 12.6172 10.7335C13.4669 10.2571 13.9877 9.9331 13.9877 9.30223C13.9877 8.46774 12.9232 7.91385 12.0627 7.91385C10.9406 7.91385 10.4226 8.445 9.6945 9.36397C9.49819 9.61171 9.13998 9.65773 8.88808 9.46674L7.54176 8.44587C7.29465 8.25852 7.23929 7.91042 7.41382 7.65411C8.55706 5.97537 10.0132 5.03226 12.2804 5.03226C14.6548 5.03226 17.1892 6.88568 17.1892 9.32903ZM14.0323 17.4194C14.0323 18.54 13.1206 19.4516 12 19.4516C10.8794 19.4516 9.96774 18.54 9.96774 17.4194C9.96774 16.2988 10.8794 15.3871 12 15.3871C13.1206 15.3871 14.0323 16.2988 14.0323 17.4194Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleExclamation = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 0C5.37305 0 0 5.37498 0 12C0 18.6289 5.37305 24 12 24C18.627 24 24 18.6289 24 12C24 5.37498 18.627 0 12 0ZM12 21.6774C6.65168 21.6774 2.32258 17.3501 2.32258 12C2.32258 6.65347 6.65187 2.32258 12 2.32258C17.3463 2.32258 21.6774 6.65182 21.6774 12C21.6774 17.3482 17.3501 21.6774 12 21.6774ZM14.0323 16.6452C14.0323 17.7658 13.1206 18.6774 12 18.6774C10.8794 18.6774 9.96774 17.7658 9.96774 16.6452C9.96774 15.5246 10.8794 14.6129 12 14.6129C13.1206 14.6129 14.0323 15.5246 14.0323 16.6452ZM10.095 6.41608L10.424 12.9967C10.4395 13.3058 10.6946 13.5484 11.004 13.5484H12.996C13.3054 13.5484 13.5605 13.3058 13.576 12.9967L13.905 6.41608C13.9216 6.08444 13.6572 5.80645 13.3251 5.80645H10.6749C10.3428 5.80645 10.0784 6.08444 10.095 6.41608Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularTriangleExclamation = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M10.3645 8.8627L10.639 13.5294C10.6545 13.7937 10.8734 14 11.1381 14H12.8618C12.9894 14 13.1121 13.9513 13.2048 13.8638C13.2976 13.7763 13.3535 13.6567 13.361 13.5294L13.6355 8.8627C13.6523 8.5755 13.424 8.33333 13.1363 8.33333H10.8635C10.5759 8.33333 10.3476 8.5755 10.3645 8.8627ZM13.75 16.3333C13.75 17.2998 12.9665 18.0833 12 18.0833C11.0335 18.0833 10.25 17.2998 10.25 16.3333C10.25 15.3668 11.0335 14.5833 12 14.5833C12.9665 14.5833 13.75 15.3668 13.75 16.3333ZM13.7324 1.3327C12.9643 0.00141171 11.0371 -0.0010049 10.2676 1.3327L0.269881 18.6672C-0.497702 19.9977 0.463256 21.6667 2.00226 21.6667H21.9975C23.5336 21.6667 24.499 20.0003 23.7299 18.6672L13.7324 1.3327ZM2.2163 19.2917L11.7835 2.70866C11.8797 2.54191 12.1203 2.54191 12.2165 2.70866L21.7837 19.2917C21.8799 19.4584 21.7596 19.6666 21.5672 19.6666H2.43284C2.24046 19.6667 2.12017 19.4584 2.2163 19.2917Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularInfoCircle = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 0C5.37305 0 0 5.37498 0 12C0 18.6289 5.37305 24 12 24C18.627 24 24 18.6289 24 12C24 5.37498 18.627 0 12 0ZM12 21.6774C6.65168 21.6774 2.32258 17.3501 2.32258 12C2.32258 6.65347 6.65187 2.32258 12 2.32258C17.3463 2.32258 21.6774 6.65182 21.6774 12C21.6774 17.3482 17.3501 21.6774 12 21.6774ZM12 5.32258C13.1224 5.32258 14.0323 6.23245 14.0323 7.35484C14.0323 8.47723 13.1224 9.3871 12 9.3871C10.8776 9.3871 9.96774 8.47723 9.96774 7.35484C9.96774 6.23245 10.8776 5.32258 12 5.32258ZM14.7097 17.6129C14.7097 17.9336 14.4497 18.1935 14.129 18.1935H9.87097C9.55031 18.1935 9.29032 17.9336 9.29032 17.6129V16.4516C9.29032 16.131 9.55031 15.871 9.87097 15.871H10.4516V12.7742H9.87097C9.55031 12.7742 9.29032 12.5142 9.29032 12.1935V11.0323C9.29032 10.7116 9.55031 10.4516 9.87097 10.4516H12.9677C13.2884 10.4516 13.5484 10.7116 13.5484 11.0323V15.871H14.129C14.4497 15.871 14.7097 16.131 14.7097 16.4516V17.6129Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidCalendar = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0.5 21.75C0.5 22.9922 1.50781 24 2.75 24H19.25C20.4922 24 21.5 22.9922 21.5 21.75V9H0.5V21.75ZM15.5 12.5625C15.5 12.2531 15.7531 12 16.0625 12H17.9375C18.2469 12 18.5 12.2531 18.5 12.5625V14.4375C18.5 14.7469 18.2469 15 17.9375 15H16.0625C15.7531 15 15.5 14.7469 15.5 14.4375V12.5625ZM15.5 18.5625C15.5 18.2531 15.7531 18 16.0625 18H17.9375C18.2469 18 18.5 18.2531 18.5 18.5625V20.4375C18.5 20.7469 18.2469 21 17.9375 21H16.0625C15.7531 21 15.5 20.7469 15.5 20.4375V18.5625ZM9.5 12.5625C9.5 12.2531 9.75313 12 10.0625 12H11.9375C12.2469 12 12.5 12.2531 12.5 12.5625V14.4375C12.5 14.7469 12.2469 15 11.9375 15H10.0625C9.75313 15 9.5 14.7469 9.5 14.4375V12.5625ZM9.5 18.5625C9.5 18.2531 9.75313 18 10.0625 18H11.9375C12.2469 18 12.5 18.2531 12.5 18.5625V20.4375C12.5 20.7469 12.2469 21 11.9375 21H10.0625C9.75313 21 9.5 20.7469 9.5 20.4375V18.5625ZM3.5 12.5625C3.5 12.2531 3.75312 12 4.0625 12H5.9375C6.24687 12 6.5 12.2531 6.5 12.5625V14.4375C6.5 14.7469 6.24687 15 5.9375 15H4.0625C3.75312 15 3.5 14.7469 3.5 14.4375V12.5625ZM3.5 18.5625C3.5 18.2531 3.75312 18 4.0625 18H5.9375C6.24687 18 6.5 18.2531 6.5 18.5625V20.4375C6.5 20.7469 6.24687 21 5.9375 21H4.0625C3.75312 21 3.5 20.7469 3.5 20.4375V18.5625ZM19.25 3H17V0.75C17 0.3375 16.6625 0 16.25 0H14.75C14.3375 0 14 0.3375 14 0.75V3H8V0.75C8 0.3375 7.6625 0 7.25 0H5.75C5.3375 0 5 0.3375 5 0.75V3H2.75C1.50781 3 0.5 4.00781 0.5 5.25V7.5H21.5V5.25C21.5 4.00781 20.4922 3 19.25 3Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidDayCalendar = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0.5 21.75C0.5 22.9922 1.50781 24 2.75 24H19.25C20.4922 24 21.5 22.9922 21.5 21.75V9H0.5V21.75ZM3.5 12.75C3.5 12.3375 3.8375 12 4.25 12H8.75C9.1625 12 9.5 12.3375 9.5 12.75V17.25C9.5 17.6625 9.1625 18 8.75 18H4.25C3.8375 18 3.5 17.6625 3.5 17.25V12.75ZM19.25 3H17V0.75C17 0.3375 16.6625 0 16.25 0H14.75C14.3375 0 14 0.3375 14 0.75V3H8V0.75C8 0.3375 7.6625 0 7.25 0H5.75C5.3375 0 5 0.3375 5 0.75V3H2.75C1.50781 3 0.5 4.00781 0.5 5.25V7.5H21.5V5.25C21.5 4.00781 20.4922 3 19.25 3Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCalendar = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M7.4375 13.5H5.5625C5.25313 13.5 5 13.2469 5 12.9375V11.0625C5 10.7531 5.25313 10.5 5.5625 10.5H7.4375C7.74687 10.5 8 10.7531 8 11.0625V12.9375C8 13.2469 7.74687 13.5 7.4375 13.5ZM12.5 12.9375V11.0625C12.5 10.7531 12.2469 10.5 11.9375 10.5H10.0625C9.75313 10.5 9.5 10.7531 9.5 11.0625V12.9375C9.5 13.2469 9.75313 13.5 10.0625 13.5H11.9375C12.2469 13.5 12.5 13.2469 12.5 12.9375ZM17 12.9375V11.0625C17 10.7531 16.7469 10.5 16.4375 10.5H14.5625C14.2531 10.5 14 10.7531 14 11.0625V12.9375C14 13.2469 14.2531 13.5 14.5625 13.5H16.4375C16.7469 13.5 17 13.2469 17 12.9375ZM12.5 17.4375V15.5625C12.5 15.2531 12.2469 15 11.9375 15H10.0625C9.75313 15 9.5 15.2531 9.5 15.5625V17.4375C9.5 17.7469 9.75313 18 10.0625 18H11.9375C12.2469 18 12.5 17.7469 12.5 17.4375ZM8 17.4375V15.5625C8 15.2531 7.74687 15 7.4375 15H5.5625C5.25313 15 5 15.2531 5 15.5625V17.4375C5 17.7469 5.25313 18 5.5625 18H7.4375C7.74687 18 8 17.7469 8 17.4375ZM17 17.4375V15.5625C17 15.2531 16.7469 15 16.4375 15H14.5625C14.2531 15 14 15.2531 14 15.5625V17.4375C14 17.7469 14.2531 18 14.5625 18H16.4375C16.7469 18 17 17.7469 17 17.4375ZM21.5 5.25V21.75C21.5 22.9922 20.4922 24 19.25 24H2.75C1.50781 24 0.5 22.9922 0.5 21.75V5.25C0.5 4.00781 1.50781 3 2.75 3H5V0.5625C5 0.253125 5.25313 0 5.5625 0H7.4375C7.74687 0 8 0.253125 8 0.5625V3H14V0.5625C14 0.253125 14.2531 0 14.5625 0H16.4375C16.7469 0 17 0.253125 17 0.5625V3H19.25C20.4922 3 21.5 4.00781 21.5 5.25ZM19.25 21.4688V7.5H2.75V21.4688C2.75 21.6234 2.87656 21.75 3.03125 21.75H18.9688C19.1234 21.75 19.25 21.6234 19.25 21.4688Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularClockCalendar = ({
  height,
  width,
  fill,
  children,
  className,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    {...rest}
  >
    {children}
    <path
      d="M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48H432 400 288 48V448c0 8.8 7.2 16 16 16H284.5c12.3 18.8 28 35.1 46.3 48H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304c0-8.8-7.2-16-16-16z"
      fill={fill || '#000'}
      className={className || ''}
    />
  </svg>
);

export const SolidCamera = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M24 5.75V19.25C24 20.4922 22.9922 21.5 21.75 21.5H2.25C1.00781 21.5 0 20.4922 0 19.25V5.75C0 4.50781 1.00781 3.5 2.25 3.5H6.375L6.95156 1.95781C7.27969 1.08125 8.11875 0.5 9.05625 0.5H14.9391C15.8766 0.5 16.7156 1.08125 17.0438 1.95781L17.625 3.5H21.75C22.9922 3.5 24 4.50781 24 5.75ZM17.625 12.5C17.625 9.39688 15.1031 6.875 12 6.875C8.89688 6.875 6.375 9.39688 6.375 12.5C6.375 15.6031 8.89688 18.125 12 18.125C15.1031 18.125 17.625 15.6031 17.625 12.5ZM16.125 12.5C16.125 14.7734 14.2734 16.625 12 16.625C9.72656 16.625 7.875 14.7734 7.875 12.5C7.875 10.2266 9.72656 8.375 12 8.375C14.2734 8.375 16.125 10.2266 16.125 12.5Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidPhotoVideo = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M22.8 0.4H6C5.68174 0.4 5.37652 0.526428 5.15147 0.751472C4.92643 0.976515 4.8 1.28174 4.8 1.6V5.2H10.8V2.8H18V14.8H22.8C23.1183 14.8 23.4235 14.6736 23.6485 14.4485C23.8736 14.2235 24 13.9183 24 13.6V1.6C24 1.28174 23.8736 0.976515 23.6485 0.751472C23.4235 0.526428 23.1183 0.4 22.8 0.4V0.4ZM8.7 4.2625C8.7 4.35201 8.66444 4.43785 8.60115 4.50115C8.53786 4.56444 8.45201 4.6 8.3625 4.6H7.2375C7.14799 4.6 7.06215 4.56444 6.99885 4.50115C6.93556 4.43785 6.9 4.35201 6.9 4.2625V3.1375C6.9 3.04799 6.93556 2.96214 6.99885 2.89885C7.06215 2.83556 7.14799 2.8 7.2375 2.8H8.3625C8.45201 2.8 8.53786 2.83556 8.60115 2.89885C8.66444 2.96214 8.7 3.04799 8.7 3.1375V4.2625ZM21.9 12.0625C21.9 12.152 21.8644 12.2379 21.8011 12.3011C21.7379 12.3644 21.652 12.4 21.5625 12.4H20.4375C20.348 12.4 20.2621 12.3644 20.1989 12.3011C20.1356 12.2379 20.1 12.152 20.1 12.0625V10.9375C20.1 10.848 20.1356 10.7621 20.1989 10.6989C20.2621 10.6356 20.348 10.6 20.4375 10.6H21.5625C21.652 10.6 21.7379 10.6356 21.8011 10.6989C21.8644 10.7621 21.9 10.848 21.9 10.9375V12.0625ZM21.9 8.1625C21.9 8.25201 21.8644 8.33786 21.8011 8.40115C21.7379 8.46444 21.652 8.5 21.5625 8.5H20.4375C20.348 8.5 20.2621 8.46444 20.1989 8.40115C20.1356 8.33786 20.1 8.25201 20.1 8.1625V7.0375C20.1 6.94799 20.1356 6.86214 20.1989 6.79885C20.2621 6.73556 20.348 6.7 20.4375 6.7H21.5625C21.652 6.7 21.7379 6.73556 21.8011 6.79885C21.8644 6.86214 21.9 6.94799 21.9 7.0375V8.1625ZM21.9 4.2625C21.9 4.35201 21.8644 4.43785 21.8011 4.50115C21.7379 4.56444 21.652 4.6 21.5625 4.6H20.4375C20.348 4.6 20.2621 4.56444 20.1989 4.50115C20.1356 4.43785 20.1 4.35201 20.1 4.2625V3.1375C20.1 3.04799 20.1356 2.96214 20.1989 2.89885C20.2621 2.83556 20.348 2.8 20.4375 2.8H21.5625C21.652 2.8 21.7379 2.83556 21.8011 2.89885C21.8644 2.96214 21.9 3.04799 21.9 3.1375V4.2625ZM15.6 6.4H1.2C0.88174 6.4 0.576516 6.52643 0.351472 6.75147C0.126428 6.97652 0 7.28174 0 7.6L0 18.4C0 18.7183 0.126428 19.0235 0.351472 19.2485C0.576516 19.4736 0.88174 19.6 1.2 19.6H15.6C15.9183 19.6 16.2235 19.4736 16.4485 19.2485C16.6736 19.0235 16.8 18.7183 16.8 18.4V7.6C16.8 7.28174 16.6736 6.97652 16.4485 6.75147C16.2235 6.52643 15.9183 6.4 15.6 6.4ZM3.6 8.8C3.83734 8.8 4.06935 8.87038 4.26668 9.00224C4.46402 9.13409 4.61783 9.32151 4.70866 9.54078C4.79948 9.76005 4.82325 10.0013 4.77694 10.2341C4.73064 10.4669 4.61635 10.6807 4.44853 10.8485C4.28071 11.0164 4.06689 11.1306 3.83411 11.1769C3.60133 11.2232 3.36005 11.1995 3.14078 11.1087C2.92151 11.0178 2.73409 10.864 2.60224 10.6667C2.47038 10.4693 2.4 10.2373 2.4 10C2.4 9.68174 2.52643 9.37652 2.75147 9.15147C2.97652 8.92643 3.28174 8.8 3.6 8.8ZM14.4 17.2H2.4V16L4.8 13.6L6 14.8L10.8 10L14.4 13.6V17.2Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidVideo = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '16'}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M14.0083 0H1.99167C0.891667 0 0 0.891667 0 1.99167V14.0083C0 15.1083 0.891667 16 1.99167 16H14.0083C15.1083 16 16 15.1083 16 14.0083V1.99167C16 0.891667 15.1083 0 14.0083 0ZM21.9 1.57083L17.3333 4.72083V11.2792L21.9 14.425C22.7833 15.0333 24 14.4125 24 13.35V2.64583C24 1.5875 22.7875 0.9625 21.9 1.57083Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidImage = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M6.85714 8.57143C7.1962 8.57143 7.52764 8.47089 7.80955 8.28252C8.09146 8.09415 8.31119 7.82642 8.44094 7.51317C8.57069 7.19993 8.60464 6.85524 8.53849 6.5227C8.47234 6.19016 8.30907 5.88471 8.06933 5.64496C7.82958 5.40521 7.52412 5.24194 7.19158 5.1758C6.85904 5.10965 6.51436 5.1436 6.20111 5.27335C5.88787 5.4031 5.62013 5.62282 5.43177 5.90474C5.2434 6.18665 5.14286 6.51809 5.14286 6.85714C5.14286 7.3118 5.32347 7.74783 5.64496 8.06933C5.96645 8.39082 6.40249 8.57143 6.85714 8.57143ZM22.2857 0H1.71429C1.25963 0 0.823594 0.180612 0.502103 0.502103C0.180612 0.823593 0 1.25963 0 1.71429L0 22.2857C0 22.7404 0.180612 23.1764 0.502103 23.4979C0.823594 23.8194 1.25963 24 1.71429 24H22.2857C22.7404 24 23.1764 23.8194 23.4979 23.4979C23.8194 23.1764 24 22.7404 24 22.2857V1.71429C24 1.25963 23.8194 0.823593 23.4979 0.502103C23.1764 0.180612 22.7404 0 22.2857 0ZM20.5714 17.1429H3.42857V3.42857H20.5714V17.1429ZM14.4 9.48589C14.3202 9.37944 14.2166 9.29304 14.0976 9.23353C13.9786 9.17402 13.8474 9.14304 13.7143 9.14304C13.5812 9.14304 13.45 9.17402 13.331 9.23353C13.2119 9.29304 13.1084 9.37944 13.0286 9.48589L10.3864 13.0082L9.28446 11.3571C9.20618 11.2398 9.10014 11.1436 8.97576 11.077C8.85138 11.0105 8.71249 10.9757 8.57143 10.9757C8.43036 10.9757 8.29148 11.0105 8.1671 11.077C8.04272 11.1436 7.93668 11.2398 7.85839 11.3571L5.14286 15.4286H18.8571L14.4 9.48589Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCamera = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M16.0641 5.75H21.75V19.25H2.25V5.75H7.93594L9.06094 2.75H14.9437L16.0641 5.75ZM15.2016 0.5H9.06094C8.12344 0.5 7.28437 1.08125 6.95625 1.95781L6.375 3.5H2.25C1.00781 3.5 0 4.50781 0 5.75V19.25C0 20.4922 1.00781 21.5 2.25 21.5H21.75C22.9922 21.5 24 20.4922 24 19.25V5.75C24 4.50781 22.9922 3.5 21.75 3.5H17.625L16.9547 1.71875C16.6828 0.982813 15.9844 0.5 15.2016 0.5ZM12 18.125C8.89688 18.125 6.375 15.6031 6.375 12.5C6.375 9.39688 8.89688 6.875 12 6.875C15.1031 6.875 17.625 9.39688 17.625 12.5C17.625 15.6031 15.1031 18.125 12 18.125ZM12 9.125C10.1391 9.125 8.625 10.6391 8.625 12.5C8.625 14.3609 10.1391 15.875 12 15.875C13.8609 15.875 15.375 14.3609 15.375 12.5C15.375 10.6391 13.8609 9.125 12 9.125Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularPhotoVideo = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M22.8 0.4H6C5.33738 0.4 4.8 0.892375 4.8 1.49987V4.6H6.6V2.2H8.4V4.6H10.2V2.2H18.6V13.6H22.8C23.4626 13.6 24 13.1076 24 12.5001V1.49987C24 0.892375 23.4626 0.4 22.8 0.4ZM22.2 11.8H20.4V9.7H22.2V11.8ZM22.2 7.9H20.4V6.1H22.2V7.9ZM22.2 4.3H20.4V2.2H22.2V4.3ZM4.8 12.4C5.03734 12.4 5.26935 12.3296 5.46668 12.1978C5.66402 12.0659 5.81783 11.8785 5.90866 11.6592C5.99948 11.4399 6.02324 11.1987 5.97694 10.9659C5.93064 10.7331 5.81635 10.5193 5.64853 10.3515C5.48071 10.1836 5.26689 10.0694 5.03411 10.0231C4.80133 9.97676 4.56005 10.0005 4.34078 10.0913C4.12151 10.1822 3.93409 10.336 3.80224 10.5333C3.67038 10.7307 3.6 10.9627 3.6 11.2C3.6 11.5183 3.72643 11.8235 3.95147 12.0485C4.17652 12.2736 4.48174 12.4 4.8 12.4ZM15.6 6.4H1.2C0.88174 6.4 0.576516 6.52643 0.351472 6.75147C0.126428 6.97652 0 7.28174 0 7.6L0 18.4C0 18.7183 0.126428 19.0235 0.351472 19.2485C0.576516 19.4736 0.88174 19.6 1.2 19.6H15.6C15.9183 19.6 16.2235 19.4736 16.4485 19.2485C16.6736 19.0235 16.8 18.7183 16.8 18.4V7.6C16.8 7.28174 16.6736 6.97652 16.4485 6.75147C16.2235 6.52643 15.9183 6.4 15.6 6.4ZM15 15.4L11.2241 11.6241C11.1116 11.5117 10.9591 11.4485 10.8 11.4485C10.6409 11.4485 10.4884 11.5117 10.3759 11.6241L6.6 15.4L5.22412 14.0241C5.11161 13.9117 4.95906 13.8485 4.8 13.8485C4.64094 13.8485 4.48839 13.9117 4.37588 14.0241L1.8 16.6V8.2H15V15.4Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularVideo = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '16'}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M22.6625 1.33333C22.4042 1.33333 22.1417 1.40833 21.9042 1.57083L17.3333 4.42083V1.99167C17.3333 0.891667 16.3667 0 15.175 0H2.15833C0.966667 0 0 0.891667 0 1.99167V14.0083C0 15.1083 0.966667 16 2.15833 16H15.175C16.3667 16 17.3333 15.1083 17.3333 14.0083V11.5792L21.9042 14.425C22.1417 14.5917 22.4083 14.6625 22.6625 14.6625C23.3542 14.6625 24 14.1208 24 13.35V2.64583C24 1.875 23.3542 1.33333 22.6625 1.33333ZM15.3333 5.66667V13.9542C15.3083 13.9708 15.2583 14 15.175 14H2.15833C2.075 14 2.025 13.975 2 13.9542V2.04583C2.025 2.02917 2.075 2 2.15833 2H15.175C15.2583 2 15.3083 2.025 15.3333 2.04583V5.66667ZM22 12.1333L17.3333 9.225V6.77917L22 3.87083V12.1333Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAltImage = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M22.2857 0H1.71429C1.25963 0 0.823594 0.180612 0.502103 0.502103C0.180612 0.823593 0 1.25963 0 1.71429L0 22.2857C0 22.7404 0.180612 23.1764 0.502103 23.4979C0.823594 23.8194 1.25963 24 1.71429 24H22.2857C22.7404 24 23.1764 23.8194 23.4979 23.4979C23.8194 23.1764 24 22.7404 24 22.2857V1.71429C24 1.25963 23.8194 0.823593 23.4979 0.502103C23.1764 0.180612 22.7404 0 22.2857 0ZM21.4286 21.4286H2.57143V18H21.4286V21.4286ZM21.4286 15.4286H20.5714L15.3713 8.94643C14.9716 8.44768 14.1713 8.44768 13.7716 8.94643L10.3763 13.1786L8.60571 10.7261C8.18143 10.1368 7.24714 10.1368 6.82286 10.7261L3.42857 15.4286H2.57143V2.57143H21.4286V15.4286ZM7.71429 7.71429C8.05334 7.71429 8.38478 7.61374 8.66669 7.42538C8.9486 7.23701 9.16833 6.96927 9.29808 6.65603C9.42783 6.34278 9.46178 5.9981 9.39563 5.66556C9.32949 5.33302 9.16622 5.02756 8.92647 4.78782C8.68672 4.54807 8.38127 4.3848 8.04873 4.31865C7.71619 4.25251 7.3715 4.28646 7.05826 4.41621C6.74501 4.54596 6.47728 4.76568 6.28891 5.04759C6.10054 5.32951 6 5.66095 6 6C6 6.45466 6.18061 6.89069 6.5021 7.21218C6.82359 7.53367 7.25963 7.71429 7.71429 7.71429Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularImage = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.75 0H2.25C1.00734 0 0 1.00734 0 2.25V15.75C0 16.9927 1.00734 18 2.25 18H21.75C22.9927 18 24 16.9927 24 15.75V2.25C24 1.00734 22.9927 0 21.75 0ZM21.4688 15.75H2.53125C2.45666 15.75 2.38512 15.7204 2.33238 15.6676C2.27963 15.6149 2.25 15.5433 2.25 15.4688V2.53125C2.25 2.45666 2.27963 2.38512 2.33238 2.33238C2.38512 2.27963 2.45666 2.25 2.53125 2.25H21.4688C21.5433 2.25 21.6149 2.27963 21.6676 2.33238C21.7204 2.38512 21.75 2.45666 21.75 2.53125V15.4688C21.75 15.5433 21.7204 15.6149 21.6676 15.6676C21.6149 15.7204 21.5433 15.75 21.4688 15.75ZM6 4.125C4.96448 4.125 4.125 4.96448 4.125 6C4.125 7.03552 4.96448 7.875 6 7.875C7.03552 7.875 7.875 7.03552 7.875 6C7.875 4.96448 7.03552 4.125 6 4.125ZM4.5 13.5H19.5V9.75L15.3977 5.64773C15.1781 5.42808 14.8219 5.42808 14.6022 5.64773L9 11.25L7.14773 9.39773C6.92808 9.17808 6.57192 9.17808 6.35222 9.39773L4.5 11.25V13.5Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularImages = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M20 16.6667V17.3333C20 18.4379 19.1046 19.3333 18 19.3333H2C0.895417 19.3333 0 18.4379 0 17.3333V6.66667C0 5.56208 0.895417 4.66667 2 4.66667H2.66667V6.66667H2.25C2.1837 6.66667 2.12011 6.69301 2.07322 6.73989C2.02634 6.78677 2 6.85036 2 6.91667V17.0833C2 17.1496 2.02634 17.2132 2.07322 17.2601C2.12011 17.307 2.1837 17.3333 2.25 17.3333H17.75C17.8163 17.3333 17.8799 17.307 17.9268 17.2601C17.9737 17.2132 18 17.1496 18 17.0833V16.6667H20ZM21.75 2.66667H6.25C6.1837 2.66667 6.12011 2.69301 6.07322 2.73989C6.02634 2.78678 6 2.85036 6 2.91667V13.0833C6 13.1496 6.02634 13.2132 6.07322 13.2601C6.12011 13.307 6.1837 13.3333 6.25 13.3333H21.75C21.8163 13.3333 21.8799 13.307 21.9268 13.2601C21.9737 13.2132 22 13.1496 22 13.0833V2.91667C22 2.85036 21.9737 2.78678 21.9268 2.73989C21.8799 2.69301 21.8163 2.66667 21.75 2.66667ZM22 0.666668C23.1046 0.666668 24 1.56208 24 2.66667V13.3333C24 14.4379 23.1046 15.3333 22 15.3333H6C4.89542 15.3333 4 14.4379 4 13.3333V2.66667C4 1.56208 4.89542 0.666668 6 0.666668H22ZM11 5.33333C11 6.25379 10.2538 7 9.33333 7C8.41288 7 7.66667 6.25379 7.66667 5.33333C7.66667 4.41288 8.41288 3.66667 9.33333 3.66667C10.2538 3.66667 11 4.41288 11 5.33333ZM8 9.33333L9.64646 7.68688C9.84171 7.49163 10.1583 7.49163 10.3536 7.68688L12 9.33333L16.3131 5.02021C16.5084 4.82496 16.825 4.82496 17.0203 5.02021L20 8V11.3333H8V9.33333Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidPercent = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M5.75 10.5C8.65156 10.5 11 8.15156 11 5.25C11 2.34844 8.65156 0 5.75 0C2.84844 0 0.5 2.34844 0.5 5.25C0.5 8.15156 2.84844 10.5 5.75 10.5ZM5.75 3C6.99219 3 8 4.00781 8 5.25C8 6.49219 6.99219 7.5 5.75 7.5C4.50781 7.5 3.5 6.49219 3.5 5.25C3.5 4.00781 4.50781 3 5.75 3ZM16.25 13.5C13.3484 13.5 11 15.8484 11 18.75C11 21.6516 13.3484 24 16.25 24C19.1516 24 21.5 21.6516 21.5 18.75C21.5 15.8484 19.1516 13.5 16.25 13.5ZM16.25 21C15.0078 21 14 19.9922 14 18.75C14 17.5078 15.0078 16.5 16.25 16.5C17.4922 16.5 18.5 17.5078 18.5 18.75C18.5 19.9922 17.4922 21 16.25 21ZM18.8891 0.009375L20.3703 0.0046875C21.2797 0 21.8188 1.02656 21.2938 1.77656L4.12813 23.5125C4.02463 23.6601 3.8871 23.7806 3.72718 23.8638C3.56726 23.9471 3.38965 23.9906 3.20937 23.9906L1.64375 23.9953C0.729687 23.9953 0.195312 22.9688 0.720312 22.2234L17.9703 0.4875C18.1813 0.1875 18.5234 0.009375 18.8891 0.009375Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidPercentage = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M6.82824 6.82847C8.3901 5.26661 8.3901 2.7335 6.82824 1.17164C5.26637 -0.39023 2.73326 -0.39023 1.1714 1.17164C-0.390466 2.7335 -0.390466 5.26661 1.1714 6.82847C2.73389 8.39096 5.26637 8.39096 6.82824 6.82847ZM22.8281 17.1715C21.2663 15.6097 18.7332 15.6097 17.1713 17.1715C15.6094 18.7334 15.6094 21.2665 17.1713 22.8284C18.7332 24.3902 21.2663 24.3902 22.8281 22.8284C24.3906 21.2665 24.3906 18.734 22.8281 17.1715ZM22.7069 2.70725L21.2931 1.29351C20.5119 0.512265 19.2457 0.512265 18.465 1.29351L1.29327 18.4653C0.512028 19.2465 0.512028 20.5128 1.29327 21.2934L2.70701 22.7071C3.48826 23.4884 4.7545 23.4884 5.53512 22.7071L22.7069 5.53536C23.4881 4.75474 23.4881 3.4885 22.7069 2.70725Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidSync = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M20.6555 0.589219L20.843 4.46906C19.7539 3.18433 18.3978 2.15249 16.8692 1.44542C15.3406 0.738351 13.6762 0.373062 11.992 0.375C6.31547 0.375 1.58953 4.44938 0.576094 9.83531C0.561102 9.91646 0.564149 9.99992 0.58502 10.0798C0.605891 10.1596 0.644073 10.2339 0.69686 10.2973C0.749646 10.3607 0.815743 10.4118 0.890463 10.4468C0.965183 10.4818 1.0467 10.5 1.12922 10.5H3.42844C3.55519 10.4999 3.67818 10.4569 3.77747 10.3781C3.87676 10.2993 3.94653 10.1893 3.97547 10.0659C4.35044 8.50977 5.17024 7.09637 6.33485 5.99822C7.49947 4.90006 8.95854 4.16462 10.534 3.88163C12.1095 3.59863 13.7333 3.78032 15.2073 4.40453C16.6813 5.02874 17.9417 6.06847 18.8348 7.39688L14.0789 7.16906C14.0028 7.16544 13.9268 7.17732 13.8554 7.20396C13.7841 7.2306 13.7189 7.27146 13.6638 7.32406C13.6087 7.37666 13.5648 7.4399 13.5349 7.50995C13.505 7.58 13.4896 7.65539 13.4897 7.73156V9.95391C13.4897 10.1031 13.549 10.2462 13.6544 10.3517C13.7599 10.4571 13.903 10.5164 14.0522 10.5164H23.4375C23.5867 10.5164 23.7298 10.4571 23.8352 10.3517C23.9407 10.2462 24 10.1031 24 9.95391V0.5625C24 0.413316 23.9407 0.270242 23.8352 0.164752C23.7298 0.0592632 23.5867 0 23.4375 0L21.217 0C21.1409 4.09301e-05 21.0656 0.0155201 20.9957 0.0455008C20.9258 0.0754815 20.8626 0.11934 20.8101 0.174423C20.7576 0.229506 20.7169 0.294668 20.6903 0.365965C20.6637 0.437262 20.6519 0.513212 20.6555 0.589219ZM11.992 20.25C10.6395 20.2512 9.30747 19.919 8.11381 19.2829C6.92015 18.6469 5.90162 17.7265 5.14828 16.6031L9.92016 16.8314C9.99624 16.835 10.0723 16.8232 10.1436 16.7965C10.215 16.7699 10.2802 16.729 10.3353 16.6764C10.3904 16.6238 10.4342 16.5606 10.4642 16.4905C10.4941 16.4205 10.5095 16.3451 10.5094 16.2689V14.047C10.5094 13.8978 10.4501 13.7548 10.3446 13.6493C10.2391 13.5438 10.0961 13.4845 9.94687 13.4845H0.5625C0.413316 13.4845 0.270242 13.5438 0.164752 13.6493C0.0592632 13.7548 0 13.8978 0 14.047L0 23.4375C0 23.5867 0.0592632 23.7298 0.164752 23.8352C0.270242 23.9407 0.413316 24 0.5625 24H2.78203C2.85833 24.0001 2.93385 23.9847 3.00399 23.9547C3.07414 23.9246 3.13744 23.8807 3.19006 23.8254C3.24268 23.7702 3.28351 23.7048 3.31006 23.6333C3.33662 23.5618 3.34835 23.4856 3.34453 23.4094L3.15 19.5389C4.23886 20.821 5.59383 21.8507 7.12076 22.5563C8.64769 23.2619 10.3099 23.6266 11.992 23.625C17.6691 23.625 22.395 19.5506 23.4084 14.1647C23.4234 14.0835 23.4204 14.0001 23.3995 13.9202C23.3786 13.8404 23.3405 13.7661 23.2877 13.7027C23.2349 13.6393 23.1688 13.5882 23.0941 13.5532C23.0193 13.5182 22.9378 13.5 22.8553 13.5H20.5561C20.4293 13.5001 20.3064 13.5431 20.2071 13.6219C20.1078 13.7007 20.038 13.8107 20.0091 13.9341C19.5762 15.7342 18.5499 17.3362 17.0955 18.4819C15.6412 19.6277 13.8435 20.2505 11.992 20.25Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidAltSync = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M17.551 6.06194C16.0383 4.64555 14.0752 3.86913 11.9926 3.87097C8.24468 3.87426 5.00903 6.4441 4.11566 10.0089C4.05063 10.2684 3.81944 10.4516 3.5519 10.4516H0.779177C0.416371 10.4516 0.140758 10.1222 0.207871 9.76568C1.25482 4.206 6.13611 0 12 0C15.2152 0 18.135 1.26464 20.2894 3.32347L22.0176 1.59532C22.7491 0.863758 24 1.38189 24 2.4165V8.90323C24 9.5446 23.4801 10.0645 22.8387 10.0645H16.352C15.3174 10.0645 14.7992 8.81366 15.5308 8.08205L17.551 6.06194ZM1.16129 13.9355H7.64802C8.68263 13.9355 9.20076 15.1863 8.46919 15.918L6.44903 17.9381C7.96171 19.3545 9.92492 20.131 12.0075 20.1291C15.7536 20.1257 18.9905 17.5576 19.8843 13.9912C19.9494 13.7317 20.1806 13.5485 20.4481 13.5485H23.2209C23.5837 13.5485 23.8593 13.8779 23.7922 14.2344C22.7452 19.794 17.8639 24 12 24C8.78477 24 5.86495 22.7354 3.71056 20.6765L1.98242 22.4047C1.25085 23.1362 0 22.6181 0 21.5835V15.0968C0 14.4554 0.519919 13.9355 1.16129 13.9355Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularPercent = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M5.85787 10.2857C8.69716 10.2857 11.0007 7.98214 11.0007 5.14286C11.0007 2.30357 8.69716 0 5.85787 0C3.01859 0 0.715016 2.30357 0.715016 5.14286C0.715016 7.98214 3.01859 10.2857 5.85787 10.2857ZM5.85787 2.57143C7.27752 2.57143 8.4293 3.72321 8.4293 5.14286C8.4293 6.5625 7.27752 7.71429 5.85787 7.71429C4.43823 7.71429 3.28644 6.5625 3.28644 5.14286C3.28644 3.72321 4.43823 2.57143 5.85787 2.57143ZM16.1436 13.7143C13.3043 13.7143 11.0007 16.0179 11.0007 18.8571C11.0007 21.6964 13.3043 24 16.1436 24C18.9829 24 21.2864 21.6964 21.2864 18.8571C21.2864 16.0179 18.9829 13.7143 16.1436 13.7143ZM16.1436 21.4286C14.7239 21.4286 13.5722 20.2768 13.5722 18.8571C13.5722 17.4375 14.7239 16.2857 16.1436 16.2857C17.5632 16.2857 18.715 17.4375 18.715 18.8571C18.715 20.2768 17.5632 21.4286 16.1436 21.4286ZM21.1739 1.00714L3.7793 23.7321C3.65609 23.8982 3.46323 24 3.25966 24H1.35787C0.843588 24 0.53823 23.4268 0.822159 22.9982L18.2436 0.267857C18.3668 0.101786 18.5597 0 18.7632 0H20.6436C21.1579 0 21.4632 0.578571 21.1739 1.00714Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularPercentage = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M6.14576 6.14577C7.55119 4.73959 7.55119 2.46045 6.14576 1.05501C4.73957 -0.351171 2.46043 -0.351171 1.055 1.05501C-0.350439 2.46045 -0.350439 4.74034 1.055 6.14577C2.46118 7.55196 4.74032 7.55196 6.14576 6.14577ZM17.8542 17.8542C16.4488 19.2597 16.4488 21.5396 17.8542 22.945C19.2604 24.3504 21.5395 24.3504 22.945 22.945C24.3504 21.5388 24.3504 19.2597 22.945 17.8542C21.5388 16.448 19.2596 16.448 17.8542 17.8542ZM23.6477 2.04872L21.9505 0.351546C21.4818 -0.117182 20.7221 -0.117182 20.2533 0.351546L0.352278 20.2541C-0.11645 20.7228 -0.11645 21.4826 0.352278 21.9513L2.04945 23.6485C2.51818 24.1172 3.27789 24.1172 3.74662 23.6485L23.6484 3.74664C24.1164 3.27716 24.1164 2.51744 23.6477 2.04872Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularSync = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.4375 0.375H22.1385C21.8227 0.375 21.5687 0.635062 21.5762 0.950906L21.6862 5.57161C19.6037 2.43952 16.0432 0.375 12 0.375C6.31936 0.375 1.59061 4.44956 0.576375 9.8355C0.511312 10.1809 0.778313 10.5 1.12983 10.5H2.46933C2.7353 10.5 2.96348 10.3133 3.0195 10.0533C3.9113 5.91225 7.58986 2.8125 12 2.8125C15.7287 2.8125 18.9348 5.02884 20.3754 8.21728L14.4509 8.07623C14.1351 8.06873 13.875 8.32266 13.875 8.63859V9.9375C13.875 10.2481 14.1269 10.5 14.4375 10.5H23.4375C23.7481 10.5 24 10.2481 24 9.9375V0.9375C24 0.626859 23.7481 0.375 23.4375 0.375ZM22.8702 13.5H21.5307C21.2647 13.5 21.0365 13.6867 20.9805 13.9467C20.0887 18.0877 16.4101 21.1875 12 21.1875C8.27128 21.1875 5.06522 18.9712 3.62456 15.7827L9.54909 15.9238C9.86489 15.9313 10.125 15.6773 10.125 15.3614V14.0625C10.125 13.7519 9.87314 13.5 9.5625 13.5H0.5625C0.251859 13.5 0 13.7519 0 14.0625V23.0625C0 23.3731 0.251859 23.625 0.5625 23.625H1.86145C2.17734 23.625 2.43131 23.3649 2.42381 23.0491L2.3138 18.4284C4.39631 21.5605 7.95675 23.625 12 23.625C17.6806 23.625 22.4094 19.5504 23.4236 14.1645C23.4887 13.8191 23.2217 13.5 22.8702 13.5Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAltSync = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.0088 0.99121L20.4847 3.51532C18.3133 1.34356 15.3138 0 12 0C5.57555 0 0.330194 5.04861 0.015 11.3948C-0.0014032 11.7247 0.264919 12 0.59521 12H1.95223C2.25963 12 2.51415 11.7604 2.53156 11.4535C2.81424 6.46689 6.94127 2.51613 12 2.51613C14.6208 2.51613 16.9915 3.57692 18.7071 5.29287L16.088 7.91202C15.7222 8.27782 15.9813 8.90323 16.4986 8.90323H23.4194C23.74 8.90323 24 8.64324 24 8.32258V1.40182C24 0.884516 23.3745 0.625452 23.0088 0.99121ZM23.4048 12H22.0478C21.7404 12 21.4859 12.2396 21.4684 12.5465C21.1858 17.5331 17.0587 21.4839 12 21.4839C9.37921 21.4839 7.00853 20.4231 5.29287 18.7071L7.91197 16.088C8.27777 15.7222 8.01871 15.0968 7.5014 15.0968H0.580645C0.259984 15.0968 0 15.3568 0 15.6774V22.5982C0 23.1155 0.625452 23.3745 0.99121 23.0087L3.51532 20.4847C5.68669 22.6564 8.68626 24 12 24C18.4245 24 23.6698 18.9514 23.985 12.6052C24.0014 12.2753 23.7351 12 23.4048 12Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidRoute = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M19.5 15H15C14.175 15 13.5 14.325 13.5 13.5C13.5 12.675 14.175 12 15 12H19.5C19.5 12 24 6.98438 24 4.5C24 2.01562 21.9844 0 19.5 0C17.0156 0 15 2.01562 15 4.5C15 5.69531 16.0406 7.47188 17.1234 9H15C12.5203 9 10.5 11.0203 10.5 13.5C10.5 15.9797 12.5203 18 15 18H19.5C20.325 18 21 18.675 21 19.5C21 20.325 20.325 21 19.5 21H8.69531C7.94531 22.1625 7.11094 23.2359 6.47812 24H19.5C21.9797 24 24 21.9797 24 19.5C24 17.0203 21.9797 15 19.5 15ZM19.5 3C20.3297 3 21 3.67031 21 4.5C21 5.32969 20.3297 6 19.5 6C18.6703 6 18 5.32969 18 4.5C18 3.67031 18.6703 3 19.5 3ZM4.5 12C2.01562 12 0 14.0156 0 16.5C0 18.9844 4.5 24 4.5 24C4.5 24 9 18.9844 9 16.5C9 14.0156 6.98438 12 4.5 12ZM4.5 18C3.67031 18 3 17.3297 3 16.5C3 15.6703 3.67031 15 4.5 15C5.32969 15 6 15.6703 6 16.5C6 17.3297 5.32969 18 4.5 18Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidGlobe = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M16.2847 7.35484C15.5831 3.03387 13.9282 0 12.0024 0C10.0766 0 8.4218 3.03387 7.72018 7.35484H16.2847ZM7.35728 12C7.35728 13.0742 7.41534 14.1048 7.51696 15.0968H16.4831C16.5847 14.1048 16.6428 13.0742 16.6428 12C16.6428 10.9258 16.5847 9.89516 16.4831 8.90323H7.51696C7.41534 9.89516 7.35728 10.9258 7.35728 12ZM23.0686 7.35484C21.6847 4.06935 18.8831 1.52903 15.4234 0.503226C16.6041 2.13871 17.417 4.60161 17.8428 7.35484H23.0686ZM8.57663 0.503226C5.1218 1.52903 2.31534 4.06935 0.936312 7.35484H6.16212C6.58309 4.60161 7.39599 2.13871 8.57663 0.503226ZM23.5863 8.90323H18.0363C18.1379 9.91935 18.196 10.9597 18.196 12C18.196 13.0403 18.1379 14.0806 18.0363 15.0968H23.5815C23.8476 14.1048 23.9976 13.0742 23.9976 12C23.9976 10.9258 23.8476 9.89516 23.5863 8.90323ZM5.80889 12C5.80889 10.9597 5.86696 9.91935 5.96857 8.90323H0.41857C0.15728 9.89516 0.00244141 10.9258 0.00244141 12C0.00244141 13.0742 0.15728 14.1048 0.41857 15.0968H5.96373C5.86696 14.0806 5.80889 13.0403 5.80889 12ZM7.72018 16.6452C8.4218 20.9661 10.0766 24 12.0024 24C13.9282 24 15.5831 20.9661 16.2847 16.6452H7.72018ZM15.4282 23.4968C18.8831 22.471 21.6895 19.9306 23.0734 16.6452H17.8476C17.4218 19.3984 16.6089 21.8613 15.4282 23.4968ZM0.936312 16.6452C2.32018 19.9306 5.1218 22.471 8.58147 23.4968C7.40083 21.8613 6.58793 19.3984 6.16212 16.6452H0.936312Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidMap = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0 4.23583V18.6658C0 19.1375 0.47625 19.46 0.914167 19.285L6.66667 16.6667V0.666664L0.838333 2.99791C0.590908 3.09688 0.378804 3.2677 0.229379 3.48835C0.0799536 3.70899 5.92587e-05 3.96935 0 4.23583H0ZM8 16.6667L16 19.3333V3.33333L8 0.666664V16.6667ZM23.0858 0.714997L17.3333 3.33333V19.3333L23.1617 17.0021C23.4091 16.9032 23.6213 16.7324 23.7707 16.5117C23.9201 16.291 24 16.0307 24 15.7642V1.33416C24 0.862497 23.5238 0.539997 23.0858 0.714997Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidMapPin = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '14'}
    height={height || '24'}
    viewBox="0 0 14 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M5.49998 14.8569V22.2018L6.53219 23.7497C6.75485 24.0834 7.24564 24.0834 7.4683 23.7497L8.50004 22.2018V14.8569C8.013 14.9469 7.51283 15.0003 7.00001 15.0003C6.48719 15.0003 5.98702 14.9469 5.49998 14.8569ZM7.00001 0C3.27197 0 0.249878 3.02209 0.249878 6.75013C0.249878 10.4782 3.27197 13.5003 7.00001 13.5003C10.7281 13.5003 13.7501 10.4782 13.7501 6.75013C13.7501 3.02209 10.7281 0 7.00001 0ZM7.00001 3.56257C5.24216 3.56257 3.81245 4.99229 3.81245 6.75013C3.81245 7.06045 3.56026 7.31264 3.24994 7.31264C2.93962 7.31264 2.68743 7.06045 2.68743 6.75013C2.68743 4.37212 4.62246 2.43755 7.00001 2.43755C7.31033 2.43755 7.56252 2.68974 7.56252 3.00006C7.56252 3.31038 7.31033 3.56257 7.00001 3.56257Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidMapMarker = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '18'}
    height={height || '24'}
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M8.07506 23.5158C1.26422 13.6421 0 12.6287 0 9C0 4.02942 4.02942 0 9 0C13.9706 0 18 4.02942 18 9C18 12.6287 16.7358 13.6421 9.92494 23.5158C9.47798 24.1614 8.52197 24.1614 8.07506 23.5158ZM9 12.75C11.0711 12.75 12.75 11.0711 12.75 9C12.75 6.92892 11.0711 5.25 9 5.25C6.92892 5.25 5.25 6.92892 5.25 9C5.25 11.0711 6.92892 12.75 9 12.75Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidMapSigns = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.7802 3.96984L21.75 1.93922C21.4688 1.65797 21.0872 1.5 20.6892 1.5H13.5V0.75C13.5 0.335625 13.1644 0 12.75 0H11.25C10.8356 0 10.5 0.335625 10.5 0.75V1.5H2.62501C2.00391 1.5 1.5 2.00391 1.5 2.625V6.375C1.5 6.99609 2.00391 7.5 2.62501 7.5H20.6892C21.0872 7.5 21.4683 7.34203 21.75 7.06078L23.7802 5.03062C24.0731 4.73719 24.0731 4.26281 23.7802 3.96984ZM10.5 23.25C10.5 23.6644 10.8356 24 11.25 24H12.75C13.1644 24 13.5 23.6644 13.5 23.25V18H10.5V23.25ZM21.375 10.5H13.5V9H10.5V10.5H3.31079C2.91282 10.5 2.53172 10.658 2.25001 10.9392L0.219849 12.9698C-0.0731201 13.2628 -0.0731201 13.7377 0.219849 14.0306L2.25001 16.0608C2.53126 16.342 2.91282 16.5 3.31079 16.5H21.375C21.9961 16.5 22.5 15.9961 22.5 15.375V11.625C22.5 11.0039 21.9961 10.5 21.375 10.5Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidLocation = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.25 10.5H20.865C20.2317 6.73406 17.2659 3.76828 13.5 3.135V0.75C13.5 0.335625 13.1644 0 12.75 0H11.25C10.8356 0 10.5 0.335625 10.5 0.75V3.135C6.73406 3.76828 3.76828 6.73406 3.135 10.5H0.75C0.335625 10.5 0 10.8356 0 11.25V12.75C0 13.1644 0.335625 13.5 0.75 13.5H3.135C3.76828 17.2659 6.73406 20.2317 10.5 20.865V23.25C10.5 23.6644 10.8356 24 11.25 24H12.75C13.1644 24 13.5 23.6644 13.5 23.25V20.865C17.2659 20.2317 20.2317 17.2659 20.865 13.5H23.25C23.6644 13.5 24 13.1644 24 12.75V11.25C24 10.8356 23.6644 10.5 23.25 10.5ZM12 18C8.68594 18 6 15.3136 6 12C6 8.68641 8.68594 6 12 6C15.3141 6 18 8.68641 18 12C18 15.3136 15.3141 18 12 18ZM12 7.875C9.72188 7.875 7.875 9.72188 7.875 12C7.875 14.2781 9.72188 16.125 12 16.125C14.2781 16.125 16.125 14.2781 16.125 12C16.125 9.72188 14.2781 7.875 12 7.875Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidDirections = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.5596 10.9367L13.0631 0.44015C12.4762 -0.146717 11.5242 -0.146717 10.9368 0.44015L0.440272 10.9367C-0.146595 11.5241 -0.146595 12.4756 0.440272 13.0629L10.9368 23.5595C11.5237 24.1468 12.4757 24.1468 13.0631 23.5595L23.5596 13.0629C24.1465 12.4756 24.1465 11.5241 23.5596 10.9367ZM18.8263 11.5255L14.879 15.169C14.639 15.3907 14.2494 15.2206 14.2494 14.8934V12.3748H9.74951V15.3748C9.74951 15.582 9.5817 15.7498 9.37452 15.7498H7.87454C7.66735 15.7498 7.49954 15.582 7.49954 15.3748V11.6248C7.49954 10.7966 8.17125 10.1249 8.99952 10.1249H14.2494V7.6063C14.2494 7.27958 14.6385 7.10896 14.879 7.33067L18.8263 10.9742C18.987 11.1228 18.987 11.3769 18.8263 11.5255Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularRoute = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M19.875 15.75H15.375C14.3391 15.75 13.5 14.9109 13.5 13.875C13.5 12.8391 14.3391 12 15.375 12H19.5C19.5 12 24 6.98438 24 4.5C24 2.01562 21.9844 0 19.5 0C17.0156 0 15 2.01562 15 4.5C15 5.89687 16.4203 8.09531 17.6672 9.75H15.375C13.1016 9.75 11.25 11.6016 11.25 13.875C11.25 16.1484 13.1016 18 15.375 18H19.875C20.9109 18 21.75 18.8391 21.75 19.875C21.75 20.9109 20.9109 21.75 19.875 21.75H6.33281C7.57969 20.0953 9 17.8969 9 16.5C9 14.0156 6.98438 12 4.5 12C2.01562 12 0 14.0156 0 16.5C0 18.9844 4.5 24 4.5 24H19.875C22.1484 24 24 22.1484 24 19.875C24 17.6016 22.1484 15.75 19.875 15.75ZM17.25 4.5C17.25 3.25781 18.2578 2.25 19.5 2.25C20.7422 2.25 21.75 3.25781 21.75 4.49531C21.7266 5.12344 20.775 6.75469 19.5 8.45156C18.225 6.75469 17.2734 5.12813 17.25 4.5ZM4.5 20.4516C3.225 18.7547 2.27344 17.1281 2.25 16.5C2.25 15.2578 3.25781 14.25 4.5 14.25C5.74219 14.25 6.75 15.2578 6.75 16.4953C6.72656 17.1234 5.775 18.7547 4.5 20.4516ZM4.5 15.75C4.0875 15.75 3.75 16.0875 3.75 16.5C3.75 16.9125 4.0875 17.25 4.5 17.25C4.9125 17.25 5.25 16.9125 5.25 16.5C5.25 16.0875 4.9125 15.75 4.5 15.75ZM20.25 4.5C20.25 4.0875 19.9125 3.75 19.5 3.75C19.0875 3.75 18.75 4.0875 18.75 4.5C18.75 4.9125 19.0875 5.25 19.5 5.25C19.9125 5.25 20.25 4.9125 20.25 4.5Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularGlobe = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0ZM20.6758 7.74194H17.4242C17.1 5.97581 16.5774 4.4129 15.9145 3.15968C17.9903 4.07903 19.6742 5.70968 20.6758 7.74194ZM12 2.32258C12.9 2.32258 14.3516 4.31613 15.0581 7.74194H8.94194C9.64839 4.31613 11.1 2.32258 12 2.32258ZM2.32258 12C2.32258 11.3371 2.39032 10.6887 2.51613 10.0645H6.27581C6.22742 10.6984 6.19355 11.3371 6.19355 12C6.19355 12.6629 6.22742 13.3016 6.27581 13.9355H2.51613C2.39032 13.3113 2.32258 12.6629 2.32258 12ZM3.32419 16.2581H6.57581C6.9 18.0242 7.42258 19.5871 8.08548 20.8403C6.00968 19.921 4.32581 18.2903 3.32419 16.2581ZM6.57581 7.74194H3.32419C4.32581 5.70968 6.00968 4.07903 8.08548 3.15968C7.42258 4.4129 6.9 5.97581 6.57581 7.74194ZM12 21.6774C11.1 21.6774 9.64839 19.6839 8.94194 16.2581H15.0629C14.3516 19.6839 12.9 21.6774 12 21.6774ZM15.3919 13.9355H8.60806C8.55484 13.3161 8.51613 12.6774 8.51613 12C8.51613 11.3226 8.55484 10.6839 8.60806 10.0645H15.3968C15.45 10.6839 15.4887 11.3226 15.4887 12C15.4887 12.6774 15.4452 13.3161 15.3919 13.9355ZM15.9145 20.8403C16.5774 19.5871 17.0952 18.0242 17.4242 16.2581H20.6758C19.6742 18.2903 17.9903 19.921 15.9145 20.8403ZM17.7242 13.9355C17.7726 13.3016 17.8065 12.6629 17.8065 12C17.8065 11.3371 17.7726 10.6984 17.7242 10.0645H21.4839C21.6097 10.6887 21.6774 11.3371 21.6774 12C21.6774 12.6629 21.6097 13.3113 21.4839 13.9355H17.7242Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularMap = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.3342 0.666664C23.2525 0.666664 23.1683 0.682081 23.0858 0.714997L16.0004 3.33333H16L8.83333 0.803331C8.56135 0.712926 8.27661 0.666783 7.99 0.666664C7.71125 0.666664 7.43292 0.710414 7.16458 0.797497L0.838333 2.99791C0.590908 3.09688 0.378804 3.2677 0.229379 3.48835C0.0799536 3.70899 5.92587e-05 3.96935 0 4.23583L0 18.6658C0 19.0487 0.31375 19.3333 0.66625 19.3333C0.747917 19.3333 0.831667 19.3179 0.914583 19.285L8 16.6667L15.1667 19.1962C15.7079 19.3769 16.2928 19.3791 16.8354 19.2025L23.1617 17.0021C23.4091 16.9032 23.6213 16.7324 23.7707 16.5117C23.9201 16.291 24 16.0307 24 15.7642V1.33416C24 0.951247 23.6863 0.666664 23.3342 0.666664ZM9.33333 3.10083L14.6667 4.98375V16.8992L9.33333 15.0162V3.10083ZM2 16.7521V4.71125L7.33333 2.85583V14.7808L7.30667 14.7904L2 16.7521ZM22 15.2883L16.6667 17.1437V5.21916L16.6933 5.20916L22 3.24791V15.2883Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularMapMarker = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '18'}
    height={height || '24'}
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M9 0C4.02671 0 0 4.03191 0 9C0 12.3336 1.12458 13.3754 7.09083 22.9418C7.97138 24.3536 10.0296 24.3519 10.9091 22.9418C16.8785 13.3704 18 12.333 18 9C18 4.02671 13.9681 0 9 0ZM9 21.75C3.027 12.1728 2.25 11.5682 2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 11.5572 15.0391 12.0668 9 21.75ZM5.25 9C5.25 6.92893 6.92893 5.25 9 5.25C11.0711 5.25 12.75 6.92893 12.75 9C12.75 11.0711 11.0711 12.75 9 12.75C6.92893 12.75 5.25 11.0711 5.25 9Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularMapPin = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '14'}
    height={height || '24'}
    viewBox="0 0 14 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M6.99994 0C3.27194 0 0.249878 3.02206 0.249878 6.75007C0.249878 10.0928 2.68553 12.8486 5.87493 13.3867V22.6512L6.64885 23.8123C6.81572 24.0626 7.1837 24.0626 7.35104 23.8123L8.12495 22.6512V13.3867C11.3144 12.8486 13.75 10.0928 13.75 6.75007C13.75 3.02206 10.7279 0 6.99994 0ZM6.99994 11.2501C4.51836 11.2501 2.4999 9.23118 2.4999 6.75007C2.4999 4.26848 4.51836 2.25002 6.99994 2.25002C9.48153 2.25002 11.5 4.26848 11.5 6.75007C11.5 9.23118 9.48153 11.2501 6.99994 11.2501ZM6.99994 3.75004C5.34618 3.75004 3.99991 5.09536 3.99991 6.75007C3.99991 7.16444 4.33554 7.50007 4.74992 7.50007C5.1643 7.50007 5.49993 7.16444 5.49993 6.75007C5.49993 5.92318 6.17212 5.25005 6.99994 5.25005C7.41432 5.25005 7.74995 4.91442 7.74995 4.50004C7.74995 4.08566 7.41432 3.75004 6.99994 3.75004Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularMapSigns = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M20.6892 9C21.0872 9 21.4683 8.80266 21.75 8.45062L23.7802 5.91281C24.0731 5.54672 24.0731 4.95328 23.7802 4.58672L21.75 2.04891C21.4688 1.69734 21.0872 1.5 20.6892 1.5H13.125V0.75C13.125 0.335625 12.7894 0 12.375 0H11.625C11.2106 0 10.875 0.335625 10.875 0.75V1.5H2.62501C2.00391 1.5 1.5 2.12953 1.5 2.90625V7.59375C1.5 8.37047 2.00391 9 2.62501 9H10.875V10.5H3.31079C2.91282 10.5 2.53126 10.6973 2.25001 11.0489L0.219849 13.5872C-0.0731201 13.9533 -0.0731201 14.5467 0.219849 14.9133L2.25001 17.4506C2.53126 17.8022 2.91282 18 3.31079 18H10.875V23.25C10.875 23.6644 11.2106 24 11.625 24H12.375C12.7894 24 13.125 23.6644 13.125 23.25V18H21.375C21.9961 18 22.5 17.3705 22.5 16.5938V11.9062C22.5 11.1295 21.9961 10.5 21.375 10.5H13.125V9H20.6892ZM20.25 15.75H3.77063L2.57063 14.25L3.77063 12.75H20.25V15.75ZM3.75 3.75H20.2294L21.4294 5.25L20.2294 6.75H3.75V3.75Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularLocation = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 7.875C9.72188 7.875 7.875 9.72188 7.875 12C7.875 14.2781 9.72188 16.125 12 16.125C14.2781 16.125 16.125 14.2781 16.125 12C16.125 9.72188 14.2781 7.875 12 7.875ZM12 13.875C10.9659 13.875 10.125 13.0341 10.125 12C10.125 10.9659 10.9659 10.125 12 10.125C13.0341 10.125 13.875 10.9659 13.875 12C13.875 13.0341 13.0341 13.875 12 13.875ZM23.25 10.875H20.9222C20.4136 6.80578 17.1942 3.58641 13.125 3.07781V0.75C13.125 0.335625 12.7894 0 12.375 0H11.625C11.2106 0 10.875 0.335625 10.875 0.75V3.07781C6.80578 3.58641 3.58641 6.80578 3.07781 10.875H0.75C0.335625 10.875 0 11.2106 0 11.625V12.375C0 12.7894 0.335625 13.125 0.75 13.125H3.07781C3.58641 17.1942 6.80578 20.4136 10.875 20.9222V23.25C10.875 23.6644 11.2106 24 11.625 24H12.375C12.7894 24 13.125 23.6644 13.125 23.25V20.9222C17.1942 20.4136 20.4136 17.1938 20.9222 13.125H23.25C23.6644 13.125 24 12.7894 24 12.375V11.625C24 11.2106 23.6644 10.875 23.25 10.875ZM12 18.75C8.27812 18.75 5.25 15.7219 5.25 12C5.25 8.27812 8.27812 5.25 12 5.25C15.7219 5.25 18.75 8.27812 18.75 12C18.75 15.7219 15.7219 18.75 12 18.75Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularDirections = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 7.875C9.72188 7.875 7.875 9.72188 7.875 12C7.875 14.2781 9.72188 16.125 12 16.125C14.2781 16.125 16.125 14.2781 16.125 12C16.125 9.72188 14.2781 7.875 12 7.875ZM12 13.875C10.9659 13.875 10.125 13.0341 10.125 12C10.125 10.9659 10.9659 10.125 12 10.125C13.0341 10.125 13.875 10.9659 13.875 12C13.875 13.0341 13.0341 13.875 12 13.875ZM23.25 10.875H20.9222C20.4136 6.80578 17.1942 3.58641 13.125 3.07781V0.75C13.125 0.335625 12.7894 0 12.375 0H11.625C11.2106 0 10.875 0.335625 10.875 0.75V3.07781C6.80578 3.58641 3.58641 6.80578 3.07781 10.875H0.75C0.335625 10.875 0 11.2106 0 11.625V12.375C0 12.7894 0.335625 13.125 0.75 13.125H3.07781C3.58641 17.1942 6.80578 20.4136 10.875 20.9222V23.25C10.875 23.6644 11.2106 24 11.625 24H12.375C12.7894 24 13.125 23.6644 13.125 23.25V20.9222C17.1942 20.4136 20.4136 17.1938 20.9222 13.125H23.25C23.6644 13.125 24 12.7894 24 12.375V11.625C24 11.2106 23.6644 10.875 23.25 10.875ZM12 18.75C8.27812 18.75 5.25 15.7219 5.25 12C5.25 8.27812 8.27812 5.25 12 5.25C15.7219 5.25 18.75 8.27812 18.75 12C18.75 15.7219 15.7219 18.75 12 18.75Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidCheck = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M8.15146 17.597L0.351457 9.79704C-0.117152 9.32843 -0.117152 8.56864 0.351457 8.09998L2.04847 6.40292C2.51708 5.93426 3.27693 5.93426 3.74554 6.40292L9 11.6573L20.2545 0.40291C20.7231 -0.0656998 21.4829 -0.0656998 21.9515 0.40291L23.6485 2.09997C24.1172 2.56858 24.1172 3.32838 23.6485 3.79704L9.84853 17.5971C9.37987 18.0657 8.62007 18.0657 8.15146 17.597Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidCircleCheck = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M24 12C24 18.6274 18.6274 24 12 24C5.37256 24 0 18.6274 0 12C0 5.37256 5.37256 0 12 0C18.6274 0 24 5.37256 24 12ZM10.612 18.3539L19.5152 9.45068C19.8175 9.14835 19.8175 8.65814 19.5152 8.35582L18.4203 7.26097C18.118 6.9586 17.6278 6.9586 17.3254 7.26097L10.0645 14.5218L6.67456 11.1319C6.37224 10.8296 5.88203 10.8296 5.57966 11.1319L4.48481 12.2267C4.18248 12.5291 4.18248 13.0193 4.48481 13.3216L9.51706 18.3539C9.81944 18.6562 10.3096 18.6562 10.612 18.3539Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidDoubleCheck = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.6722 8.19372L21.8162 6.33774C21.3757 5.89718 20.6633 5.89718 20.2274 6.33774L9.00249 17.5627L3.78138 12.3369C3.34082 11.8963 2.62842 11.8963 2.19255 12.3369L0.331885 14.1975C-0.108675 14.6381 -0.108675 15.3505 0.331885 15.791L8.20573 23.6696C8.64629 24.1101 9.35869 24.1101 9.79456 23.6696L23.6675 9.78724C24.1081 9.34199 24.1081 8.62959 23.6722 8.19372ZM8.47288 13.1617C8.76346 13.457 9.24152 13.457 9.5321 13.1617L19.2807 3.4038C19.5713 3.10853 19.5713 2.63516 19.2807 2.34458L17.1622 0.221452C16.8716 -0.0738173 16.3936 -0.0738173 16.103 0.221452L9.00249 7.32197L6.406 4.72079C6.11541 4.42552 5.63736 4.42552 5.34678 4.72079L3.22365 6.84392C2.93307 7.13919 2.93307 7.61256 3.22365 7.90314L8.47288 13.1617Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidBadgeCheck = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M24 12C24 10.2328 22.8891 8.72344 21.3234 8.1375C22.0125 6.61875 21.7359 4.76719 20.4844 3.51562C19.2328 2.26406 17.3813 1.9875 15.8625 2.67656C15.2766 1.11094 13.7672 0 12 0C10.2328 0 8.72344 1.11094 8.1375 2.67656C6.61875 1.9875 4.7625 2.26406 3.51562 3.51562C2.26406 4.76719 1.9875 6.61875 2.67656 8.1375C1.11094 8.72344 0 10.2328 0 12C0 13.7672 1.11094 15.2766 2.67656 15.8625C1.9875 17.3813 2.26406 19.2375 3.51562 20.4844C4.7625 21.7313 6.61406 22.0172 8.1375 21.3234C8.72344 22.8844 10.2328 24 12 24C13.7672 24 15.2766 22.8891 15.8625 21.3234C17.3906 22.0172 19.2375 21.7313 20.4844 20.4844C21.7359 19.2328 22.0125 17.3813 21.3234 15.8625C22.8891 15.2766 24 13.7672 24 12ZM17.2125 9.92578L11.07 16.0191C10.868 16.2197 10.5413 16.2183 10.3411 16.0163L6.79172 12.4383C6.59109 12.2362 6.5925 11.9095 6.79453 11.7089L8.01469 10.4986C8.21672 10.298 8.54344 10.2994 8.74406 10.5014L10.7198 12.4931L15.2761 7.97344C15.4781 7.77281 15.8048 7.77422 16.005 7.97625L17.2153 9.19641C17.4159 9.39891 17.415 9.72563 17.2125 9.92578Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCheck = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.4402 0.943767L7.63311 14.7508L2.55989 9.67761C2.31392 9.43164 1.91511 9.43164 1.66909 9.67761L0.184474 11.1622C-0.0614915 11.4082 -0.0614915 11.807 0.184474 12.053L7.18768 19.0562C7.43365 19.3022 7.83246 19.3022 8.07848 19.0562L23.8155 3.31918C24.0615 3.07321 24.0615 2.6744 23.8155 2.42838L22.3309 0.943767C22.0849 0.697801 21.6861 0.697801 21.4402 0.943767Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleCheck = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 0C5.37256 0 0 5.37256 0 12C0 18.6274 5.37256 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37256 18.6274 0 12 0ZM12 2.32258C17.3483 2.32258 21.6774 6.65085 21.6774 12C21.6774 17.3483 17.3491 21.6774 12 21.6774C6.65168 21.6774 2.32258 17.3491 2.32258 12C2.32258 6.65168 6.65085 2.32258 12 2.32258ZM18.7841 8.62582L17.6936 7.52656C17.4678 7.2989 17.1001 7.2974 16.8725 7.52327L10.0329 14.3079L7.13971 11.3913C6.91389 11.1636 6.54624 11.1621 6.31858 11.388L5.21927 12.4784C4.99161 12.7042 4.99011 13.0719 5.21598 13.2996L9.60861 17.7278C9.83444 17.9554 10.2021 17.9569 10.4297 17.7311L18.7808 9.447C19.0084 9.22113 19.0099 8.85348 18.7841 8.62582Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularDoubleCheck = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.7911 7.23177L22.3237 5.71191C22.1844 5.60691 22.0275 5.55494 21.8523 5.55494C21.6771 5.55494 21.5378 5.60745 21.4333 5.71191L7.65071 19.5465L2.56774 14.4635C2.46273 14.3237 2.32398 14.2541 2.1488 14.2541C1.97362 14.2541 1.81611 14.3237 1.67736 14.4635L0.209469 15.9304C0.0701801 16.0702 0 16.2277 0 16.4018C0 16.5759 0.0701801 16.7163 0.209469 16.8207L7.17927 23.8425C7.31855 23.9475 7.47552 24 7.65071 24C7.82589 24 7.96518 23.9475 8.06964 23.8425L23.7905 8.12161C23.9298 7.98178 24 7.82428 24 7.65017C24.0005 7.47659 23.9304 7.33623 23.7911 7.23177ZM7.06516 13.556C7.20552 13.6616 7.36409 13.7146 7.54088 13.7146C7.71767 13.7146 7.85803 13.6616 7.96357 13.556L18.9293 2.59024C19.0697 2.4488 19.141 2.29023 19.141 2.11451C19.141 1.93879 19.0697 1.79736 18.9293 1.69182L17.4491 0.158575C17.3088 0.0530368 17.1502 0 16.9734 0C16.7966 0 16.6563 0.0530368 16.5507 0.158575L7.54088 9.22092L4.30456 5.9846C4.19902 5.84317 4.05866 5.77298 3.88187 5.77298C3.70508 5.77298 3.54651 5.84317 3.40615 5.9846L1.92594 7.46481C1.78558 7.60624 1.71432 7.76482 1.71432 7.94053C1.71432 8.11679 1.78558 8.25768 1.92594 8.36322L7.06516 13.556Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularMinusSquare = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M5.78571 13.5C5.43214 13.5 5.14286 13.2107 5.14286 12.8571V11.1429C5.14286 10.7893 5.43214 10.5 5.78571 10.5H18.2143C18.5679 10.5 18.8571 10.7893 18.8571 11.1429V12.8571C18.8571 13.2107 18.5679 13.5 18.2143 13.5H5.78571ZM24 2.57143V21.4286C24 22.8482 22.8482 24 21.4286 24H2.57143C1.15179 24 0 22.8482 0 21.4286V2.57143C0 1.15179 1.15179 0 2.57143 0H21.4286C22.8482 0 24 1.15179 24 2.57143ZM21.4286 21.1071V2.89286C21.4286 2.71607 21.2839 2.57143 21.1071 2.57143H2.89286C2.71607 2.57143 2.57143 2.71607 2.57143 2.89286V21.1071C2.57143 21.2839 2.71607 21.4286 2.89286 21.4286H21.1071C21.2839 21.4286 21.4286 21.2839 21.4286 21.1071Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCheckSquare = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.4286 0H2.57143C1.15125 0 0 1.15125 0 2.57143V21.4286C0 22.8488 1.15125 24 2.57143 24H21.4286C22.8488 24 24 22.8488 24 21.4286V2.57143C24 1.15125 22.8488 0 21.4286 0ZM21.4286 21.4286H2.57143V2.57143H21.4286V21.4286ZM19.5073 8.47907L10.2614 17.6507C10.0094 17.9007 9.60236 17.8991 9.35234 17.6471L4.48907 12.7444C4.23905 12.4924 4.24066 12.0853 4.49277 11.8353L5.70986 10.628C5.96191 10.378 6.36895 10.3796 6.61896 10.6317L9.82211 13.8608L17.3945 6.34923C17.6466 6.09921 18.0536 6.10082 18.3036 6.35288L19.5109 7.56991C19.7609 7.82202 19.7593 8.22905 19.5073 8.47907Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularSquare = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.4286 0H2.57143C1.15179 0 0 1.15179 0 2.57143V21.4286C0 22.8482 1.15179 24 2.57143 24H21.4286C22.8482 24 24 22.8482 24 21.4286V2.57143C24 1.15179 22.8482 0 21.4286 0ZM21.1071 21.4286H2.89286C2.71607 21.4286 2.57143 21.2839 2.57143 21.1071V2.89286C2.57143 2.71607 2.71607 2.57143 2.89286 2.57143H21.1071C21.2839 2.57143 21.4286 2.71607 21.4286 2.89286V21.1071C21.4286 21.2839 21.2839 21.4286 21.1071 21.4286Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidRocketLaunch = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.6796 0.904541C23.6244 0.648468 23.352 0.376465 23.0959 0.321716C21.5914 0 20.4124 0 19.2384 0C14.4001 0 11.4985 2.58765 9.33242 6H4.44791C3.68397 6 2.77921 6.55893 2.43748 7.2421L0.120858 11.8733C0.0492357 12.0312 0.00917232 12.2017 0.00292065 12.375C0.00302007 12.6734 0.121601 12.9595 0.332594 13.1704C0.543586 13.3814 0.829719 13.4999 1.12809 13.5H6.00087C6.59187 13.5 7.17708 13.6163 7.7231 13.8424C8.26913 14.0686 8.76526 14.4 9.18319 14.8179C9.60112 15.2357 9.93264 15.7318 10.1588 16.2778C10.385 16.8238 10.5015 17.409 10.5015 18V22.875C10.5016 23.1734 10.6202 23.4595 10.8312 23.6704C11.0422 23.8814 11.3283 23.9999 11.6267 24C11.8 23.9936 11.9704 23.9535 12.1285 23.8821L16.7573 21.5662C17.4398 21.2247 17.9982 20.321 17.9982 19.5579V14.6624C21.4008 12.4915 23.9991 9.58081 23.9991 4.76733C24.0035 3.58841 24.0035 2.40948 23.6796 0.904541ZM18.0026 7.875C17.6318 7.87495 17.2693 7.76493 16.961 7.55887C16.6527 7.35281 16.4124 7.05996 16.2706 6.71734C16.1287 6.37472 16.0916 5.99773 16.164 5.63404C16.2364 5.27034 16.415 4.93627 16.6772 4.67408C16.9394 4.41188 17.2735 4.23333 17.6372 4.16101C18.0009 4.08868 18.3779 4.12583 18.7205 4.26775C19.0631 4.40967 19.3559 4.65 19.5619 4.95833C19.768 5.26667 19.8779 5.62917 19.8779 6C19.8777 6.49725 19.68 6.97406 19.3284 7.32565C18.9767 7.67723 18.4999 7.87482 18.0026 7.875ZM1.67272 16.5031C0.46066 17.715 -0.138274 20.7466 0.0270027 23.9724C3.2668 24.1392 6.29004 23.534 7.49725 22.3268C9.3858 20.4387 9.50713 17.9212 7.7931 16.2073C6.07907 14.4936 3.56109 14.6149 1.67272 16.5031ZM5.49927 20.4421C5.09684 20.8445 4.08915 21.0461 3.00931 20.9905C2.95428 19.9154 3.1539 18.9049 3.55789 18.501C4.18731 17.8716 5.02652 17.8312 5.5978 18.4024C6.16908 18.9737 6.1287 19.8127 5.49927 20.4421Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidCircleX = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    // viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0ZM17.8839 15.15C18.1113 15.3774 18.1113 15.7452 17.8839 15.9726L15.9677 17.8839C15.7403 18.1113 15.3726 18.1113 15.1452 17.8839L12 14.7097L8.85 17.8839C8.62258 18.1113 8.25484 18.1113 8.02742 17.8839L6.11613 15.9677C5.88871 15.7403 5.88871 15.3726 6.11613 15.1452L9.29032 12L6.11613 8.85C5.88871 8.62258 5.88871 8.25484 6.11613 8.02742L8.03226 6.11129C8.25968 5.88387 8.62742 5.88387 8.85484 6.11129L12 9.29032L15.15 6.11613C15.3774 5.88871 15.7452 5.88871 15.9726 6.11613L17.8887 8.03226C18.1161 8.25968 18.1161 8.62742 17.8887 8.85484L14.7097 12L17.8839 15.15Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCircleX = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0ZM12 21.6774C6.65323 21.6774 2.32258 17.3468 2.32258 12C2.32258 6.65323 6.65323 2.32258 12 2.32258C17.3468 2.32258 21.6774 6.65323 21.6774 12C21.6774 17.3468 17.3468 21.6774 12 21.6774ZM16.9258 8.99032L13.9161 12L16.9258 15.0097C17.1532 15.2371 17.1532 15.6048 16.9258 15.8323L15.8323 16.9258C15.6048 17.1532 15.2371 17.1532 15.0097 16.9258L12 13.9161L8.99032 16.9258C8.7629 17.1532 8.39516 17.1532 8.16774 16.9258L7.07419 15.8323C6.84677 15.6048 6.84677 15.2371 7.07419 15.0097L10.0839 12L7.07419 8.99032C6.84677 8.7629 6.84677 8.39516 7.07419 8.16774L8.16774 7.07419C8.39516 6.84677 8.7629 6.84677 8.99032 7.07419L12 10.0839L15.0097 7.07419C15.2371 6.84677 15.6048 6.84677 15.8323 7.07419L16.9258 8.16774C17.1532 8.39516 17.1532 8.7629 16.9258 8.99032Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularX = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M15.5696 12L23.6484 3.92113C24.1157 3.45388 24.1157 2.69565 23.6484 2.22765L21.7712 0.350432C21.304 -0.116811 20.5457 -0.116811 20.0777 0.350432L11.9996 8.43006L3.92074 0.351182C3.4535 -0.116061 2.69526 -0.116061 2.22727 0.351182L0.350798 2.22765C-0.116444 2.6949 -0.116444 3.45313 0.350798 3.92113L8.42967 12L0.350798 20.0789C-0.116444 20.5461 -0.116444 21.3044 0.350798 21.7723L2.22802 23.6496C2.69526 24.1168 3.4535 24.1168 3.92149 23.6496L11.9996 15.5699L20.0785 23.6488C20.5457 24.1161 21.304 24.1161 21.772 23.6488L23.6492 21.7716C24.1164 21.3044 24.1164 20.5461 23.6492 20.0781L15.5696 12Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidEye = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '16'}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.855 7.39168C21.5954 2.98292 17.1221 0 12 0C6.87791 0 2.40332 2.98501 0.144977 7.3921C0.0496614 7.58064 0 7.78895 0 8.00022C0 8.21149 0.0496614 8.4198 0.144977 8.60835C2.40457 13.0171 6.87791 16 12 16C17.1221 16 21.5967 13.015 23.855 8.60793C23.9503 8.41939 24 8.21108 24 7.99981C24 7.78854 23.9503 7.58023 23.855 7.39168ZM12 14C10.8133 14 9.65327 13.6481 8.66657 12.9888C7.67988 12.3296 6.91084 11.3925 6.45671 10.2961C6.00259 9.19976 5.88377 7.99336 6.11528 6.82947C6.34679 5.66558 6.91823 4.59648 7.75735 3.75737C8.59647 2.91825 9.66557 2.3468 10.8295 2.11529C11.9933 1.88378 13.1997 2.0026 14.2961 2.45673C15.3925 2.91085 16.3295 3.67989 16.9888 4.66659C17.6481 5.65328 18 6.81332 18 8.00002C18.0004 8.78806 17.8455 9.56845 17.5441 10.2966C17.2427 11.0247 16.8007 11.6863 16.2435 12.2435C15.6863 12.8007 15.0247 13.2427 14.2966 13.5441C13.5684 13.8455 12.788 14.0004 12 14ZM12 4.00001C11.643 4.005 11.2882 4.05811 10.9454 4.15792C11.228 4.54196 11.3636 5.01455 11.3276 5.48999C11.2917 5.96543 11.0865 6.41224 10.7494 6.74939C10.4122 7.08654 9.96541 7.2917 9.48997 7.32766C9.01453 7.36363 8.54194 7.22802 8.15791 6.94543C7.93923 7.75109 7.9787 8.60505 8.27078 9.3871C8.56285 10.1692 9.09282 10.8399 9.78608 11.305C10.4793 11.7701 11.301 12.006 12.1354 11.9797C12.9698 11.9533 13.7749 11.666 14.4375 11.1581C15.1 10.6502 15.5866 9.94727 15.8287 9.14835C16.0708 8.34942 16.0563 7.49467 15.7872 6.70442C15.5181 5.91416 15.008 5.22819 14.3286 4.74305C13.6492 4.25792 12.8348 3.99804 12 4.00001Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidEyeSlash = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M11.9999 15.4C9.15552 15.4 6.85302 13.1984 6.64115 10.4084L2.70741 7.36826C2.19029 8.01701 1.71441 8.70288 1.33041 9.45288C1.24463 9.62257 1.19994 9.81005 1.19994 10.0002C1.19994 10.1903 1.24463 10.3778 1.33041 10.5475C3.36403 14.5154 7.39002 17.2 11.9999 17.2C13.009 17.2 13.9825 17.05 14.9207 16.8077L12.9749 15.3021C12.6535 15.3642 12.3272 15.3969 11.9999 15.4ZM23.7681 17.5787L19.6225 14.3747C20.8818 13.3135 21.9175 12.0124 22.6694 10.5471C22.7551 10.3774 22.7998 10.19 22.7998 9.99981C22.7998 9.80967 22.7551 9.62219 22.6694 9.4525C20.6357 5.48464 16.6097 2.80002 11.9999 2.80002C10.0692 2.80236 8.16988 3.28841 6.4754 4.21377L1.70466 0.526406C1.64245 0.477996 1.57131 0.44232 1.49531 0.421416C1.4193 0.400511 1.33992 0.394788 1.26171 0.404574C1.18349 0.41436 1.10797 0.439463 1.03945 0.478448C0.970942 0.517433 0.910784 0.569536 0.862416 0.631781L0.126294 1.5794C0.0286432 1.70502 -0.0151132 1.86428 0.00464778 2.02216C0.0244088 2.18004 0.106069 2.3236 0.231668 2.42128L22.2951 19.4736C22.3573 19.522 22.4285 19.5577 22.5045 19.5786C22.5805 19.5995 22.6598 19.6052 22.7381 19.5954C22.8163 19.5856 22.8918 19.5605 22.9603 19.5216C23.0288 19.4826 23.089 19.4305 23.1374 19.3682L23.8738 18.4206C23.9715 18.2949 24.0152 18.1356 23.9953 17.9778C23.9755 17.8199 23.8938 17.6763 23.7681 17.5787ZM16.8786 12.2537L15.4049 11.1145C15.529 10.7558 15.5948 10.3795 15.5999 10C15.6072 9.44435 15.4841 8.89473 15.2405 8.39529C14.9968 7.89584 14.6395 7.46049 14.1971 7.12422C13.7547 6.78794 13.2396 6.56011 12.6931 6.45901C12.1467 6.35792 11.5842 6.38639 11.0508 6.54214C11.2769 6.84855 11.3992 7.21919 11.3999 7.60001C11.3943 7.72673 11.3749 7.85247 11.3421 7.97501L8.58177 5.84164C9.54063 5.04034 10.7503 4.60094 11.9999 4.60002C12.7091 4.59962 13.4115 4.73903 14.0668 5.01026C14.7222 5.2815 15.3176 5.67924 15.8191 6.18076C16.3206 6.68227 16.7184 7.27772 16.9896 7.93305C17.2609 8.58839 17.4003 9.29076 17.3999 10C17.3999 10.8111 17.2015 11.5671 16.8786 12.2541V12.2537Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularEye = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '16'}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 3.33334C11.5584 3.34024 11.12 3.4104 10.6983 3.54167C10.8934 3.88472 10.9973 4.27205 11 4.66668C11 4.97309 10.9396 5.27651 10.8224 5.55961C10.7051 5.8427 10.5332 6.09992 10.3166 6.31659C10.0999 6.53326 9.84268 6.70514 9.55959 6.8224C9.2765 6.93966 8.97308 7.00001 8.66666 7.00001C8.27204 6.99728 7.88471 6.89341 7.54166 6.69835C7.271 7.63701 7.30255 8.63704 7.63182 9.55678C7.9611 10.4765 8.57141 11.2694 9.37632 11.823C10.1812 12.3766 11.1399 12.6629 12.1166 12.6414C13.0932 12.6199 14.0384 12.2916 14.8181 11.7031C15.5979 11.1145 16.1727 10.2956 16.4611 9.36226C16.7496 8.42891 16.737 7.42846 16.4253 6.50262C16.1136 5.57679 15.5184 4.7725 14.7242 4.2037C13.93 3.63489 12.9769 3.33039 12 3.33334ZM23.855 7.39168C21.5954 2.98292 17.1221 0 12 0C6.87791 0 2.40332 2.98501 0.144977 7.3921C0.0496614 7.58064 0 7.78895 0 8.00022C0 8.21149 0.0496614 8.4198 0.144977 8.60835C2.40457 13.0171 6.87791 16 12 16C17.1221 16 21.5967 13.015 23.855 8.60793C23.9503 8.41939 24 8.21108 24 7.99981C24 7.78854 23.9503 7.58023 23.855 7.39168ZM12 14C7.88958 14 4.12123 11.7084 2.08623 8.00002C4.12123 4.29167 7.88916 2 12 2C16.1108 2 19.8788 4.29167 21.9138 8.00002C19.8792 11.7084 16.1108 14 12 14Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularEyeSlash = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.7746 18.0623L1.35033 0.53192C1.28882 0.482676 1.21822 0.446029 1.14255 0.42407C1.06688 0.402112 0.987625 0.395273 0.909313 0.403943C0.831 0.412613 0.755163 0.436624 0.68613 0.474603C0.617097 0.512582 0.55622 0.563786 0.506976 0.625292L0.131987 1.09365C0.0826277 1.15518 0.0458847 1.22584 0.0238609 1.30158C0.00183712 1.37732 -0.00503511 1.45666 0.00363744 1.53506C0.01231 1.61347 0.0363571 1.68939 0.0744027 1.75849C0.112448 1.82758 0.163746 1.8885 0.22536 1.93775L22.6497 19.4681C22.7112 19.5173 22.7818 19.554 22.8575 19.5759C22.9331 19.5979 23.0124 19.6047 23.0907 19.5961C23.169 19.5874 23.2448 19.5634 23.3139 19.5254C23.3829 19.4874 23.4438 19.4362 23.493 19.3747L23.868 18.9064C23.9174 18.8448 23.9541 18.7742 23.9761 18.6984C23.9982 18.6227 24.005 18.5433 23.9964 18.4649C23.9877 18.3865 23.9636 18.3106 23.9256 18.2415C23.8876 18.1724 23.8363 18.1115 23.7746 18.0623ZM11.1297 5.89276L16.1841 9.84439C16.1009 7.5967 14.2679 5.80013 12 5.80013C11.7075 5.80068 11.4158 5.83172 11.1297 5.89276ZM12.8703 14.1076L7.81588 10.156C7.8995 12.4033 9.73244 14.1999 12 14.1999C12.2925 14.1993 12.5842 14.1683 12.8703 14.1076ZM12 4.60017C15.6993 4.60017 19.0907 6.66261 20.9221 10C20.4732 10.8214 19.9184 11.5803 19.2722 12.2574L20.6874 13.3637C21.4753 12.5208 22.1428 11.5729 22.671 10.5471C22.7568 10.3774 22.8015 10.19 22.8015 9.99982C22.8015 9.80968 22.7568 9.62221 22.671 9.45252C20.6356 5.48477 16.6097 2.80023 12 2.80023C10.6238 2.80023 9.31096 3.06272 8.07649 3.50558L9.81682 4.86641C10.527 4.70517 11.2545 4.60017 12 4.60017ZM12 15.3998C8.30074 15.3998 4.90972 13.3374 3.0779 10C3.52743 9.17865 4.08277 8.41982 4.72972 7.74295L3.31452 6.63673C2.52672 7.47951 1.85929 8.42722 1.3312 9.4529C1.24542 9.62258 1.20073 9.81006 1.20073 10.0002C1.20073 10.1903 1.24542 10.3778 1.3312 10.5475C3.36476 14.5152 7.39064 17.1998 12 17.1998C13.3762 17.1998 14.689 16.9354 15.9235 16.4944L14.1832 15.134C13.473 15.2948 12.7459 15.3998 12 15.3998Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidToggleOn = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '16'}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M16 0H8C3.58333 0 0 3.58333 0 8C0 12.4167 3.58333 16 8 16H16C20.4167 16 24 12.4167 24 8C24 3.58333 20.4167 0 16 0ZM16 13.3333C13.05 13.3333 10.6667 10.9458 10.6667 8C10.6667 5.05 13.0542 2.66667 16 2.66667C18.95 2.66667 21.3333 5.05417 21.3333 8C21.3333 10.95 18.9458 13.3333 16 13.3333Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidToggleOff = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '16'}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M16 0H8C3.58171 0 0 3.58171 0 8C0 12.4183 3.58171 16 8 16H16C20.4183 16 24 12.4183 24 8C24 3.58171 20.4183 0 16 0ZM2.66667 8C2.66667 5.05246 5.05204 2.66667 8 2.66667C10.9475 2.66667 13.3333 5.05204 13.3333 8C13.3333 10.9475 10.948 13.3333 8 13.3333C5.05246 13.3333 2.66667 10.948 2.66667 8ZM16 13.3333H13.9623C16.6797 10.2976 16.6805 5.70333 13.9623 2.66667H16C18.9475 2.66667 21.3333 5.05204 21.3333 8C21.3333 10.9475 18.948 13.3333 16 13.3333Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularToggleOn = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '16'}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M16 0H8C3.58333 0 0 3.58333 0 8C0 12.4167 3.58333 16 8 16H16C20.4167 16 24 12.4167 24 8C24 3.58333 20.4167 0 16 0ZM16 14C12.6833 14 10 11.3167 10 8C10 4.68333 12.6833 2 16 2C19.3167 2 22 4.68333 22 8C22 11.3167 19.3167 14 16 14Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularToggleOff = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '16'}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M16 0H8C3.58171 0 0 3.58171 0 8C0 12.4183 3.58171 16 8 16H16C20.4183 16 24 12.4183 24 8C24 3.58171 20.4183 0 16 0ZM2 8C2 4.68404 4.6835 2 8 2C11.3159 2 14 4.6835 14 8C14 11.3159 11.3165 14 8 14C4.68408 14 2 11.3165 2 8ZM16 14H13.2908C16.9035 10.8119 16.9026 5.18733 13.2908 2H16C19.3159 2 22 4.6835 22 8C22 11.3159 19.3165 14 16 14Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidPlus = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M22.2857 9.42857H14.5714V1.71429C14.5714 0.767679 13.8038 0 12.8571 0H11.1429C10.1962 0 9.42857 0.767679 9.42857 1.71429V9.42857H1.71429C0.767679 9.42857 0 10.1962 0 11.1429V12.8571C0 13.8038 0.767679 14.5714 1.71429 14.5714H9.42857V22.2857C9.42857 23.2323 10.1962 24 11.1429 24H12.8571C13.8038 24 14.5714 23.2323 14.5714 22.2857V14.5714H22.2857C23.2323 14.5714 24 13.8038 24 12.8571V11.1429C24 10.1962 23.2323 9.42857 22.2857 9.42857Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidCirclePlus = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0ZM18.9677 13.3548C18.9677 13.6742 18.7065 13.9355 18.3871 13.9355H13.9355V18.3871C13.9355 18.7065 13.6742 18.9677 13.3548 18.9677H10.6452C10.3258 18.9677 10.0645 18.7065 10.0645 18.3871V13.9355H5.6129C5.29355 13.9355 5.03226 13.6742 5.03226 13.3548V10.6452C5.03226 10.3258 5.29355 10.0645 5.6129 10.0645H10.0645V5.6129C10.0645 5.29355 10.3258 5.03226 10.6452 5.03226H13.3548C13.6742 5.03226 13.9355 5.29355 13.9355 5.6129V10.0645H18.3871C18.7065 10.0645 18.9677 10.3258 18.9677 10.6452V13.3548Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularPlus = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23 10H14V1C14 0.4475 13.5525 0 13 0H11C10.4475 0 10 0.4475 10 1V10H1C0.4475 10 0 10.4475 0 11V13C0 13.5525 0.4475 14 1 14H10V23C10 23.5525 10.4475 24 11 24H13C13.5525 24 14 23.5525 14 23V14H23C23.5525 14 24 13.5525 24 13V11C24 10.4475 23.5525 10 23 10Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCirclePlus = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M18.1935 11.2258V12.7742C18.1935 13.0935 17.9323 13.3548 17.6129 13.3548H13.3548V17.6129C13.3548 17.9323 13.0935 18.1935 12.7742 18.1935H11.2258C10.9065 18.1935 10.6452 17.9323 10.6452 17.6129V13.3548H6.3871C6.06774 13.3548 5.80645 13.0935 5.80645 12.7742V11.2258C5.80645 10.9065 6.06774 10.6452 6.3871 10.6452H10.6452V6.3871C10.6452 6.06774 10.9065 5.80645 11.2258 5.80645H12.7742C13.0935 5.80645 13.3548 6.06774 13.3548 6.3871V10.6452H17.6129C17.9323 10.6452 18.1935 10.9065 18.1935 11.2258ZM24 12C24 18.629 18.629 24 12 24C5.37097 24 0 18.629 0 12C0 5.37097 5.37097 0 12 0C18.629 0 24 5.37097 24 12ZM21.6774 12C21.6774 6.65323 17.3468 2.32258 12 2.32258C6.65323 2.32258 2.32258 6.65323 2.32258 12C2.32258 17.3468 6.65323 21.6774 12 21.6774C17.3468 21.6774 21.6774 17.3468 21.6774 12Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidPhone = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.1281 1.15361L18.2532 0.0286313C17.7236 -0.0932411 17.1798 0.183316 16.9642 0.68018L14.7142 5.93007C14.5174 6.38943 14.6486 6.92849 15.0377 7.24254L17.8782 9.56749C16.1908 13.1627 13.2424 16.1533 9.57216 17.8736L7.24721 15.033C6.92847 14.6439 6.3941 14.5127 5.93474 14.7096L0.684849 16.9595C0.183297 17.1798 -0.0932598 17.7236 0.0286126 18.2532L1.15359 23.1281C1.27077 23.6344 1.72076 24 2.25044 24C14.2549 24 24 14.2736 24 2.25046C24 1.72547 23.6391 1.27079 23.1281 1.15361Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidAltPhone = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.3156 16.9592L18.0655 14.7092C17.8412 14.6136 17.5919 14.5935 17.3552 14.6518C17.1185 14.7101 16.9071 14.8438 16.7529 15.0326L14.4279 17.8733C10.779 16.1529 7.84242 13.2163 6.12198 9.5674L8.96266 7.24236C9.15188 7.08845 9.28581 6.87709 9.34418 6.64026C9.40254 6.40343 9.38215 6.15404 9.2861 5.92983L7.03606 0.679743C6.93064 0.438055 6.7442 0.240725 6.50887 0.12178C6.27355 0.00283371 6.00409 -0.0302726 5.74697 0.0281692L0.87189 1.15319C0.623996 1.21043 0.402825 1.35001 0.244474 1.54914C0.0861227 1.74827 -5.71046e-05 1.9952 2.8389e-08 2.24961C2.8389e-08 14.2733 9.74548 24 21.7504 24C22.0049 24.0002 22.2519 23.914 22.4511 23.7557C22.6504 23.5973 22.79 23.3761 22.8473 23.1281L23.9723 18.253C24.0304 17.9946 23.9965 17.7241 23.8767 17.488C23.7568 17.2518 23.5584 17.0649 23.3156 16.9592Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidLink = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M15.3099 8.69021C18.1106 11.4938 18.0721 15.9885 15.3268 18.7491C15.3216 18.7547 15.3156 18.7608 15.3099 18.7664L12.1599 21.9164C9.38166 24.6947 4.86156 24.6943 2.08371 21.9164C-0.694569 19.1386 -0.694569 14.618 2.08371 11.8402L3.82305 10.1009C4.2843 9.63962 5.07864 9.94618 5.10245 10.598C5.13283 11.4287 5.28179 12.2633 5.55667 13.0693C5.64976 13.3422 5.58325 13.6441 5.37934 13.848L4.76589 14.4614C3.45217 15.7752 3.41097 17.9143 4.71175 19.2408C6.02537 20.5805 8.18452 20.5884 9.50822 19.2647L12.6582 16.1152C13.9797 14.7937 13.9741 12.6578 12.6582 11.3419C12.4847 11.1688 12.31 11.0342 12.1735 10.9403C12.0769 10.8739 11.9972 10.786 11.9406 10.6834C11.8841 10.5808 11.8523 10.4664 11.8478 10.3493C11.8293 9.85402 12.0048 9.3436 12.3962 8.95219L13.3831 7.96524C13.6419 7.70645 14.0479 7.67467 14.348 7.8841C14.6916 8.12408 15.0135 8.39382 15.3099 8.69021ZM21.9162 2.08357C19.1384 -0.694335 14.6183 -0.69471 11.84 2.08357L8.69002 5.23356C8.6844 5.23919 8.6783 5.24528 8.67315 5.2509C5.92787 8.01146 5.88939 12.5062 8.69002 15.3098C8.9864 15.6062 9.30828 15.8759 9.65194 16.1159C9.95204 16.3253 10.3581 16.2935 10.6168 16.0347L11.6037 15.0478C11.9951 14.6564 12.1706 14.1459 12.1521 13.6506C12.1476 13.5336 12.1158 13.4192 12.0593 13.3166C12.0027 13.214 11.923 13.126 11.8264 13.0597C11.6899 12.9657 11.5152 12.8312 11.3417 12.658C10.0258 11.3421 10.0202 9.20621 11.3417 7.88476L14.4917 4.73523C15.8154 3.41153 17.9745 3.4195 19.2882 4.75914C20.5889 6.0857 20.5478 8.22479 19.234 9.53851L18.6206 10.152C18.4167 10.3559 18.3501 10.6577 18.4432 10.9306C18.7181 11.7366 18.8671 12.5712 18.8975 13.4019C18.9213 14.0538 19.7156 14.3603 20.1769 13.8991L21.9162 12.1597C24.6945 9.38199 24.6945 4.86137 21.9162 2.08357Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidCog = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.1941 14.8839L21.1328 13.6935C21.3409 12.571 21.3409 11.4194 21.1328 10.2968L23.1941 9.10646C23.4312 8.97098 23.5377 8.69034 23.4602 8.42905C22.9231 6.70647 22.0086 5.14841 20.8135 3.85164C20.6296 3.65326 20.3296 3.60487 20.0973 3.74035L18.0361 4.93067C17.1699 4.18551 16.1732 3.60971 15.0941 3.23229V0.856494C15.0941 0.585527 14.9054 0.348431 14.6393 0.290367C12.8635 -0.106406 11.0442 -0.0870511 9.35546 0.290367C9.08933 0.348431 8.90062 0.585527 8.90062 0.856494V3.23713C7.82643 3.61939 6.82966 4.19519 5.95869 4.93551L3.90225 3.74519C3.66515 3.60971 3.36999 3.65326 3.18612 3.85648C1.99097 5.14841 1.07645 6.70647 0.53936 8.43388C0.457102 8.69517 0.568392 8.97582 0.805488 9.1113L2.86677 10.3016C2.65871 11.4242 2.65871 12.5758 2.86677 13.6984L0.805488 14.8887C0.568392 15.0242 0.461941 15.3048 0.53936 15.5661C1.07645 17.2887 1.99097 18.8467 3.18612 20.1435C3.36999 20.3419 3.66999 20.3903 3.90225 20.2548L5.96353 19.0645C6.82966 19.8096 7.82643 20.3855 8.90546 20.7629V23.1435C8.90546 23.4145 9.09417 23.6516 9.36029 23.7096C11.1361 24.1064 12.9554 24.0871 14.6441 23.7096C14.9103 23.6516 15.099 23.4145 15.099 23.1435V20.7629C16.1732 20.3806 17.1699 19.8048 18.0409 19.0645L20.1022 20.2548C20.3393 20.3903 20.6344 20.3467 20.8183 20.1435C22.0135 18.8516 22.928 17.2935 23.4651 15.5661C23.5377 15.3 23.4312 15.0193 23.1941 14.8839ZM11.9974 15.8661C9.86352 15.8661 8.12643 14.129 8.12643 11.9952C8.12643 9.8613 9.86352 8.12421 11.9974 8.12421C14.1312 8.12421 15.8683 9.8613 15.8683 11.9952C15.8683 14.129 14.1312 15.8661 11.9974 15.8661Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidPen = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M13.6286 4.37068L19.6294 10.3715L6.59893 23.4019L1.24876 23.9925C0.532526 24.0717 -0.072614 23.4661 0.0070714 22.7499L0.602368 17.396L13.6286 4.37068ZM23.3408 3.47726L20.5233 0.659681C19.6444 -0.219202 18.2189 -0.219202 17.3401 0.659681L14.6893 3.31039L20.6901 9.31118L23.3408 6.66046C24.2197 5.78111 24.2197 4.35615 23.3408 3.47726Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidTrash = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M20.75 1.50001H15.125L14.6844 0.623446C14.591 0.436046 14.4473 0.278409 14.2692 0.16827C14.0912 0.0581305 13.8859 -0.000141936 13.6766 8.21846e-06H8.31875C8.10986 -0.000794775 7.90498 0.0572604 7.72756 0.167522C7.55015 0.277784 7.40738 0.435793 7.31562 0.623446L6.875 1.50001H1.25C1.05109 1.50001 0.860322 1.57903 0.71967 1.71968C0.579018 1.86033 0.5 2.0511 0.5 2.25001L0.5 3.75001C0.5 3.94892 0.579018 4.13968 0.71967 4.28034C0.860322 4.42099 1.05109 4.50001 1.25 4.50001H20.75C20.9489 4.50001 21.1397 4.42099 21.2803 4.28034C21.421 4.13968 21.5 3.94892 21.5 3.75001V2.25001C21.5 2.0511 21.421 1.86033 21.2803 1.71968C21.1397 1.57903 20.9489 1.50001 20.75 1.50001ZM2.99375 21.8906C3.02952 22.4619 3.28164 22.998 3.69878 23.3899C4.11591 23.7817 4.66672 23.9999 5.23906 24H16.7609C17.3333 23.9999 17.8841 23.7817 18.3012 23.3899C18.7184 22.998 18.9705 22.4619 19.0062 21.8906L20 6.00001H2L2.99375 21.8906Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidAltTrash = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M2 21.75C2 22.3467 2.23705 22.919 2.65901 23.341C3.08097 23.7629 3.65326 24 4.25 24H17.75C18.3467 24 18.919 23.7629 19.341 23.341C19.7629 22.919 20 22.3467 20 21.75V6.00001H2V21.75ZM14.75 9.75C14.75 9.55109 14.829 9.36033 14.9697 9.21968C15.1103 9.07902 15.3011 9 15.5 9C15.6989 9 15.8897 9.07902 16.0303 9.21968C16.171 9.36033 16.25 9.55109 16.25 9.75V20.25C16.25 20.4489 16.171 20.6397 16.0303 20.7803C15.8897 20.921 15.6989 21 15.5 21C15.3011 21 15.1103 20.921 14.9697 20.7803C14.829 20.6397 14.75 20.4489 14.75 20.25V9.75ZM10.25 9.75C10.25 9.55109 10.329 9.36033 10.4697 9.21968C10.6103 9.07902 10.8011 9 11 9C11.1989 9 11.3897 9.07902 11.5303 9.21968C11.671 9.36033 11.75 9.55109 11.75 9.75V20.25C11.75 20.4489 11.671 20.6397 11.5303 20.7803C11.3897 20.921 11.1989 21 11 21C10.8011 21 10.6103 20.921 10.4697 20.7803C10.329 20.6397 10.25 20.4489 10.25 20.25V9.75ZM5.75 9.75C5.75 9.55109 5.82902 9.36033 5.96967 9.21968C6.11032 9.07902 6.30109 9 6.5 9C6.69891 9 6.88968 9.07902 7.03033 9.21968C7.17098 9.36033 7.25 9.55109 7.25 9.75V20.25C7.25 20.4489 7.17098 20.6397 7.03033 20.7803C6.88968 20.921 6.69891 21 6.5 21C6.30109 21 6.11032 20.921 5.96967 20.7803C5.82902 20.6397 5.75 20.4489 5.75 20.25V9.75ZM20.75 1.50001H15.125L14.6844 0.623446C14.591 0.436046 14.4473 0.278409 14.2692 0.16827C14.0912 0.0581305 13.8859 -0.000141936 13.6766 8.21846e-06H8.31875C8.10986 -0.000794775 7.90498 0.0572604 7.72756 0.167522C7.55015 0.277784 7.40738 0.435793 7.31562 0.623446L6.875 1.50001H1.25C1.05109 1.50001 0.860322 1.57903 0.71967 1.71968C0.579018 1.86033 0.5 2.0511 0.5 2.25001L0.5 3.75001C0.5 3.94892 0.579018 4.13968 0.71967 4.28034C0.860322 4.42099 1.05109 4.50001 1.25 4.50001H20.75C20.9489 4.50001 21.1397 4.42099 21.2803 4.28034C21.421 4.13968 21.5 3.94892 21.5 3.75001V2.25001C21.5 2.0511 21.421 1.86033 21.2803 1.71968C21.1397 1.57903 20.9489 1.50001 20.75 1.50001Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularPhone = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M22.3361 1.07651L17.9209 0.0594248C16.9085 -0.174927 15.8774 0.350021 15.4696 1.30618L13.4307 6.06352C13.0558 6.93531 13.3089 7.96645 14.0447 8.56639L15.9195 10.0991C14.5791 12.5551 12.5543 14.5799 10.0983 15.9157L8.56559 14.0409C7.96565 13.305 6.9345 13.0519 6.06272 13.4268L1.30069 15.4657C0.344533 15.8735 -0.175728 16.9046 0.0539366 17.917L1.07102 22.3322C1.296 23.3118 2.15842 23.9961 3.16144 23.9961C14.64 24.0008 24 14.7064 24 3.16693C24 2.1639 23.3157 1.30149 22.3361 1.07651ZM3.25049 21.751L2.2709 17.4999L6.87357 15.5266L9.48425 18.7185C14.115 16.5437 16.5429 14.1252 18.7177 9.48505L15.5258 6.87437L17.4991 2.27171L21.7502 3.2513C21.7034 13.4503 13.4495 21.7042 3.25049 21.751Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAltPhone = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M22.6991 15.4687L17.9371 13.4273C17.5096 13.2455 17.0347 13.2071 16.5835 13.3178C16.1324 13.4285 15.7292 13.6824 15.4344 14.0414L13.9016 15.9164C11.4428 14.5762 9.42179 12.5564 8.08026 10.0983L9.95525 8.56549C10.3143 8.27037 10.5681 7.86697 10.6788 7.4156C10.7895 6.96424 10.7511 6.48917 10.5693 6.06145L8.5312 1.30273C8.33448 0.839621 7.9808 0.460686 7.53233 0.232551C7.08386 0.00441704 6.56933 -0.0583109 6.07919 0.0553967L1.66406 1.07305C1.19032 1.18056 0.767346 1.44627 0.464855 1.82639C0.162363 2.2065 -0.00159226 2.67834 1.1657e-05 3.16412C1.1657e-05 14.7075 9.35994 24.0046 20.8386 23.9999C21.3243 24.0014 21.796 23.8373 22.176 23.5347C22.5559 23.2321 22.8214 22.8091 22.9287 22.3354L23.9459 17.9189C24.058 17.4291 23.9946 16.9155 23.7667 16.4677C23.5389 16.0199 23.161 15.6664 22.6991 15.4687ZM20.7495 21.7541C10.5506 21.7073 2.29687 13.4531 2.24999 3.2485L6.50106 2.26882L8.47401 6.87285L5.28232 9.48423C7.45683 14.1248 9.88494 16.545 14.5166 18.7185L17.1271 15.5259L21.7297 17.4998L20.7495 21.7541Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularLink = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M14.7291 9.27094C17.124 11.6658 17.278 15.4719 15.1862 18.0441C14.8936 18.4064 15.0557 18.2252 11.2046 22.0762C8.64073 24.6401 4.48902 24.6424 1.92384 22.0762C-0.640739 19.5126 -0.641818 15.3612 1.92384 12.7955C3.46007 11.2592 4.3536 10.3627 4.89613 9.82093C5.24596 9.47161 5.84914 9.71058 5.85641 10.2049C5.86513 10.8024 5.93974 11.397 6.07888 11.9781C6.12416 12.167 6.06613 12.3657 5.92878 12.503L3.77961 14.6517C2.24423 16.188 2.23804 18.6779 3.77961 20.2205C5.31594 21.7558 7.8058 21.762 9.34836 20.2205L12.8729 16.6955C14.4065 15.1615 14.4093 12.6636 12.8729 11.1272C12.5616 10.8154 12.2001 10.5582 11.8035 10.3665C11.5868 10.2618 11.4668 10.0266 11.4959 9.78774C11.5595 9.26639 11.7911 8.76188 12.1904 8.36251L12.3955 8.15743C12.5654 7.98746 12.8256 7.94208 13.0405 8.0499C13.6498 8.35571 14.2211 8.76291 14.7291 9.27094ZM22.0761 1.92376C19.5109 -0.642403 15.3592 -0.640106 12.7954 1.92376C8.94429 5.77482 9.10639 5.5936 8.81379 5.95595C6.72191 8.52811 6.87594 12.3342 9.27082 14.7291C9.77886 15.2371 10.3502 15.6443 10.9595 15.9501C11.1743 16.0579 11.4345 16.0125 11.6045 15.8426L11.8096 15.6375C12.2089 15.2382 12.4405 14.7336 12.504 14.2123C12.5331 13.9734 12.4132 13.7382 12.1965 13.6335C11.7998 13.4418 11.4383 13.1846 11.1271 12.8728C9.59065 11.3364 9.59342 8.83852 11.1271 7.30454L14.6516 3.77954C16.1942 2.23797 18.684 2.24415 20.2203 3.77954C21.7619 5.3221 21.7557 7.81196 20.2203 9.34829L18.0712 11.497C17.9339 11.6343 17.8758 11.8331 17.9211 12.0219C18.0603 12.603 18.1349 13.1977 18.1436 13.7951C18.1509 14.2895 18.754 14.5284 19.1039 14.1791C19.6464 13.6373 20.5399 12.7408 22.0762 11.2046C24.6418 8.63888 24.6407 4.4874 22.0761 1.92376Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCog = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.5088 11.0807L23.0496 10.1912C23.5057 9.92796 23.7268 9.39081 23.5904 8.88217C23.0386 6.82421 21.9529 4.98473 20.4908 3.52102C20.1192 3.14902 19.5436 3.07363 19.0883 3.33661L17.5503 4.2249C17.0507 3.86736 16.5176 3.55914 15.9584 3.30458V1.52621C15.9584 1.27006 15.8737 1.0211 15.7176 0.818041C15.5615 0.614977 15.3426 0.469186 15.0951 0.403337C13.0744 -0.134099 10.9281 -0.134776 8.90493 0.403289C8.39595 0.538676 8.04151 0.999467 8.04151 1.52616V3.30453C7.48236 3.5591 6.94924 3.86731 6.44962 4.22486L4.91164 3.33657C4.45632 3.07358 3.88075 3.14897 3.50914 3.52097C2.04707 4.98468 0.961361 6.82412 0.409554 8.88212C0.273151 9.39076 0.49428 9.92791 0.950377 10.1912L2.49117 11.0807C2.43214 11.6922 2.43214 12.3079 2.49117 12.9193L0.950377 13.8088C0.49428 14.0721 0.273151 14.6092 0.409554 15.1179C0.961361 17.1758 2.04707 19.0153 3.50914 20.479C3.88075 20.851 4.45632 20.9264 4.91164 20.6634L6.44962 19.7751C6.94923 20.1327 7.48236 20.4409 8.04151 20.6954V22.4738C8.04154 22.7299 8.1262 22.9789 8.28233 23.1819C8.43845 23.385 8.6573 23.5308 8.90483 23.5966C10.9255 24.1341 13.0718 24.1348 15.095 23.5967C15.604 23.4613 15.9584 23.0005 15.9584 22.4738V20.6954C16.5176 20.4409 17.0507 20.1327 17.5503 19.7752L19.0883 20.6635C19.5436 20.9265 20.1192 20.8511 20.4908 20.4791C21.9529 19.0154 23.0386 17.1759 23.5904 15.1179C23.7268 14.6093 23.5057 14.0721 23.0496 13.8088L21.5088 12.9194C21.5678 12.3073 21.5678 11.6928 21.5088 11.0807ZM18.9598 14.13L21.0801 15.3537C20.6987 16.3837 20.1448 17.3414 19.4422 18.1857L17.3214 16.961C15.7738 18.2867 15.5476 18.4164 13.6359 19.0915V21.5398C12.5531 21.7246 11.4468 21.7246 10.364 21.5398V19.0915C8.45256 18.4165 8.22553 18.2862 6.67849 16.961L4.55773 18.1857C3.85514 17.3414 3.30128 16.3837 2.91988 15.3537L5.04015 14.13C4.67096 12.1317 4.67077 11.8694 5.04015 9.87009L2.91988 8.64642C3.29972 7.61921 3.85423 6.66018 4.55773 5.81437L6.67849 7.039C8.22611 5.71334 8.45237 5.58362 10.364 4.90857V2.46027C11.4468 2.27543 12.5531 2.27543 13.6359 2.46027V4.90861C15.5474 5.58361 15.7744 5.71387 17.3214 7.03905L19.4422 5.81442C20.1448 6.65872 20.6987 7.6164 21.0801 8.64647L18.9598 9.87013C19.329 11.8685 19.3292 12.1307 18.9598 14.13ZM12 7.35487C9.43859 7.35487 7.3548 9.43867 7.3548 12C7.3548 14.5614 9.43859 16.6452 12 16.6452C14.5613 16.6452 16.6451 14.5614 16.6451 12C16.6451 9.43867 14.5613 7.35487 12 7.35487ZM12 14.3226C10.7193 14.3226 9.67738 13.2807 9.67738 12C9.67738 10.7194 10.7193 9.67746 12 9.67746C13.2807 9.67746 14.3225 10.7194 14.3225 12C14.3225 13.2807 13.2807 14.3226 12 14.3226Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularPen = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.1215 2.63724L21.3632 0.878963C20.7773 0.293029 20.0095 6.10352e-05 19.2417 6.10352e-05C18.4739 6.10352e-05 17.7061 0.293029 17.1206 0.878495L13.6289 4.3702L12 5.9991L0.602388 17.3962L0.00707801 22.7503C-0.0679217 23.4243 0.46317 24 1.1227 24C1.16442 24 1.2066 23.9976 1.24879 23.9929L6.59908 23.4018L18.0009 12L19.6293 10.3716L23.121 6.87987C24.2929 5.708 24.2929 3.80864 23.1215 2.63724ZM5.56643 21.2526L2.39863 21.6023L2.7516 18.4294L13.5909 7.59003L15.045 6.13597L17.864 8.95502L16.41 10.4091L5.56643 21.2526ZM21.5301 5.28848L19.4545 7.36409L16.6359 4.54504L18.7115 2.46943C18.9028 2.27818 19.1259 2.24958 19.2417 2.24958C19.3575 2.24958 19.5811 2.27818 19.7718 2.46943L21.5301 4.2277C21.8226 4.52067 21.8226 4.99645 21.5301 5.28848Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularTrash = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M20.75 3.75H16.8875L15.2938 1.09219C15.0937 0.758778 14.8106 0.482914 14.4721 0.291499C14.1336 0.100085 13.7513 -0.000346232 13.3625 8.96813e-07H8.6375C8.24866 -0.000346232 7.86636 0.100085 7.52789 0.291499C7.18943 0.482914 6.90634 0.758778 6.70625 1.09219L5.1125 3.75H1.25C1.05109 3.75 0.860322 3.82902 0.71967 3.96967C0.579018 4.11032 0.5 4.30109 0.5 4.5L0.5 5.25C0.5 5.44891 0.579018 5.63968 0.71967 5.78033C0.860322 5.92098 1.05109 6 1.25 6H2L2.99375 21.8906C3.02952 22.4619 3.28164 22.998 3.69878 23.3899C4.11591 23.7817 4.66672 23.9999 5.23906 24H16.7609C17.3333 23.9999 17.8841 23.7817 18.3012 23.3899C18.7184 22.998 18.9705 22.4619 19.0062 21.8906L20 6H20.75C20.9489 6 21.1397 5.92098 21.2803 5.78033C21.421 5.63968 21.5 5.44891 21.5 5.25V4.5C21.5 4.30109 21.421 4.11032 21.2803 3.96967C21.1397 3.82902 20.9489 3.75 20.75 3.75ZM8.6375 2.25H13.3625L14.2625 3.75H7.7375L8.6375 2.25ZM16.7609 21.75H5.23953L4.25516 6H17.7458L16.7609 21.75Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAltTrash = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M13.0625 19.5H14.1875C14.3367 19.5 14.4798 19.4407 14.5852 19.3352C14.6907 19.2298 14.75 19.0867 14.75 18.9375V8.8125C14.75 8.66332 14.6907 8.52024 14.5852 8.41475C14.4798 8.30926 14.3367 8.25 14.1875 8.25H13.0625C12.9133 8.25 12.7702 8.30926 12.6648 8.41475C12.5593 8.52024 12.5 8.66332 12.5 8.8125V18.9375C12.5 19.0867 12.5593 19.2298 12.6648 19.3352C12.7702 19.4407 12.9133 19.5 13.0625 19.5ZM20.75 3.75H16.887L15.2933 1.09219C15.0933 0.758914 14.8103 0.483137 14.472 0.29173C14.1338 0.100323 13.7517 -0.000184847 13.363 2.55209e-07H8.63703C8.24851 -2.29111e-05 7.86659 0.100562 7.52848 0.291961C7.19037 0.48336 6.90758 0.75905 6.70766 1.09219L5.11297 3.75H1.25C1.05109 3.75 0.860322 3.82902 0.71967 3.96967C0.579018 4.11032 0.5 4.30109 0.5 4.5L0.5 5.25C0.5 5.44891 0.579018 5.63968 0.71967 5.78033C0.860322 5.92098 1.05109 6 1.25 6H2V21.75C2 22.3467 2.23705 22.919 2.65901 23.341C3.08097 23.7629 3.65326 24 4.25 24H17.75C18.3467 24 18.919 23.7629 19.341 23.341C19.7629 22.919 20 22.3467 20 21.75V6H20.75C20.9489 6 21.1397 5.92098 21.2803 5.78033C21.421 5.63968 21.5 5.44891 21.5 5.25V4.5C21.5 4.30109 21.421 4.11032 21.2803 3.96967C21.1397 3.82902 20.9489 3.75 20.75 3.75ZM8.555 2.38641C8.58007 2.34468 8.61553 2.31018 8.65793 2.28627C8.70033 2.26236 8.7482 2.24986 8.79688 2.25H13.2031C13.2517 2.24994 13.2995 2.26248 13.3418 2.28639C13.3841 2.31029 13.4195 2.34475 13.4445 2.38641L14.263 3.75H7.73703L8.555 2.38641ZM17.75 21.75H4.25V6H17.75V21.75ZM7.8125 19.5H8.9375C9.08668 19.5 9.22976 19.4407 9.33525 19.3352C9.44074 19.2298 9.5 19.0867 9.5 18.9375V8.8125C9.5 8.66332 9.44074 8.52024 9.33525 8.41475C9.22976 8.30926 9.08668 8.25 8.9375 8.25H7.8125C7.66332 8.25 7.52024 8.30926 7.41475 8.41475C7.30926 8.52024 7.25 8.66332 7.25 8.8125V18.9375C7.25 19.0867 7.30926 19.2298 7.41475 19.3352C7.52024 19.4407 7.66332 19.5 7.8125 19.5Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidReply = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0.389479 7.89856L8.63967 0.774261C9.36182 0.150589 10.5 0.656886 10.5 1.6257V5.37818C18.0295 5.46439 24 6.97343 24 14.109C24 16.9891 22.1446 19.8423 20.0938 21.334C19.4538 21.7995 18.5417 21.2152 18.7777 20.4606C20.9032 13.6632 17.7695 11.8586 10.5 11.754V15.875C10.5 16.8453 9.36093 17.3494 8.63967 16.7264L0.389479 9.60144C-0.129475 9.15322 -0.130178 8.34739 0.389479 7.89856Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidEdit = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M16.775 3.79789L20.5333 7.55622C20.6917 7.71455 20.6917 7.97289 20.5333 8.13122L11.4333 17.2312L7.56667 17.6604C7.05 17.7187 6.6125 17.2812 6.67083 16.7646L7.1 12.8979L16.2 3.79789C16.3583 3.63955 16.6167 3.63955 16.775 3.79789ZM23.525 2.84372L21.4917 0.810388C20.8583 0.177055 19.8292 0.177055 19.1917 0.810388L17.7167 2.28539C17.5583 2.44372 17.5583 2.70205 17.7167 2.86039L21.475 6.61872C21.6333 6.77705 21.8917 6.77705 22.05 6.61872L23.525 5.14372C24.1583 4.50622 24.1583 3.47706 23.525 2.84372ZM16 14.7562V18.9979H2.66667V5.66456H12.2417C12.375 5.66456 12.5 5.61039 12.5958 5.51872L14.2625 3.85206C14.5792 3.53539 14.3542 2.99789 13.9083 2.99789H2C0.895833 2.99789 0 3.89372 0 4.99789V19.6646C0 20.7687 0.895833 21.6646 2 21.6646H16.6667C17.7708 21.6646 18.6667 20.7687 18.6667 19.6646V13.0896C18.6667 12.6437 18.1292 12.4229 17.8125 12.7354L16.1458 14.4021C16.0542 14.4979 16 14.6229 16 14.7562Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidFilter = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M22.8739 0H1.12631C0.127026 0 -0.377208 1.21247 0.330839 1.92052L8.99999 10.591V20.25C8.99999 20.6171 9.1791 20.9611 9.47985 21.1716L13.2299 23.7957C13.9697 24.3136 15 23.7887 15 22.8741V10.591L23.6694 1.92052C24.376 1.21387 23.8752 0 22.8739 0Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidExternalLink = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M20.25 15H18.75C18.5511 15 18.3603 15.079 18.2197 15.2197C18.079 15.3603 18 15.5511 18 15.75V21H3V6H9.75C9.94891 6 10.1397 5.92098 10.2803 5.78033C10.421 5.63968 10.5 5.44891 10.5 5.25V3.75C10.5 3.55109 10.421 3.36032 10.2803 3.21967C10.1397 3.07902 9.94891 3 9.75 3H2.25C1.65326 3 1.08097 3.23705 0.65901 3.65901C0.237053 4.08097 0 4.65326 0 5.25L0 21.75C0 22.3467 0.237053 22.919 0.65901 23.341C1.08097 23.7629 1.65326 24 2.25 24H18.75C19.3467 24 19.919 23.7629 20.341 23.341C20.7629 22.919 21 22.3467 21 21.75V15.75C21 15.5511 20.921 15.3603 20.7803 15.2197C20.6397 15.079 20.4489 15 20.25 15ZM22.875 0H16.875C15.8733 0 15.3727 1.21453 16.0781 1.92188L17.753 3.59672L6.32812 15.0173C6.22325 15.1219 6.14003 15.2461 6.08325 15.3828C6.02647 15.5195 5.99724 15.6662 5.99724 15.8142C5.99724 15.9623 6.02647 16.1089 6.08325 16.2456C6.14003 16.3824 6.22325 16.5066 6.32812 16.6111L7.39078 17.6719C7.4953 17.7768 7.61949 17.86 7.75624 17.9168C7.89298 17.9735 8.03959 18.0028 8.18766 18.0028C8.33572 18.0028 8.48233 17.9735 8.61908 17.9168C8.75582 17.86 8.88001 17.7768 8.98453 17.6719L20.4037 6.24938L22.0781 7.92188C22.7812 8.625 24 8.13281 24 7.125V1.125C24 0.826631 23.8815 0.540483 23.6705 0.329505C23.4595 0.118526 23.1734 0 22.875 0V0Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidDownload = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M10.125 0H13.875C14.4984 0 15 0.501562 15 1.125V9H19.1109C19.9453 9 20.3625 10.0078 19.7719 10.5984L12.6422 17.7328C12.2906 18.0844 11.7141 18.0844 11.3625 17.7328L4.22344 10.5984C3.63281 10.0078 4.05 9 4.88437 9H9V1.125C9 0.501562 9.50156 0 10.125 0ZM24 17.625V22.875C24 23.4984 23.4984 24 22.875 24H1.125C0.501562 24 0 23.4984 0 22.875V17.625C0 17.0016 0.501562 16.5 1.125 16.5H8.00156L10.2984 18.7969C11.2406 19.7391 12.7594 19.7391 13.7016 18.7969L15.9984 16.5H22.875C23.4984 16.5 24 17.0016 24 17.625ZM18.1875 21.75C18.1875 21.2344 17.7656 20.8125 17.25 20.8125C16.7344 20.8125 16.3125 21.2344 16.3125 21.75C16.3125 22.2656 16.7344 22.6875 17.25 22.6875C17.7656 22.6875 18.1875 22.2656 18.1875 21.75ZM21.1875 21.75C21.1875 21.2344 20.7656 20.8125 20.25 20.8125C19.7344 20.8125 19.3125 21.2344 19.3125 21.75C19.3125 22.2656 19.7344 22.6875 20.25 22.6875C20.7656 22.6875 21.1875 22.2656 21.1875 21.75Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularReply = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M0.585937 11.0808L7.91918 18.4116C9.17793 19.6704 11.3333 18.7741 11.3333 16.9975V13.7358C17.4413 14.0916 17.9388 15.8274 16.9242 19.0641C16.3554 20.8791 18.3854 22.3512 19.9321 21.3333C22.4158 19.6986 24 17.1583 24 14.0854C24 6.98664 17.0817 5.87081 11.3333 5.69789V2.33527C11.3333 0.555269 9.17543 -0.335147 7.91918 0.921102L0.585937 8.25247C-0.195312 9.0333 -0.195312 10.3 0.585937 11.0808ZM2.00002 9.66664L9.33335 2.33331V7.66789C15.2992 7.69414 22 8.15864 22 14.0854C22 16.8754 20.3333 18.6666 18.8325 19.6541C20.8933 13.0796 16.1884 11.745 9.33335 11.6704V17L2.00002 9.66664Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularEdit = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M16.7629 14.7058L18.0962 13.3724C18.3046 13.1641 18.6671 13.3099 18.6671 13.61V19.6684C18.6671 20.7726 17.7712 21.6685 16.667 21.6685H2.00004C0.895853 21.6685 0 20.7726 0 19.6684V5.00144C0 3.89724 0.895853 3.00139 2.00004 3.00139H13.3961C13.692 3.00139 13.842 3.35973 13.6336 3.57224L12.3003 4.9056C12.2378 4.9681 12.1544 5.00144 12.0628 5.00144H2.00004V19.6684H16.667V14.9391C16.667 14.8516 16.7004 14.7683 16.7629 14.7058ZM23.288 6.2973L12.3461 17.2392L8.57935 17.6559C7.48766 17.7767 6.55848 16.8559 6.67931 15.7558L7.09599 11.9891L18.0379 1.04718C18.9921 0.0929961 20.5338 0.0929961 21.4838 1.04718L23.2838 2.84722C24.238 3.80141 24.238 5.34728 23.288 6.2973ZM19.1712 7.58482L16.7504 5.16394L9.00853 12.9099L8.70435 15.6308L11.4252 15.3267L19.1712 7.58482ZM21.8713 4.26392L20.0713 2.46388C19.9004 2.29304 19.6213 2.29304 19.4546 2.46388L18.1671 3.75141L20.5879 6.17229L21.8755 4.88477C22.0421 4.70976 22.0421 4.43476 21.8713 4.26392Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularFilter = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.7477 0H2.25267C0.254014 0 -0.754407 2.42489 0.661685 3.84098L8.24999 11.432V19.5C8.24999 20.2082 8.58341 20.8751 9.14999 21.375L12.15 23.5812C13.6159 24.6057 15.75 23.6533 15.75 21.7812V11.432L23.3387 3.84098C24.7519 2.42775 23.7504 0 21.7477 0ZM13.5 10.5V21.75L10.5 19.5V10.5L2.25 2.25H21.75L13.5 10.5Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularExternalLink = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.325 0L15.675 0.00796875C15.496 0.00796875 15.3243 0.0790846 15.1977 0.205672C15.0711 0.332259 15 0.503948 15 0.682969V2.24437C15 2.33417 15.0179 2.42307 15.0527 2.50587C15.0874 2.58866 15.1384 2.66368 15.2025 2.72654C15.2666 2.7894 15.3426 2.83884 15.4261 2.87195C15.5096 2.90506 15.5988 2.92118 15.6886 2.91937L19.14 2.79188L19.2366 2.88844L6.165 15.9605C6.11256 16.0127 6.07095 16.0748 6.04256 16.1432C6.01417 16.2116 5.99956 16.2849 5.99956 16.3589C5.99956 16.4329 6.01417 16.5062 6.04256 16.5746C6.07095 16.643 6.11256 16.7051 6.165 16.7573L7.24312 17.8355C7.29538 17.8879 7.35748 17.9295 7.42585 17.9579C7.49423 17.9863 7.56753 18.0009 7.64156 18.0009C7.7156 18.0009 7.7889 17.9863 7.85727 17.9579C7.92565 17.9295 7.98774 17.8879 8.04 17.8355L21.1116 4.76344L21.2081 4.86L21.0806 8.31141C21.0788 8.40119 21.0949 8.49042 21.1281 8.57389C21.1612 8.65736 21.2106 8.73339 21.2735 8.79752C21.3363 8.86164 21.4113 8.91258 21.4941 8.94735C21.5769 8.98212 21.6658 9.00002 21.7556 9H23.317C23.4961 9 23.6677 8.92888 23.7943 8.8023C23.9209 8.67571 23.992 8.50402 23.992 8.325L24 0.675C24 0.495979 23.9289 0.32429 23.8023 0.197703C23.6757 0.0711159 23.504 0 23.325 0V0ZM20.25 13.5H19.5C19.3011 13.5 19.1103 13.579 18.9697 13.7197C18.829 13.8603 18.75 14.0511 18.75 14.25V21.4688C18.75 21.5433 18.7204 21.6149 18.6676 21.6676C18.6149 21.7204 18.5433 21.75 18.4688 21.75H2.53125C2.45666 21.75 2.38512 21.7204 2.33238 21.6676C2.27963 21.6149 2.25 21.5433 2.25 21.4688V5.53125C2.25 5.45666 2.27963 5.38512 2.33238 5.33238C2.38512 5.27963 2.45666 5.25 2.53125 5.25H9.75C9.94891 5.25 10.1397 5.17098 10.2803 5.03033C10.421 4.88968 10.5 4.69891 10.5 4.5V3.75C10.5 3.55109 10.421 3.36032 10.2803 3.21967C10.1397 3.07902 9.94891 3 9.75 3H2.25C1.65326 3 1.08097 3.23705 0.65901 3.65901C0.237053 4.08097 0 4.65326 0 5.25L0 21.75C0 22.3467 0.237053 22.919 0.65901 23.341C1.08097 23.7629 1.65326 24 2.25 24H18.75C19.3467 24 19.919 23.7629 20.341 23.341C20.7629 22.919 21 22.3467 21 21.75V14.25C21 14.0511 20.921 13.8603 20.7803 13.7197C20.6397 13.579 20.4489 13.5 20.25 13.5Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAltExternalLink = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M20.25 13.5H19.5C19.3011 13.5 19.1103 13.579 18.9697 13.7197C18.829 13.8603 18.75 14.0511 18.75 14.25V21.4688C18.75 21.5433 18.7204 21.6149 18.6676 21.6676C18.6149 21.7204 18.5433 21.75 18.4688 21.75H2.53125C2.45666 21.75 2.38512 21.7204 2.33238 21.6676C2.27963 21.6149 2.25 21.5433 2.25 21.4688V5.53125C2.25 5.45666 2.27963 5.38512 2.33238 5.33238C2.38512 5.27963 2.45666 5.25 2.53125 5.25H9.75C9.94891 5.25 10.1397 5.17098 10.2803 5.03033C10.421 4.88968 10.5 4.69891 10.5 4.5V3.75C10.5 3.55109 10.421 3.36032 10.2803 3.21967C10.1397 3.07902 9.94891 3 9.75 3H2.25C1.65326 3 1.08097 3.23705 0.65901 3.65901C0.237053 4.08097 0 4.65326 0 5.25L0 21.75C0 22.3467 0.237053 22.919 0.65901 23.341C1.08097 23.7629 1.65326 24 2.25 24H18.75C19.3467 24 19.919 23.7629 20.341 23.341C20.7629 22.919 21 22.3467 21 21.75V14.25C21 14.0511 20.921 13.8603 20.7803 13.7197C20.6397 13.579 20.4489 13.5 20.25 13.5ZM23.4375 0H17.0625C16.9513 9.77905e-05 16.8427 0.0331408 16.7503 0.0949558C16.6578 0.156771 16.5858 0.244585 16.5433 0.347307C16.5008 0.45003 16.4896 0.563053 16.5113 0.672102C16.5329 0.781151 16.5864 0.881335 16.665 0.96L18.9239 3.21984L6.16453 15.9792C6.11209 16.0315 6.07048 16.0936 6.04209 16.1619C6.0137 16.2303 5.99909 16.3036 5.99909 16.3777C5.99909 16.4517 6.0137 16.525 6.04209 16.5934C6.07048 16.6617 6.11209 16.7238 6.16453 16.7761L7.22531 17.8369C7.27757 17.8893 7.33967 17.9309 7.40804 17.9593C7.47641 17.9877 7.54972 18.0023 7.62375 18.0023C7.69778 18.0023 7.77109 17.9877 7.83946 17.9593C7.90783 17.9309 7.96993 17.8893 8.02219 17.8369L20.7816 5.07703L23.0414 7.33641C23.1202 7.41458 23.2204 7.46768 23.3294 7.48902C23.4383 7.51036 23.5511 7.49899 23.6536 7.45634C23.7561 7.41369 23.8437 7.34167 23.9053 7.24934C23.967 7.15701 23.9999 7.04851 24 6.9375V0.5625C24 0.413316 23.9407 0.270242 23.8352 0.164752C23.7298 0.0592632 23.5867 0 23.4375 0V0Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularDownload = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M22 12.3333H18.1625L20.0833 10.4125C21.3375 9.15831 20.45 6.99998 18.6708 6.99998H16.0042V2.33331C16.0042 1.22915 15.1083 0.333313 14.0042 0.333313H10.0042C8.9 0.333313 8.00417 1.22915 8.00417 2.33331V6.99998H5.3375C3.5625 6.99998 2.6625 9.15415 3.925 10.4125L5.84583 12.3333H2C0.895833 12.3333 0 13.2291 0 14.3333V19.6666C0 20.7708 0.895833 21.6666 2 21.6666H22C23.1042 21.6666 24 20.7708 24 19.6666V14.3333C24 13.2291 23.1042 12.3333 22 12.3333ZM5.33333 8.99998H10V2.33331H14V8.99998H18.6667L12 15.6666L5.33333 8.99998ZM22 19.6666H2V14.3333H7.8375L10.5833 17.0791C11.3667 17.8625 12.6292 17.8583 13.4125 17.0791L16.1583 14.3333H22V19.6666ZM18.3333 17C18.3333 16.4458 18.7792 16 19.3333 16C19.8875 16 20.3333 16.4458 20.3333 17C20.3333 17.5541 19.8875 18 19.3333 18C18.7792 18 18.3333 17.5541 18.3333 17Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidShare = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M17 15C15.9403 15 14.9662 15.3665 14.1973 15.9795L9.39331 12.9769C9.53558 12.3334 9.53558 11.6666 9.39331 11.023L14.1973 8.0205C14.9662 8.63348 15.9403 9 17 9C19.4853 9 21.5 6.98527 21.5 4.5C21.5 2.01473 19.4853 0 17 0C14.5147 0 12.5 2.01473 12.5 4.5C12.5 4.83553 12.537 5.16234 12.6067 5.47692L7.80266 8.47945C7.03377 7.86652 6.05975 7.5 5 7.5C2.51473 7.5 0.5 9.51473 0.5 12C0.5 14.4853 2.51473 16.5 5 16.5C6.05975 16.5 7.03377 16.1335 7.80266 15.5205L12.6067 18.5231C12.5357 18.8439 12.4999 19.1714 12.5 19.5C12.5 21.9853 14.5147 24 17 24C19.4853 24 21.5 21.9853 21.5 19.5C21.5 17.0147 19.4853 15 17 15Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidSearch = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.6716 20.7495L18.9987 16.0766C18.7877 15.8656 18.5018 15.7485 18.2019 15.7485H17.4379C18.7315 14.0939 19.5002 12.0129 19.5002 9.74905C19.5002 4.36364 15.1365 0 9.75112 0C4.36571 0 0.0020752 4.36364 0.0020752 9.74905C0.0020752 15.1345 4.36571 19.4981 9.75112 19.4981C12.015 19.4981 14.096 18.7294 15.7505 17.4358V18.1998C15.7505 18.4998 15.8677 18.7857 16.0786 18.9966L20.7516 23.6696C21.1922 24.1101 21.9046 24.1101 22.3405 23.6696L23.667 22.3431C24.1075 21.9025 24.1075 21.1901 23.6716 20.7495ZM9.75112 15.7485C6.43738 15.7485 3.75171 13.0675 3.75171 9.74905C3.75171 6.43531 6.4327 3.74963 9.75112 3.74963C13.0649 3.74963 15.7505 6.43062 15.7505 9.74905C15.7505 13.0628 13.0695 15.7485 9.75112 15.7485Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidClock = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0ZM16.4753 15.1452L15.5076 16.3548C15.4441 16.4342 15.3655 16.5004 15.2765 16.5494C15.1874 16.5985 15.0896 16.6295 14.9885 16.6407C14.8875 16.6519 14.7852 16.6432 14.6875 16.6149C14.5899 16.5866 14.4987 16.5393 14.4194 16.4758L11.1774 14.07C10.9509 13.8886 10.7681 13.6587 10.6424 13.3971C10.5168 13.1355 10.4516 12.849 10.4516 12.5589V5.03226C10.4516 4.82693 10.5332 4.63001 10.6784 4.48482C10.8236 4.33963 11.0205 4.25806 11.2258 4.25806H12.7742C12.9795 4.25806 13.1764 4.33963 13.3216 4.48482C13.4668 4.63001 13.5484 4.82693 13.5484 5.03226V12L16.3548 14.0565C16.4343 14.12 16.5004 14.1986 16.5495 14.2877C16.5985 14.3768 16.6295 14.4747 16.6407 14.5758C16.6519 14.6769 16.643 14.7793 16.6147 14.877C16.5863 14.9746 16.5389 15.0658 16.4753 15.1452Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidSearchPlus = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M14.2503 8.99912V10.499C14.2503 10.8083 13.9972 11.0614 13.6879 11.0614H11.0631V13.6862C11.0631 13.9955 10.81 14.2486 10.5007 14.2486H9.00083C8.69149 14.2486 8.43838 13.9955 8.43838 13.6862V11.0614H5.81364C5.5043 11.0614 5.2512 10.8083 5.2512 10.499V8.99912C5.2512 8.68978 5.5043 8.43668 5.81364 8.43668H8.43838V5.81193C8.43838 5.50259 8.69149 5.24949 9.00083 5.24949H10.5007C10.81 5.24949 11.0631 5.50259 11.0631 5.81193V8.43668H13.6879C13.9972 8.43668 14.2503 8.68978 14.2503 8.99912ZM23.6713 22.3431L22.3448 23.6696C21.9043 24.1101 21.1918 24.1101 20.7559 23.6696L16.0783 18.9966C15.8673 18.7857 15.7502 18.4998 15.7502 18.1998V17.4358C14.0956 18.7294 12.0146 19.4981 9.75076 19.4981C4.36535 19.4981 0.00170898 15.1345 0.00170898 9.74905C0.00170898 4.36364 4.36535 0 9.75076 0C15.1362 0 19.4998 4.36364 19.4998 9.74905C19.4998 12.0129 18.7311 14.0939 17.4375 15.7485H18.2015C18.5015 15.7485 18.7874 15.8656 18.9983 16.0766L23.6713 20.7495C24.1072 21.1901 24.1072 21.9026 23.6713 22.3431ZM16.1251 9.74905C16.1251 6.22439 13.2754 3.37467 9.75076 3.37467C6.2261 3.37467 3.37638 6.22439 3.37638 9.74905C3.37638 13.2737 6.2261 16.1234 9.75076 16.1234C13.2754 16.1234 16.1251 13.2737 16.1251 9.74905Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularShare = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '24'}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M17 15C15.8 15 14.7078 15.4688 13.9016 16.2375L9.29375 13.3547C9.57031 12.4734 9.57031 11.5219 9.29375 10.6453L13.9016 7.7625C14.7078 8.53125 15.8 9 17 9C19.4844 9 21.5 6.98438 21.5 4.5C21.5 2.01562 19.4844 0 17 0C14.5156 0 12.5 2.01562 12.5 4.5C12.5 4.95937 12.5703 5.41875 12.7062 5.85469L8.09844 8.7375C7.29219 7.96875 6.2 7.5 5 7.5C2.51562 7.5 0.5 9.51562 0.5 12C0.5 14.4844 2.51562 16.5 5 16.5C6.2 16.5 7.29219 16.0312 8.09844 15.2625L12.7062 18.1453C12.5703 18.5859 12.5 19.0406 12.5 19.5C12.5 21.9844 14.5156 24 17 24C19.4844 24 21.5 21.9844 21.5 19.5C21.5 17.0156 19.4844 15 17 15ZM17 2.25C18.2422 2.25 19.25 3.25781 19.25 4.5C19.25 5.74219 18.2422 6.75 17 6.75C15.7578 6.75 14.75 5.74219 14.75 4.5C14.75 3.25781 15.7578 2.25 17 2.25ZM5 14.25C3.75781 14.25 2.75 13.2422 2.75 12C2.75 10.7578 3.75781 9.75 5 9.75C6.24219 9.75 7.25 10.7578 7.25 12C7.25 13.2422 6.24219 14.25 5 14.25ZM17 21.75C15.7578 21.75 14.75 20.7422 14.75 19.5C14.75 18.2578 15.7578 17.25 17 17.25C18.2422 17.25 19.25 18.2578 19.25 19.5C19.25 20.7422 18.2422 21.75 17 21.75Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularSearch = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.8348 21.9786L18.1444 16.2883C18.0366 16.1805 17.896 16.1242 17.746 16.1242H17.1273C18.6038 14.4134 19.499 12.1869 19.499 9.74952C19.499 4.36385 15.1352 0 9.74952 0C4.36385 0 0 4.36385 0 9.74952C0 15.1352 4.36385 19.499 9.74952 19.499C12.1869 19.499 14.4134 18.6038 16.1242 17.1273V17.746C16.1242 17.896 16.1851 18.0366 16.2883 18.1444L21.9786 23.8348C22.1989 24.0551 22.5551 24.0551 22.7754 23.8348L23.8348 22.7754C24.0551 22.5551 24.0551 22.1989 23.8348 21.9786ZM9.74952 17.2492C5.60598 17.2492 2.24989 13.8931 2.24989 9.74952C2.24989 5.60598 5.60598 2.24989 9.74952 2.24989C13.8931 2.24989 17.2492 5.60598 17.2492 9.74952C17.2492 13.8931 13.8931 17.2492 9.74952 17.2492Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularClock = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12 0C5.37097 0 0 5.37097 0 12C0 18.629 5.37097 24 12 24C18.629 24 24 18.629 24 12C24 5.37097 18.629 0 12 0ZM12 21.6774C6.65323 21.6774 2.32258 17.3468 2.32258 12C2.32258 6.65323 6.65323 2.32258 12 2.32258C17.3468 2.32258 21.6774 6.65323 21.6774 12C21.6774 17.3468 17.3468 21.6774 12 21.6774ZM14.9903 16.6258L10.8823 13.6403C10.7323 13.529 10.6452 13.3548 10.6452 13.171V5.22581C10.6452 4.90645 10.9065 4.64516 11.2258 4.64516H12.7742C13.0935 4.64516 13.3548 4.90645 13.3548 5.22581V12.0823L16.5871 14.4339C16.8484 14.6226 16.9016 14.9855 16.7129 15.2468L15.8032 16.5C15.6145 16.7565 15.2516 16.8145 14.9903 16.6258Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularSearchPlus = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M14.6243 9.18705V10.312C14.6243 10.6214 14.3712 10.8745 14.0618 10.8745H10.8745V14.0618C10.8745 14.3712 10.6214 14.6243 10.312 14.6243H9.18705C8.87769 14.6243 8.62458 14.3712 8.62458 14.0618V10.8745H5.43723C5.12787 10.8745 4.87476 10.6214 4.87476 10.312V9.18705C4.87476 8.87769 5.12787 8.62458 5.43723 8.62458H8.62458V5.43723C8.62458 5.12787 8.87769 4.87476 9.18705 4.87476H10.312C10.6214 4.87476 10.8745 5.12787 10.8745 5.43723V8.62458H14.0618C14.3712 8.62458 14.6243 8.87769 14.6243 9.18705ZM23.8348 22.7754L22.7754 23.8348C22.5551 24.0551 22.1989 24.0551 21.9786 23.8348L16.2883 18.1444C16.1805 18.0366 16.1242 17.896 16.1242 17.746V17.1273C14.4134 18.6038 12.1869 19.499 9.74952 19.499C4.36385 19.499 0 15.1352 0 9.74952C0 4.36385 4.36385 0 9.74952 0C15.1352 0 19.499 4.36385 19.499 9.74952C19.499 12.1869 18.6038 14.4134 17.1273 16.1242H17.746C17.896 16.1242 18.0366 16.1851 18.1444 16.2883L23.8348 21.9786C24.0551 22.1989 24.0551 22.5551 23.8348 22.7754ZM17.2492 9.74952C17.2492 5.60598 13.8931 2.24989 9.74952 2.24989C5.60598 2.24989 2.24989 5.60598 2.24989 9.74952C2.24989 13.8931 5.60598 17.2492 9.74952 17.2492C13.8931 17.2492 17.2492 13.8931 17.2492 9.74952Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidEnvelope = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.5453 5.94375C23.7281 5.79844 24 5.93437 24 6.16406V15.75C24 16.9922 22.9922 18 21.75 18H2.25C1.00781 18 0 16.9922 0 15.75V6.16875C0 5.93438 0.267187 5.80312 0.454687 5.94844C1.50469 6.76406 2.89688 7.8 7.67813 11.2734C8.66719 11.9953 10.3359 13.5141 12 13.5047C13.6734 13.5188 15.375 11.9672 16.3266 11.2734C21.1078 7.8 22.4953 6.75938 23.5453 5.94375ZM12 12C13.0875 12.0188 14.6531 10.6313 15.4406 10.0594C21.6609 5.54531 22.1344 5.15156 23.5687 4.02656C23.8406 3.81562 24 3.4875 24 3.14062V2.25C24 1.00781 22.9922 0 21.75 0H2.25C1.00781 0 0 1.00781 0 2.25V3.14062C0 3.4875 0.159375 3.81094 0.43125 4.02656C1.86563 5.14687 2.33906 5.54531 8.55938 10.0594C9.34688 10.6313 10.9125 12.0188 12 12Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidEnvelopeOpen = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M24 21.75C24 22.9927 22.9926 24 21.75 24H2.25C1.00734 24 0 22.9927 0 21.75V9.40894C4.14475e-06 9.06775 0.0776011 8.73104 0.226921 8.42426C0.376241 8.11748 0.593372 7.84868 0.86189 7.63819C2.02969 6.72277 2.99475 5.98046 8.55876 1.94237C9.34743 1.36735 10.9124 -0.0162583 12 0.000147907C13.0874 -0.0164458 14.6529 1.36759 15.4412 1.94232C21.0047 5.97999 21.9711 6.72333 23.1381 7.63819C23.4066 7.84868 23.6238 8.11748 23.7731 8.42426C23.9224 8.73104 24 9.06775 24 9.40894V21.75ZM20.9219 12.5341C20.8018 12.3594 20.561 12.3188 20.3904 12.4448C19.3195 13.2357 17.7906 14.3528 15.4412 16.0578C14.6526 16.6328 13.0876 18.0163 12 17.9999C10.912 18.016 9.34879 16.6338 8.55876 16.0578C6.20967 14.353 4.68061 13.2358 3.60961 12.4448C3.43903 12.3188 3.19823 12.3594 3.07809 12.5341L2.65284 13.1527C2.59772 13.2328 2.5759 13.3313 2.59199 13.4272C2.60807 13.5231 2.6608 13.609 2.73905 13.6668C3.81187 14.4589 5.33845 15.5741 7.67512 17.27C8.62547 17.9628 10.3247 19.5112 12 19.5C13.6746 19.5113 15.3732 17.9638 16.3248 17.27C18.6615 15.5741 20.1882 14.4589 21.2609 13.6668C21.3391 13.609 21.3919 13.5231 21.408 13.4272C21.424 13.3313 21.4022 13.2328 21.3471 13.1527L20.9219 12.5341Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidEnvelopeOpenText = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M8.25007 10.1251H15.75C16.1644 10.1251 16.5 9.78946 16.5 9.37509V8.62509C16.5 8.21072 16.1644 7.8751 15.75 7.8751H8.25007C7.8357 7.8751 7.50008 8.21072 7.50008 8.62509V9.37509C7.50008 9.78946 7.8357 10.1251 8.25007 10.1251ZM7.50008 13.8751C7.50008 14.2894 7.8357 14.6251 8.25007 14.6251H15.75C16.1644 14.6251 16.5 14.2894 16.5 13.8751V13.1251C16.5 12.7107 16.1644 12.3751 15.75 12.3751H8.25007C7.8357 12.3751 7.50008 12.7107 7.50008 13.1251V13.8751ZM12 19.553C11.2304 19.553 10.4607 19.3158 9.8035 18.841L0.00012207 11.7591V21.75C0.00012207 22.9927 1.00746 24 2.25011 24H21.75C22.9926 24 24 22.9927 24 21.75V11.7591L14.1966 18.841C13.5394 19.3153 12.7697 19.553 12 19.553ZM23.138 7.63838C22.7231 7.31307 22.3298 7.00698 21.75 6.56917V4.50012C21.75 3.25747 20.7427 2.25013 19.5 2.25013H15.8649C15.7224 2.14701 15.5897 2.05044 15.4411 1.94263C14.6532 1.36748 13.0875 -0.0162615 12 0.000144626C10.9126 -0.0162615 9.34741 1.36748 8.55898 1.94263C8.41038 2.05044 8.27773 2.14701 8.13523 2.25013H4.50009C3.25745 2.25013 2.25011 3.25747 2.25011 4.50012V6.56917C1.67027 7.00651 1.27699 7.31307 0.862148 7.63838C0.59363 7.84881 0.376486 8.11756 0.227143 8.42429C0.0777994 8.73101 0.00016828 9.06769 0.00012207 9.40884L0.00012207 9.90805L4.50009 13.1588V4.50012H19.5V13.1588L24 9.90805V9.40884C24 8.7179 23.6822 8.06494 23.138 7.63838Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidMailBulk = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M6.66667 19C5.6 19 4.53333 18.0666 4 17.6666C1.33333 15.8 0.533333 15.1333 0 14.7333V20.3333C0 21.0696 0.597083 21.6666 1.33333 21.6666H12C12.7362 21.6666 13.3333 21.0696 13.3333 20.3333V14.7333C12.8 15.1333 12 15.8 9.33333 17.6666C8.8 18.0666 7.73333 19 6.66667 19ZM12 11H1.33333C0.597083 11 0 11.5971 0 12.3333V13C1.06667 13.8 0.933333 13.8 4.8 16.6C5.2 16.8666 6 17.6666 6.66667 17.6666C7.33333 17.6666 8.13333 16.8666 8.53333 16.7333C12.4 13.9333 12.2667 13.9333 13.3333 13.1333V12.3333C13.3333 11.5971 12.7362 11 12 11ZM22.6667 6.99998H9.33333C8.59708 6.99998 8 7.59706 8 8.33331V9.66665H12C13.3837 9.66665 14.5246 10.7258 14.6546 12.0758L14.6667 12.0666V17.6666H22.6667C23.4029 17.6666 24 17.0696 24 16.3333V8.33331C24 7.59706 23.4029 6.99998 22.6667 6.99998ZM21.3333 12.3333H18.6667V9.66665H21.3333V12.3333ZM6.66667 8.33331C6.66667 6.8629 7.86292 5.66665 9.33333 5.66665H18.6667V1.66665C18.6667 0.930396 18.0696 0.333313 17.3333 0.333313H4C3.26375 0.333313 2.66667 0.930396 2.66667 1.66665V9.66665H6.66667V8.33331Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularEnvelope = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.75 0H2.25C1.00734 0 0 1.00734 0 2.25V15.75C0 16.9927 1.00734 18 2.25 18H21.75C22.9927 18 24 16.9927 24 15.75V2.25C24 1.00734 22.9927 0 21.75 0ZM21.75 2.25V4.16273C20.699 5.01862 19.0234 6.3495 15.4412 9.15445C14.6518 9.77541 13.0881 11.2672 12 11.2498C10.9121 11.2674 9.34786 9.77517 8.55877 9.15445C4.97719 6.34992 3.30117 5.01877 2.25 4.16273V2.25H21.75ZM2.25 15.75V7.04991C3.32409 7.90542 4.8473 9.10594 7.16897 10.9239C8.19352 11.7304 9.98775 13.5108 12 13.5C14.0024 13.5108 15.7739 11.7563 16.8306 10.9243C19.1522 9.10636 20.6759 7.90552 21.75 7.04995V15.75H2.25Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularEnvelopeOpen = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.1837 7.71169C22.9635 7.52967 17.9467 3.49528 16.8438 2.61839C15.8077 1.7902 14.0361 0 12 0C9.97477 0 8.22019 1.76798 7.15617 2.61839C6.00947 3.53011 1.01227 7.54941 0.821016 7.70662C0.564311 7.91771 0.357551 8.18304 0.215594 8.48354C0.0736379 8.78405 9.42652e-06 9.11226 0 9.44461L0 21.75C0 22.9927 1.00734 24 2.25 24H21.75C22.9927 24 24 22.9927 24 21.75V9.44573C24 9.11443 23.9268 8.78721 23.7857 8.48745C23.6446 8.1877 23.4391 7.9228 23.1837 7.71169ZM21.75 21.4688C21.75 21.5433 21.7204 21.6149 21.6676 21.6676C21.6149 21.7204 21.5433 21.75 21.4688 21.75H2.53125C2.45666 21.75 2.38512 21.7204 2.33238 21.6676C2.27963 21.6149 2.25 21.5433 2.25 21.4688V9.57877C2.25 9.49378 2.28825 9.41348 2.35434 9.36009C3.09825 8.75944 7.45402 5.256 8.55891 4.37761C9.41039 3.6975 10.8937 2.25 12 2.25C13.1106 2.25 14.6183 3.72042 15.4411 4.37761C16.5461 5.25609 20.9022 8.76009 21.6458 9.36117C21.6783 9.38752 21.7046 9.42082 21.7227 9.45864C21.7407 9.49647 21.75 9.53785 21.75 9.57975V21.4688ZM20.2504 12.6701C20.4496 12.912 20.4128 13.2699 20.1686 13.4661C18.8104 14.5575 17.3902 15.6972 16.8438 16.1316C15.7798 16.982 14.0252 18.75 12 18.75C9.96319 18.75 8.18967 16.9576 7.15617 16.1316C6.62747 15.7112 5.19942 14.5653 3.83147 13.466C3.58725 13.2697 3.55055 12.9119 3.74967 12.67L4.46489 11.8015C4.66073 11.5637 5.01131 11.5276 5.25141 11.7206C6.59288 12.7988 7.99669 13.9254 8.55891 14.3724C9.3817 15.0296 10.8894 16.5 12 16.5C13.1063 16.5 14.5897 15.0525 15.4411 14.3724C16.0033 13.9254 17.4072 12.7988 18.7487 11.7208C18.9888 11.5278 19.3394 11.5639 19.5352 11.8017L20.2504 12.6701Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularEnvelopeOpenText = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.1839 7.71187C23.1127 7.65281 22.5342 7.18687 21.75 6.55594V4.5C21.75 3.25734 20.7427 2.25 19.5 2.25H16.4002C15.3394 1.35234 13.7705 0 12 0C10.2352 0 8.67656 1.34203 7.60078 2.25H4.5C3.25734 2.25 2.25 3.25734 2.25 4.5V6.55547C1.46203 7.18922 0.883594 7.65516 0.82125 7.70672C0.56454 7.91774 0.357758 8.18301 0.215762 8.48345C0.0737651 8.7839 7.98109e-05 9.11206 0 9.44438L0 21.75C0 22.9927 1.00734 24 2.25 24H21.75C22.9927 24 24 22.9927 24 21.75V9.44578C24 8.775 23.7009 8.13891 23.1839 7.71187ZM4.5 4.5H19.5V11.8434C17.8003 13.2178 15.8114 14.828 15.4411 15.1223C14.5898 15.8025 13.1062 17.25 12 17.25C10.8895 17.25 9.38156 15.7795 8.55891 15.1223C8.18859 14.828 6.19969 13.2173 4.5 11.8425V4.5ZM21.75 21.4688C21.75 21.6239 21.6239 21.75 21.4688 21.75H2.53125C2.37609 21.75 2.25 21.6239 2.25 21.4688V12.9169C4.07625 14.3925 6.74766 16.5567 7.15594 16.8816C8.18953 17.7075 9.96328 19.5 12 19.5C14.0255 19.5 15.78 17.7319 16.8441 16.8816C17.2659 16.5464 19.9303 14.3883 21.75 12.9178V21.4688ZM8.25 9H15.75C16.1644 9 16.5 8.66438 16.5 8.25V7.5C16.5 7.08563 16.1644 6.75 15.75 6.75H8.25C7.83563 6.75 7.5 7.08563 7.5 7.5V8.25C7.5 8.66438 7.83563 9 8.25 9ZM16.5 12V11.25C16.5 10.8356 16.1644 10.5 15.75 10.5H8.25C7.83563 10.5 7.5 10.8356 7.5 11.25V12C7.5 12.4144 7.83563 12.75 8.25 12.75H15.75C16.1644 12.75 16.5 12.4144 16.5 12Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularMailBulk = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M4.66667 2.33331H16.6667V4.33331H18.6667V2.33331C18.6667 1.22873 17.7712 0.333313 16.6667 0.333313H4.66667C3.56208 0.333313 2.66667 1.22873 2.66667 2.33331V8.33331H4.66667V2.33331ZM14 9.66665H2C0.895417 9.66665 0 10.5621 0 11.6666V19.6666C0 20.7712 0.895417 21.6666 2 21.6666H14C15.1046 21.6666 16 20.7712 16 19.6666V11.6666C16 10.5621 15.1046 9.66665 14 9.66665ZM14 19.6666H2V14.665C2.60375 15.1237 5.33333 17.0866 5.33333 17.0866C5.935 17.5533 6.9425 18.3333 8 18.3333C9.0575 18.3333 10.065 17.5533 10.6667 17.0866C10.6667 17.0866 13.3958 15.1241 14 14.665V19.6666ZM14 12.2246C13.9013 12.3016 9.34125 15.6387 9.12125 15.7891C8.76708 16.0321 8.32542 16.3333 8 16.3333C7.60792 16.3333 7.05458 15.8937 6.6875 15.6029C6.54542 15.4896 2.09875 12.1683 2 12.0912V11.6666H14V12.2246ZM22 5.66665H10C8.89542 5.66665 8 6.56206 8 7.66665V8.33331H10V7.66665H22V15.6666H17.3333V17.6666H22C23.1046 17.6666 24 16.7712 24 15.6666V7.66665C24 6.56206 23.1046 5.66665 22 5.66665ZM18 8.99998V11.6666H20.6667V8.99998H18Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidSave = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.2468 5.24684L18.7532 0.753161C18.2709 0.270923 17.6169 3.56612e-06 16.9349 0H2.57143C1.15125 0 0 1.15125 0 2.57143V21.4286C0 22.8488 1.15125 24 2.57143 24H21.4286C22.8488 24 24 22.8488 24 21.4286V7.06511C24 6.38312 23.7291 5.72907 23.2468 5.24684ZM12 20.5714C10.1065 20.5714 8.57143 19.0364 8.57143 17.1429C8.57143 15.2493 10.1065 13.7143 12 13.7143C13.8935 13.7143 15.4286 15.2493 15.4286 17.1429C15.4286 19.0364 13.8935 20.5714 12 20.5714ZM17.1429 4.25786V9.64286C17.1429 9.99788 16.855 10.2857 16.5 10.2857H4.07143C3.71641 10.2857 3.42857 9.99788 3.42857 9.64286V4.07143C3.42857 3.71641 3.71641 3.42857 4.07143 3.42857H16.3136C16.4841 3.42857 16.6476 3.49629 16.7681 3.61687L16.9546 3.8033C17.0143 3.86299 17.0616 3.93385 17.0939 4.01185C17.1262 4.08984 17.1429 4.17344 17.1429 4.25786Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidFolderOpen = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '16'}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.8623 9.50388L20.8446 14.677C20.6098 15.0796 20.2735 15.4136 19.8694 15.6457C19.4652 15.8779 19.0073 16 18.5412 16H1.87604C1.10425 16 0.623375 15.1628 1.01225 14.4961L4.02992 9.323C4.26476 8.92042 4.60102 8.58641 5.00517 8.35428C5.40932 8.12215 5.86726 8 6.33333 8H22.9985C23.7703 8 24.2512 8.83721 23.8623 9.50388ZM6.33333 6.66667H20V4.66667C20 3.56208 19.1046 2.66667 18 2.66667H11.3333L8.66667 0H2C0.895417 0 0 0.895417 0 2V13.5853L2.87821 8.65117C3.59225 7.42708 4.91621 6.66667 6.33333 6.66667Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularSave = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.2468 5.24684L18.7532 0.753161C18.2709 0.270923 17.6169 3.56612e-06 16.9349 0H2.57143C1.15125 0 0 1.15125 0 2.57143V21.4286C0 22.8488 1.15125 24 2.57143 24H21.4286C22.8488 24 24 22.8488 24 21.4286V7.06511C24 6.38312 23.7291 5.72907 23.2468 5.24684ZM14.5714 2.57143V6.85714H7.71429V2.57143H14.5714ZM21.1071 21.4286H2.89286C2.80761 21.4286 2.72585 21.3947 2.66557 21.3344C2.60529 21.2741 2.57143 21.1924 2.57143 21.1071V2.89286C2.57143 2.80761 2.60529 2.72585 2.66557 2.66557C2.72585 2.60529 2.80761 2.57143 2.89286 2.57143H5.14286V8.14286C5.14286 8.85295 5.71848 9.42857 6.42857 9.42857H15.8571C16.5672 9.42857 17.1429 8.85295 17.1429 8.14286V2.77939L21.3344 6.97098C21.3643 7.00083 21.388 7.03627 21.4041 7.07527C21.4203 7.11427 21.4286 7.15607 21.4286 7.19829V21.1071C21.4286 21.1924 21.3947 21.2741 21.3344 21.3344C21.2741 21.3947 21.1924 21.4286 21.1071 21.4286ZM12 10.7143C9.40055 10.7143 7.28571 12.8291 7.28571 15.4286C7.28571 18.028 9.40055 20.1429 12 20.1429C14.5994 20.1429 16.7143 18.028 16.7143 15.4286C16.7143 12.8291 14.5994 10.7143 12 10.7143ZM12 17.5714C10.8184 17.5714 9.85714 16.6101 9.85714 15.4286C9.85714 14.247 10.8184 13.2857 12 13.2857C13.1816 13.2857 14.1429 14.247 14.1429 15.4286C14.1429 16.6101 13.1816 17.5714 12 17.5714Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularFolderOpen = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '16'}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.9966 6.66664H20.0007V4.66657C20.0007 3.56237 19.1048 2.66651 18.0006 2.66651H11.3337L8.66695 -0.000244141H2.00007C0.895863 -0.000244141 0 0.895618 0 1.99982V14.0002C0 15.1044 0.895863 16.0003 2.00007 16.0003H18.6673C19.3548 16.0003 19.9965 15.6461 20.3632 15.0586L23.6924 9.72507C24.5258 8.39586 23.5674 6.66664 21.9966 6.66664ZM2.00007 2.24983C2.00007 2.11232 2.11257 1.99982 2.25007 1.99982H7.83776L10.5045 4.66657H17.7506C17.8881 4.66657 18.0006 4.77908 18.0006 4.91658V6.66664H6.33354C5.63352 6.66664 4.9835 7.03332 4.62098 7.63334L2.00007 11.9751V2.24983ZM18.6673 14.0002H3.0001L6.21687 8.66671H22.0007L18.6673 14.0002Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidComments = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M17.3333 7.33335C17.3333 3.65002 13.4542 0.666687 8.66667 0.666687C3.87917 0.666687 0 3.65002 0 7.33335C0 8.76252 0.5875 10.0792 1.58333 11.1667C1.025 12.425 0.104167 13.425 0.0916667 13.4375C0 13.5334 -0.025 13.675 0.0291667 13.8C0.0833333 13.925 0.2 14 0.333333 14C1.85833 14 3.12083 13.4875 4.02917 12.9584C5.37083 13.6125 6.95833 14 8.66667 14C13.4542 14 17.3333 11.0167 17.3333 7.33335ZM22.4167 16.5C23.4125 15.4167 24 14.0959 24 12.6667C24 9.87919 21.7708 7.49169 18.6125 6.49585C18.65 6.77085 18.6667 7.05002 18.6667 7.33335C18.6667 11.7459 14.1792 15.3334 8.66667 15.3334C8.21667 15.3334 7.77917 15.3 7.34583 15.2542C8.65833 17.65 11.7417 19.3334 15.3333 19.3334C17.0417 19.3334 18.6292 18.95 19.9708 18.2917C20.8792 18.8209 22.1417 19.3334 23.6667 19.3334C23.8 19.3334 23.9208 19.2542 23.9708 19.1334C24.025 19.0125 24 18.8709 23.9083 18.7709C23.8958 18.7584 22.975 17.7625 22.4167 16.5Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularComments = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '20'}
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M22.1643 15.4244C23.31 14.2953 23.9974 12.8788 23.9974 11.3332C23.9974 8.00024 20.8103 5.2464 16.6566 4.7548C15.3443 2.35508 12.2613 0.667786 8.66591 0.667786C3.87898 0.667786 0.000280597 3.65076 0.000280597 7.33365C0.000280597 8.87514 0.687698 10.2916 1.83339 11.4248C1.19597 12.7038 0.279414 13.6954 0.262749 13.7121C0.000280605 13.9912 -0.0747104 14.3995 0.0794378 14.7536C0.22942 15.1077 0.579378 15.3369 0.962665 15.3369C3.19156 15.3369 4.99135 14.4953 6.17871 13.7204C6.56199 13.8079 6.95778 13.8745 7.3619 13.9245C8.67007 16.3159 11.7405 17.999 15.3318 17.999C16.1983 17.999 17.0316 17.8991 17.8231 17.7157C19.0105 18.4865 20.8061 19.3322 23.0392 19.3322C23.4225 19.3322 23.7683 19.1031 23.9224 18.749C24.0724 18.3948 24.0016 17.9865 23.7391 17.7074C23.7224 17.6949 22.8017 16.7034 22.1643 15.4244ZM5.79958 11.579L5.08717 12.0414C4.49974 12.4205 3.89981 12.7205 3.29155 12.933C3.40404 12.7372 3.51653 12.5289 3.62485 12.3164L4.2706 11.0207L3.23739 10C2.67496 9.44173 2.00004 8.52934 2.00004 7.33365C2.00004 4.80479 5.05384 2.66755 8.66591 2.66755C12.278 2.66755 15.3318 4.80479 15.3318 7.33365C15.3318 9.86252 12.278 11.9998 8.66591 11.9998C7.97849 11.9998 7.29107 11.9206 6.62449 11.7665L5.79958 11.579ZM20.7603 13.9995L19.7312 15.0161L20.377 16.3117C20.4853 16.5242 20.5978 16.7325 20.7103 16.9283C20.102 16.7159 19.5021 16.4159 18.9147 16.0368L18.2023 15.5743L17.3732 15.766C16.7066 15.9201 16.0192 15.9993 15.3318 15.9993C13.082 15.9993 11.074 15.1619 9.8616 13.9287C14.0819 13.4787 17.3315 10.7041 17.3315 7.33365C17.3315 7.192 17.3149 7.05452 17.3024 6.91704C19.9854 7.52113 21.9976 9.28342 21.9976 11.3332C21.9976 12.5289 21.3227 13.4413 20.7603 13.9995Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAltComments = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.3333 6.99998H17.3333V2.99998C17.3333 1.52915 16.1375 0.333313 14.6667 0.333313H2.66667C1.19583 0.333313 0 1.52915 0 2.99998V9.66665C0 11.1375 1.19583 12.3333 2.66667 12.3333H4V14.5C4 14.7958 4.24167 15 4.5 15C4.6 15 4.70417 14.9708 4.79583 14.9L8 13.0875V16.3333C8 17.8041 9.19583 19 10.6667 19H14.6667L19.2042 21.5666C19.2958 21.6333 19.4 21.6666 19.5 21.6666C19.7583 21.6666 20 21.4625 20 21.1666V19H21.3333C22.8042 19 24 17.8041 24 16.3333V9.66665C24 8.19581 22.8042 6.99998 21.3333 6.99998ZM4 10.3333H2.66667C2.3 10.3333 2 10.0333 2 9.66665V2.99998C2 2.63331 2.3 2.33331 2.66667 2.33331H14.6667C15.0333 2.33331 15.3333 2.63331 15.3333 2.99998V9.66665C15.3333 10.0333 15.0333 10.3333 14.6667 10.3333H8.80833L8.35 10.5916L6 11.9208V10.3333H4ZM22 16.3333C22 16.7 21.7 17 21.3333 17H18V18.5875L15.65 17.2583L15.1917 17H10.6667C10.3 17 10 16.7 10 16.3333V12.3333H14.6667C16.1375 12.3333 17.3333 11.1375 17.3333 9.66665V8.99998H21.3333C21.7 8.99998 22 9.29998 22 9.66665V16.3333Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularComment = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M12.0016 0.501343C5.37429 0.501343 0.00311061 4.86484 0.00311061 10.2501C0.00311061 12.481 0.935802 14.5245 2.48248 16.1696C1.78413 18.0163 0.331193 19.5817 0.307759 19.6004C-0.00157629 19.9285 -0.0859404 20.4066 0.0921616 20.819C0.270263 21.2315 0.678023 21.4986 1.12796 21.4986C4.0104 21.4986 6.28355 20.2941 7.64743 19.3286C9.00195 19.7551 10.4643 19.9988 12.0016 19.9988C18.6288 19.9988 24 15.6353 24 10.2501C24 4.86484 18.6288 0.501343 12.0016 0.501343ZM12.0016 17.7491C10.7502 17.7491 9.51282 17.5569 8.32703 17.182L7.26311 16.8445L6.34916 17.4913C5.67894 17.9647 4.76031 18.4943 3.6542 18.8505C3.99634 18.2834 4.32911 17.646 4.58689 16.9664L5.0837 15.6494L4.1182 14.6276C3.26988 13.7231 2.25282 12.2279 2.25282 10.2501C2.25282 6.11624 6.62569 2.75105 12.0016 2.75105C17.3774 2.75105 21.7503 6.11624 21.7503 10.2501C21.7503 14.3839 17.3774 17.7491 12.0016 17.7491Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAltComment = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21 0H3C1.34531 0 0 1.34531 0 3V16.5C0 18.1547 1.34531 19.5 3 19.5H7.5V23.4375C7.5 23.7703 7.77187 24 8.0625 24C8.175 24 8.29219 23.9672 8.39531 23.8875L14.25 19.5H21C22.6547 19.5 24 18.1547 24 16.5V3C24 1.34531 22.6547 0 21 0ZM21.75 16.5C21.75 16.9125 21.4125 17.25 21 17.25H13.5L12.9 17.7L9.75 20.0625V17.25H3C2.5875 17.25 2.25 16.9125 2.25 16.5V3C2.25 2.5875 2.5875 2.25 3 2.25H21C21.4125 2.25 21.75 2.5875 21.75 3V16.5Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidCloudUpload = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M20.16 7.89748C20.3137 7.49623 20.4 7.05748 20.4 6.59998C20.4 4.61248 18.7875 2.99998 16.8 2.99998C16.0613 2.99998 15.3713 3.22498 14.8013 3.60748C13.7625 1.80748 11.8238 0.599976 9.6 0.599976C6.285 0.599976 3.6 3.28498 3.6 6.59998C3.6 6.70123 3.60375 6.80248 3.6075 6.90373C1.5075 7.64248 0 9.64497 0 12C0 14.9812 2.41875 17.4 5.4 17.4H19.2C21.8513 17.4 24 15.2512 24 12.6C24 10.2787 22.35 8.33998 20.16 7.89748ZM14.9138 10.2862L14.5087 10.6912C14.1488 11.0512 13.5638 11.04 13.215 10.6725L12 9.37873V14.1C12 14.5987 11.5988 15 11.1 15H10.5C10.0013 15 9.6 14.5987 9.6 14.1V9.37873L8.385 10.6725C8.03625 11.0437 7.45125 11.0512 7.09125 10.6912L6.68625 10.2862C6.33375 9.93372 6.33375 9.36372 6.68625 9.01497L10.1625 5.53873C10.515 5.18623 11.085 5.18623 11.4338 5.53873L14.91 9.01497C15.2625 9.36747 15.2625 9.93747 14.9138 10.2862Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidCloudDownload = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M20.16 7.89748C20.3137 7.49623 20.4 7.05748 20.4 6.59998C20.4 4.61248 18.7875 2.99998 16.8 2.99998C16.0613 2.99998 15.3713 3.22498 14.8013 3.60748C13.7625 1.80748 11.8238 0.599976 9.6 0.599976C6.285 0.599976 3.6 3.28498 3.6 6.59998C3.6 6.70123 3.60375 6.80248 3.6075 6.90373C1.5075 7.64248 0 9.64497 0 12C0 14.9812 2.41875 17.4 5.4 17.4H19.2C21.8513 17.4 24 15.2512 24 12.6C24 10.2787 22.35 8.33998 20.16 7.89748ZM14.9138 11.385L11.4375 14.8612C11.085 15.2137 10.515 15.2137 10.1663 14.8612L6.69 11.385C6.3375 11.0325 6.3375 10.4625 6.69 10.1137L7.095 9.70872C7.455 9.34872 8.04 9.35997 8.38875 9.72748L9.60375 11.0212V6.29998C9.60375 5.80123 10.005 5.39998 10.5038 5.39998H11.1038C11.6025 5.39998 12.0038 5.80123 12.0038 6.29998V11.0212L13.2188 9.72748C13.5675 9.35623 14.1525 9.34872 14.5125 9.70872L14.9175 10.1137C15.2625 10.4625 15.2625 11.0325 14.9138 11.385Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCloudUpload = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M20.3888 6.90373C20.2388 4.72873 18.4275 2.99998 16.2 2.99998C15.915 2.99998 15.6338 3.02998 15.36 3.08623C14.1638 1.58623 12.3038 0.599976 10.2 0.599976C7.0275 0.599976 4.36875 2.83873 3.73875 5.84248C1.49625 6.75373 0 8.93997 0 11.4C0 14.715 2.685 17.4 6 17.4H18.6C21.5813 17.4 24 14.9812 24 12C24 9.68248 22.53 7.65748 20.3888 6.90373ZM18.6 15.6H6C3.67875 15.6 1.8 13.7212 1.8 11.4C1.8 9.28498 3.36375 7.53373 5.4 7.24123V7.19998C5.4 4.54873 7.54875 2.39998 10.2 2.39998C12.2063 2.39998 13.9237 3.62998 14.64 5.37748C15.06 5.01748 15.6038 4.79998 16.2 4.79998C17.5238 4.79998 18.6 5.87623 18.6 7.19998C18.6 7.64248 18.48 8.05872 18.27 8.41497C18.3788 8.40372 18.4913 8.39998 18.6 8.39998C20.5875 8.39998 22.2 10.0125 22.2 12C22.2 13.9875 20.5875 15.6 18.6 15.6ZM11.1188 5.04373C10.9425 4.86748 10.6575 4.86748 10.4813 5.04373L6.58125 8.94372C6.405 9.11998 6.405 9.40497 6.58125 9.58123L7.215 10.215C7.39125 10.3912 7.68 10.3912 7.85625 10.2112L9.9 8.11873V13.35C9.9 13.5975 10.1025 13.8 10.35 13.8H11.25C11.4975 13.8 11.7 13.5975 11.7 13.35V8.11873L13.7438 10.2112C13.92 10.3912 14.205 10.3912 14.385 10.215L15.0188 9.58123C15.195 9.40497 15.195 9.11998 15.0188 8.94372L11.1188 5.04373Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularCloudDownload = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M20.3888 6.90373C20.2388 4.72873 18.4275 2.99998 16.2 2.99998C15.915 2.99998 15.6338 3.02998 15.36 3.08623C14.1638 1.58623 12.3038 0.599976 10.2 0.599976C7.0275 0.599976 4.36875 2.83873 3.73875 5.84248C1.49625 6.75373 0 8.93997 0 11.4C0 14.715 2.685 17.4 6 17.4H18.6C21.5813 17.4 24 14.9812 24 12C24 9.68248 22.53 7.65748 20.3888 6.90373ZM18.6 15.6H6C3.67875 15.6 1.8 13.7212 1.8 11.4C1.8 9.28498 3.36375 7.53373 5.4 7.24123V7.19998C5.4 4.54873 7.54875 2.39998 10.2 2.39998C12.2063 2.39998 13.9237 3.62998 14.64 5.37748C15.06 5.01748 15.6038 4.79998 16.2 4.79998C17.5238 4.79998 18.6 5.87623 18.6 7.19998C18.6 7.64248 18.48 8.05872 18.27 8.41497C18.3788 8.40372 18.4913 8.39998 18.6 8.39998C20.5875 8.39998 22.2 10.0125 22.2 12C22.2 13.9875 20.5875 15.6 18.6 15.6ZM14.385 8.98497C14.2088 8.80873 13.92 8.80873 13.7438 8.98872L11.7 11.0812V5.84998C11.7 5.60248 11.4975 5.39998 11.25 5.39998H10.35C10.1025 5.39998 9.9 5.60248 9.9 5.84998V11.0812L7.85625 8.98872C7.68 8.80873 7.395 8.80873 7.215 8.98497L6.58125 9.61872C6.405 9.79498 6.405 10.08 6.58125 10.2562L10.4813 14.1562C10.6575 14.3325 10.9425 14.3325 11.1188 14.1562L15.0188 10.2562C15.195 10.08 15.195 9.79498 15.0188 9.61872L14.385 8.98497Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidTask = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M6.5442 1.03977C6.49194 0.987332 6.42985 0.945724 6.36147 0.917333C6.2931 0.888943 6.2198 0.874329 6.14576 0.874329C6.07173 0.874329 5.99843 0.888943 5.93005 0.917333C5.86168 0.945724 5.79958 0.987332 5.74732 1.03977L2.76232 4.00743L1.69826 2.97056C1.646 2.91812 1.5839 2.87651 1.51553 2.84812C1.44716 2.81973 1.37385 2.80511 1.29982 2.80511C1.22579 2.80511 1.15248 2.81973 1.08411 2.84812C1.01574 2.87651 0.95364 2.91812 0.901382 2.97056L0.165444 3.70743C0.113004 3.75969 0.0713954 3.82179 0.0430049 3.89016C0.0146143 3.95853 0 4.03184 0 4.10587C0 4.1799 0.0146143 4.25321 0.0430049 4.32158C0.0713954 4.38995 0.113004 4.45205 0.165444 4.50431L2.39623 6.72618C2.50758 6.83203 2.65533 6.89105 2.80896 6.89105C2.96259 6.89105 3.11035 6.83203 3.2217 6.72618L3.95248 5.994L7.33686 2.61009C7.44231 2.50455 7.50189 2.3617 7.50268 2.21252C7.50347 2.06333 7.4454 1.91985 7.34108 1.81321L6.5442 1.03977ZM6.5442 8.50181C6.49194 8.44937 6.42985 8.40776 6.36147 8.37937C6.2931 8.35098 6.2198 8.33637 6.14576 8.33637C6.07173 8.33637 5.99843 8.35098 5.93005 8.37937C5.86168 8.40776 5.79958 8.44937 5.74732 8.50181L2.76232 11.4887L1.69826 10.4528C1.646 10.4003 1.5839 10.3587 1.51553 10.3303C1.44716 10.3019 1.37385 10.2873 1.29982 10.2873C1.22579 10.2873 1.15248 10.3019 1.08411 10.3303C1.01574 10.3587 0.95364 10.4003 0.901382 10.4528L0.165444 11.1882C0.113004 11.2405 0.0713954 11.3026 0.0430049 11.3709C0.0146143 11.4393 0 11.5126 0 11.5867C0 11.6607 0.0146143 11.734 0.0430049 11.8024C0.0713954 11.8707 0.113004 11.9328 0.165444 11.9851L2.3906 14.2117C2.50187 14.3175 2.64955 14.3765 2.8031 14.3765C2.95665 14.3765 3.10433 14.3175 3.2156 14.2117L3.95154 13.4762L7.33592 10.0909C7.44096 9.98608 7.50035 9.84403 7.50114 9.69565C7.50193 9.54727 7.44406 9.40459 7.34014 9.29869L6.5442 8.50181ZM2.99998 16.6257C1.75826 16.6257 0.722319 17.6335 0.722319 18.8757C0.722319 20.1179 1.7592 21.1257 2.99998 21.1257C3.59672 21.1257 4.16901 20.8887 4.59097 20.4667C5.01293 20.0448 5.24998 19.4725 5.24998 18.8757C5.24998 18.279 5.01293 17.7067 4.59097 17.2847C4.16901 16.8628 3.59672 16.6257 2.99998 16.6257ZM23.25 17.3757H9.74999C9.55107 17.3757 9.36031 17.4547 9.21966 17.5954C9.079 17.736 8.99998 17.9268 8.99998 18.1257V19.6257C8.99998 19.8246 9.079 20.0154 9.21966 20.1561C9.36031 20.2967 9.55107 20.3757 9.74999 20.3757H23.25C23.4489 20.3757 23.6397 20.2967 23.7803 20.1561C23.921 20.0154 24 19.8246 24 19.6257V18.1257C24 17.9268 23.921 17.736 23.7803 17.5954C23.6397 17.4547 23.4489 17.3757 23.25 17.3757ZM23.25 2.37571H9.74999C9.55107 2.37571 9.36031 2.45473 9.21966 2.59538C9.079 2.73603 8.99998 2.9268 8.99998 3.12571V4.62571C8.99998 4.82463 9.079 5.01539 9.21966 5.15604C9.36031 5.2967 9.55107 5.37571 9.74999 5.37571H23.25C23.4489 5.37571 23.6397 5.2967 23.7803 5.15604C23.921 5.01539 24 4.82463 24 4.62571V3.12571C24 2.9268 23.921 2.73603 23.7803 2.59538C23.6397 2.45473 23.4489 2.37571 23.25 2.37571ZM23.25 9.87572H9.74999C9.55107 9.87572 9.36031 9.95474 9.21966 10.0954C9.079 10.236 8.99998 10.4268 8.99998 10.6257V12.1257C8.99998 12.3246 9.079 12.5154 9.21966 12.6561C9.36031 12.7967 9.55107 12.8757 9.74999 12.8757H23.25C23.4489 12.8757 23.6397 12.7967 23.7803 12.6561C23.921 12.5154 24 12.3246 24 12.1257V10.6257C24 10.4268 23.921 10.236 23.7803 10.0954C23.6397 9.95474 23.4489 9.87572 23.25 9.87572Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidAltTask = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M22.875 15.5H1.125C0.501562 15.5 0 16.0016 0 16.625V20.375C0 20.9984 0.501562 21.5 1.125 21.5H22.875C23.4984 21.5 24 20.9984 24 20.375V16.625C24 16.0016 23.4984 15.5 22.875 15.5ZM21.75 19.25H13.5469V17.75H21.75V19.25ZM22.875 8H1.125C0.501562 8 0 8.50156 0 9.125V12.875C0 13.4984 0.501562 14 1.125 14H22.875C23.4984 14 24 13.4984 24 12.875V9.125C24 8.50156 23.4984 8 22.875 8ZM21.75 11.75H7.54688V10.25H21.75V11.75ZM22.875 0.5H1.125C0.501562 0.5 0 1.00156 0 1.625V5.375C0 5.99844 0.501562 6.5 1.125 6.5H22.875C23.4984 6.5 24 5.99844 24 5.375V1.625C24 1.00156 23.4984 0.5 22.875 0.5ZM21.75 4.25H16.5469V2.75H21.75V4.25Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularList = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M21.75 0.5H2.25C1.00734 0.5 0 1.50734 0 2.75V19.25C0 20.4927 1.00734 21.5 2.25 21.5H21.75C22.9927 21.5 24 20.4927 24 19.25V2.75C24 1.50734 22.9927 0.5 21.75 0.5ZM21.4688 19.25H2.53125C2.45666 19.25 2.38512 19.2204 2.33238 19.1676C2.27963 19.1149 2.25 19.0433 2.25 18.9688V3.03125C2.25 2.95666 2.27963 2.88512 2.33238 2.83238C2.38512 2.77963 2.45666 2.75 2.53125 2.75H21.4688C21.5433 2.75 21.6149 2.77963 21.6676 2.83238C21.7204 2.88512 21.75 2.95666 21.75 3.03125V18.9688C21.75 19.0433 21.7204 19.1149 21.6676 19.1676C21.6149 19.2204 21.5433 19.25 21.4688 19.25ZM19.5 14.9375V16.0625C19.5 16.3731 19.2481 16.625 18.9375 16.625H9.5625C9.25186 16.625 9 16.3731 9 16.0625V14.9375C9 14.6269 9.25186 14.375 9.5625 14.375H18.9375C19.2481 14.375 19.5 14.6269 19.5 14.9375ZM19.5 10.4375V11.5625C19.5 11.8731 19.2481 12.125 18.9375 12.125H9.5625C9.25186 12.125 9 11.8731 9 11.5625V10.4375C9 10.1269 9.25186 9.875 9.5625 9.875H18.9375C19.2481 9.875 19.5 10.1269 19.5 10.4375ZM19.5 5.9375V7.0625C19.5 7.37314 19.2481 7.625 18.9375 7.625H9.5625C9.25186 7.625 9 7.37314 9 7.0625V5.9375C9 5.62686 9.25186 5.375 9.5625 5.375H18.9375C19.2481 5.375 19.5 5.62686 19.5 5.9375ZM7.6875 6.5C7.6875 7.43197 6.93197 8.1875 6 8.1875C5.06803 8.1875 4.3125 7.43197 4.3125 6.5C4.3125 5.56803 5.06803 4.8125 6 4.8125C6.93197 4.8125 7.6875 5.56803 7.6875 6.5ZM7.6875 11C7.6875 11.932 6.93197 12.6875 6 12.6875C5.06803 12.6875 4.3125 11.932 4.3125 11C4.3125 10.068 5.06803 9.3125 6 9.3125C6.93197 9.3125 7.6875 10.068 7.6875 11ZM7.6875 15.5C7.6875 16.432 6.93197 17.1875 6 17.1875C5.06803 17.1875 4.3125 16.432 4.3125 15.5C4.3125 14.568 5.06803 13.8125 6 13.8125C6.93197 13.8125 7.6875 14.568 7.6875 15.5Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularMemoCheck = ({
  height,
  width,
  fill,
  children,
  className,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    {...rest}
    className={className || ''}
  >
    {children}
    <path
      d="M64 48H320c8.8 0 16 7.2 16 16V220.5c14.6-9.5 30.8-17 48-21.8V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c3.3 0 6.6-.3 9.7-.7c-17.9-12.8-33.3-28.8-45.3-47.3H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16zm56 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm456 48a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
      fill={fill || '#000'}
    />
  </svg>
);

export const RegularFile = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '18'}
    height={height || '24'}
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M17.3374 4.59285L13.4053 0.660808C12.9836 0.239016 12.4118 0 11.8166 0H2.25127C1.00932 0.00468658 0.00170898 1.0123 0.00170898 2.25425V21.7504C0.00170898 22.9924 1.00932 24 2.25127 24H15.7486C16.9906 24 17.9982 22.9924 17.9982 21.7504V6.18629C17.9982 5.5911 17.7592 5.01465 17.3374 4.59285ZM15.5659 6.00352H11.9994V2.43702L15.5659 6.00352ZM2.25127 21.7504V2.25425H9.74981V7.1283C9.74981 7.75161 10.2513 8.25308 10.8746 8.25308H15.7486V21.7504H2.25127Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularFileExport = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '22'}
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.8453 11.9608L20.8549 8.94792C20.5403 8.63125 19.9999 8.85375 19.9999 9.3V11.3367H15.9999V5.83252C15.9999 5.30335 15.7845 4.79085 15.4095 4.41627L11.9141 0.920871C11.5391 0.545873 11.0308 0.333374 10.502 0.333374H1.99957C0.895829 0.337541 0 1.23337 0 2.33712V19.667C0 20.7708 0.895829 21.6666 1.99957 21.6666H13.997C15.1012 21.6666 15.9999 20.7708 15.9999 19.667V15.3362H13.9999V19.667H1.99957V2.33712H8.66496V6.6696C8.66496 7.22376 9.11079 7.66918 9.66496 7.66918H13.9999V11.3362H7.16664C6.89039 11.3362 6.66664 11.56 6.66664 11.8362V12.8362C6.66664 13.1125 6.89039 13.3362 7.16664 13.3362H19.9999V15.3729C19.9999 15.8191 20.5403 16.0416 20.8549 15.725L23.8453 12.7121C24.0516 12.5042 24.0516 12.1687 23.8453 11.9608ZM10.6645 5.6696V2.49961L13.8349 5.6696H10.6645Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularFileImport = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.3358 4.59281L19.4034 0.660938C18.9816 0.239063 18.4097 0 17.8148 0H8.24953C7.00781 0.0046875 6 1.0125 6 2.25422V12.3783H0.5625C0.251719 12.3783 0 12.63 0 12.9408V14.0658C0 14.3766 0.251719 14.6283 0.5625 14.6283H13.5V16.9195C13.5 17.4216 14.108 17.6719 14.4619 17.3156L17.8261 13.9261C18.0581 13.6922 18.0581 13.3148 17.8261 13.0809L14.4619 9.69141C14.108 9.33516 13.5 9.58547 13.5 10.0875V12.3787H8.24953V2.25422H15.7481V7.12828C15.7481 7.75172 16.2497 8.25281 16.8731 8.25281H21.75V21.7505H8.24953V16.8783H6V21.7505C6 22.9922 7.00781 24 8.24953 24H21.7467C22.9889 24 24 22.9922 24 21.7505V6.18609C24 5.59125 23.7577 5.01469 23.3358 4.59281ZM17.9977 6.00328V2.43703L21.5644 6.00328H17.9977Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const FundsIcon = ({ children, ...rest }: IconProps) => (
  <svg
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.3326 9.33333H22.1035C21.7368 8.5 21.2035 7.7625 20.5451 7.14583L21.3326 4H19.9993C18.7743 4 17.691 4.5625 16.9576 5.42917C16.641 5.38333 16.3285 5.33333 15.9993 5.33333H10.666C7.44097 5.33333 4.75347 7.625 4.13264 10.6667H2.33264C1.71597 10.6667 1.22847 10.1042 1.35347 9.46667C1.44514 8.99167 1.89097 8.66667 2.3743 8.66667H2.41597C2.55347 8.66667 2.66597 8.55417 2.66597 8.41667V7.58333C2.66597 7.44583 2.55347 7.33333 2.41597 7.33333C1.22847 7.33333 0.170138 8.18333 0.0201382 9.35833C-0.163195 10.7833 0.945138 12 2.33264 12H3.9993C3.9993 14.175 5.05764 16.0875 6.66597 17.3042V20.6667C6.66597 21.0333 6.96597 21.3333 7.33264 21.3333H9.9993C10.366 21.3333 10.666 21.0333 10.666 20.6667V18.6667H15.9993V20.6667C15.9993 21.0333 16.2993 21.3333 16.666 21.3333H19.3326C19.6993 21.3333 19.9993 21.0333 19.9993 20.6667V17.3042C20.491 16.9333 20.9285 16.4958 21.3035 16H23.3326C23.6993 16 23.9993 15.7 23.9993 15.3333V10C23.9993 9.63333 23.6993 9.33333 23.3326 9.33333ZM17.9993 12C17.6326 12 17.3326 11.7 17.3326 11.3333C17.3326 10.9667 17.6326 10.6667 17.9993 10.6667C18.366 10.6667 18.666 10.9667 18.666 11.3333C18.666 11.7 18.366 12 17.9993 12ZM10.666 4H15.9993C16.2243 4 16.4451 4.01667 16.6618 4.03333C16.6618 4.02083 16.666 4.0125 16.666 4C16.666 1.79167 14.8743 0 12.666 0C10.4576 0 8.66597 1.79167 8.66597 4C8.66597 4.0875 8.6868 4.17083 8.69097 4.25833C9.3243 4.09583 9.98264 4 10.666 4Z"
      fill="#16A085"
    />
  </svg>
);

export const HamburgerMenuIcon = ({ ...rest }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M23.3571 5H0.642857C0.287839 5 0 4.71216 0 4.35714V2.64286C0 2.28784 0.287839 2 0.642857 2H23.3571C23.7122 2 24 2.28784 24 2.64286V4.35714C24 4.71216 23.7122 5 23.3571 5ZM23.3571 13.5714H0.642857C0.287839 13.5714 0 13.2836 0 12.9286V11.2143C0 10.8593 0.287839 10.5714 0.642857 10.5714H23.3571C23.7122 10.5714 24 10.8593 24 11.2143V12.9286C24 13.2836 23.7122 13.5714 23.3571 13.5714ZM23.3571 22.1429H0.642857C0.287839 22.1429 0 21.855 0 21.5V19.7857C0 19.4307 0.287839 19.1429 0.642857 19.1429H23.3571C23.7122 19.1429 24 19.4307 24 19.7857V21.5C24 21.855 23.7122 22.1429 23.3571 22.1429Z"
      fill="#29292D"
    />
  </svg>
);

export const CloseNavigationIcon = ({ ...rest }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M14.9747 12L21.7073 5.26761C22.0967 4.87824 22.0967 4.24637 21.7073 3.85638L20.1429 2.29203C19.7536 1.90266 19.1217 1.90266 18.7317 2.29203L11.9997 9.02505L5.26708 2.29265C4.8777 1.90328 4.24582 1.90328 3.85581 2.29265L2.29204 3.85638C1.90265 4.24575 1.90265 4.87761 2.29204 5.26761L9.02464 12L2.29204 18.7324C1.90265 19.1218 1.90265 19.7536 2.29204 20.1436L3.85644 21.708C4.24582 22.0973 4.8777 22.0973 5.26771 21.708L11.9997 14.975L18.7323 21.7074C19.1217 22.0967 19.7536 22.0967 20.1436 21.7074L21.708 20.143C22.0973 19.7536 22.0973 19.1218 21.708 18.7318L14.9747 12Z"
      fill="#29292D"
    />
  </svg>
);

export const RegularFileSignature = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.6891 8.30543L22.3612 6.97752C21.947 6.56335 21.2749 6.56335 20.8607 6.97752L19.7253 8.11293L22.5537 10.9412L23.6891 9.80584C24.1036 9.39167 24.1036 8.71959 23.6891 8.30543ZM13.7108 14.0833C13.394 14.3972 13.1611 14.7856 13.0333 15.2129L12.3987 17.3333H11.367C11.1887 17.3333 11.0287 17.2341 10.9437 17.0625C10.445 16.0683 9.01538 15.7983 8.19371 16.4721L7.61538 14.7379C7.47872 14.3292 7.09705 14.0542 6.66622 14.0542C6.23539 14.0542 5.85372 14.3287 5.71706 14.7379L4.95831 17.015C4.89581 17.2058 4.71748 17.3333 4.51706 17.3333H3.99998C3.63165 17.3333 3.33332 17.6316 3.33332 18C3.33332 18.3683 3.63165 18.6666 3.99998 18.6666H4.51706C5.29289 18.6666 5.97914 18.1716 6.22414 17.4362L6.66664 16.1075L7.36705 18.2108C7.40883 18.3359 7.4868 18.4458 7.59109 18.5266C7.69537 18.6074 7.82129 18.6554 7.95288 18.6645C7.96872 18.6658 7.98413 18.6666 7.99955 18.6666C8.2508 18.6666 8.48246 18.5245 8.5958 18.2975L8.91496 17.6587C9.03079 17.4258 9.24579 17.4008 9.33288 17.4008C9.41996 17.4008 9.63496 17.4254 9.75746 17.6729C10.065 18.2854 10.682 18.6662 11.3666 18.6662H13.9999V20.6666H1.99957V3.33712H8.66496V7.6696C8.66496 8.22376 9.11079 8.66918 9.66496 8.66918H13.9999V11.9192L15.9999 9.93667V6.83252C15.9999 6.30335 15.7845 5.79085 15.4095 5.41627L11.9141 1.92087C11.5391 1.54587 11.0308 1.33337 10.502 1.33337H1.99957C0.895829 1.33754 0 2.23337 0 3.33712V20.667C0 21.7708 0.895829 22.6666 1.99957 22.6666H13.997C15.1012 22.6666 15.9999 21.7708 15.9999 20.667V17.5333L21.6107 11.8842L18.7824 9.05584L13.7108 14.0833ZM10.6645 3.49961L13.8349 6.6696H10.6645V3.49961Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularFileInvoiceDollar = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M20.3358 4.59281L16.4034 0.660938C15.9816 0.239063 15.4097 0 14.8148 0H5.24953C4.00781 0.0046875 3 1.0125 3 2.25422V21.7505C3 22.9922 4.00781 24 5.24953 24H18.7467C19.9889 24 21 22.9922 21 21.7505V6.18609C21 5.59125 20.7577 5.01469 20.3358 4.59281ZM14.9977 2.43703L18.5644 6.00328H14.9977V2.43703ZM18.75 21.7505H5.24953V2.25422H12.7481V7.12828C12.7481 7.75172 13.2497 8.25281 13.8731 8.25281H18.75V21.7505ZM12.75 10.125C12.75 9.91781 12.5822 9.75 12.375 9.75H11.625C11.4178 9.75 11.25 9.91781 11.25 10.125V11.2556C10.1428 11.2852 9.24984 12.2189 9.24984 13.3683C9.24984 14.3044 9.85828 15.1406 10.7302 15.4022L12.8395 16.035C13.0814 16.1077 13.2506 16.3528 13.2506 16.6317C13.2506 16.9725 13.0022 17.25 12.6975 17.25H11.3798C11.1661 17.25 10.9598 17.1895 10.7789 17.0756C10.627 16.9805 10.4339 16.9861 10.3041 17.1098L9.75328 17.6353C9.58781 17.7933 9.59719 18.067 9.78 18.2044C10.2066 18.5245 10.7212 18.7092 11.2505 18.7364V19.875C11.2505 20.0822 11.4183 20.25 11.6255 20.25H12.3755C12.5827 20.25 12.7505 20.0822 12.7505 19.875V18.7444C13.8577 18.7148 14.7506 17.7816 14.7506 16.6317C14.7506 15.6956 14.1422 14.8594 13.2703 14.5978L11.1609 13.965C10.9191 13.8923 10.7498 13.6472 10.7498 13.3683C10.7498 13.0275 10.9983 12.75 11.303 12.75H12.6206C12.8344 12.75 13.0406 12.8105 13.2216 12.9244C13.3734 13.0195 13.5666 13.0139 13.6964 12.8902L14.2472 12.3647C14.4127 12.2067 14.4033 11.933 14.2205 11.7956C13.7939 11.4755 13.2792 11.2908 12.75 11.2636V10.125ZM7.125 5.25H10.875C11.0822 5.25 11.25 5.08219 11.25 4.875V4.125C11.25 3.91781 11.0822 3.75 10.875 3.75H7.125C6.91781 3.75 6.75 3.91781 6.75 4.125V4.875C6.75 5.08219 6.91781 5.25 7.125 5.25ZM11.25 7.875V7.125C11.25 6.91781 11.0822 6.75 10.875 6.75H7.125C6.91781 6.75 6.75 6.91781 6.75 7.125V7.875C6.75 8.08219 6.91781 8.25 7.125 8.25H10.875C11.0822 8.25 11.25 8.08219 11.25 7.875Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAltFile = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M16.5 11.625V12.9375C16.5 13.2469 16.2469 13.5 15.9375 13.5H8.0625C7.75313 13.5 7.5 13.2469 7.5 12.9375V11.625C7.5 11.3156 7.75313 11.0625 8.0625 11.0625H15.9375C16.2469 11.0625 16.5 11.3156 16.5 11.625ZM15.9375 15H8.0625C7.75313 15 7.5 15.2531 7.5 15.5625V16.875C7.5 17.1844 7.75313 17.4375 8.0625 17.4375H15.9375C16.2469 17.4375 16.5 17.1844 16.5 16.875V15.5625C16.5 15.2531 16.2469 15 15.9375 15ZM21 6.18281V21.75C21 22.9922 19.9922 24 18.75 24H5.25C4.00781 24 3 22.9922 3 21.75V2.25C3 1.00781 4.00781 0 5.25 0H14.8172C15.4125 0 15.9844 0.239063 16.4062 0.660938L20.3391 4.59375C20.7609 5.01094 21 5.5875 21 6.18281ZM15 2.43281V6H18.5672L15 2.43281ZM18.75 21.75V8.25H13.875C13.2516 8.25 12.75 7.74844 12.75 7.125V2.25H5.25V21.75H18.75Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularLandmark = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M2 8.00004H22C22.3683 8.00004 22.6667 7.70171 22.6667 7.33337V5.79546C22.6667 5.51754 22.4942 5.26879 22.2342 5.17129L12.4683 1.41837C12.3175 1.36171 12.1588 1.33337 12 1.33337C11.8413 1.33337 11.6825 1.36171 11.5317 1.41837L1.76583 5.17129C1.63879 5.21896 1.52932 5.30425 1.45204 5.41578C1.37476 5.52731 1.33334 5.65977 1.33333 5.79546V7.33337C1.33333 7.70171 1.63167 8.00004 2 8.00004ZM12 3.38087L18.8158 6.00004H5.18417L12 3.38087ZM23.3333 20.6667H22.6667V18C22.6667 17.2638 21.9846 16.6667 21.1429 16.6667H20V9.33337H18V16.6667H15.3333V9.33337H13.3333V16.6667H10.6667V9.33337H8.66667V16.6667H6V9.33337H4V16.6667H2.85708C2.01542 16.6667 1.33333 17.2638 1.33333 18V20.6667H0.666667C0.298333 20.6667 0 20.965 0 21.3334V22C0 22.3684 0.298333 22.6667 0.666667 22.6667H23.3333C23.7017 22.6667 24 22.3684 24 22V21.3334C24 20.965 23.7017 20.6667 23.3333 20.6667ZM20.6667 20.6667H3.33333V18.6667H20.6667V20.6667Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularHistory = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.8449 11.9774C23.8571 18.589 18.4651 23.9954 11.8535 24C8.75605 24.0022 5.93223 22.8308 3.80218 20.906C3.55555 20.6832 3.54573 20.2991 3.78075 20.0641L4.60139 19.2435C4.82054 19.0243 5.1712 19.018 5.40244 19.2243C7.11302 20.7505 9.3698 21.6774 11.8449 21.6774C17.194 21.6774 21.5223 17.3483 21.5223 12C21.5223 6.65085 17.1932 2.32258 11.8449 2.32258C9.15844 2.32258 6.72999 3.41487 4.97765 5.1795L7.35302 7.52206C7.72275 7.88666 7.46455 8.51613 6.94531 8.51613H0.735797C0.415135 8.51613 0.155151 8.25614 0.155151 7.93548V1.81176C0.155151 1.29639 0.776587 1.03645 1.14351 1.39834L3.32562 3.55031C5.4997 1.35808 8.51344 0 11.8449 0C18.4648 0 23.8326 5.36037 23.8449 11.9774ZM15.7614 16.3406L16.4445 15.4014C16.6331 15.1421 16.5757 14.7789 16.3164 14.5903L13.0062 12.1828V5.22581C13.0062 4.90514 12.7462 4.64516 12.4255 4.64516H11.2642C10.9436 4.64516 10.6836 4.90514 10.6836 5.22581V13.3656L14.9503 16.4686C15.2097 16.6572 15.5728 16.5999 15.7614 16.3406Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularPhoneRotary = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M17.3639 9.01171C17.1015 8.55248 16.7224 8.17078 16.2649 7.90529C15.8075 7.63981 15.288 7.49999 14.7591 7.5H9.24094C8.71203 7.49999 8.19253 7.63981 7.73507 7.90529C7.27762 8.17078 6.89849 8.55248 6.6361 9.01171L1.69782 17.654C1.56822 17.8807 1.50003 18.1373 1.50001 18.3984V21C1.50001 21.3978 1.65804 21.7793 1.93935 22.0606C2.22065 22.3419 2.60218 22.5 3.00001 22.5H21C21.3978 22.5 21.7793 22.3419 22.0607 22.0606C22.342 21.7793 22.5 21.3978 22.5 21V18.3984C22.5 18.1373 22.4318 17.8807 22.3022 17.654L17.3639 9.01171ZM20.25 20.25H3.75001V18.5976L8.58985 10.1278C8.65545 10.013 8.75022 9.91765 8.86456 9.8513C8.9789 9.78495 9.10875 9.75 9.24094 9.74999H14.7591C14.8913 9.75 15.0211 9.78495 15.1354 9.8513C15.2498 9.91765 15.3446 10.013 15.4102 10.1278L20.25 18.5976V20.25ZM12 12C11.4067 12 10.8266 12.1759 10.3333 12.5056C9.83994 12.8352 9.45543 13.3038 9.22836 13.8519C9.0013 14.4001 8.94189 15.0033 9.05765 15.5853C9.1734 16.1672 9.45913 16.7017 9.87868 17.1213C10.2982 17.5409 10.8328 17.8266 11.4147 17.9423C11.9967 18.0581 12.5999 17.9987 13.148 17.7716C13.6962 17.5446 14.1648 17.16 14.4944 16.6667C14.8241 16.1734 15 15.5933 15 15C15 14.2043 14.6839 13.4413 14.1213 12.8787C13.5587 12.3161 12.7956 12 12 12ZM23.7272 5.76562C20.4731 3.04687 16.2834 1.5 12 1.5C7.71657 1.5 3.52688 3.04687 0.272823 5.76562C0.186815 5.83845 0.117815 5.92924 0.0706802 6.0316C0.023546 6.13397 -0.000576683 6.24543 1.04667e-05 6.35812V8.99999C1.04667e-05 9.19891 0.079028 9.38967 0.21968 9.53032C0.360332 9.67098 0.551098 9.74999 0.75001 9.74999H4.03641C4.17572 9.74996 4.31226 9.71114 4.43074 9.63786C4.54921 9.56459 4.64494 9.45977 4.70719 9.33515L6.00001 6C7.87032 5.19 9.9 4.875 12 4.875C14.0986 4.875 16.1283 5.19 18 6L19.2928 9.33515C19.3551 9.45977 19.4508 9.56459 19.5693 9.63786C19.6877 9.71114 19.8243 9.74996 19.9636 9.74999H23.25C23.4489 9.74999 23.6397 9.67098 23.7803 9.53032C23.921 9.38967 24 9.19891 24 8.99999V6.35812C24.0006 6.24543 23.9765 6.13397 23.9293 6.0316C23.8822 5.92924 23.8132 5.83845 23.7272 5.76562Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularPhoneOffice = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M15.3333 15.3334H14C13.6317 15.3334 13.3333 15.6317 13.3333 16V17.3334C13.3333 17.7017 13.6317 18 14 18H15.3333C15.7017 18 16 17.7017 16 17.3334V16C16 15.6317 15.7017 15.3334 15.3333 15.3334ZM13.3333 12V13.3334C13.3333 13.7017 13.6317 14 14 14H15.3333C15.7017 14 16 13.7017 16 13.3334V12C16 11.6317 15.7017 11.3334 15.3333 11.3334H14C13.6317 11.3334 13.3333 11.6317 13.3333 12ZM18 18H19.3333C19.7017 18 20 17.7017 20 17.3334V16C20 15.6317 19.7017 15.3334 19.3333 15.3334H18C17.6317 15.3334 17.3333 15.6317 17.3333 16V17.3334C17.3333 17.7017 17.6317 18 18 18ZM18 14H19.3333C19.7017 14 20 13.7017 20 13.3334V12C20 11.6317 19.7017 11.3334 19.3333 11.3334H18C17.6317 11.3334 17.3333 11.6317 17.3333 12V13.3334C17.3333 13.7017 17.6317 14 18 14ZM21.3333 2.66671H11.2108C10.9354 1.89171 10.2029 1.33337 9.33333 1.33337H6C5.13042 1.33337 4.39792 1.89171 4.1225 2.66671H2.66667C1.19375 2.66671 0 3.86046 0 5.33337V20C0 21.473 1.19375 22.6667 2.66667 22.6667H21.3333C22.8063 22.6667 24 21.473 24 20V5.33337C24 3.86046 22.8063 2.66671 21.3333 2.66671ZM6 3.33337H9.33333V16.6667H6V3.33337ZM22 20C22 20.3675 21.7008 20.6667 21.3333 20.6667H2.66667C2.29917 20.6667 2 20.3675 2 20V5.33337C2 4.96587 2.29917 4.66671 2.66667 4.66671H4V16.6667C4 17.7713 4.89542 18.6667 6 18.6667H9.33333C10.4379 18.6667 11.3333 17.7713 11.3333 16.6667V4.66671H13.3333V7.66671C13.3333 8.58587 14.0808 9.33337 15 9.33337H22V20ZM22 7.33337H15.3333V4.66671H21.3333C21.7008 4.66671 22 4.96587 22 5.33337V7.33337Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularPhoneLaptop = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M4.2 4.20002H17.4V6.00002H19.2V3.60002C19.1991 3.28204 19.0724 2.97733 18.8475 2.75248C18.6227 2.52763 18.318 2.40091 18 2.40002H3.6C3.28201 2.40091 2.97731 2.52763 2.75246 2.75248C2.5276 2.97733 2.40089 3.28204 2.4 3.60002V13.2H0.6C0.44087 13.2 0.288258 13.2632 0.175736 13.3758C0.0632141 13.4883 0 13.6409 0 13.8L0 14.4C0.00138307 15.0355 0.254221 15.6447 0.703279 16.0944C1.15234 16.5441 1.76112 16.7977 2.39663 16.8H13.2V13.2H4.2V4.20002ZM22.65 7.20002H15.75C15.392 7.20002 15.0486 7.34226 14.7954 7.59543C14.5422 7.8486 14.4 8.19198 14.4 8.55002V20.25C14.4 20.6081 14.5422 20.9514 14.7954 21.2046C15.0486 21.4578 15.392 21.6 15.75 21.6H22.65C23.008 21.6 23.3514 21.4578 23.6046 21.2046C23.8578 20.9514 24 20.6081 24 20.25V8.55002C24 8.19198 23.8578 7.8486 23.6046 7.59543C23.3514 7.34226 23.008 7.20002 22.65 7.20002ZM22.2 19.8H16.2V9.00002H22.2V19.8Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularVoicemail = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M18.6 6.59998C17.1678 6.59998 15.7943 7.1689 14.7816 8.1816C13.7689 9.1943 13.2 10.5678 13.2 12C13.2 13.3894 13.7393 14.643 14.6014 15.6H9.39863C10.2611 14.643 10.8 13.3894 10.8 12C10.8 10.932 10.4833 9.88792 9.88994 8.9999C9.29658 8.11187 8.45321 7.41974 7.46649 7.01103C6.47977 6.60232 5.39401 6.49538 4.34651 6.70374C3.29902 6.9121 2.33683 7.4264 1.58163 8.1816C0.826422 8.9368 0.312122 9.89899 0.103762 10.9465C-0.104598 11.994 0.00233974 13.0797 0.411053 14.0665C0.819766 15.0532 1.5119 15.8966 2.39992 16.4899C3.28795 17.0833 4.33198 17.4 5.4 17.4H18.6C20.0322 17.4 21.4057 16.831 22.4184 15.8184C23.4311 14.8057 24 13.4321 24 12C24 10.5678 23.4311 9.1943 22.4184 8.1816C21.4057 7.1689 20.0322 6.59998 18.6 6.59998ZM1.8 12C1.8 11.288 2.01114 10.5919 2.40671 9.99992C2.80228 9.40791 3.36453 8.94649 4.02234 8.67401C4.68016 8.40154 5.404 8.33024 6.10233 8.46915C6.80066 8.60806 7.44212 8.95092 7.94559 9.45439C8.44905 9.95786 8.79192 10.5993 8.93083 11.2977C9.06974 11.996 8.99844 12.7198 8.72597 13.3776C8.45349 14.0355 7.99207 14.5977 7.40005 14.9933C6.80804 15.3888 6.11201 15.6 5.4 15.6C4.44556 15.5989 3.53052 15.2193 2.85562 14.5444C2.18073 13.8695 1.80109 12.9544 1.8 12ZM18.6 15.6C17.888 15.6 17.192 15.3888 16.5999 14.9933C16.0079 14.5977 15.5465 14.0355 15.274 13.3776C15.0016 12.7198 14.9303 11.996 15.0692 11.2977C15.2081 10.5993 15.5509 9.95786 16.0544 9.45439C16.5579 8.95092 17.1993 8.60806 17.8977 8.46915C18.596 8.33024 19.3198 8.40154 19.9777 8.67401C20.6355 8.94649 21.1977 9.40791 21.5933 9.99992C21.9889 10.5919 22.2 11.288 22.2 12C22.1989 12.9544 21.8193 13.8695 21.1444 14.5444C20.4695 15.2193 19.5544 15.5989 18.6 15.6Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularMobile = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M13.5 19.5C13.5 20.3297 12.8297 21 12 21C11.1703 21 10.5 20.3297 10.5 19.5C10.5 18.6703 11.1703 18 12 18C12.8297 18 13.5 18.6703 13.5 19.5ZM15.75 16.6875V4.3125C15.75 4.00313 15.4969 3.75 15.1875 3.75H8.8125C8.50313 3.75 8.25 4.00313 8.25 4.3125V16.6875C8.25 16.9969 8.50313 17.25 8.8125 17.25H15.1875C15.4969 17.25 15.75 16.9969 15.75 16.6875ZM19.5 2.25V21.75C19.5 22.9922 18.4922 24 17.25 24H6.75C5.50781 24 4.5 22.9922 4.5 21.75V2.25C4.5 1.00781 5.50781 0 6.75 0H17.25C18.4922 0 19.5 1.00781 19.5 2.25ZM17.25 21.4688V2.53125C17.25 2.37656 17.1234 2.25 16.9688 2.25H7.03125C6.87656 2.25 6.75 2.37656 6.75 2.53125V21.4688C6.75 21.6234 6.87656 21.75 7.03125 21.75H16.9688C17.1234 21.75 17.25 21.6234 17.25 21.4688Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularMobileAndroid = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M15.1875 17.25H8.8125C8.50313 17.25 8.25 16.9969 8.25 16.6875V4.3125C8.25 4.00313 8.50313 3.75 8.8125 3.75H15.1875C15.4969 3.75 15.75 4.00313 15.75 4.3125V16.6875C15.75 16.9969 15.4969 17.25 15.1875 17.25ZM19.5 2.25V21.75C19.5 22.9922 18.4922 24 17.25 24H6.75C5.50781 24 4.5 22.9922 4.5 21.75V2.25C4.5 1.00781 5.50781 0 6.75 0H17.25C18.4922 0 19.5 1.00781 19.5 2.25ZM17.25 21.4688V2.53125C17.25 2.37656 17.1234 2.25 16.9688 2.25H7.03125C6.87656 2.25 6.75 2.37656 6.75 2.53125V21.4688C6.75 21.6234 6.87656 21.75 7.03125 21.75H16.9688C17.1234 21.75 17.25 21.6234 17.25 21.4688ZM14.25 19.6875V19.3125C14.25 19.0031 13.9969 18.75 13.6875 18.75H10.3125C10.0031 18.75 9.75 19.0031 9.75 19.3125V19.6875C9.75 19.9969 10.0031 20.25 10.3125 20.25H13.6875C13.9969 20.25 14.25 19.9969 14.25 19.6875Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularAward = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M22.4221 20.3067L19.4995 13.8568C19.7076 13.321 19.8895 13.1925 20.5467 12.5354C20.8067 12.2752 20.9937 11.9513 21.0889 11.596C21.1841 11.2407 21.1842 10.8666 21.089 10.5113C20.7004 9.06053 20.7 9.26209 21.089 7.81038C21.1841 7.45507 21.1841 7.081 21.0889 6.72572C20.9937 6.37044 20.8067 6.04646 20.5467 5.78632C19.4835 4.72226 19.5848 4.89851 19.1957 3.44633C19.1006 3.09098 18.9136 2.76695 18.6535 2.50684C18.3934 2.24673 18.0694 2.05972 17.714 1.96462C16.2628 1.57602 16.4381 1.67727 15.375 0.614154C15.1149 0.353941 14.7908 0.166787 14.4354 0.0715034C14.0801 -0.0237801 13.7059 -0.0238354 13.3504 0.0713431C11.9034 0.458998 12.0994 0.459935 10.6495 0.0713431C10.2941 -0.0238064 9.91992 -0.0237366 9.56455 0.0715454C9.20917 0.166827 8.88514 0.353965 8.625 0.614154C7.56282 1.67634 7.73766 1.57556 6.28595 1.96462C5.9306 2.05972 5.60657 2.24673 5.34646 2.50684C5.08635 2.76695 4.89933 3.09098 4.80423 3.44633C4.41564 4.89757 4.51689 4.72226 3.45377 5.78538C2.92455 6.3146 2.71737 7.08663 2.91143 7.80944C3.30002 9.26021 3.30049 9.05865 2.91143 10.5104C2.81628 10.8657 2.81631 11.2397 2.91151 11.595C3.00671 11.9503 3.19372 12.2743 3.45377 12.5344C4.16158 13.2427 4.29845 13.3341 4.50095 13.8558L1.57784 20.3067C1.29847 20.9231 1.80518 21.593 2.53643 21.593C2.55002 21.593 2.56409 21.5925 2.57768 21.592L5.99298 21.4744L8.34281 23.708C8.55234 23.9062 8.82469 24 9.09375 24C9.49359 24 9.88687 23.7942 10.057 23.4188L12 19.1311L13.9429 23.4188C14.1131 23.7942 14.5064 24 14.9062 24C15.1758 24 15.4481 23.9062 15.6567 23.708L18.0065 21.4744L21.4218 21.592C21.4359 21.5925 21.4495 21.593 21.4631 21.593C22.1943 21.5925 22.7015 20.9231 22.4221 20.3067ZM8.70609 20.9484L6.85923 19.1935L4.51595 19.2741L5.90907 16.1996C6.03048 16.2596 6.15188 16.32 6.28595 16.3561C7.46438 16.6721 7.54172 16.6233 8.30438 17.386C8.70891 17.7905 9.24515 18 9.78703 18C9.87843 18 9.96843 17.9742 10.0594 17.9625L8.70609 20.9484ZM9.80999 15.7097C8.77781 14.6747 8.22844 14.5472 6.95438 14.2055C6.42282 12.2227 6.15563 12.0549 5.10751 11.0068C5.64704 8.99443 5.47736 8.69209 5.10751 7.3135C6.55876 5.86226 6.57095 5.54679 6.95485 4.11476C8.31844 3.75008 8.6925 3.72945 10.1541 2.2679C12.1519 2.80321 12.4598 2.64008 13.8473 2.2679C14.8453 3.26586 15.0497 3.57945 17.0461 4.11476C17.5776 6.09757 17.8448 6.26538 18.8929 7.31397C18.3618 9.29678 18.509 9.57615 18.8929 11.0082C17.895 12.0061 17.5814 12.211 17.0461 14.2074C15.8147 14.5374 15.2517 14.6499 14.19 15.7116C12.7303 14.8594 11.0484 14.9874 9.80999 15.7097ZM18.0839 19.2258L17.1407 19.1935L15.2939 20.9484L13.9406 17.9625C14.0315 17.9747 14.1215 18 14.2129 18C14.7543 18 15.2911 17.7905 15.6956 17.386C16.4648 16.6167 16.5304 16.6735 17.714 16.3561C17.8476 16.3205 17.969 16.2596 18.0909 16.1996L19.484 19.2736L18.0839 19.2258ZM16.5 9.00006C16.5 6.51476 14.4853 4.50008 12 4.50008C9.51468 4.50008 7.5 6.51476 7.5 9.00006C7.5 11.4854 9.51468 13.5 12 13.5C14.4853 13.5 16.5 11.4854 16.5 9.00006ZM12 11.25C10.7592 11.25 9.75 10.2408 9.75 9.00006C9.75 7.75928 10.7592 6.75007 12 6.75007C13.2408 6.75007 14.25 7.75928 14.25 9.00006C14.25 10.2408 13.2408 11.25 12 11.25Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const RegularHandshake = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M9.58875 9.24935L12.0487 6.9956C12.3263 6.7406 12.6862 6.60185 13.0612 6.60185L16.2 6.59435C16.2788 6.59435 16.3538 6.62435 16.4062 6.6806L18.72 8.9906H23.4C23.73 8.9906 24 8.7206 24 8.3906V7.7906C24 7.4606 23.73 7.1906 23.4 7.1906H19.47L17.685 5.4056C17.2913 5.01935 16.7588 4.7981 16.2 4.7981H7.695C7.14 4.7981 6.60375 5.01935 6.21 5.40935L4.425 7.19435H0.6C0.27 7.19435 0 7.46435 0 7.79435V8.39435C0 8.72435 0.27 8.99435 0.6 8.99435H5.17125L7.485 6.68435C7.56 6.65435 7.62375 6.6281 7.69875 6.5981H9.825L8.37375 7.92935C7.27125 8.9381 7.2075 10.6406 8.20875 11.7281C8.76375 12.3356 10.5037 13.2731 12.015 11.8931L12.3225 11.6118L16.38 14.9043C16.5075 15.0093 16.53 15.1968 16.425 15.3281L15.4462 16.5356C15.3413 16.6631 15.1538 16.6856 15.0225 16.5806L14.1263 15.8531L13.0013 17.2218C12.9188 17.3231 12.7987 17.3868 12.6675 17.4018C12.5363 17.4168 12.405 17.3756 12.3263 17.3118L10.9462 16.1306L10.3612 16.8506C9.84 17.4918 8.89125 17.5893 8.2875 17.0981L4.63875 13.7981H0.6C0.27 13.7981 0 14.0681 0 14.3981V14.9981C0 15.3281 0.27 15.5981 0.6 15.5981H3.9375L7.11 18.4631C8.26875 19.4043 9.8775 19.4268 11.07 18.6056C11.5388 19.0106 12.045 19.2018 12.6112 19.2018C13.2937 19.2018 13.935 18.9243 14.4413 18.3018C15.27 18.6281 16.2488 18.3993 16.8413 17.6718L17.8237 16.4606C18.0338 16.2018 18.165 15.9056 18.2325 15.5981H23.4C23.73 15.5981 24 15.3281 24 14.9981V14.3981C24 14.0681 23.73 13.7981 23.4 13.7981H17.805C17.7188 13.6931 17.6213 13.5956 17.5163 13.5093L13.665 10.3818L14.1337 9.95435C14.3775 9.72935 14.3963 9.3506 14.1713 9.10685L13.7625 8.66435C13.5375 8.4206 13.1588 8.4056 12.915 8.62685L10.845 10.5243C10.4888 10.8506 9.88125 10.8768 9.5475 10.5243C9.195 10.1531 9.22875 9.57935 9.58875 9.24935Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidLandmark = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M23.5134 4.31765L12.5269 0.0956236C12.1874 -0.0318745 11.8131 -0.0318745 11.4736 0.0956236L0.486563 4.31765C0.343641 4.37128 0.220484 4.46724 0.133542 4.59271C0.0465997 4.71818 1.14503e-05 4.86719 0 5.01984L0 6.75C0 7.16437 0.335625 7.5 0.75 7.5H23.25C23.6644 7.5 24 7.16437 24 6.75V5.01984C24 4.70719 23.8059 4.42734 23.5134 4.31765ZM3 9V16.5H2.25C1.83562 16.5 1.5 16.8356 1.5 17.25V19.5H22.5V17.25C22.5 16.8356 22.1644 16.5 21.75 16.5H21V9H18V16.5H13.5V9H10.5V16.5H6V9H3ZM23.25 21H0.75C0.335625 21 0 21.3356 0 21.75V23.25C0 23.6644 0.335625 24 0.75 24H23.25C23.6644 24 24 23.6644 24 23.25V21.75C24 21.3356 23.6644 21 23.25 21Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidHistory = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M24 11.9773C24.0122 18.5889 18.6203 23.9953 12.0087 23.9999C9.15314 24.002 6.53017 23.0065 4.46893 21.3429C3.93295 20.9104 3.89288 20.1071 4.37995 19.62L4.92512 19.0749C5.34169 18.6583 6.00672 18.6127 6.46824 18.9789C7.98686 20.1839 9.90875 20.9032 12 20.9032C16.9212 20.9032 20.9032 16.9204 20.9032 12C20.9032 7.07878 16.9204 3.09677 12 3.09677C9.63802 3.09677 7.49278 4.01463 5.89993 5.51283L8.35577 7.96867C8.84351 8.45641 8.49807 9.29031 7.80836 9.29031H0.774193C0.346596 9.29031 0 8.94372 0 8.51612V1.48195C0 0.792241 0.833902 0.446806 1.32164 0.934499L3.71061 3.32346C5.86495 1.26464 8.78477 0 12 0C18.6198 0 23.9877 5.36032 24 11.9773ZM15.2462 15.7894L15.7215 15.1783C16.1153 14.672 16.024 13.9424 15.5178 13.5487L13.5484 12.0169V6.96774C13.5484 6.32637 13.0285 5.80645 12.3871 5.80645H11.6129C10.9715 5.80645 10.4516 6.32637 10.4516 6.96774V13.5315L13.6166 15.9931C14.1228 16.3869 14.8524 16.2957 15.2462 15.7894V15.7894Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidPhoneRotary = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M17.3639 9.01171C17.1015 8.55248 16.7224 8.17078 16.2649 7.90529C15.8075 7.63981 15.288 7.49999 14.7591 7.5H9.24094C8.71203 7.49999 8.19253 7.63981 7.73507 7.90529C7.27762 8.17078 6.89849 8.55248 6.6361 9.01171L1.69782 17.654C1.56822 17.8807 1.50003 18.1373 1.50001 18.3984V21C1.50001 21.3978 1.65804 21.7793 1.93935 22.0606C2.22065 22.3419 2.60218 22.5 3.00001 22.5H21C21.3978 22.5 21.7793 22.3419 22.0607 22.0606C22.342 21.7793 22.5 21.3978 22.5 21V18.3984C22.5 18.1373 22.4318 17.8807 22.3022 17.654L17.3639 9.01171ZM12 18C11.3325 18 10.68 17.802 10.125 17.4312C9.56994 17.0603 9.13736 16.5332 8.88191 15.9165C8.62646 15.2998 8.55963 14.6212 8.68985 13.9666C8.82008 13.3119 9.14152 12.7105 9.61352 12.2385C10.0855 11.7665 10.6869 11.4451 11.3416 11.3148C11.9963 11.1846 12.6749 11.2515 13.2916 11.5069C13.9083 11.7623 14.4354 12.1949 14.8062 12.7499C15.1771 13.305 15.375 13.9575 15.375 14.625C15.375 15.5201 15.0194 16.3785 14.3865 17.0115C13.7535 17.6444 12.8951 18 12 18ZM23.7272 5.76562C20.4731 3.04687 16.2834 1.5 12 1.5C7.71657 1.5 3.52688 3.04687 0.272823 5.76562C0.186815 5.83845 0.117815 5.92924 0.0706802 6.0316C0.023546 6.13397 -0.000576683 6.24543 1.04667e-05 6.35812V8.99999C1.04667e-05 9.19891 0.079028 9.38967 0.21968 9.53032C0.360332 9.67098 0.551098 9.74999 0.75001 9.74999H4.03641C4.17572 9.74996 4.31226 9.71114 4.43074 9.63786C4.54921 9.56459 4.64494 9.45977 4.70719 9.33515L6.00001 6C7.87032 5.19 9.9 4.875 12 4.875C14.0986 4.875 16.1283 5.19 18 6L19.2928 9.33515C19.3551 9.45977 19.4508 9.56459 19.5693 9.63786C19.6877 9.71114 19.8243 9.74996 19.9636 9.74999H23.25C23.4489 9.74999 23.6397 9.67098 23.7803 9.53032C23.921 9.38967 24 9.19891 24 8.99999V6.35812C24.0006 6.24543 23.9765 6.13397 23.9293 6.0316C23.8822 5.92924 23.8132 5.83845 23.7272 5.76562Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidPhoneOffice = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M5.33333 18.6667H8C8.73625 18.6667 9.33333 18.0696 9.33333 17.3334V2.66671C9.33333 1.93046 8.73625 1.33337 8 1.33337H5.33333C4.59708 1.33337 4 1.93046 4 2.66671V17.3334C4 18.0696 4.59708 18.6667 5.33333 18.6667ZM22 2.66671H10.6667V17.3334C10.6667 18.8038 9.47042 20 8 20H5.33333C3.86292 20 2.66667 18.8038 2.66667 17.3334V2.66671H2C0.895417 2.66671 0 3.56212 0 4.66671V20.6667C0 21.7713 0.895417 22.6667 2 22.6667H22C23.1046 22.6667 24 21.7713 24 20.6667V4.66671C24 3.56212 23.1046 2.66671 22 2.66671ZM16 19.3334C16 19.7017 15.7017 20 15.3333 20H14C13.6317 20 13.3333 19.7017 13.3333 19.3334V18C13.3333 17.6317 13.6317 17.3334 14 17.3334H15.3333C15.7017 17.3334 16 17.6317 16 18V19.3334ZM16 14C16 14.3684 15.7017 14.6667 15.3333 14.6667H14C13.6317 14.6667 13.3333 14.3684 13.3333 14V12.6667C13.3333 12.2984 13.6317 12 14 12H15.3333C15.7017 12 16 12.2984 16 12.6667V14ZM21.3333 19.3334C21.3333 19.7017 21.035 20 20.6667 20H19.3333C18.965 20 18.6667 19.7017 18.6667 19.3334V18C18.6667 17.6317 18.965 17.3334 19.3333 17.3334H20.6667C21.035 17.3334 21.3333 17.6317 21.3333 18V19.3334ZM21.3333 14C21.3333 14.3684 21.035 14.6667 20.6667 14.6667H19.3333C18.965 14.6667 18.6667 14.3684 18.6667 14V12.6667C18.6667 12.2984 18.965 12 19.3333 12H20.6667C21.035 12 21.3333 12.2984 21.3333 12.6667V14ZM21.3333 9.33337H13.3333V5.33337H21.3333V9.33337Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidPhoneLaptop = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M22.65 7.20002H15.75C15.392 7.20002 15.0486 7.34226 14.7954 7.59543C14.5422 7.8486 14.4 8.19198 14.4 8.55002V20.25C14.4 20.6081 14.5422 20.9514 14.7954 21.2046C15.0486 21.4578 15.392 21.6 15.75 21.6H22.65C23.008 21.6 23.3514 21.4578 23.6046 21.2046C23.8578 20.9514 24 20.6081 24 20.25V8.55002C24 8.19198 23.8578 7.8486 23.6046 7.59543C23.3514 7.34226 23.008 7.20002 22.65 7.20002ZM21.6 19.2H16.8V9.60002H21.6V19.2ZM4.8 4.80002H16.8V6.00002H19.2V4.20002C19.199 3.72352 19.0095 3.26677 18.6729 2.92951C18.3363 2.59226 17.8799 2.40191 17.4034 2.40002L4.19663 2.40002C3.72013 2.40191 3.26373 2.59226 2.92711 2.92951C2.59048 3.26677 2.40099 3.72352 2.4 4.20002V13.2H0.6C0.44087 13.2 0.288258 13.2632 0.175736 13.3758C0.0632141 13.4883 0 13.6409 0 13.8L0 14.4C0.00138307 15.0355 0.254221 15.6447 0.703279 16.0944C1.15234 16.5441 1.76112 16.7977 2.39663 16.8H13.2V13.2H4.8V4.80002Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidVoicemail = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M18.5999 6.59998C17.622 6.59994 16.6625 6.86544 15.8237 7.36814C14.9849 7.87085 14.2983 8.5919 13.8373 9.45431C13.3763 10.3167 13.1582 11.2881 13.2061 12.2649C13.2541 13.2416 13.5664 14.187 14.1096 15.0001H9.8901C10.5589 13.9991 10.8741 12.8033 10.7855 11.6027C10.6969 10.4021 10.2097 9.26558 9.40124 8.37358C8.59278 7.48158 7.50943 6.88531 6.3233 6.67949C5.13717 6.47367 3.91628 6.6701 2.85456 7.23758C1.79285 7.80505 0.951205 8.71103 0.463327 9.8116C-0.0245506 10.9122 -0.130681 12.1442 0.161794 13.312C0.45427 14.4798 1.12858 15.5163 2.0776 16.257C3.02663 16.9977 4.19594 17.4 5.3998 17.4001H18.5999C20.0321 17.4001 21.4057 16.8312 22.4184 15.8185C23.4311 14.8058 24 13.4322 24 12C24 10.5679 23.4311 9.19433 22.4184 8.18162C21.4057 7.16892 20.0321 6.59998 18.5999 6.59998ZM2.39977 12C2.39977 11.4067 2.57572 10.8267 2.90536 10.3333C3.23501 9.83996 3.70355 9.45544 4.25174 9.22837C4.79992 9.00131 5.40313 8.9419 5.98508 9.05765C6.56703 9.17341 7.10158 9.45914 7.52114 9.8787C7.94071 10.2983 8.22643 10.8328 8.34219 11.4148C8.45794 11.9967 8.39853 12.5999 8.17147 13.1481C7.9444 13.6963 7.55988 14.1648 7.06653 14.4945C6.57318 14.8241 5.99315 15.0001 5.3998 15.0001C4.60414 15.0001 3.84107 14.684 3.27846 14.1214C2.71584 13.5588 2.39977 12.7957 2.39977 12ZM18.5999 15.0001C18.0066 15.0001 17.4266 14.8241 16.9332 14.4945C16.4399 14.1648 16.0553 13.6963 15.8283 13.1481C15.6012 12.5999 15.5418 11.9967 15.6576 11.4148C15.7733 10.8328 16.059 10.2983 16.4786 9.8787C16.8982 9.45914 17.4327 9.17341 18.0147 9.05765C18.5966 8.9419 19.1998 9.00131 19.748 9.22837C20.2962 9.45544 20.7647 9.83996 21.0944 10.3333C21.424 10.8267 21.6 11.4067 21.6 12C21.6 12.7957 21.2839 13.5588 20.7213 14.1214C20.1587 14.684 19.3956 15.0001 18.5999 15.0001Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidMobile = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M17.25 0H6.75C5.50781 0 4.5 1.00781 4.5 2.25V21.75C4.5 22.9922 5.50781 24 6.75 24H17.25C18.4922 24 19.5 22.9922 19.5 21.75V2.25C19.5 1.00781 18.4922 0 17.25 0ZM12 22.5C11.1703 22.5 10.5 21.8297 10.5 21C10.5 20.1703 11.1703 19.5 12 19.5C12.8297 19.5 13.5 20.1703 13.5 21C13.5 21.8297 12.8297 22.5 12 22.5ZM17.25 17.4375C17.25 17.7469 16.9969 18 16.6875 18H7.3125C7.00312 18 6.75 17.7469 6.75 17.4375V2.8125C6.75 2.50312 7.00312 2.25 7.3125 2.25H16.6875C16.9969 2.25 17.25 2.50312 17.25 2.8125V17.4375Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidMobileAndroid = ({
  height,
  width,
  fill,
  children,
  ...rest
}: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
    <path
      d="M17.25 0H6.75C5.50781 0 4.5 1.00781 4.5 2.25V21.75C4.5 22.9922 5.50781 24 6.75 24H17.25C18.4922 24 19.5 22.9922 19.5 21.75V2.25C19.5 1.00781 18.4922 0 17.25 0ZM14.25 21.1875C14.25 21.4969 13.9969 21.75 13.6875 21.75H10.3125C10.0031 21.75 9.75 21.4969 9.75 21.1875V20.8125C9.75 20.5031 10.0031 20.25 10.3125 20.25H13.6875C13.9969 20.25 14.25 20.5031 14.25 20.8125V21.1875ZM17.25 17.4375C17.25 17.7469 16.9969 18 16.6875 18H7.3125C7.00312 18 6.75 17.7469 6.75 17.4375V2.8125C6.75 2.50312 7.00312 2.25 7.3125 2.25H16.6875C16.9969 2.25 17.25 2.50312 17.25 2.8125V17.4375Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidReaction = ({ height, width, fill, ...rest }: IconProps) => (
  <svg
    width={
      (!height && !width && '28') ||
      (width && !height && width) ||
      (height && !width && height) ||
      (width && height && width)
    }
    height={
      (!height && !width && '22') ||
      (width && !height && width) ||
      (height && !width && height) ||
      (height && width && height)
    }
    viewBox="0 0 28 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M23.5481 10.2745C26.0029 10.2745 28 8.27735 28 5.82253C28 3.36771 26.0029 1.37061 23.5481 1.37061C21.0934 1.37061 19.0962 3.36771 19.0962 5.82253C19.0962 8.27735 21.0934 10.2745 23.5481 10.2745ZM21.0378 5.04179H22.7278V3.35174H24.3684V5.04179H26.0584V6.68235H24.3684V8.37234H22.7278V6.68235H21.0378V5.04179Z"
      fill={fill || '#000'}
    />
    <path
      d="M17.4556 5.82256C17.4556 3.70537 18.5414 1.83726 20.1851 0.744926C19.3926 0.393354 18.5164 0.197144 17.595 0.197144C15.1975 0.197144 13.1033 1.5196 12.0034 3.47345C10.9035 1.5196 8.8093 0.197144 6.41185 0.197144C2.87634 0.197198 0 3.07353 0 6.60904C0 9.82864 1.41132 12.866 3.8721 14.9421L12.0034 21.8027L20.1347 14.9421C21.1754 14.0641 22.0273 13.0137 22.665 11.8508C19.7226 11.4217 17.4556 8.88209 17.4556 5.82256V5.82256Z"
      fill={fill || '#000'}
    />
  </svg>
);

export const RegularReaction = ({
  height,
  width,
  fill,
  ...rest
}: IconProps) => (
  <svg
    width={
      (!height && !width && '28') ||
      (width && !height && width) ||
      (height && !width && height) ||
      (width && height && width)
    }
    height={
      (!height && !width && '22') ||
      (width && !height && width) ||
      (height && !width && height) ||
      (height && width && height)
    }
    viewBox="0 0 28 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M28 5.85085C28 2.71748 25.4509 0.168274 22.3175 0.168274C21.4787 0.168274 20.6818 0.351149 19.9645 0.678782C19.2314 0.386258 18.432 0.225204 17.5958 0.225204C15.1982 0.225204 13.1039 1.54771 12.004 3.50164C10.904 1.54771 8.80972 0.225204 6.41216 0.225204C2.87645 0.225258 0 3.10171 0 6.63737C0 9.8571 1.41137 12.8946 3.87226 14.9708L12.0039 21.8317L20.1356 14.9708C21.286 14.0001 22.2055 12.8186 22.86 11.5073C25.7398 11.2333 28 8.80124 28 5.85085ZM19.0776 13.7169L12.0039 19.6851L4.93019 13.7168C2.83965 11.953 1.64062 9.37262 1.64062 6.63737C1.64062 4.00635 3.78115 1.86588 6.41211 1.86588C9.04307 1.86588 11.1836 4.00635 11.1836 6.63737H12.8242C12.8242 4.00635 14.9647 1.86588 17.5957 1.86588C17.8105 1.86588 18.0219 1.88049 18.2293 1.90816C17.2427 2.93076 16.6349 4.32108 16.6349 5.85085C16.6349 8.55028 18.527 10.816 21.0546 11.3918C20.5349 12.2602 19.8709 13.0476 19.0776 13.7169ZM22.3175 9.89281C20.0887 9.89281 18.2755 8.07959 18.2755 5.85085C18.2755 3.62212 20.0887 1.8089 22.3175 1.8089C24.5462 1.8089 26.3594 3.62217 26.3594 5.85085C26.3594 8.07953 24.5462 9.89281 22.3175 9.89281Z"
      fill={fill || '#000'}
    />
    <path
      d="M23.1378 3.57227H21.4971V5.06704H20.0023V6.70766H21.4971V8.20244H23.1378V6.70766H24.6325V5.06704H23.1378V3.57227Z"
      fill={fill || '#000'}
    />
  </svg>
);
export const SolidPiggyBank = ({ height, width, fill, ...rest }: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M7.21739 12C10.6503 12 13.4348 9.31403 13.4348 6.00248C13.4348 2.69094 10.6503 0 7.21739 0C3.78444 0 1 2.68597 1 5.99752C1 9.30906 3.78444 12 7.21739 12ZM5.04542 8.37071C5.10204 8.17211 5.15865 7.97849 5.22041 7.77989C5.29247 7.55151 5.35938 7.52669 5.57555 7.63591C5.94612 7.81961 6.33728 7.92387 6.74903 7.97352C7.01152 8.00331 7.27401 7.97849 7.51591 7.87422C7.97398 7.6806 8.04603 7.16922 7.66002 6.8614C7.5262 6.75714 7.37694 6.6777 7.22254 6.61316C6.82108 6.44435 6.40419 6.31527 6.02332 6.09681C5.41085 5.74431 5.01969 5.25279 5.06601 4.53289C5.11748 3.71866 5.59613 3.20728 6.36816 2.93918C6.68727 2.82499 6.68727 2.82995 6.69241 2.50724C6.69241 2.39801 6.69241 2.28879 6.69241 2.17956C6.69756 1.93628 6.74388 1.89657 6.99093 1.88664C7.06813 1.88664 7.14534 1.88664 7.22254 1.88664C7.75781 1.88664 7.75781 1.88664 7.75781 2.40298C7.75781 2.76541 7.75781 2.77038 8.13353 2.82499C8.42175 2.86967 8.69454 2.94911 8.96217 3.0633C9.11143 3.12784 9.1629 3.22714 9.12172 3.37609C9.05482 3.5995 8.99305 3.82292 8.91585 4.04137C8.84379 4.2499 8.77689 4.27969 8.57101 4.18535C8.15412 3.99173 7.71664 3.90732 7.25342 3.93215C7.12989 3.93711 7.01666 3.95201 6.90343 4.00166C6.50713 4.17046 6.44022 4.59247 6.77991 4.85561C6.94976 4.98966 7.14534 5.08399 7.35121 5.16343C7.7012 5.30244 8.05633 5.44146 8.39602 5.62019C9.46142 6.19115 9.74964 7.482 8.9982 8.36078C8.72542 8.67853 8.37543 8.89202 7.95854 9.00124C7.7784 9.05089 7.69605 9.14026 7.70634 9.31899C7.71664 9.49772 7.70634 9.67149 7.70634 9.85023C7.70634 10.0091 7.62399 10.0935 7.45929 10.0985C7.26371 10.1034 7.06299 10.1034 6.86741 10.0985C6.69241 10.0935 6.61006 9.99917 6.61006 9.83533C6.61006 9.70625 6.61006 9.57716 6.60492 9.44808C6.59977 9.16508 6.59462 9.15019 6.3064 9.1055C5.94097 9.05089 5.58584 8.97145 5.2513 8.81258C4.9991 8.69839 4.97337 8.63384 5.04542 8.37071Z"
      fill={fill || 'black'}
    />
    <path
      d="M21.9583 12.2145H21.2012C20.7018 10.7427 19.7246 9.43603 18.4197 8.42379C18.4197 8.37731 18.409 8.32566 18.3983 8.27918C18.1244 7.35473 18.4627 6.51291 18.8547 5.90866C19.1285 5.48517 18.7741 4.9429 18.2587 5.00487C17.1042 5.14431 16.3095 5.55231 15.7618 6.01195C15.3859 6.32699 15.1174 6.75048 14.9993 7.22045C14.1724 10.5154 11.0849 12.9686 7.40669 12.9686C5.61861 12.9686 3.97551 12.3901 2.65996 11.4192C2.20354 12.3695 1.95654 13.4076 1.95654 14.4973C1.95654 15.086 2.03172 15.6593 2.17133 16.2119C2.17133 16.2119 2.17133 16.2222 2.1767 16.2377C2.32168 16.811 2.54183 17.3636 2.82105 17.8852C3.19155 18.6547 3.72851 19.5533 4.46952 20.2815C5.53807 21.3403 5.72064 22.6521 5.74748 23.2202V23.4629C5.74748 23.4732 5.74748 23.4835 5.74748 23.4939C5.74748 23.499 5.74748 23.499 5.74748 23.499C5.76896 23.7779 6.01059 24 6.30592 24H9.69951C10.0056 24 10.258 23.7624 10.258 23.4629V22.6572C10.752 22.7192 11.2567 22.7553 11.7668 22.7553C12.1695 22.7553 12.5615 22.7347 12.9535 22.6934V23.4629C12.9535 23.7573 13.2005 24 13.5119 24H16.9163C17.2223 24 17.4747 23.7624 17.4747 23.4629V22.6572C17.4801 22.3887 17.5767 21.3196 18.6292 20.4055C18.6667 20.3745 18.7043 20.3435 18.7419 20.3125C18.7527 20.3022 18.7634 20.297 18.7741 20.2867C19.9447 19.2848 20.8092 18.035 21.2549 16.6405H21.9691C22.5382 16.6405 23 16.1964 23 15.649V13.2061C22.9893 12.6587 22.5275 12.2145 21.9583 12.2145ZM17.711 12.3901C17.2438 12.3901 16.8679 12.0286 16.8679 11.5793C16.8679 11.13 17.2438 10.7685 17.711 10.7685C18.1781 10.7685 18.554 11.13 18.554 11.5793C18.554 12.0286 18.1781 12.3901 17.711 12.3901Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const Android = ({ height, width, fill, ...rest }: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 10 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M7.55212 0.166504H2.44796C1.64246 0.166504 0.989624 0.819336 0.989624 1.62484V10.3748C0.989624 11.1803 1.64246 11.8332 2.44796 11.8332H7.55212C8.35763 11.8332 9.01046 11.1803 9.01046 10.3748V1.62484C9.01046 0.819336 8.35649 0.166504 7.55212 0.166504ZM7.91671 10.3748C7.91671 10.5759 7.75315 10.7394 7.55212 10.7394H2.44796C2.24698 10.7394 2.08337 10.5754 2.08337 10.3748V1.62484C2.08337 1.42382 2.24694 1.26025 2.44796 1.26025H7.55212C7.75264 1.26025 7.91671 1.42386 7.91671 1.62484V10.3748ZM5.00004 9.0988C4.69812 9.0988 4.45317 9.34352 4.45317 9.64567C4.45317 9.94759 4.69812 10.1925 5.00004 10.1925C5.30196 10.1925 5.54692 9.94759 5.54692 9.64567C5.54692 9.34261 5.3031 9.0988 5.00004 9.0988Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const Desktop = ({ height, width, fill, ...rest }: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M12 0H1.5C0.671484 0 0 0.671484 0 1.5V8.25C0 9.07852 0.671484 9.75 1.5 9.75H4.97578L4.75078 10.875H3.5625C3.25312 10.875 3 11.1281 3 11.4375C3 11.7469 3.25312 12 3.5625 12H9.9375C10.248 12 10.5 11.748 10.5 11.4375C10.5 11.127 10.248 10.875 9.9375 10.875H8.74852L8.52422 9.75H12C12.8285 9.75 13.5 9.07852 13.5 8.25V1.5C13.5 0.671484 12.8273 0 12 0ZM7.60078 10.875H5.89922L6.12422 9.75H7.37719L7.60078 10.875ZM12.375 8.25C12.375 8.45677 12.2068 8.625 12 8.625H1.5C1.29323 8.625 1.125 8.45677 1.125 8.25V7.125H12.375V8.25ZM12.375 6H1.125V1.5C1.125 1.29323 1.29323 1.125 1.5 1.125H12C12.2068 1.125 12.375 1.29323 12.375 1.5V6Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const Wifi = ({ height, width, fill, ...rest }: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 15 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M7.47889 8.10391C6.77576 8.10391 6.18748 8.71328 6.18748 9.4375C6.18748 10.1617 6.77506 10.75 7.47889 10.75C8.18272 10.75 8.81248 10.1617 8.81248 9.4375C8.81248 8.71328 8.2242 8.10391 7.47889 8.10391ZM14.8242 3.02969C12.968 1.26297 10.2984 0.25 7.49998 0.25C4.70155 0.25 2.03248 1.26297 0.175131 3.02969C-0.0504548 3.24355 -0.0592438 3.59945 0.155355 3.82445C0.367745 4.04931 0.72512 4.05883 0.95012 3.84423C2.58045 2.275 4.98748 1.375 7.49998 1.375C10.0125 1.375 12.3984 2.27523 14.0508 3.84531C14.1586 3.94844 14.2992 4 14.4164 4C14.5651 4 14.7138 3.94141 14.8237 3.82495C15.0586 3.59922 15.0515 3.24531 14.8242 3.02969ZM7.49998 4.37266C5.70397 4.37266 4.03358 5.02891 2.79842 6.21836C2.57342 6.43516 2.56639 6.79141 2.78201 7.01406C2.99808 7.23965 3.35412 7.24478 3.57748 7.03018C4.60311 6.04375 5.9953 5.5 7.49998 5.5C9.00467 5.5 10.3969 6.04352 11.4234 7.0307C11.5312 7.13594 11.6508 7.1875 11.7914 7.1875C11.9386 7.1875 12.0865 7.12963 12.1971 7.01465C12.4124 6.79127 12.4051 6.43527 12.181 6.21918C10.9664 5.02891 9.2953 4.37266 7.49998 4.37266Z"
      fill={fill || 'black'}
    />
  </svg>
);

export const Bluetooth = ({ height, width, fill, ...rest }: IconProps) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M4.79593 6.74976L7.59865 4.45875C7.75028 4.35211 7.8261 4.19508 7.8261 4.03101C7.8261 3.86695 7.75043 3.71039 7.61973 3.60328L4.29364 0.905624C4.1202 0.762796 3.87495 0.729843 3.66707 0.822866C3.45816 0.893694 3.3261 1.09289 3.3261 1.31273V5.51039L0.967509 3.60445C0.722944 3.40303 0.352183 3.43087 0.140634 3.66745C-0.0702547 3.90211 -0.0404422 4.25836 0.206398 4.45992L3.00911 6.75094L0.206398 9.04195C-0.0403688 9.24337 -0.0702058 9.59859 0.140658 9.83437C0.351596 10.0709 0.722234 10.0995 0.967533 9.89737L3.3261 7.96851V12.1873C3.3261 12.407 3.45909 12.6063 3.66702 12.6977C3.74675 12.7334 3.8299 12.7498 3.91305 12.7498C4.04986 12.7498 4.18599 12.7036 4.2936 12.615L7.61968 9.91734C7.75028 9.78961 7.8261 9.63258 7.8261 9.46851C7.8261 9.30445 7.75043 9.14766 7.61973 9.04078L4.79593 6.74976ZM4.50001 2.53125L6.33498 4.01015L4.50001 5.51015V2.53125ZM4.50001 10.9685V7.96851L6.33498 9.44742L4.50001 10.9685Z"
      fill={fill || '#231F20'}
    />
  </svg>
);

export const ThryvpayLogo = ({ height, width, ...rest }: IconProps) => (
  <svg
    width={width || '80'}
    height={height || '30'}
    viewBox="0 0 320 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <rect width="320" height="121" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlinkHref="#image0_313_945"
          transform="translate(0 -0.0874351) scale(0.00176991 0.00468076)"
        />
      </pattern>
      <image
        id="image0_313_945"
        width="565"
        height="251"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const ThryvLogo = ({ height, width, ...rest }: IconProps) => (
  <svg
    width={width || '90'}
    height={height || '48'}
    viewBox="0 0 540 379"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M238.9 238.1C238.9 232.7 238.8 207.1 238.9 192.1C238.9 189.1 239.2 186.1 239.6 183.1C240.9 173.6 245.8 168.9 255.3 168.1C259.1 167.7 263 167.7 266.9 167.5V153.4C257.8 153.6 248.8 152.6 239.9 155.1C229.8 157.9 223.3 164.2 221.3 174.7C220.6 178.3 220.3 182 220.2 185.6V238.2H238.9V238.1ZM210.1 238V176.1C209.6 165.1 202 156.9 191.3 154.8C186.3 153.8 181.2 153.5 176.1 153.4C168.2 153.2 160.4 153.3 152.1 153.3V126.3H133.7V238H152.4V168.1C161.5 168.1 170.3 167.8 179 168.2C184.4 168.4 188.6 171.5 190.1 176.8C191.3 180.7 191.9 184.8 192 188.9C192.2 204 192.1 236.7 192.1 238H210.1Z"
      fill="black"
    />
    <path
      d="M111.5 223.5C102 222.6 97.0999 217.9 95.7999 208.5C95.3999 205.5 95.0999 202.5 95.0999 199.5C95.0999 193.6 95.0999 181.1 95.0999 168.1H122.7V153.7H95.0999C95.0999 139.2 95.0999 127 95.0999 126.7H76.5999C76.4999 127.7 76.4999 189.4 76.5999 206C76.5999 209.6 76.9999 213.3 77.6999 216.9C79.5999 227.4 86.1999 233.7 96.2999 236.4C105.1 238.9 114.1 237.9 123.3 238.1V224C119.2 223.9 115.4 223.8 111.5 223.5Z"
      fill="black"
    />
    <path
      d="M371.4 153.4H388.9C389.9 153.4 391.2 154.9 391.6 155.9C399 175.1 415.7 219 416.5 221C418.6 216.8 434.2 176.1 441.6 156.1C442.4 154 443.4 153.4 445.7 153.4H461.8C461.5 154.5 440.2 206.3 429.9 231.4C427.8 236.5 424.4 239.3 418.7 239.1C417.5 239.1 416.2 239.1 415 239.1C409.1 239.3 405.5 236.5 403.3 231.1C395.4 211.3 374.1 159.9 371.4 153.4Z"
      fill="black"
    />
    <path
      d="M296.7 265.7C302.4 265.7 307.6 265.6 312.7 265.8C314.9 265.9 315.9 265.2 316.9 263.1C332.7 227.8 348.6 192.6 364.5 157.4C365 156.3 365.4 155.1 366 153.6C360.2 153.6 354.8 153.7 349.5 153.6C347.7 153.6 346.8 154.2 346.1 155.9C341.9 165.6 337.6 175.2 333.4 184.8C328.5 195.9 323.5 207.1 318.4 218.6C317 215.4 315.9 212.7 314.7 210C307.2 192.1 299.8 174.2 292.3 156.4C291.9 155.4 290.8 153.8 289.9 153.8C284 153.6 278.2 153.7 272 153.7C272.3 154.6 272.5 155.3 272.8 155.8C284.1 181.2 295.4 206.6 306.9 231.9C308.8 236.1 309.4 239.5 307 243.9C303.2 250.8 300.2 258.2 296.7 265.7Z"
      fill="black"
    />
    <path
      d="M461.8 144.2L424.4 127.2L391 112.1C389.1 111.2 387 112.6 387 114.7V124.4C387 125.9 385.9 127.1 384.4 127.2L287.4 135L171.9 144.2H461.8Z"
      fill="#FF5000"
    />
    <path
      d="M441 235.3C441 234.6 441.2 234 441.5 233.4C441.8 232.8 442.3 232.3 442.9 232C443.5 231.7 444.1 231.5 444.8 231.5C445.5 231.5 446.1 231.7 446.7 232C447.3 232.3 447.8 232.8 448.1 233.4C448.4 234 448.6 234.6 448.6 235.3C448.6 236 448.4 236.6 448.1 237.2C447.8 237.8 447.3 238.3 446.7 238.6C446.1 239 445.5 239.1 444.7 239.1C444 239.1 443.3 238.9 442.7 238.6C442.1 238.2 441.6 237.8 441.3 237.2C441 236.6 441 236 441 235.3ZM441.6 235.3C441.6 235.9 441.7 236.4 442 236.9C442.3 237.4 442.7 237.8 443.2 238.1C443.7 238.4 444.2 238.5 444.8 238.5C445.4 238.5 445.9 238.4 446.4 238.1C446.9 237.8 447.3 237.4 447.6 236.9C447.9 236.4 448 235.9 448 235.3C448 234.7 447.9 234.2 447.6 233.7C447.3 233.2 446.9 232.8 446.4 232.5C445.9 232.2 445.4 232.1 444.8 232.1C444.2 232.1 443.7 232.2 443.2 232.5C442.7 232.8 442.3 233.2 442 233.7C441.7 234.2 441.6 234.7 441.6 235.3ZM446.4 234.4C446.4 235 446.1 235.4 445.6 235.6L446.8 237.6H445.7L444.7 235.8H444.2V237.6H443.2V233H444.5C445.1 233 445.5 233.1 445.8 233.3C446.2 233.6 446.4 233.9 446.4 234.4ZM444.3 235.1H444.7C445 235.1 445.1 235 445.3 234.9C445.4 234.8 445.5 234.6 445.5 234.4C445.5 234.2 445.4 234 445.3 233.9C445.2 233.8 445 233.8 444.7 233.8H444.4V235.1H444.3Z"
      fill="black"
    />
  </svg>
);

export const RegularHeart = ({ height, width, fill, ...rest }: IconProps) => (
  <svg
    width={
      (!height && !width && '22') ||
      (width && !height && width) ||
      (height && !width && height) ||
      (width && height && width)
    }
    height={
      (!height && !width && '22') ||
      (width && !height && width) ||
      (height && !width && height) ||
      (height && width && height)
    }
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M244 84L255.1 96L267.1 84.02C300.6 51.37 347 36.51 392.6 44.1C461.5 55.58 512 115.2 512 185.1V190.9C512 232.4 494.8 272.1 464.4 300.4L283.7 469.1C276.2 476.1 266.3 480 256 480C245.7 480 235.8 476.1 228.3 469.1L47.59 300.4C17.23 272.1 0 232.4 0 190.9V185.1C0 115.2 50.52 55.58 119.4 44.1C164.1 36.51 211.4 51.37 244 84C243.1 84 244 84.01 244 84L244 84zM255.1 163.9L210.1 117.1C188.4 96.28 157.6 86.4 127.3 91.44C81.55 99.07 48 138.7 48 185.1V190.9C48 219.1 59.71 246.1 80.34 265.3L256 429.3L431.7 265.3C452.3 246.1 464 219.1 464 190.9V185.1C464 138.7 430.4 99.07 384.7 91.44C354.4 86.4 323.6 96.28 301.9 117.1L255.1 163.9z"
      fill={fill || 'black'}
    />
  </svg>
);

export const SolidHeart = ({ height, width, fill, ...rest }: IconProps) => (
  <svg
    width={width || '22'}
    height={height || '22'}
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"
      fill={fill || 'black'}
    />
  </svg>
);
